
; var CONSTANTS = {
    LICENSES: {
        API: 'api',
        ACL: 'allow_acl_feature',
        PAGE: 'page_limit',
        PRODUCT: 'product_limit',
        OPERATOR: 'user_limit'
    }
}
; /*! jQuery v3.7.1 | (c) OpenJS Foundation and other contributors | jquery.org/license */
!function(e,t){"use strict";"object"==typeof module&&"object"==typeof module.exports?module.exports=e.document?t(e,!0):function(e){if(!e.document)throw new Error("jQuery requires a window with a document");return t(e)}:t(e)}("undefined"!=typeof window?window:this,function(ie,e){"use strict";var oe=[],r=Object.getPrototypeOf,ae=oe.slice,g=oe.flat?function(e){return oe.flat.call(e)}:function(e){return oe.concat.apply([],e)},s=oe.push,se=oe.indexOf,n={},i=n.toString,ue=n.hasOwnProperty,o=ue.toString,a=o.call(Object),le={},v=function(e){return"function"==typeof e&&"number"!=typeof e.nodeType&&"function"!=typeof e.item},y=function(e){return null!=e&&e===e.window},C=ie.document,u={type:!0,src:!0,nonce:!0,noModule:!0};function m(e,t,n){var r,i,o=(n=n||C).createElement("script");if(o.text=e,t)for(r in u)(i=t[r]||t.getAttribute&&t.getAttribute(r))&&o.setAttribute(r,i);n.head.appendChild(o).parentNode.removeChild(o)}function x(e){return null==e?e+"":"object"==typeof e||"function"==typeof e?n[i.call(e)]||"object":typeof e}var t="3.7.1",l=/HTML$/i,ce=function(e,t){return new ce.fn.init(e,t)};function c(e){var t=!!e&&"length"in e&&e.length,n=x(e);return!v(e)&&!y(e)&&("array"===n||0===t||"number"==typeof t&&0<t&&t-1 in e)}function fe(e,t){return e.nodeName&&e.nodeName.toLowerCase()===t.toLowerCase()}ce.fn=ce.prototype={jquery:t,constructor:ce,length:0,toArray:function(){return ae.call(this)},get:function(e){return null==e?ae.call(this):e<0?this[e+this.length]:this[e]},pushStack:function(e){var t=ce.merge(this.constructor(),e);return t.prevObject=this,t},each:function(e){return ce.each(this,e)},map:function(n){return this.pushStack(ce.map(this,function(e,t){return n.call(e,t,e)}))},slice:function(){return this.pushStack(ae.apply(this,arguments))},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},even:function(){return this.pushStack(ce.grep(this,function(e,t){return(t+1)%2}))},odd:function(){return this.pushStack(ce.grep(this,function(e,t){return t%2}))},eq:function(e){var t=this.length,n=+e+(e<0?t:0);return this.pushStack(0<=n&&n<t?[this[n]]:[])},end:function(){return this.prevObject||this.constructor()},push:s,sort:oe.sort,splice:oe.splice},ce.extend=ce.fn.extend=function(){var e,t,n,r,i,o,a=arguments[0]||{},s=1,u=arguments.length,l=!1;for("boolean"==typeof a&&(l=a,a=arguments[s]||{},s++),"object"==typeof a||v(a)||(a={}),s===u&&(a=this,s--);s<u;s++)if(null!=(e=arguments[s]))for(t in e)r=e[t],"__proto__"!==t&&a!==r&&(l&&r&&(ce.isPlainObject(r)||(i=Array.isArray(r)))?(n=a[t],o=i&&!Array.isArray(n)?[]:i||ce.isPlainObject(n)?n:{},i=!1,a[t]=ce.extend(l,o,r)):void 0!==r&&(a[t]=r));return a},ce.extend({expando:"jQuery"+(t+Math.random()).replace(/\D/g,""),isReady:!0,error:function(e){throw new Error(e)},noop:function(){},isPlainObject:function(e){var t,n;return!(!e||"[object Object]"!==i.call(e))&&(!(t=r(e))||"function"==typeof(n=ue.call(t,"constructor")&&t.constructor)&&o.call(n)===a)},isEmptyObject:function(e){var t;for(t in e)return!1;return!0},globalEval:function(e,t,n){m(e,{nonce:t&&t.nonce},n)},each:function(e,t){var n,r=0;if(c(e)){for(n=e.length;r<n;r++)if(!1===t.call(e[r],r,e[r]))break}else for(r in e)if(!1===t.call(e[r],r,e[r]))break;return e},text:function(e){var t,n="",r=0,i=e.nodeType;if(!i)while(t=e[r++])n+=ce.text(t);return 1===i||11===i?e.textContent:9===i?e.documentElement.textContent:3===i||4===i?e.nodeValue:n},makeArray:function(e,t){var n=t||[];return null!=e&&(c(Object(e))?ce.merge(n,"string"==typeof e?[e]:e):s.call(n,e)),n},inArray:function(e,t,n){return null==t?-1:se.call(t,e,n)},isXMLDoc:function(e){var t=e&&e.namespaceURI,n=e&&(e.ownerDocument||e).documentElement;return!l.test(t||n&&n.nodeName||"HTML")},merge:function(e,t){for(var n=+t.length,r=0,i=e.length;r<n;r++)e[i++]=t[r];return e.length=i,e},grep:function(e,t,n){for(var r=[],i=0,o=e.length,a=!n;i<o;i++)!t(e[i],i)!==a&&r.push(e[i]);return r},map:function(e,t,n){var r,i,o=0,a=[];if(c(e))for(r=e.length;o<r;o++)null!=(i=t(e[o],o,n))&&a.push(i);else for(o in e)null!=(i=t(e[o],o,n))&&a.push(i);return g(a)},guid:1,support:le}),"function"==typeof Symbol&&(ce.fn[Symbol.iterator]=oe[Symbol.iterator]),ce.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),function(e,t){n["[object "+t+"]"]=t.toLowerCase()});var pe=oe.pop,de=oe.sort,he=oe.splice,ge="[\\x20\\t\\r\\n\\f]",ve=new RegExp("^"+ge+"+|((?:^|[^\\\\])(?:\\\\.)*)"+ge+"+$","g");ce.contains=function(e,t){var n=t&&t.parentNode;return e===n||!(!n||1!==n.nodeType||!(e.contains?e.contains(n):e.compareDocumentPosition&&16&e.compareDocumentPosition(n)))};var f=/([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;function p(e,t){return t?"\0"===e?"\ufffd":e.slice(0,-1)+"\\"+e.charCodeAt(e.length-1).toString(16)+" ":"\\"+e}ce.escapeSelector=function(e){return(e+"").replace(f,p)};var ye=C,me=s;!function(){var e,b,w,o,a,T,r,C,d,i,k=me,S=ce.expando,E=0,n=0,s=W(),c=W(),u=W(),h=W(),l=function(e,t){return e===t&&(a=!0),0},f="checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",t="(?:\\\\[\\da-fA-F]{1,6}"+ge+"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",p="\\["+ge+"*("+t+")(?:"+ge+"*([*^$|!~]?=)"+ge+"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|("+t+"))|)"+ge+"*\\]",g=":("+t+")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|"+p+")*)|.*)\\)|)",v=new RegExp(ge+"+","g"),y=new RegExp("^"+ge+"*,"+ge+"*"),m=new RegExp("^"+ge+"*([>+~]|"+ge+")"+ge+"*"),x=new RegExp(ge+"|>"),j=new RegExp(g),A=new RegExp("^"+t+"$"),D={ID:new RegExp("^#("+t+")"),CLASS:new RegExp("^\\.("+t+")"),TAG:new RegExp("^("+t+"|[*])"),ATTR:new RegExp("^"+p),PSEUDO:new RegExp("^"+g),CHILD:new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\("+ge+"*(even|odd|(([+-]|)(\\d*)n|)"+ge+"*(?:([+-]|)"+ge+"*(\\d+)|))"+ge+"*\\)|)","i"),bool:new RegExp("^(?:"+f+")$","i"),needsContext:new RegExp("^"+ge+"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\("+ge+"*((?:-\\d)?\\d*)"+ge+"*\\)|)(?=[^-]|$)","i")},N=/^(?:input|select|textarea|button)$/i,q=/^h\d$/i,L=/^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,H=/[+~]/,O=new RegExp("\\\\[\\da-fA-F]{1,6}"+ge+"?|\\\\([^\\r\\n\\f])","g"),P=function(e,t){var n="0x"+e.slice(1)-65536;return t||(n<0?String.fromCharCode(n+65536):String.fromCharCode(n>>10|55296,1023&n|56320))},M=function(){V()},R=J(function(e){return!0===e.disabled&&fe(e,"fieldset")},{dir:"parentNode",next:"legend"});try{k.apply(oe=ae.call(ye.childNodes),ye.childNodes),oe[ye.childNodes.length].nodeType}catch(e){k={apply:function(e,t){me.apply(e,ae.call(t))},call:function(e){me.apply(e,ae.call(arguments,1))}}}function I(t,e,n,r){var i,o,a,s,u,l,c,f=e&&e.ownerDocument,p=e?e.nodeType:9;if(n=n||[],"string"!=typeof t||!t||1!==p&&9!==p&&11!==p)return n;if(!r&&(V(e),e=e||T,C)){if(11!==p&&(u=L.exec(t)))if(i=u[1]){if(9===p){if(!(a=e.getElementById(i)))return n;if(a.id===i)return k.call(n,a),n}else if(f&&(a=f.getElementById(i))&&I.contains(e,a)&&a.id===i)return k.call(n,a),n}else{if(u[2])return k.apply(n,e.getElementsByTagName(t)),n;if((i=u[3])&&e.getElementsByClassName)return k.apply(n,e.getElementsByClassName(i)),n}if(!(h[t+" "]||d&&d.test(t))){if(c=t,f=e,1===p&&(x.test(t)||m.test(t))){(f=H.test(t)&&U(e.parentNode)||e)==e&&le.scope||((s=e.getAttribute("id"))?s=ce.escapeSelector(s):e.setAttribute("id",s=S)),o=(l=Y(t)).length;while(o--)l[o]=(s?"#"+s:":scope")+" "+Q(l[o]);c=l.join(",")}try{return k.apply(n,f.querySelectorAll(c)),n}catch(e){h(t,!0)}finally{s===S&&e.removeAttribute("id")}}}return re(t.replace(ve,"$1"),e,n,r)}function W(){var r=[];return function e(t,n){return r.push(t+" ")>b.cacheLength&&delete e[r.shift()],e[t+" "]=n}}function F(e){return e[S]=!0,e}function $(e){var t=T.createElement("fieldset");try{return!!e(t)}catch(e){return!1}finally{t.parentNode&&t.parentNode.removeChild(t),t=null}}function B(t){return function(e){return fe(e,"input")&&e.type===t}}function _(t){return function(e){return(fe(e,"input")||fe(e,"button"))&&e.type===t}}function z(t){return function(e){return"form"in e?e.parentNode&&!1===e.disabled?"label"in e?"label"in e.parentNode?e.parentNode.disabled===t:e.disabled===t:e.isDisabled===t||e.isDisabled!==!t&&R(e)===t:e.disabled===t:"label"in e&&e.disabled===t}}function X(a){return F(function(o){return o=+o,F(function(e,t){var n,r=a([],e.length,o),i=r.length;while(i--)e[n=r[i]]&&(e[n]=!(t[n]=e[n]))})})}function U(e){return e&&"undefined"!=typeof e.getElementsByTagName&&e}function V(e){var t,n=e?e.ownerDocument||e:ye;return n!=T&&9===n.nodeType&&n.documentElement&&(r=(T=n).documentElement,C=!ce.isXMLDoc(T),i=r.matches||r.webkitMatchesSelector||r.msMatchesSelector,r.msMatchesSelector&&ye!=T&&(t=T.defaultView)&&t.top!==t&&t.addEventListener("unload",M),le.getById=$(function(e){return r.appendChild(e).id=ce.expando,!T.getElementsByName||!T.getElementsByName(ce.expando).length}),le.disconnectedMatch=$(function(e){return i.call(e,"*")}),le.scope=$(function(){return T.querySelectorAll(":scope")}),le.cssHas=$(function(){try{return T.querySelector(":has(*,:jqfake)"),!1}catch(e){return!0}}),le.getById?(b.filter.ID=function(e){var t=e.replace(O,P);return function(e){return e.getAttribute("id")===t}},b.find.ID=function(e,t){if("undefined"!=typeof t.getElementById&&C){var n=t.getElementById(e);return n?[n]:[]}}):(b.filter.ID=function(e){var n=e.replace(O,P);return function(e){var t="undefined"!=typeof e.getAttributeNode&&e.getAttributeNode("id");return t&&t.value===n}},b.find.ID=function(e,t){if("undefined"!=typeof t.getElementById&&C){var n,r,i,o=t.getElementById(e);if(o){if((n=o.getAttributeNode("id"))&&n.value===e)return[o];i=t.getElementsByName(e),r=0;while(o=i[r++])if((n=o.getAttributeNode("id"))&&n.value===e)return[o]}return[]}}),b.find.TAG=function(e,t){return"undefined"!=typeof t.getElementsByTagName?t.getElementsByTagName(e):t.querySelectorAll(e)},b.find.CLASS=function(e,t){if("undefined"!=typeof t.getElementsByClassName&&C)return t.getElementsByClassName(e)},d=[],$(function(e){var t;r.appendChild(e).innerHTML="<a id='"+S+"' href='' disabled='disabled'></a><select id='"+S+"-\r\\' disabled='disabled'><option selected=''></option></select>",e.querySelectorAll("[selected]").length||d.push("\\["+ge+"*(?:value|"+f+")"),e.querySelectorAll("[id~="+S+"-]").length||d.push("~="),e.querySelectorAll("a#"+S+"+*").length||d.push(".#.+[+~]"),e.querySelectorAll(":checked").length||d.push(":checked"),(t=T.createElement("input")).setAttribute("type","hidden"),e.appendChild(t).setAttribute("name","D"),r.appendChild(e).disabled=!0,2!==e.querySelectorAll(":disabled").length&&d.push(":enabled",":disabled"),(t=T.createElement("input")).setAttribute("name",""),e.appendChild(t),e.querySelectorAll("[name='']").length||d.push("\\["+ge+"*name"+ge+"*="+ge+"*(?:''|\"\")")}),le.cssHas||d.push(":has"),d=d.length&&new RegExp(d.join("|")),l=function(e,t){if(e===t)return a=!0,0;var n=!e.compareDocumentPosition-!t.compareDocumentPosition;return n||(1&(n=(e.ownerDocument||e)==(t.ownerDocument||t)?e.compareDocumentPosition(t):1)||!le.sortDetached&&t.compareDocumentPosition(e)===n?e===T||e.ownerDocument==ye&&I.contains(ye,e)?-1:t===T||t.ownerDocument==ye&&I.contains(ye,t)?1:o?se.call(o,e)-se.call(o,t):0:4&n?-1:1)}),T}for(e in I.matches=function(e,t){return I(e,null,null,t)},I.matchesSelector=function(e,t){if(V(e),C&&!h[t+" "]&&(!d||!d.test(t)))try{var n=i.call(e,t);if(n||le.disconnectedMatch||e.document&&11!==e.document.nodeType)return n}catch(e){h(t,!0)}return 0<I(t,T,null,[e]).length},I.contains=function(e,t){return(e.ownerDocument||e)!=T&&V(e),ce.contains(e,t)},I.attr=function(e,t){(e.ownerDocument||e)!=T&&V(e);var n=b.attrHandle[t.toLowerCase()],r=n&&ue.call(b.attrHandle,t.toLowerCase())?n(e,t,!C):void 0;return void 0!==r?r:e.getAttribute(t)},I.error=function(e){throw new Error("Syntax error, unrecognized expression: "+e)},ce.uniqueSort=function(e){var t,n=[],r=0,i=0;if(a=!le.sortStable,o=!le.sortStable&&ae.call(e,0),de.call(e,l),a){while(t=e[i++])t===e[i]&&(r=n.push(i));while(r--)he.call(e,n[r],1)}return o=null,e},ce.fn.uniqueSort=function(){return this.pushStack(ce.uniqueSort(ae.apply(this)))},(b=ce.expr={cacheLength:50,createPseudo:F,match:D,attrHandle:{},find:{},relative:{">":{dir:"parentNode",first:!0}," ":{dir:"parentNode"},"+":{dir:"previousSibling",first:!0},"~":{dir:"previousSibling"}},preFilter:{ATTR:function(e){return e[1]=e[1].replace(O,P),e[3]=(e[3]||e[4]||e[5]||"").replace(O,P),"~="===e[2]&&(e[3]=" "+e[3]+" "),e.slice(0,4)},CHILD:function(e){return e[1]=e[1].toLowerCase(),"nth"===e[1].slice(0,3)?(e[3]||I.error(e[0]),e[4]=+(e[4]?e[5]+(e[6]||1):2*("even"===e[3]||"odd"===e[3])),e[5]=+(e[7]+e[8]||"odd"===e[3])):e[3]&&I.error(e[0]),e},PSEUDO:function(e){var t,n=!e[6]&&e[2];return D.CHILD.test(e[0])?null:(e[3]?e[2]=e[4]||e[5]||"":n&&j.test(n)&&(t=Y(n,!0))&&(t=n.indexOf(")",n.length-t)-n.length)&&(e[0]=e[0].slice(0,t),e[2]=n.slice(0,t)),e.slice(0,3))}},filter:{TAG:function(e){var t=e.replace(O,P).toLowerCase();return"*"===e?function(){return!0}:function(e){return fe(e,t)}},CLASS:function(e){var t=s[e+" "];return t||(t=new RegExp("(^|"+ge+")"+e+"("+ge+"|$)"))&&s(e,function(e){return t.test("string"==typeof e.className&&e.className||"undefined"!=typeof e.getAttribute&&e.getAttribute("class")||"")})},ATTR:function(n,r,i){return function(e){var t=I.attr(e,n);return null==t?"!="===r:!r||(t+="","="===r?t===i:"!="===r?t!==i:"^="===r?i&&0===t.indexOf(i):"*="===r?i&&-1<t.indexOf(i):"$="===r?i&&t.slice(-i.length)===i:"~="===r?-1<(" "+t.replace(v," ")+" ").indexOf(i):"|="===r&&(t===i||t.slice(0,i.length+1)===i+"-"))}},CHILD:function(d,e,t,h,g){var v="nth"!==d.slice(0,3),y="last"!==d.slice(-4),m="of-type"===e;return 1===h&&0===g?function(e){return!!e.parentNode}:function(e,t,n){var r,i,o,a,s,u=v!==y?"nextSibling":"previousSibling",l=e.parentNode,c=m&&e.nodeName.toLowerCase(),f=!n&&!m,p=!1;if(l){if(v){while(u){o=e;while(o=o[u])if(m?fe(o,c):1===o.nodeType)return!1;s=u="only"===d&&!s&&"nextSibling"}return!0}if(s=[y?l.firstChild:l.lastChild],y&&f){p=(a=(r=(i=l[S]||(l[S]={}))[d]||[])[0]===E&&r[1])&&r[2],o=a&&l.childNodes[a];while(o=++a&&o&&o[u]||(p=a=0)||s.pop())if(1===o.nodeType&&++p&&o===e){i[d]=[E,a,p];break}}else if(f&&(p=a=(r=(i=e[S]||(e[S]={}))[d]||[])[0]===E&&r[1]),!1===p)while(o=++a&&o&&o[u]||(p=a=0)||s.pop())if((m?fe(o,c):1===o.nodeType)&&++p&&(f&&((i=o[S]||(o[S]={}))[d]=[E,p]),o===e))break;return(p-=g)===h||p%h==0&&0<=p/h}}},PSEUDO:function(e,o){var t,a=b.pseudos[e]||b.setFilters[e.toLowerCase()]||I.error("unsupported pseudo: "+e);return a[S]?a(o):1<a.length?(t=[e,e,"",o],b.setFilters.hasOwnProperty(e.toLowerCase())?F(function(e,t){var n,r=a(e,o),i=r.length;while(i--)e[n=se.call(e,r[i])]=!(t[n]=r[i])}):function(e){return a(e,0,t)}):a}},pseudos:{not:F(function(e){var r=[],i=[],s=ne(e.replace(ve,"$1"));return s[S]?F(function(e,t,n,r){var i,o=s(e,null,r,[]),a=e.length;while(a--)(i=o[a])&&(e[a]=!(t[a]=i))}):function(e,t,n){return r[0]=e,s(r,null,n,i),r[0]=null,!i.pop()}}),has:F(function(t){return function(e){return 0<I(t,e).length}}),contains:F(function(t){return t=t.replace(O,P),function(e){return-1<(e.textContent||ce.text(e)).indexOf(t)}}),lang:F(function(n){return A.test(n||"")||I.error("unsupported lang: "+n),n=n.replace(O,P).toLowerCase(),function(e){var t;do{if(t=C?e.lang:e.getAttribute("xml:lang")||e.getAttribute("lang"))return(t=t.toLowerCase())===n||0===t.indexOf(n+"-")}while((e=e.parentNode)&&1===e.nodeType);return!1}}),target:function(e){var t=ie.location&&ie.location.hash;return t&&t.slice(1)===e.id},root:function(e){return e===r},focus:function(e){return e===function(){try{return T.activeElement}catch(e){}}()&&T.hasFocus()&&!!(e.type||e.href||~e.tabIndex)},enabled:z(!1),disabled:z(!0),checked:function(e){return fe(e,"input")&&!!e.checked||fe(e,"option")&&!!e.selected},selected:function(e){return e.parentNode&&e.parentNode.selectedIndex,!0===e.selected},empty:function(e){for(e=e.firstChild;e;e=e.nextSibling)if(e.nodeType<6)return!1;return!0},parent:function(e){return!b.pseudos.empty(e)},header:function(e){return q.test(e.nodeName)},input:function(e){return N.test(e.nodeName)},button:function(e){return fe(e,"input")&&"button"===e.type||fe(e,"button")},text:function(e){var t;return fe(e,"input")&&"text"===e.type&&(null==(t=e.getAttribute("type"))||"text"===t.toLowerCase())},first:X(function(){return[0]}),last:X(function(e,t){return[t-1]}),eq:X(function(e,t,n){return[n<0?n+t:n]}),even:X(function(e,t){for(var n=0;n<t;n+=2)e.push(n);return e}),odd:X(function(e,t){for(var n=1;n<t;n+=2)e.push(n);return e}),lt:X(function(e,t,n){var r;for(r=n<0?n+t:t<n?t:n;0<=--r;)e.push(r);return e}),gt:X(function(e,t,n){for(var r=n<0?n+t:n;++r<t;)e.push(r);return e})}}).pseudos.nth=b.pseudos.eq,{radio:!0,checkbox:!0,file:!0,password:!0,image:!0})b.pseudos[e]=B(e);for(e in{submit:!0,reset:!0})b.pseudos[e]=_(e);function G(){}function Y(e,t){var n,r,i,o,a,s,u,l=c[e+" "];if(l)return t?0:l.slice(0);a=e,s=[],u=b.preFilter;while(a){for(o in n&&!(r=y.exec(a))||(r&&(a=a.slice(r[0].length)||a),s.push(i=[])),n=!1,(r=m.exec(a))&&(n=r.shift(),i.push({value:n,type:r[0].replace(ve," ")}),a=a.slice(n.length)),b.filter)!(r=D[o].exec(a))||u[o]&&!(r=u[o](r))||(n=r.shift(),i.push({value:n,type:o,matches:r}),a=a.slice(n.length));if(!n)break}return t?a.length:a?I.error(e):c(e,s).slice(0)}function Q(e){for(var t=0,n=e.length,r="";t<n;t++)r+=e[t].value;return r}function J(a,e,t){var s=e.dir,u=e.next,l=u||s,c=t&&"parentNode"===l,f=n++;return e.first?function(e,t,n){while(e=e[s])if(1===e.nodeType||c)return a(e,t,n);return!1}:function(e,t,n){var r,i,o=[E,f];if(n){while(e=e[s])if((1===e.nodeType||c)&&a(e,t,n))return!0}else while(e=e[s])if(1===e.nodeType||c)if(i=e[S]||(e[S]={}),u&&fe(e,u))e=e[s]||e;else{if((r=i[l])&&r[0]===E&&r[1]===f)return o[2]=r[2];if((i[l]=o)[2]=a(e,t,n))return!0}return!1}}function K(i){return 1<i.length?function(e,t,n){var r=i.length;while(r--)if(!i[r](e,t,n))return!1;return!0}:i[0]}function Z(e,t,n,r,i){for(var o,a=[],s=0,u=e.length,l=null!=t;s<u;s++)(o=e[s])&&(n&&!n(o,r,i)||(a.push(o),l&&t.push(s)));return a}function ee(d,h,g,v,y,e){return v&&!v[S]&&(v=ee(v)),y&&!y[S]&&(y=ee(y,e)),F(function(e,t,n,r){var i,o,a,s,u=[],l=[],c=t.length,f=e||function(e,t,n){for(var r=0,i=t.length;r<i;r++)I(e,t[r],n);return n}(h||"*",n.nodeType?[n]:n,[]),p=!d||!e&&h?f:Z(f,u,d,n,r);if(g?g(p,s=y||(e?d:c||v)?[]:t,n,r):s=p,v){i=Z(s,l),v(i,[],n,r),o=i.length;while(o--)(a=i[o])&&(s[l[o]]=!(p[l[o]]=a))}if(e){if(y||d){if(y){i=[],o=s.length;while(o--)(a=s[o])&&i.push(p[o]=a);y(null,s=[],i,r)}o=s.length;while(o--)(a=s[o])&&-1<(i=y?se.call(e,a):u[o])&&(e[i]=!(t[i]=a))}}else s=Z(s===t?s.splice(c,s.length):s),y?y(null,t,s,r):k.apply(t,s)})}function te(e){for(var i,t,n,r=e.length,o=b.relative[e[0].type],a=o||b.relative[" "],s=o?1:0,u=J(function(e){return e===i},a,!0),l=J(function(e){return-1<se.call(i,e)},a,!0),c=[function(e,t,n){var r=!o&&(n||t!=w)||((i=t).nodeType?u(e,t,n):l(e,t,n));return i=null,r}];s<r;s++)if(t=b.relative[e[s].type])c=[J(K(c),t)];else{if((t=b.filter[e[s].type].apply(null,e[s].matches))[S]){for(n=++s;n<r;n++)if(b.relative[e[n].type])break;return ee(1<s&&K(c),1<s&&Q(e.slice(0,s-1).concat({value:" "===e[s-2].type?"*":""})).replace(ve,"$1"),t,s<n&&te(e.slice(s,n)),n<r&&te(e=e.slice(n)),n<r&&Q(e))}c.push(t)}return K(c)}function ne(e,t){var n,v,y,m,x,r,i=[],o=[],a=u[e+" "];if(!a){t||(t=Y(e)),n=t.length;while(n--)(a=te(t[n]))[S]?i.push(a):o.push(a);(a=u(e,(v=o,m=0<(y=i).length,x=0<v.length,r=function(e,t,n,r,i){var o,a,s,u=0,l="0",c=e&&[],f=[],p=w,d=e||x&&b.find.TAG("*",i),h=E+=null==p?1:Math.random()||.1,g=d.length;for(i&&(w=t==T||t||i);l!==g&&null!=(o=d[l]);l++){if(x&&o){a=0,t||o.ownerDocument==T||(V(o),n=!C);while(s=v[a++])if(s(o,t||T,n)){k.call(r,o);break}i&&(E=h)}m&&((o=!s&&o)&&u--,e&&c.push(o))}if(u+=l,m&&l!==u){a=0;while(s=y[a++])s(c,f,t,n);if(e){if(0<u)while(l--)c[l]||f[l]||(f[l]=pe.call(r));f=Z(f)}k.apply(r,f),i&&!e&&0<f.length&&1<u+y.length&&ce.uniqueSort(r)}return i&&(E=h,w=p),c},m?F(r):r))).selector=e}return a}function re(e,t,n,r){var i,o,a,s,u,l="function"==typeof e&&e,c=!r&&Y(e=l.selector||e);if(n=n||[],1===c.length){if(2<(o=c[0]=c[0].slice(0)).length&&"ID"===(a=o[0]).type&&9===t.nodeType&&C&&b.relative[o[1].type]){if(!(t=(b.find.ID(a.matches[0].replace(O,P),t)||[])[0]))return n;l&&(t=t.parentNode),e=e.slice(o.shift().value.length)}i=D.needsContext.test(e)?0:o.length;while(i--){if(a=o[i],b.relative[s=a.type])break;if((u=b.find[s])&&(r=u(a.matches[0].replace(O,P),H.test(o[0].type)&&U(t.parentNode)||t))){if(o.splice(i,1),!(e=r.length&&Q(o)))return k.apply(n,r),n;break}}}return(l||ne(e,c))(r,t,!C,n,!t||H.test(e)&&U(t.parentNode)||t),n}G.prototype=b.filters=b.pseudos,b.setFilters=new G,le.sortStable=S.split("").sort(l).join("")===S,V(),le.sortDetached=$(function(e){return 1&e.compareDocumentPosition(T.createElement("fieldset"))}),ce.find=I,ce.expr[":"]=ce.expr.pseudos,ce.unique=ce.uniqueSort,I.compile=ne,I.select=re,I.setDocument=V,I.tokenize=Y,I.escape=ce.escapeSelector,I.getText=ce.text,I.isXML=ce.isXMLDoc,I.selectors=ce.expr,I.support=ce.support,I.uniqueSort=ce.uniqueSort}();var d=function(e,t,n){var r=[],i=void 0!==n;while((e=e[t])&&9!==e.nodeType)if(1===e.nodeType){if(i&&ce(e).is(n))break;r.push(e)}return r},h=function(e,t){for(var n=[];e;e=e.nextSibling)1===e.nodeType&&e!==t&&n.push(e);return n},b=ce.expr.match.needsContext,w=/^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;function T(e,n,r){return v(n)?ce.grep(e,function(e,t){return!!n.call(e,t,e)!==r}):n.nodeType?ce.grep(e,function(e){return e===n!==r}):"string"!=typeof n?ce.grep(e,function(e){return-1<se.call(n,e)!==r}):ce.filter(n,e,r)}ce.filter=function(e,t,n){var r=t[0];return n&&(e=":not("+e+")"),1===t.length&&1===r.nodeType?ce.find.matchesSelector(r,e)?[r]:[]:ce.find.matches(e,ce.grep(t,function(e){return 1===e.nodeType}))},ce.fn.extend({find:function(e){var t,n,r=this.length,i=this;if("string"!=typeof e)return this.pushStack(ce(e).filter(function(){for(t=0;t<r;t++)if(ce.contains(i[t],this))return!0}));for(n=this.pushStack([]),t=0;t<r;t++)ce.find(e,i[t],n);return 1<r?ce.uniqueSort(n):n},filter:function(e){return this.pushStack(T(this,e||[],!1))},not:function(e){return this.pushStack(T(this,e||[],!0))},is:function(e){return!!T(this,"string"==typeof e&&b.test(e)?ce(e):e||[],!1).length}});var k,S=/^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;(ce.fn.init=function(e,t,n){var r,i;if(!e)return this;if(n=n||k,"string"==typeof e){if(!(r="<"===e[0]&&">"===e[e.length-1]&&3<=e.length?[null,e,null]:S.exec(e))||!r[1]&&t)return!t||t.jquery?(t||n).find(e):this.constructor(t).find(e);if(r[1]){if(t=t instanceof ce?t[0]:t,ce.merge(this,ce.parseHTML(r[1],t&&t.nodeType?t.ownerDocument||t:C,!0)),w.test(r[1])&&ce.isPlainObject(t))for(r in t)v(this[r])?this[r](t[r]):this.attr(r,t[r]);return this}return(i=C.getElementById(r[2]))&&(this[0]=i,this.length=1),this}return e.nodeType?(this[0]=e,this.length=1,this):v(e)?void 0!==n.ready?n.ready(e):e(ce):ce.makeArray(e,this)}).prototype=ce.fn,k=ce(C);var E=/^(?:parents|prev(?:Until|All))/,j={children:!0,contents:!0,next:!0,prev:!0};function A(e,t){while((e=e[t])&&1!==e.nodeType);return e}ce.fn.extend({has:function(e){var t=ce(e,this),n=t.length;return this.filter(function(){for(var e=0;e<n;e++)if(ce.contains(this,t[e]))return!0})},closest:function(e,t){var n,r=0,i=this.length,o=[],a="string"!=typeof e&&ce(e);if(!b.test(e))for(;r<i;r++)for(n=this[r];n&&n!==t;n=n.parentNode)if(n.nodeType<11&&(a?-1<a.index(n):1===n.nodeType&&ce.find.matchesSelector(n,e))){o.push(n);break}return this.pushStack(1<o.length?ce.uniqueSort(o):o)},index:function(e){return e?"string"==typeof e?se.call(ce(e),this[0]):se.call(this,e.jquery?e[0]:e):this[0]&&this[0].parentNode?this.first().prevAll().length:-1},add:function(e,t){return this.pushStack(ce.uniqueSort(ce.merge(this.get(),ce(e,t))))},addBack:function(e){return this.add(null==e?this.prevObject:this.prevObject.filter(e))}}),ce.each({parent:function(e){var t=e.parentNode;return t&&11!==t.nodeType?t:null},parents:function(e){return d(e,"parentNode")},parentsUntil:function(e,t,n){return d(e,"parentNode",n)},next:function(e){return A(e,"nextSibling")},prev:function(e){return A(e,"previousSibling")},nextAll:function(e){return d(e,"nextSibling")},prevAll:function(e){return d(e,"previousSibling")},nextUntil:function(e,t,n){return d(e,"nextSibling",n)},prevUntil:function(e,t,n){return d(e,"previousSibling",n)},siblings:function(e){return h((e.parentNode||{}).firstChild,e)},children:function(e){return h(e.firstChild)},contents:function(e){return null!=e.contentDocument&&r(e.contentDocument)?e.contentDocument:(fe(e,"template")&&(e=e.content||e),ce.merge([],e.childNodes))}},function(r,i){ce.fn[r]=function(e,t){var n=ce.map(this,i,e);return"Until"!==r.slice(-5)&&(t=e),t&&"string"==typeof t&&(n=ce.filter(t,n)),1<this.length&&(j[r]||ce.uniqueSort(n),E.test(r)&&n.reverse()),this.pushStack(n)}});var D=/[^\x20\t\r\n\f]+/g;function N(e){return e}function q(e){throw e}function L(e,t,n,r){var i;try{e&&v(i=e.promise)?i.call(e).done(t).fail(n):e&&v(i=e.then)?i.call(e,t,n):t.apply(void 0,[e].slice(r))}catch(e){n.apply(void 0,[e])}}ce.Callbacks=function(r){var e,n;r="string"==typeof r?(e=r,n={},ce.each(e.match(D)||[],function(e,t){n[t]=!0}),n):ce.extend({},r);var i,t,o,a,s=[],u=[],l=-1,c=function(){for(a=a||r.once,o=i=!0;u.length;l=-1){t=u.shift();while(++l<s.length)!1===s[l].apply(t[0],t[1])&&r.stopOnFalse&&(l=s.length,t=!1)}r.memory||(t=!1),i=!1,a&&(s=t?[]:"")},f={add:function(){return s&&(t&&!i&&(l=s.length-1,u.push(t)),function n(e){ce.each(e,function(e,t){v(t)?r.unique&&f.has(t)||s.push(t):t&&t.length&&"string"!==x(t)&&n(t)})}(arguments),t&&!i&&c()),this},remove:function(){return ce.each(arguments,function(e,t){var n;while(-1<(n=ce.inArray(t,s,n)))s.splice(n,1),n<=l&&l--}),this},has:function(e){return e?-1<ce.inArray(e,s):0<s.length},empty:function(){return s&&(s=[]),this},disable:function(){return a=u=[],s=t="",this},disabled:function(){return!s},lock:function(){return a=u=[],t||i||(s=t=""),this},locked:function(){return!!a},fireWith:function(e,t){return a||(t=[e,(t=t||[]).slice?t.slice():t],u.push(t),i||c()),this},fire:function(){return f.fireWith(this,arguments),this},fired:function(){return!!o}};return f},ce.extend({Deferred:function(e){var o=[["notify","progress",ce.Callbacks("memory"),ce.Callbacks("memory"),2],["resolve","done",ce.Callbacks("once memory"),ce.Callbacks("once memory"),0,"resolved"],["reject","fail",ce.Callbacks("once memory"),ce.Callbacks("once memory"),1,"rejected"]],i="pending",a={state:function(){return i},always:function(){return s.done(arguments).fail(arguments),this},"catch":function(e){return a.then(null,e)},pipe:function(){var i=arguments;return ce.Deferred(function(r){ce.each(o,function(e,t){var n=v(i[t[4]])&&i[t[4]];s[t[1]](function(){var e=n&&n.apply(this,arguments);e&&v(e.promise)?e.promise().progress(r.notify).done(r.resolve).fail(r.reject):r[t[0]+"With"](this,n?[e]:arguments)})}),i=null}).promise()},then:function(t,n,r){var u=0;function l(i,o,a,s){return function(){var n=this,r=arguments,e=function(){var e,t;if(!(i<u)){if((e=a.apply(n,r))===o.promise())throw new TypeError("Thenable self-resolution");t=e&&("object"==typeof e||"function"==typeof e)&&e.then,v(t)?s?t.call(e,l(u,o,N,s),l(u,o,q,s)):(u++,t.call(e,l(u,o,N,s),l(u,o,q,s),l(u,o,N,o.notifyWith))):(a!==N&&(n=void 0,r=[e]),(s||o.resolveWith)(n,r))}},t=s?e:function(){try{e()}catch(e){ce.Deferred.exceptionHook&&ce.Deferred.exceptionHook(e,t.error),u<=i+1&&(a!==q&&(n=void 0,r=[e]),o.rejectWith(n,r))}};i?t():(ce.Deferred.getErrorHook?t.error=ce.Deferred.getErrorHook():ce.Deferred.getStackHook&&(t.error=ce.Deferred.getStackHook()),ie.setTimeout(t))}}return ce.Deferred(function(e){o[0][3].add(l(0,e,v(r)?r:N,e.notifyWith)),o[1][3].add(l(0,e,v(t)?t:N)),o[2][3].add(l(0,e,v(n)?n:q))}).promise()},promise:function(e){return null!=e?ce.extend(e,a):a}},s={};return ce.each(o,function(e,t){var n=t[2],r=t[5];a[t[1]]=n.add,r&&n.add(function(){i=r},o[3-e][2].disable,o[3-e][3].disable,o[0][2].lock,o[0][3].lock),n.add(t[3].fire),s[t[0]]=function(){return s[t[0]+"With"](this===s?void 0:this,arguments),this},s[t[0]+"With"]=n.fireWith}),a.promise(s),e&&e.call(s,s),s},when:function(e){var n=arguments.length,t=n,r=Array(t),i=ae.call(arguments),o=ce.Deferred(),a=function(t){return function(e){r[t]=this,i[t]=1<arguments.length?ae.call(arguments):e,--n||o.resolveWith(r,i)}};if(n<=1&&(L(e,o.done(a(t)).resolve,o.reject,!n),"pending"===o.state()||v(i[t]&&i[t].then)))return o.then();while(t--)L(i[t],a(t),o.reject);return o.promise()}});var H=/^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;ce.Deferred.exceptionHook=function(e,t){ie.console&&ie.console.warn&&e&&H.test(e.name)&&ie.console.warn("jQuery.Deferred exception: "+e.message,e.stack,t)},ce.readyException=function(e){ie.setTimeout(function(){throw e})};var O=ce.Deferred();function P(){C.removeEventListener("DOMContentLoaded",P),ie.removeEventListener("load",P),ce.ready()}ce.fn.ready=function(e){return O.then(e)["catch"](function(e){ce.readyException(e)}),this},ce.extend({isReady:!1,readyWait:1,ready:function(e){(!0===e?--ce.readyWait:ce.isReady)||(ce.isReady=!0)!==e&&0<--ce.readyWait||O.resolveWith(C,[ce])}}),ce.ready.then=O.then,"complete"===C.readyState||"loading"!==C.readyState&&!C.documentElement.doScroll?ie.setTimeout(ce.ready):(C.addEventListener("DOMContentLoaded",P),ie.addEventListener("load",P));var M=function(e,t,n,r,i,o,a){var s=0,u=e.length,l=null==n;if("object"===x(n))for(s in i=!0,n)M(e,t,s,n[s],!0,o,a);else if(void 0!==r&&(i=!0,v(r)||(a=!0),l&&(a?(t.call(e,r),t=null):(l=t,t=function(e,t,n){return l.call(ce(e),n)})),t))for(;s<u;s++)t(e[s],n,a?r:r.call(e[s],s,t(e[s],n)));return i?e:l?t.call(e):u?t(e[0],n):o},R=/^-ms-/,I=/-([a-z])/g;function W(e,t){return t.toUpperCase()}function F(e){return e.replace(R,"ms-").replace(I,W)}var $=function(e){return 1===e.nodeType||9===e.nodeType||!+e.nodeType};function B(){this.expando=ce.expando+B.uid++}B.uid=1,B.prototype={cache:function(e){var t=e[this.expando];return t||(t={},$(e)&&(e.nodeType?e[this.expando]=t:Object.defineProperty(e,this.expando,{value:t,configurable:!0}))),t},set:function(e,t,n){var r,i=this.cache(e);if("string"==typeof t)i[F(t)]=n;else for(r in t)i[F(r)]=t[r];return i},get:function(e,t){return void 0===t?this.cache(e):e[this.expando]&&e[this.expando][F(t)]},access:function(e,t,n){return void 0===t||t&&"string"==typeof t&&void 0===n?this.get(e,t):(this.set(e,t,n),void 0!==n?n:t)},remove:function(e,t){var n,r=e[this.expando];if(void 0!==r){if(void 0!==t){n=(t=Array.isArray(t)?t.map(F):(t=F(t))in r?[t]:t.match(D)||[]).length;while(n--)delete r[t[n]]}(void 0===t||ce.isEmptyObject(r))&&(e.nodeType?e[this.expando]=void 0:delete e[this.expando])}},hasData:function(e){var t=e[this.expando];return void 0!==t&&!ce.isEmptyObject(t)}};var _=window.$_priv_data=new B,z=window.$_pub_data=new B,X=/^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,U=/[A-Z]/g;function V(e,t,n){var r,i;if(void 0===n&&1===e.nodeType)if(r="data-"+t.replace(U,"-$&").toLowerCase(),"string"==typeof(n=e.getAttribute(r))){try{n="true"===(i=n)||"false"!==i&&("null"===i?null:i===+i+""?+i:X.test(i)?JSON.parse(i):i)}catch(e){}z.set(e,t,n)}else n=void 0;return n}ce.extend({hasData:function(e){return z.hasData(e)||_.hasData(e)},data:function(e,t,n){return z.access(e,t,n)},removeData:function(e,t){z.remove(e,t)},_data:function(e,t,n){return _.access(e,t,n)},_removeData:function(e,t){_.remove(e,t)}}),ce.fn.extend({data:function(n,e){var t,r,i,o=this[0],a=o&&o.attributes;if(void 0===n){if(this.length&&(i=z.get(o),1===o.nodeType&&!_.get(o,"hasDataAttrs"))){t=a.length;while(t--)a[t]&&0===(r=a[t].name).indexOf("data-")&&(r=F(r.slice(5)),V(o,r,i[r]));_.set(o,"hasDataAttrs",!0)}return i}return"object"==typeof n?this.each(function(){z.set(this,n)}):M(this,function(e){var t;if(o&&void 0===e)return void 0!==(t=z.get(o,n))?t:void 0!==(t=V(o,n))?t:void 0;this.each(function(){z.set(this,n,e)})},null,e,1<arguments.length,null,!0)},removeData:function(e){return this.each(function(){z.remove(this,e)})}}),ce.extend({queue:function(e,t,n){var r;if(e)return t=(t||"fx")+"queue",r=_.get(e,t),n&&(!r||Array.isArray(n)?r=_.access(e,t,ce.makeArray(n)):r.push(n)),r||[]},dequeue:function(e,t){t=t||"fx";var n=ce.queue(e,t),r=n.length,i=n.shift(),o=ce._queueHooks(e,t);"inprogress"===i&&(i=n.shift(),r--),i&&("fx"===t&&n.unshift("inprogress"),delete o.stop,i.call(e,function(){ce.dequeue(e,t)},o)),!r&&o&&o.empty.fire()},_queueHooks:function(e,t){var n=t+"queueHooks";return _.get(e,n)||_.access(e,n,{empty:ce.Callbacks("once memory").add(function(){_.remove(e,[t+"queue",n])})})}}),ce.fn.extend({queue:function(t,n){var e=2;return"string"!=typeof t&&(n=t,t="fx",e--),arguments.length<e?ce.queue(this[0],t):void 0===n?this:this.each(function(){var e=ce.queue(this,t,n);ce._queueHooks(this,t),"fx"===t&&"inprogress"!==e[0]&&ce.dequeue(this,t)})},dequeue:function(e){return this.each(function(){ce.dequeue(this,e)})},clearQueue:function(e){return this.queue(e||"fx",[])},promise:function(e,t){var n,r=1,i=ce.Deferred(),o=this,a=this.length,s=function(){--r||i.resolveWith(o,[o])};"string"!=typeof e&&(t=e,e=void 0),e=e||"fx";while(a--)(n=_.get(o[a],e+"queueHooks"))&&n.empty&&(r++,n.empty.add(s));return s(),i.promise(t)}});var G=/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,Y=new RegExp("^(?:([+-])=|)("+G+")([a-z%]*)$","i"),Q=["Top","Right","Bottom","Left"],J=C.documentElement,K=function(e){return ce.contains(e.ownerDocument,e)},Z={composed:!0};J.getRootNode&&(K=function(e){return ce.contains(e.ownerDocument,e)||e.getRootNode(Z)===e.ownerDocument});var ee=function(e,t){return"none"===(e=t||e).style.display||""===e.style.display&&K(e)&&"none"===ce.css(e,"display")};function te(e,t,n,r){var i,o,a=20,s=r?function(){return r.cur()}:function(){return ce.css(e,t,"")},u=s(),l=n&&n[3]||(ce.cssNumber[t]?"":"px"),c=e.nodeType&&(ce.cssNumber[t]||"px"!==l&&+u)&&Y.exec(ce.css(e,t));if(c&&c[3]!==l){u/=2,l=l||c[3],c=+u||1;while(a--)ce.style(e,t,c+l),(1-o)*(1-(o=s()/u||.5))<=0&&(a=0),c/=o;c*=2,ce.style(e,t,c+l),n=n||[]}return n&&(c=+c||+u||0,i=n[1]?c+(n[1]+1)*n[2]:+n[2],r&&(r.unit=l,r.start=c,r.end=i)),i}var ne={};function re(e,t){for(var n,r,i,o,a,s,u,l=[],c=0,f=e.length;c<f;c++)(r=e[c]).style&&(n=r.style.display,t?("none"===n&&(l[c]=_.get(r,"display")||null,l[c]||(r.style.display="")),""===r.style.display&&ee(r)&&(l[c]=(u=a=o=void 0,a=(i=r).ownerDocument,s=i.nodeName,(u=ne[s])||(o=a.body.appendChild(a.createElement(s)),u=ce.css(o,"display"),o.parentNode.removeChild(o),"none"===u&&(u="block"),ne[s]=u)))):"none"!==n&&(l[c]="none",_.set(r,"display",n)));for(c=0;c<f;c++)null!=l[c]&&(e[c].style.display=l[c]);return e}ce.fn.extend({show:function(){return re(this,!0)},hide:function(){return re(this)},toggle:function(e){return"boolean"==typeof e?e?this.show():this.hide():this.each(function(){ee(this)?ce(this).show():ce(this).hide()})}});var xe,be,we=/^(?:checkbox|radio)$/i,Te=/<([a-z][^\/\0>\x20\t\r\n\f]*)/i,Ce=/^$|^module$|\/(?:java|ecma)script/i;xe=C.createDocumentFragment().appendChild(C.createElement("div")),(be=C.createElement("input")).setAttribute("type","radio"),be.setAttribute("checked","checked"),be.setAttribute("name","t"),xe.appendChild(be),le.checkClone=xe.cloneNode(!0).cloneNode(!0).lastChild.checked,xe.innerHTML="<textarea>x</textarea>",le.noCloneChecked=!!xe.cloneNode(!0).lastChild.defaultValue,xe.innerHTML="<option></option>",le.option=!!xe.lastChild;var ke={thead:[1,"<table>","</table>"],col:[2,"<table><colgroup>","</colgroup></table>"],tr:[2,"<table><tbody>","</tbody></table>"],td:[3,"<table><tbody><tr>","</tr></tbody></table>"],_default:[0,"",""]};function Se(e,t){var n;return n="undefined"!=typeof e.getElementsByTagName?e.getElementsByTagName(t||"*"):"undefined"!=typeof e.querySelectorAll?e.querySelectorAll(t||"*"):[],void 0===t||t&&fe(e,t)?ce.merge([e],n):n}function Ee(e,t){for(var n=0,r=e.length;n<r;n++)_.set(e[n],"globalEval",!t||_.get(t[n],"globalEval"))}ke.tbody=ke.tfoot=ke.colgroup=ke.caption=ke.thead,ke.th=ke.td,le.option||(ke.optgroup=ke.option=[1,"<select multiple='multiple'>","</select>"]);var je=/<|&#?\w+;/;function Ae(e,t,n,r,i){for(var o,a,s,u,l,c,f=t.createDocumentFragment(),p=[],d=0,h=e.length;d<h;d++)if((o=e[d])||0===o)if("object"===x(o))ce.merge(p,o.nodeType?[o]:o);else if(je.test(o)){a=a||f.appendChild(t.createElement("div")),s=(Te.exec(o)||["",""])[1].toLowerCase(),u=ke[s]||ke._default,a.innerHTML=u[1]+ce.htmlPrefilter(o)+u[2],c=u[0];while(c--)a=a.lastChild;ce.merge(p,a.childNodes),(a=f.firstChild).textContent=""}else p.push(t.createTextNode(o));f.textContent="",d=0;while(o=p[d++])if(r&&-1<ce.inArray(o,r))i&&i.push(o);else if(l=K(o),a=Se(f.appendChild(o),"script"),l&&Ee(a),n){c=0;while(o=a[c++])Ce.test(o.type||"")&&n.push(o)}return f}var De=/^([^.]*)(?:\.(.+)|)/;function Ne(){return!0}function qe(){return!1}function Le(e,t,n,r,i,o){var a,s;if("object"==typeof t){for(s in"string"!=typeof n&&(r=r||n,n=void 0),t)Le(e,s,n,r,t[s],o);return e}if(null==r&&null==i?(i=n,r=n=void 0):null==i&&("string"==typeof n?(i=r,r=void 0):(i=r,r=n,n=void 0)),!1===i)i=qe;else if(!i)return e;return 1===o&&(a=i,(i=function(e){return ce().off(e),a.apply(this,arguments)}).guid=a.guid||(a.guid=ce.guid++)),e.each(function(){ce.event.add(this,t,i,r,n)})}function He(e,r,t){t?(_.set(e,r,!1),ce.event.add(e,r,{namespace:!1,handler:function(e){var t,n=_.get(this,r);if(1&e.isTrigger&&this[r]){if(n)(ce.event.special[r]||{}).delegateType&&e.stopPropagation();else if(n=ae.call(arguments),_.set(this,r,n),this[r](),t=_.get(this,r),_.set(this,r,!1),n!==t)return e.stopImmediatePropagation(),e.preventDefault(),t}else n&&(_.set(this,r,ce.event.trigger(n[0],n.slice(1),this)),e.stopPropagation(),e.isImmediatePropagationStopped=Ne)}})):void 0===_.get(e,r)&&ce.event.add(e,r,Ne)}ce.event={global:{},add:function(t,e,n,r,i){var o,a,s,u,l,c,f,p,d,h,g,v=_.get(t);if($(t)){n.handler&&(n=(o=n).handler,i=o.selector),i&&ce.find.matchesSelector(J,i),n.guid||(n.guid=ce.guid++),(u=v.events)||(u=v.events=Object.create(null)),(a=v.handle)||(a=v.handle=function(e){return"undefined"!=typeof ce&&ce.event.triggered!==e.type?ce.event.dispatch.apply(t,arguments):void 0}),l=(e=(e||"").match(D)||[""]).length;while(l--)d=g=(s=De.exec(e[l])||[])[1],h=(s[2]||"").split(".").sort(),d&&(f=ce.event.special[d]||{},d=(i?f.delegateType:f.bindType)||d,f=ce.event.special[d]||{},c=ce.extend({type:d,origType:g,data:r,handler:n,guid:n.guid,selector:i,needsContext:i&&ce.expr.match.needsContext.test(i),namespace:h.join(".")},o),(p=u[d])||((p=u[d]=[]).delegateCount=0,f.setup&&!1!==f.setup.call(t,r,h,a)||t.addEventListener&&t.addEventListener(d,a)),f.add&&(f.add.call(t,c),c.handler.guid||(c.handler.guid=n.guid)),i?p.splice(p.delegateCount++,0,c):p.push(c),ce.event.global[d]=!0)}},remove:function(e,t,n,r,i){var o,a,s,u,l,c,f,p,d,h,g,v=_.hasData(e)&&_.get(e);if(v&&(u=v.events)){l=(t=(t||"").match(D)||[""]).length;while(l--)if(d=g=(s=De.exec(t[l])||[])[1],h=(s[2]||"").split(".").sort(),d){f=ce.event.special[d]||{},p=u[d=(r?f.delegateType:f.bindType)||d]||[],s=s[2]&&new RegExp("(^|\\.)"+h.join("\\.(?:.*\\.|)")+"(\\.|$)"),a=o=p.length;while(o--)c=p[o],!i&&g!==c.origType||n&&n.guid!==c.guid||s&&!s.test(c.namespace)||r&&r!==c.selector&&("**"!==r||!c.selector)||(p.splice(o,1),c.selector&&p.delegateCount--,f.remove&&f.remove.call(e,c));a&&!p.length&&(f.teardown&&!1!==f.teardown.call(e,h,v.handle)||ce.removeEvent(e,d,v.handle),delete u[d])}else for(d in u)ce.event.remove(e,d+t[l],n,r,!0);ce.isEmptyObject(u)&&_.remove(e,"handle events")}},dispatch:function(e){var t,n,r,i,o,a,s=new Array(arguments.length),u=ce.event.fix(e),l=(_.get(this,"events")||Object.create(null))[u.type]||[],c=ce.event.special[u.type]||{};for(s[0]=u,t=1;t<arguments.length;t++)s[t]=arguments[t];if(u.delegateTarget=this,!c.preDispatch||!1!==c.preDispatch.call(this,u)){a=ce.event.handlers.call(this,u,l),t=0;while((i=a[t++])&&!u.isPropagationStopped()){u.currentTarget=i.elem,n=0;while((o=i.handlers[n++])&&!u.isImmediatePropagationStopped())u.rnamespace&&!1!==o.namespace&&!u.rnamespace.test(o.namespace)||(u.handleObj=o,u.data=o.data,void 0!==(r=((ce.event.special[o.origType]||{}).handle||o.handler).apply(i.elem,s))&&!1===(u.result=r)&&(u.preventDefault(),u.stopPropagation()))}return c.postDispatch&&c.postDispatch.call(this,u),u.result}},handlers:function(e,t){var n,r,i,o,a,s=[],u=t.delegateCount,l=e.target;if(u&&l.nodeType&&!("click"===e.type&&1<=e.button))for(;l!==this;l=l.parentNode||this)if(1===l.nodeType&&("click"!==e.type||!0!==l.disabled)){for(o=[],a={},n=0;n<u;n++)void 0===a[i=(r=t[n]).selector+" "]&&(a[i]=r.needsContext?-1<ce(i,this).index(l):ce.find(i,this,null,[l]).length),a[i]&&o.push(r);o.length&&s.push({elem:l,handlers:o})}return l=this,u<t.length&&s.push({elem:l,handlers:t.slice(u)}),s},addProp:function(t,e){Object.defineProperty(ce.Event.prototype,t,{enumerable:!0,configurable:!0,get:v(e)?function(){if(this.originalEvent)return e(this.originalEvent)}:function(){if(this.originalEvent)return this.originalEvent[t]},set:function(e){Object.defineProperty(this,t,{enumerable:!0,configurable:!0,writable:!0,value:e})}})},fix:function(e){return e[ce.expando]?e:new ce.Event(e)},special:{load:{noBubble:!0},click:{setup:function(e){var t=this||e;return we.test(t.type)&&t.click&&fe(t,"input")&&He(t,"click",!0),!1},trigger:function(e){var t=this||e;return we.test(t.type)&&t.click&&fe(t,"input")&&He(t,"click"),!0},_default:function(e){var t=e.target;return we.test(t.type)&&t.click&&fe(t,"input")&&_.get(t,"click")||fe(t,"a")}},beforeunload:{postDispatch:function(e){void 0!==e.result&&e.originalEvent&&(e.originalEvent.returnValue=e.result)}}}},ce.removeEvent=function(e,t,n){e.removeEventListener&&e.removeEventListener(t,n)},ce.Event=function(e,t){if(!(this instanceof ce.Event))return new ce.Event(e,t);e&&e.type?(this.originalEvent=e,this.type=e.type,this.isDefaultPrevented=e.defaultPrevented||void 0===e.defaultPrevented&&!1===e.returnValue?Ne:qe,this.target=e.target&&3===e.target.nodeType?e.target.parentNode:e.target,this.currentTarget=e.currentTarget,this.relatedTarget=e.relatedTarget):this.type=e,t&&ce.extend(this,t),this.timeStamp=e&&e.timeStamp||Date.now(),this[ce.expando]=!0},ce.Event.prototype={constructor:ce.Event,isDefaultPrevented:qe,isPropagationStopped:qe,isImmediatePropagationStopped:qe,isSimulated:!1,preventDefault:function(){var e=this.originalEvent;this.isDefaultPrevented=Ne,e&&!this.isSimulated&&e.preventDefault()},stopPropagation:function(){var e=this.originalEvent;this.isPropagationStopped=Ne,e&&!this.isSimulated&&e.stopPropagation()},stopImmediatePropagation:function(){var e=this.originalEvent;this.isImmediatePropagationStopped=Ne,e&&!this.isSimulated&&e.stopImmediatePropagation(),this.stopPropagation()}},ce.each({altKey:!0,bubbles:!0,cancelable:!0,changedTouches:!0,ctrlKey:!0,detail:!0,eventPhase:!0,metaKey:!0,pageX:!0,pageY:!0,shiftKey:!0,view:!0,"char":!0,code:!0,charCode:!0,key:!0,keyCode:!0,button:!0,buttons:!0,clientX:!0,clientY:!0,offsetX:!0,offsetY:!0,pointerId:!0,pointerType:!0,screenX:!0,screenY:!0,targetTouches:!0,toElement:!0,touches:!0,which:!0},ce.event.addProp),ce.each({focus:"focusin",blur:"focusout"},function(r,i){function o(e){if(C.documentMode){var t=_.get(this,"handle"),n=ce.event.fix(e);n.type="focusin"===e.type?"focus":"blur",n.isSimulated=!0,t(e),n.target===n.currentTarget&&t(n)}else ce.event.simulate(i,e.target,ce.event.fix(e))}ce.event.special[r]={setup:function(){var e;if(He(this,r,!0),!C.documentMode)return!1;(e=_.get(this,i))||this.addEventListener(i,o),_.set(this,i,(e||0)+1)},trigger:function(){return He(this,r),!0},teardown:function(){var e;if(!C.documentMode)return!1;(e=_.get(this,i)-1)?_.set(this,i,e):(this.removeEventListener(i,o),_.remove(this,i))},_default:function(e){return _.get(e.target,r)},delegateType:i},ce.event.special[i]={setup:function(){var e=this.ownerDocument||this.document||this,t=C.documentMode?this:e,n=_.get(t,i);n||(C.documentMode?this.addEventListener(i,o):e.addEventListener(r,o,!0)),_.set(t,i,(n||0)+1)},teardown:function(){var e=this.ownerDocument||this.document||this,t=C.documentMode?this:e,n=_.get(t,i)-1;n?_.set(t,i,n):(C.documentMode?this.removeEventListener(i,o):e.removeEventListener(r,o,!0),_.remove(t,i))}}}),ce.each({mouseenter:"mouseover",mouseleave:"mouseout",pointerenter:"pointerover",pointerleave:"pointerout"},function(e,i){ce.event.special[e]={delegateType:i,bindType:i,handle:function(e){var t,n=e.relatedTarget,r=e.handleObj;return n&&(n===this||ce.contains(this,n))||(e.type=r.origType,t=r.handler.apply(this,arguments),e.type=i),t}}}),ce.fn.extend({on:function(e,t,n,r){return Le(this,e,t,n,r)},one:function(e,t,n,r){return Le(this,e,t,n,r,1)},off:function(e,t,n){var r,i;if(e&&e.preventDefault&&e.handleObj)return r=e.handleObj,ce(e.delegateTarget).off(r.namespace?r.origType+"."+r.namespace:r.origType,r.selector,r.handler),this;if("object"==typeof e){for(i in e)this.off(i,t,e[i]);return this}return!1!==t&&"function"!=typeof t||(n=t,t=void 0),!1===n&&(n=qe),this.each(function(){ce.event.remove(this,e,n,t)})}});var Oe=/<script|<style|<link/i,Pe=/checked\s*(?:[^=]|=\s*.checked.)/i,Me=/^\s*<!\[CDATA\[|\]\]>\s*$/g;function Re(e,t){return fe(e,"table")&&fe(11!==t.nodeType?t:t.firstChild,"tr")&&ce(e).children("tbody")[0]||e}function Ie(e){return e.type=(null!==e.getAttribute("type"))+"/"+e.type,e}function We(e){return"true/"===(e.type||"").slice(0,5)?e.type=e.type.slice(5):e.removeAttribute("type"),e}function Fe(e,t){var n,r,i,o,a,s;if(1===t.nodeType){if(_.hasData(e)&&(s=_.get(e).events))for(i in _.remove(t,"handle events"),s)for(n=0,r=s[i].length;n<r;n++)ce.event.add(t,i,s[i][n]);z.hasData(e)&&(o=z.access(e),a=ce.extend({},o),z.set(t,a))}}function $e(n,r,i,o){r=g(r);var e,t,a,s,u,l,c=0,f=n.length,p=f-1,d=r[0],h=v(d);if(h||1<f&&"string"==typeof d&&!le.checkClone&&Pe.test(d))return n.each(function(e){var t=n.eq(e);h&&(r[0]=d.call(this,e,t.html())),$e(t,r,i,o)});if(f&&(t=(e=Ae(r,n[0].ownerDocument,!1,n,o)).firstChild,1===e.childNodes.length&&(e=t),t||o)){for(s=(a=ce.map(Se(e,"script"),Ie)).length;c<f;c++)u=e,c!==p&&(u=ce.clone(u,!0,!0),s&&ce.merge(a,Se(u,"script"))),i.call(n[c],u,c);if(s)for(l=a[a.length-1].ownerDocument,ce.map(a,We),c=0;c<s;c++)u=a[c],Ce.test(u.type||"")&&!_.access(u,"globalEval")&&ce.contains(l,u)&&(u.src&&"module"!==(u.type||"").toLowerCase()?ce._evalUrl&&!u.noModule&&ce._evalUrl(u.src,{nonce:u.nonce||u.getAttribute("nonce")},l):m(u.textContent.replace(Me,""),u,l))}return n}function Be(e,t,n){for(var r,i=t?ce.filter(t,e):e,o=0;null!=(r=i[o]);o++)n||1!==r.nodeType||ce.cleanData(Se(r)),r.parentNode&&(n&&K(r)&&Ee(Se(r,"script")),r.parentNode.removeChild(r));return e}ce.extend({htmlPrefilter:function(e){return e},clone:function(e,t,n){var r,i,o,a,s,u,l,c=e.cloneNode(!0),f=K(e);if(!(le.noCloneChecked||1!==e.nodeType&&11!==e.nodeType||ce.isXMLDoc(e)))for(a=Se(c),r=0,i=(o=Se(e)).length;r<i;r++)s=o[r],u=a[r],void 0,"input"===(l=u.nodeName.toLowerCase())&&we.test(s.type)?u.checked=s.checked:"input"!==l&&"textarea"!==l||(u.defaultValue=s.defaultValue);if(t)if(n)for(o=o||Se(e),a=a||Se(c),r=0,i=o.length;r<i;r++)Fe(o[r],a[r]);else Fe(e,c);return 0<(a=Se(c,"script")).length&&Ee(a,!f&&Se(e,"script")),c},cleanData:function(e){for(var t,n,r,i=ce.event.special,o=0;void 0!==(n=e[o]);o++)if($(n)){if(t=n[_.expando]){if(t.events)for(r in t.events)i[r]?ce.event.remove(n,r):ce.removeEvent(n,r,t.handle);n[_.expando]=void 0}n[z.expando]&&(n[z.expando]=void 0)}}}),ce.fn.extend({detach:function(e){return Be(this,e,!0)},remove:function(e){return Be(this,e)},text:function(e){return M(this,function(e){return void 0===e?ce.text(this):this.empty().each(function(){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||(this.textContent=e)})},null,e,arguments.length)},append:function(){return $e(this,arguments,function(e){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||Re(this,e).appendChild(e)})},prepend:function(){return $e(this,arguments,function(e){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var t=Re(this,e);t.insertBefore(e,t.firstChild)}})},before:function(){return $e(this,arguments,function(e){this.parentNode&&this.parentNode.insertBefore(e,this)})},after:function(){return $e(this,arguments,function(e){this.parentNode&&this.parentNode.insertBefore(e,this.nextSibling)})},empty:function(){for(var e,t=0;null!=(e=this[t]);t++)1===e.nodeType&&(ce.cleanData(Se(e,!1)),e.textContent="");return this},clone:function(e,t){return e=null!=e&&e,t=null==t?e:t,this.map(function(){return ce.clone(this,e,t)})},html:function(e){return M(this,function(e){var t=this[0]||{},n=0,r=this.length;if(void 0===e&&1===t.nodeType)return t.innerHTML;if("string"==typeof e&&!Oe.test(e)&&!ke[(Te.exec(e)||["",""])[1].toLowerCase()]){e=ce.htmlPrefilter(e);try{for(;n<r;n++)1===(t=this[n]||{}).nodeType&&(ce.cleanData(Se(t,!1)),t.innerHTML=e);t=0}catch(e){}}t&&this.empty().append(e)},null,e,arguments.length)},replaceWith:function(){var n=[];return $e(this,arguments,function(e){var t=this.parentNode;ce.inArray(this,n)<0&&(ce.cleanData(Se(this)),t&&t.replaceChild(e,this))},n)}}),ce.each({appendTo:"append",prependTo:"prepend",insertBefore:"before",insertAfter:"after",replaceAll:"replaceWith"},function(e,a){ce.fn[e]=function(e){for(var t,n=[],r=ce(e),i=r.length-1,o=0;o<=i;o++)t=o===i?this:this.clone(!0),ce(r[o])[a](t),s.apply(n,t.get());return this.pushStack(n)}});var _e=new RegExp("^("+G+")(?!px)[a-z%]+$","i"),ze=/^--/,Xe=function(e){var t=e.ownerDocument.defaultView;return t&&t.opener||(t=ie),t.getComputedStyle(e)},Ue=function(e,t,n){var r,i,o={};for(i in t)o[i]=e.style[i],e.style[i]=t[i];for(i in r=n.call(e),t)e.style[i]=o[i];return r},Ve=new RegExp(Q.join("|"),"i");function Ge(e,t,n){var r,i,o,a,s=ze.test(t),u=e.style;return(n=n||Xe(e))&&(a=n.getPropertyValue(t)||n[t],s&&a&&(a=a.replace(ve,"$1")||void 0),""!==a||K(e)||(a=ce.style(e,t)),!le.pixelBoxStyles()&&_e.test(a)&&Ve.test(t)&&(r=u.width,i=u.minWidth,o=u.maxWidth,u.minWidth=u.maxWidth=u.width=a,a=n.width,u.width=r,u.minWidth=i,u.maxWidth=o)),void 0!==a?a+"":a}function Ye(e,t){return{get:function(){if(!e())return(this.get=t).apply(this,arguments);delete this.get}}}!function(){function e(){if(l){u.style.cssText="position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0",l.style.cssText="position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%",J.appendChild(u).appendChild(l);var e=ie.getComputedStyle(l);n="1%"!==e.top,s=12===t(e.marginLeft),l.style.right="60%",o=36===t(e.right),r=36===t(e.width),l.style.position="absolute",i=12===t(l.offsetWidth/3),J.removeChild(u),l=null}}function t(e){return Math.round(parseFloat(e))}var n,r,i,o,a,s,u=C.createElement("div"),l=C.createElement("div");l.style&&(l.style.backgroundClip="content-box",l.cloneNode(!0).style.backgroundClip="",le.clearCloneStyle="content-box"===l.style.backgroundClip,ce.extend(le,{boxSizingReliable:function(){return e(),r},pixelBoxStyles:function(){return e(),o},pixelPosition:function(){return e(),n},reliableMarginLeft:function(){return e(),s},scrollboxSize:function(){return e(),i},reliableTrDimensions:function(){var e,t,n,r;return null==a&&(e=C.createElement("table"),t=C.createElement("tr"),n=C.createElement("div"),e.style.cssText="position:absolute;left:-11111px;border-collapse:separate",t.style.cssText="box-sizing:content-box;border:1px solid",t.style.height="1px",n.style.height="9px",n.style.display="block",J.appendChild(e).appendChild(t).appendChild(n),r=ie.getComputedStyle(t),a=parseInt(r.height,10)+parseInt(r.borderTopWidth,10)+parseInt(r.borderBottomWidth,10)===t.offsetHeight,J.removeChild(e)),a}}))}();var Qe=["Webkit","Moz","ms"],Je=C.createElement("div").style,Ke={};function Ze(e){var t=ce.cssProps[e]||Ke[e];return t||(e in Je?e:Ke[e]=function(e){var t=e[0].toUpperCase()+e.slice(1),n=Qe.length;while(n--)if((e=Qe[n]+t)in Je)return e}(e)||e)}var et=/^(none|table(?!-c[ea]).+)/,tt={position:"absolute",visibility:"hidden",display:"block"},nt={letterSpacing:"0",fontWeight:"400"};function rt(e,t,n){var r=Y.exec(t);return r?Math.max(0,r[2]-(n||0))+(r[3]||"px"):t}function it(e,t,n,r,i,o){var a="width"===t?1:0,s=0,u=0,l=0;if(n===(r?"border":"content"))return 0;for(;a<4;a+=2)"margin"===n&&(l+=ce.css(e,n+Q[a],!0,i)),r?("content"===n&&(u-=ce.css(e,"padding"+Q[a],!0,i)),"margin"!==n&&(u-=ce.css(e,"border"+Q[a]+"Width",!0,i))):(u+=ce.css(e,"padding"+Q[a],!0,i),"padding"!==n?u+=ce.css(e,"border"+Q[a]+"Width",!0,i):s+=ce.css(e,"border"+Q[a]+"Width",!0,i));return!r&&0<=o&&(u+=Math.max(0,Math.ceil(e["offset"+t[0].toUpperCase()+t.slice(1)]-o-u-s-.5))||0),u+l}function ot(e,t,n){var r=Xe(e),i=(!le.boxSizingReliable()||n)&&"border-box"===ce.css(e,"boxSizing",!1,r),o=i,a=Ge(e,t,r),s="offset"+t[0].toUpperCase()+t.slice(1);if(_e.test(a)){if(!n)return a;a="auto"}return(!le.boxSizingReliable()&&i||!le.reliableTrDimensions()&&fe(e,"tr")||"auto"===a||!parseFloat(a)&&"inline"===ce.css(e,"display",!1,r))&&e.getClientRects().length&&(i="border-box"===ce.css(e,"boxSizing",!1,r),(o=s in e)&&(a=e[s])),(a=parseFloat(a)||0)+it(e,t,n||(i?"border":"content"),o,r,a)+"px"}function at(e,t,n,r,i){return new at.prototype.init(e,t,n,r,i)}ce.extend({cssHooks:{opacity:{get:function(e,t){if(t){var n=Ge(e,"opacity");return""===n?"1":n}}}},cssNumber:{animationIterationCount:!0,aspectRatio:!0,borderImageSlice:!0,columnCount:!0,flexGrow:!0,flexShrink:!0,fontWeight:!0,gridArea:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnStart:!0,gridRow:!0,gridRowEnd:!0,gridRowStart:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,scale:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeMiterlimit:!0,strokeOpacity:!0},cssProps:{},style:function(e,t,n,r){if(e&&3!==e.nodeType&&8!==e.nodeType&&e.style){var i,o,a,s=F(t),u=ze.test(t),l=e.style;if(u||(t=Ze(s)),a=ce.cssHooks[t]||ce.cssHooks[s],void 0===n)return a&&"get"in a&&void 0!==(i=a.get(e,!1,r))?i:l[t];"string"===(o=typeof n)&&(i=Y.exec(n))&&i[1]&&(n=te(e,t,i),o="number"),null!=n&&n==n&&("number"!==o||u||(n+=i&&i[3]||(ce.cssNumber[s]?"":"px")),le.clearCloneStyle||""!==n||0!==t.indexOf("background")||(l[t]="inherit"),a&&"set"in a&&void 0===(n=a.set(e,n,r))||(u?l.setProperty(t,n):l[t]=n))}},css:function(e,t,n,r){var i,o,a,s=F(t);return ze.test(t)||(t=Ze(s)),(a=ce.cssHooks[t]||ce.cssHooks[s])&&"get"in a&&(i=a.get(e,!0,n)),void 0===i&&(i=Ge(e,t,r)),"normal"===i&&t in nt&&(i=nt[t]),""===n||n?(o=parseFloat(i),!0===n||isFinite(o)?o||0:i):i}}),ce.each(["height","width"],function(e,u){ce.cssHooks[u]={get:function(e,t,n){if(t)return!et.test(ce.css(e,"display"))||e.getClientRects().length&&e.getBoundingClientRect().width?ot(e,u,n):Ue(e,tt,function(){return ot(e,u,n)})},set:function(e,t,n){var r,i=Xe(e),o=!le.scrollboxSize()&&"absolute"===i.position,a=(o||n)&&"border-box"===ce.css(e,"boxSizing",!1,i),s=n?it(e,u,n,a,i):0;return a&&o&&(s-=Math.ceil(e["offset"+u[0].toUpperCase()+u.slice(1)]-parseFloat(i[u])-it(e,u,"border",!1,i)-.5)),s&&(r=Y.exec(t))&&"px"!==(r[3]||"px")&&(e.style[u]=t,t=ce.css(e,u)),rt(0,t,s)}}}),ce.cssHooks.marginLeft=Ye(le.reliableMarginLeft,function(e,t){if(t)return(parseFloat(Ge(e,"marginLeft"))||e.getBoundingClientRect().left-Ue(e,{marginLeft:0},function(){return e.getBoundingClientRect().left}))+"px"}),ce.each({margin:"",padding:"",border:"Width"},function(i,o){ce.cssHooks[i+o]={expand:function(e){for(var t=0,n={},r="string"==typeof e?e.split(" "):[e];t<4;t++)n[i+Q[t]+o]=r[t]||r[t-2]||r[0];return n}},"margin"!==i&&(ce.cssHooks[i+o].set=rt)}),ce.fn.extend({css:function(e,t){return M(this,function(e,t,n){var r,i,o={},a=0;if(Array.isArray(t)){for(r=Xe(e),i=t.length;a<i;a++)o[t[a]]=ce.css(e,t[a],!1,r);return o}return void 0!==n?ce.style(e,t,n):ce.css(e,t)},e,t,1<arguments.length)}}),((ce.Tween=at).prototype={constructor:at,init:function(e,t,n,r,i,o){this.elem=e,this.prop=n,this.easing=i||ce.easing._default,this.options=t,this.start=this.now=this.cur(),this.end=r,this.unit=o||(ce.cssNumber[n]?"":"px")},cur:function(){var e=at.propHooks[this.prop];return e&&e.get?e.get(this):at.propHooks._default.get(this)},run:function(e){var t,n=at.propHooks[this.prop];return this.options.duration?this.pos=t=ce.easing[this.easing](e,this.options.duration*e,0,1,this.options.duration):this.pos=t=e,this.now=(this.end-this.start)*t+this.start,this.options.step&&this.options.step.call(this.elem,this.now,this),n&&n.set?n.set(this):at.propHooks._default.set(this),this}}).init.prototype=at.prototype,(at.propHooks={_default:{get:function(e){var t;return 1!==e.elem.nodeType||null!=e.elem[e.prop]&&null==e.elem.style[e.prop]?e.elem[e.prop]:(t=ce.css(e.elem,e.prop,""))&&"auto"!==t?t:0},set:function(e){ce.fx.step[e.prop]?ce.fx.step[e.prop](e):1!==e.elem.nodeType||!ce.cssHooks[e.prop]&&null==e.elem.style[Ze(e.prop)]?e.elem[e.prop]=e.now:ce.style(e.elem,e.prop,e.now+e.unit)}}}).scrollTop=at.propHooks.scrollLeft={set:function(e){e.elem.nodeType&&e.elem.parentNode&&(e.elem[e.prop]=e.now)}},ce.easing={linear:function(e){return e},swing:function(e){return.5-Math.cos(e*Math.PI)/2},_default:"swing"},ce.fx=at.prototype.init,ce.fx.step={};var st,ut,lt,ct,ft=/^(?:toggle|show|hide)$/,pt=/queueHooks$/;function dt(){ut&&(!1===C.hidden&&ie.requestAnimationFrame?ie.requestAnimationFrame(dt):ie.setTimeout(dt,ce.fx.interval),ce.fx.tick())}function ht(){return ie.setTimeout(function(){st=void 0}),st=Date.now()}function gt(e,t){var n,r=0,i={height:e};for(t=t?1:0;r<4;r+=2-t)i["margin"+(n=Q[r])]=i["padding"+n]=e;return t&&(i.opacity=i.width=e),i}function vt(e,t,n){for(var r,i=(yt.tweeners[t]||[]).concat(yt.tweeners["*"]),o=0,a=i.length;o<a;o++)if(r=i[o].call(n,t,e))return r}function yt(o,e,t){var n,a,r=0,i=yt.prefilters.length,s=ce.Deferred().always(function(){delete u.elem}),u=function(){if(a)return!1;for(var e=st||ht(),t=Math.max(0,l.startTime+l.duration-e),n=1-(t/l.duration||0),r=0,i=l.tweens.length;r<i;r++)l.tweens[r].run(n);return s.notifyWith(o,[l,n,t]),n<1&&i?t:(i||s.notifyWith(o,[l,1,0]),s.resolveWith(o,[l]),!1)},l=s.promise({elem:o,props:ce.extend({},e),opts:ce.extend(!0,{specialEasing:{},easing:ce.easing._default},t),originalProperties:e,originalOptions:t,startTime:st||ht(),duration:t.duration,tweens:[],createTween:function(e,t){var n=ce.Tween(o,l.opts,e,t,l.opts.specialEasing[e]||l.opts.easing);return l.tweens.push(n),n},stop:function(e){var t=0,n=e?l.tweens.length:0;if(a)return this;for(a=!0;t<n;t++)l.tweens[t].run(1);return e?(s.notifyWith(o,[l,1,0]),s.resolveWith(o,[l,e])):s.rejectWith(o,[l,e]),this}}),c=l.props;for(!function(e,t){var n,r,i,o,a;for(n in e)if(i=t[r=F(n)],o=e[n],Array.isArray(o)&&(i=o[1],o=e[n]=o[0]),n!==r&&(e[r]=o,delete e[n]),(a=ce.cssHooks[r])&&"expand"in a)for(n in o=a.expand(o),delete e[r],o)n in e||(e[n]=o[n],t[n]=i);else t[r]=i}(c,l.opts.specialEasing);r<i;r++)if(n=yt.prefilters[r].call(l,o,c,l.opts))return v(n.stop)&&(ce._queueHooks(l.elem,l.opts.queue).stop=n.stop.bind(n)),n;return ce.map(c,vt,l),v(l.opts.start)&&l.opts.start.call(o,l),l.progress(l.opts.progress).done(l.opts.done,l.opts.complete).fail(l.opts.fail).always(l.opts.always),ce.fx.timer(ce.extend(u,{elem:o,anim:l,queue:l.opts.queue})),l}ce.Animation=ce.extend(yt,{tweeners:{"*":[function(e,t){var n=this.createTween(e,t);return te(n.elem,e,Y.exec(t),n),n}]},tweener:function(e,t){v(e)?(t=e,e=["*"]):e=e.match(D);for(var n,r=0,i=e.length;r<i;r++)n=e[r],yt.tweeners[n]=yt.tweeners[n]||[],yt.tweeners[n].unshift(t)},prefilters:[function(e,t,n){var r,i,o,a,s,u,l,c,f="width"in t||"height"in t,p=this,d={},h=e.style,g=e.nodeType&&ee(e),v=_.get(e,"fxshow");for(r in n.queue||(null==(a=ce._queueHooks(e,"fx")).unqueued&&(a.unqueued=0,s=a.empty.fire,a.empty.fire=function(){a.unqueued||s()}),a.unqueued++,p.always(function(){p.always(function(){a.unqueued--,ce.queue(e,"fx").length||a.empty.fire()})})),t)if(i=t[r],ft.test(i)){if(delete t[r],o=o||"toggle"===i,i===(g?"hide":"show")){if("show"!==i||!v||void 0===v[r])continue;g=!0}d[r]=v&&v[r]||ce.style(e,r)}if((u=!ce.isEmptyObject(t))||!ce.isEmptyObject(d))for(r in f&&1===e.nodeType&&(n.overflow=[h.overflow,h.overflowX,h.overflowY],null==(l=v&&v.display)&&(l=_.get(e,"display")),"none"===(c=ce.css(e,"display"))&&(l?c=l:(re([e],!0),l=e.style.display||l,c=ce.css(e,"display"),re([e]))),("inline"===c||"inline-block"===c&&null!=l)&&"none"===ce.css(e,"float")&&(u||(p.done(function(){h.display=l}),null==l&&(c=h.display,l="none"===c?"":c)),h.display="inline-block")),n.overflow&&(h.overflow="hidden",p.always(function(){h.overflow=n.overflow[0],h.overflowX=n.overflow[1],h.overflowY=n.overflow[2]})),u=!1,d)u||(v?"hidden"in v&&(g=v.hidden):v=_.access(e,"fxshow",{display:l}),o&&(v.hidden=!g),g&&re([e],!0),p.done(function(){for(r in g||re([e]),_.remove(e,"fxshow"),d)ce.style(e,r,d[r])})),u=vt(g?v[r]:0,r,p),r in v||(v[r]=u.start,g&&(u.end=u.start,u.start=0))}],prefilter:function(e,t){t?yt.prefilters.unshift(e):yt.prefilters.push(e)}}),ce.speed=function(e,t,n){var r=e&&"object"==typeof e?ce.extend({},e):{complete:n||!n&&t||v(e)&&e,duration:e,easing:n&&t||t&&!v(t)&&t};return ce.fx.off?r.duration=0:"number"!=typeof r.duration&&(r.duration in ce.fx.speeds?r.duration=ce.fx.speeds[r.duration]:r.duration=ce.fx.speeds._default),null!=r.queue&&!0!==r.queue||(r.queue="fx"),r.old=r.complete,r.complete=function(){v(r.old)&&r.old.call(this),r.queue&&ce.dequeue(this,r.queue)},r},ce.fn.extend({fadeTo:function(e,t,n,r){return this.filter(ee).css("opacity",0).show().end().animate({opacity:t},e,n,r)},animate:function(t,e,n,r){var i=ce.isEmptyObject(t),o=ce.speed(e,n,r),a=function(){var e=yt(this,ce.extend({},t),o);(i||_.get(this,"finish"))&&e.stop(!0)};return a.finish=a,i||!1===o.queue?this.each(a):this.queue(o.queue,a)},stop:function(i,e,o){var a=function(e){var t=e.stop;delete e.stop,t(o)};return"string"!=typeof i&&(o=e,e=i,i=void 0),e&&this.queue(i||"fx",[]),this.each(function(){var e=!0,t=null!=i&&i+"queueHooks",n=ce.timers,r=_.get(this);if(t)r[t]&&r[t].stop&&a(r[t]);else for(t in r)r[t]&&r[t].stop&&pt.test(t)&&a(r[t]);for(t=n.length;t--;)n[t].elem!==this||null!=i&&n[t].queue!==i||(n[t].anim.stop(o),e=!1,n.splice(t,1));!e&&o||ce.dequeue(this,i)})},finish:function(a){return!1!==a&&(a=a||"fx"),this.each(function(){var e,t=_.get(this),n=t[a+"queue"],r=t[a+"queueHooks"],i=ce.timers,o=n?n.length:0;for(t.finish=!0,ce.queue(this,a,[]),r&&r.stop&&r.stop.call(this,!0),e=i.length;e--;)i[e].elem===this&&i[e].queue===a&&(i[e].anim.stop(!0),i.splice(e,1));for(e=0;e<o;e++)n[e]&&n[e].finish&&n[e].finish.call(this);delete t.finish})}}),ce.each(["toggle","show","hide"],function(e,r){var i=ce.fn[r];ce.fn[r]=function(e,t,n){return null==e||"boolean"==typeof e?i.apply(this,arguments):this.animate(gt(r,!0),e,t,n)}}),ce.each({slideDown:gt("show"),slideUp:gt("hide"),slideToggle:gt("toggle"),fadeIn:{opacity:"show"},fadeOut:{opacity:"hide"},fadeToggle:{opacity:"toggle"}},function(e,r){ce.fn[e]=function(e,t,n){return this.animate(r,e,t,n)}}),ce.timers=[],ce.fx.tick=function(){var e,t=0,n=ce.timers;for(st=Date.now();t<n.length;t++)(e=n[t])()||n[t]!==e||n.splice(t--,1);n.length||ce.fx.stop(),st=void 0},ce.fx.timer=function(e){ce.timers.push(e),ce.fx.start()},ce.fx.interval=13,ce.fx.start=function(){ut||(ut=!0,dt())},ce.fx.stop=function(){ut=null},ce.fx.speeds={slow:600,fast:200,_default:400},ce.fn.delay=function(r,e){return r=ce.fx&&ce.fx.speeds[r]||r,e=e||"fx",this.queue(e,function(e,t){var n=ie.setTimeout(e,r);t.stop=function(){ie.clearTimeout(n)}})},lt=C.createElement("input"),ct=C.createElement("select").appendChild(C.createElement("option")),lt.type="checkbox",le.checkOn=""!==lt.value,le.optSelected=ct.selected,(lt=C.createElement("input")).value="t",lt.type="radio",le.radioValue="t"===lt.value;var mt,xt=ce.expr.attrHandle;ce.fn.extend({attr:function(e,t){return M(this,ce.attr,e,t,1<arguments.length)},removeAttr:function(e){return this.each(function(){ce.removeAttr(this,e)})}}),ce.extend({attr:function(e,t,n){var r,i,o=e.nodeType;if(3!==o&&8!==o&&2!==o)return"undefined"==typeof e.getAttribute?ce.prop(e,t,n):(1===o&&ce.isXMLDoc(e)||(i=ce.attrHooks[t.toLowerCase()]||(ce.expr.match.bool.test(t)?mt:void 0)),void 0!==n?null===n?void ce.removeAttr(e,t):i&&"set"in i&&void 0!==(r=i.set(e,n,t))?r:(e.setAttribute(t,n+""),n):i&&"get"in i&&null!==(r=i.get(e,t))?r:null==(r=ce.find.attr(e,t))?void 0:r)},attrHooks:{type:{set:function(e,t){if(!le.radioValue&&"radio"===t&&fe(e,"input")){var n=e.value;return e.setAttribute("type",t),n&&(e.value=n),t}}}},removeAttr:function(e,t){var n,r=0,i=t&&t.match(D);if(i&&1===e.nodeType)while(n=i[r++])e.removeAttribute(n)}}),mt={set:function(e,t,n){return!1===t?ce.removeAttr(e,n):e.setAttribute(n,n),n}},ce.each(ce.expr.match.bool.source.match(/\w+/g),function(e,t){var a=xt[t]||ce.find.attr;xt[t]=function(e,t,n){var r,i,o=t.toLowerCase();return n||(i=xt[o],xt[o]=r,r=null!=a(e,t,n)?o:null,xt[o]=i),r}});var bt=/^(?:input|select|textarea|button)$/i,wt=/^(?:a|area)$/i;function Tt(e){return(e.match(D)||[]).join(" ")}function Ct(e){return e.getAttribute&&e.getAttribute("class")||""}function kt(e){return Array.isArray(e)?e:"string"==typeof e&&e.match(D)||[]}ce.fn.extend({prop:function(e,t){return M(this,ce.prop,e,t,1<arguments.length)},removeProp:function(e){return this.each(function(){delete this[ce.propFix[e]||e]})}}),ce.extend({prop:function(e,t,n){var r,i,o=e.nodeType;if(3!==o&&8!==o&&2!==o)return 1===o&&ce.isXMLDoc(e)||(t=ce.propFix[t]||t,i=ce.propHooks[t]),void 0!==n?i&&"set"in i&&void 0!==(r=i.set(e,n,t))?r:e[t]=n:i&&"get"in i&&null!==(r=i.get(e,t))?r:e[t]},propHooks:{tabIndex:{get:function(e){var t=ce.find.attr(e,"tabindex");return t?parseInt(t,10):bt.test(e.nodeName)||wt.test(e.nodeName)&&e.href?0:-1}}},propFix:{"for":"htmlFor","class":"className"}}),le.optSelected||(ce.propHooks.selected={get:function(e){var t=e.parentNode;return t&&t.parentNode&&t.parentNode.selectedIndex,null},set:function(e){var t=e.parentNode;t&&(t.selectedIndex,t.parentNode&&t.parentNode.selectedIndex)}}),ce.each(["tabIndex","readOnly","maxLength","cellSpacing","cellPadding","rowSpan","colSpan","useMap","frameBorder","contentEditable"],function(){ce.propFix[this.toLowerCase()]=this}),ce.fn.extend({addClass:function(t){var e,n,r,i,o,a;return v(t)?this.each(function(e){ce(this).addClass(t.call(this,e,Ct(this)))}):(e=kt(t)).length?this.each(function(){if(r=Ct(this),n=1===this.nodeType&&" "+Tt(r)+" "){for(o=0;o<e.length;o++)i=e[o],n.indexOf(" "+i+" ")<0&&(n+=i+" ");a=Tt(n),r!==a&&this.setAttribute("class",a)}}):this},removeClass:function(t){var e,n,r,i,o,a;return v(t)?this.each(function(e){ce(this).removeClass(t.call(this,e,Ct(this)))}):arguments.length?(e=kt(t)).length?this.each(function(){if(r=Ct(this),n=1===this.nodeType&&" "+Tt(r)+" "){for(o=0;o<e.length;o++){i=e[o];while(-1<n.indexOf(" "+i+" "))n=n.replace(" "+i+" "," ")}a=Tt(n),r!==a&&this.setAttribute("class",a)}}):this:this.attr("class","")},toggleClass:function(t,n){var e,r,i,o,a=typeof t,s="string"===a||Array.isArray(t);return v(t)?this.each(function(e){ce(this).toggleClass(t.call(this,e,Ct(this),n),n)}):"boolean"==typeof n&&s?n?this.addClass(t):this.removeClass(t):(e=kt(t),this.each(function(){if(s)for(o=ce(this),i=0;i<e.length;i++)r=e[i],o.hasClass(r)?o.removeClass(r):o.addClass(r);else void 0!==t&&"boolean"!==a||((r=Ct(this))&&_.set(this,"__className__",r),this.setAttribute&&this.setAttribute("class",r||!1===t?"":_.get(this,"__className__")||""))}))},hasClass:function(e){var t,n,r=0;t=" "+e+" ";while(n=this[r++])if(1===n.nodeType&&-1<(" "+Tt(Ct(n))+" ").indexOf(t))return!0;return!1}});var St=/\r/g;ce.fn.extend({val:function(n){var r,e,i,t=this[0];return arguments.length?(i=v(n),this.each(function(e){var t;1===this.nodeType&&(null==(t=i?n.call(this,e,ce(this).val()):n)?t="":"number"==typeof t?t+="":Array.isArray(t)&&(t=ce.map(t,function(e){return null==e?"":e+""})),(r=ce.valHooks[this.type]||ce.valHooks[this.nodeName.toLowerCase()])&&"set"in r&&void 0!==r.set(this,t,"value")||(this.value=t))})):t?(r=ce.valHooks[t.type]||ce.valHooks[t.nodeName.toLowerCase()])&&"get"in r&&void 0!==(e=r.get(t,"value"))?e:"string"==typeof(e=t.value)?e.replace(St,""):null==e?"":e:void 0}}),ce.extend({valHooks:{option:{get:function(e){var t=ce.find.attr(e,"value");return null!=t?t:Tt(ce.text(e))}},select:{get:function(e){var t,n,r,i=e.options,o=e.selectedIndex,a="select-one"===e.type,s=a?null:[],u=a?o+1:i.length;for(r=o<0?u:a?o:0;r<u;r++)if(((n=i[r]).selected||r===o)&&!n.disabled&&(!n.parentNode.disabled||!fe(n.parentNode,"optgroup"))){if(t=ce(n).val(),a)return t;s.push(t)}return s},set:function(e,t){var n,r,i=e.options,o=ce.makeArray(t),a=i.length;while(a--)((r=i[a]).selected=-1<ce.inArray(ce.valHooks.option.get(r),o))&&(n=!0);return n||(e.selectedIndex=-1),o}}}}),ce.each(["radio","checkbox"],function(){ce.valHooks[this]={set:function(e,t){if(Array.isArray(t))return e.checked=-1<ce.inArray(ce(e).val(),t)}},le.checkOn||(ce.valHooks[this].get=function(e){return null===e.getAttribute("value")?"on":e.value})});var Et=ie.location,jt={guid:Date.now()},At=/\?/;ce.parseXML=function(e){var t,n;if(!e||"string"!=typeof e)return null;try{t=(new ie.DOMParser).parseFromString(e,"text/xml")}catch(e){}return n=t&&t.getElementsByTagName("parsererror")[0],t&&!n||ce.error("Invalid XML: "+(n?ce.map(n.childNodes,function(e){return e.textContent}).join("\n"):e)),t};var Dt=/^(?:focusinfocus|focusoutblur)$/,Nt=function(e){e.stopPropagation()};ce.extend(ce.event,{trigger:function(e,t,n,r){var i,o,a,s,u,l,c,f,p=[n||C],d=ue.call(e,"type")?e.type:e,h=ue.call(e,"namespace")?e.namespace.split("."):[];if(o=f=a=n=n||C,3!==n.nodeType&&8!==n.nodeType&&!Dt.test(d+ce.event.triggered)&&(-1<d.indexOf(".")&&(d=(h=d.split(".")).shift(),h.sort()),u=d.indexOf(":")<0&&"on"+d,(e=e[ce.expando]?e:new ce.Event(d,"object"==typeof e&&e)).isTrigger=r?2:3,e.namespace=h.join("."),e.rnamespace=e.namespace?new RegExp("(^|\\.)"+h.join("\\.(?:.*\\.|)")+"(\\.|$)"):null,e.result=void 0,e.target||(e.target=n),t=null==t?[e]:ce.makeArray(t,[e]),c=ce.event.special[d]||{},r||!c.trigger||!1!==c.trigger.apply(n,t))){if(!r&&!c.noBubble&&!y(n)){for(s=c.delegateType||d,Dt.test(s+d)||(o=o.parentNode);o;o=o.parentNode)p.push(o),a=o;a===(n.ownerDocument||C)&&p.push(a.defaultView||a.parentWindow||ie)}i=0;while((o=p[i++])&&!e.isPropagationStopped())f=o,e.type=1<i?s:c.bindType||d,(l=(_.get(o,"events")||Object.create(null))[e.type]&&_.get(o,"handle"))&&l.apply(o,t),(l=u&&o[u])&&l.apply&&$(o)&&(e.result=l.apply(o,t),!1===e.result&&e.preventDefault());return e.type=d,r||e.isDefaultPrevented()||c._default&&!1!==c._default.apply(p.pop(),t)||!$(n)||u&&v(n[d])&&!y(n)&&((a=n[u])&&(n[u]=null),ce.event.triggered=d,e.isPropagationStopped()&&f.addEventListener(d,Nt),n[d](),e.isPropagationStopped()&&f.removeEventListener(d,Nt),ce.event.triggered=void 0,a&&(n[u]=a)),e.result}},simulate:function(e,t,n){var r=ce.extend(new ce.Event,n,{type:e,isSimulated:!0});ce.event.trigger(r,null,t)}}),ce.fn.extend({trigger:function(e,t){return this.each(function(){ce.event.trigger(e,t,this)})},triggerHandler:function(e,t){var n=this[0];if(n)return ce.event.trigger(e,t,n,!0)}});var qt=/\[\]$/,Lt=/\r?\n/g,Ht=/^(?:submit|button|image|reset|file)$/i,Ot=/^(?:input|select|textarea|keygen)/i;function Pt(n,e,r,i){var t;if(Array.isArray(e))ce.each(e,function(e,t){r||qt.test(n)?i(n,t):Pt(n+"["+("object"==typeof t&&null!=t?e:"")+"]",t,r,i)});else if(r||"object"!==x(e))i(n,e);else for(t in e)Pt(n+"["+t+"]",e[t],r,i)}ce.param=function(e,t){var n,r=[],i=function(e,t){var n=v(t)?t():t;r[r.length]=encodeURIComponent(e)+"="+encodeURIComponent(null==n?"":n)};if(null==e)return"";if(Array.isArray(e)||e.jquery&&!ce.isPlainObject(e))ce.each(e,function(){i(this.name,this.value)});else for(n in e)Pt(n,e[n],t,i);return r.join("&")},ce.fn.extend({serialize:function(){return ce.param(this.serializeArray())},serializeArray:function(){return this.map(function(){var e=ce.prop(this,"elements");return e?ce.makeArray(e):this}).filter(function(){var e=this.type;return this.name&&!ce(this).is(":disabled")&&Ot.test(this.nodeName)&&!Ht.test(e)&&(this.checked||!we.test(e))}).map(function(e,t){var n=ce(this).val();return null==n?null:Array.isArray(n)?ce.map(n,function(e){return{name:t.name,value:e.replace(Lt,"\r\n")}}):{name:t.name,value:n.replace(Lt,"\r\n")}}).get()}});var Mt=/%20/g,Rt=/#.*$/,It=/([?&])_=[^&]*/,Wt=/^(.*?):[ \t]*([^\r\n]*)$/gm,Ft=/^(?:GET|HEAD)$/,$t=/^\/\//,Bt={},_t={},zt="*/".concat("*"),Xt=C.createElement("a");function Ut(o){return function(e,t){"string"!=typeof e&&(t=e,e="*");var n,r=0,i=e.toLowerCase().match(D)||[];if(v(t))while(n=i[r++])"+"===n[0]?(n=n.slice(1)||"*",(o[n]=o[n]||[]).unshift(t)):(o[n]=o[n]||[]).push(t)}}function Vt(t,i,o,a){var s={},u=t===_t;function l(e){var r;return s[e]=!0,ce.each(t[e]||[],function(e,t){var n=t(i,o,a);return"string"!=typeof n||u||s[n]?u?!(r=n):void 0:(i.dataTypes.unshift(n),l(n),!1)}),r}return l(i.dataTypes[0])||!s["*"]&&l("*")}function Gt(e,t){var n,r,i=ce.ajaxSettings.flatOptions||{};for(n in t)void 0!==t[n]&&((i[n]?e:r||(r={}))[n]=t[n]);return r&&ce.extend(!0,e,r),e}Xt.href=Et.href,ce.extend({active:0,lastModified:{},etag:{},ajaxSettings:{url:Et.href,type:"GET",isLocal:/^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(Et.protocol),global:!0,processData:!0,async:!0,contentType:"application/x-www-form-urlencoded; charset=UTF-8",accepts:{"*":zt,text:"text/plain",html:"text/html",xml:"application/xml, text/xml",json:"application/json, text/javascript"},contents:{xml:/\bxml\b/,html:/\bhtml/,json:/\bjson\b/},responseFields:{xml:"responseXML",text:"responseText",json:"responseJSON"},converters:{"* text":String,"text html":!0,"text json":JSON.parse,"text xml":ce.parseXML},flatOptions:{url:!0,context:!0}},ajaxSetup:function(e,t){return t?Gt(Gt(e,ce.ajaxSettings),t):Gt(ce.ajaxSettings,e)},ajaxPrefilter:Ut(Bt),ajaxTransport:Ut(_t),ajax:function(e,t){"object"==typeof e&&(t=e,e=void 0),t=t||{};var c,f,p,n,d,r,h,g,i,o,v=ce.ajaxSetup({},t),y=v.context||v,m=v.context&&(y.nodeType||y.jquery)?ce(y):ce.event,x=ce.Deferred(),b=ce.Callbacks("once memory"),w=v.statusCode||{},a={},s={},u="canceled",T={readyState:0,getResponseHeader:function(e){var t;if(h){if(!n){n={};while(t=Wt.exec(p))n[t[1].toLowerCase()+" "]=(n[t[1].toLowerCase()+" "]||[]).concat(t[2])}t=n[e.toLowerCase()+" "]}return null==t?null:t.join(", ")},getAllResponseHeaders:function(){return h?p:null},setRequestHeader:function(e,t){return null==h&&(e=s[e.toLowerCase()]=s[e.toLowerCase()]||e,a[e]=t),this},overrideMimeType:function(e){return null==h&&(v.mimeType=e),this},statusCode:function(e){var t;if(e)if(h)T.always(e[T.status]);else for(t in e)w[t]=[w[t],e[t]];return this},abort:function(e){var t=e||u;return c&&c.abort(t),l(0,t),this}};if(x.promise(T),v.url=((e||v.url||Et.href)+"").replace($t,Et.protocol+"//"),v.type=t.method||t.type||v.method||v.type,v.dataTypes=(v.dataType||"*").toLowerCase().match(D)||[""],null==v.crossDomain){r=C.createElement("a");try{r.href=v.url,r.href=r.href,v.crossDomain=Xt.protocol+"//"+Xt.host!=r.protocol+"//"+r.host}catch(e){v.crossDomain=!0}}if(v.data&&v.processData&&"string"!=typeof v.data&&(v.data=ce.param(v.data,v.traditional)),Vt(Bt,v,t,T),h)return T;for(i in(g=ce.event&&v.global)&&0==ce.active++&&ce.event.trigger("ajaxStart"),v.type=v.type.toUpperCase(),v.hasContent=!Ft.test(v.type),f=v.url.replace(Rt,""),v.hasContent?v.data&&v.processData&&0===(v.contentType||"").indexOf("application/x-www-form-urlencoded")&&(v.data=v.data.replace(Mt,"+")):(o=v.url.slice(f.length),v.data&&(v.processData||"string"==typeof v.data)&&(f+=(At.test(f)?"&":"?")+v.data,delete v.data),!1===v.cache&&(f=f.replace(It,"$1"),o=(At.test(f)?"&":"?")+"_="+jt.guid+++o),v.url=f+o),v.ifModified&&(ce.lastModified[f]&&T.setRequestHeader("If-Modified-Since",ce.lastModified[f]),ce.etag[f]&&T.setRequestHeader("If-None-Match",ce.etag[f])),(v.data&&v.hasContent&&!1!==v.contentType||t.contentType)&&T.setRequestHeader("Content-Type",v.contentType),T.setRequestHeader("Accept",v.dataTypes[0]&&v.accepts[v.dataTypes[0]]?v.accepts[v.dataTypes[0]]+("*"!==v.dataTypes[0]?", "+zt+"; q=0.01":""):v.accepts["*"]),v.headers)T.setRequestHeader(i,v.headers[i]);if(v.beforeSend&&(!1===v.beforeSend.call(y,T,v)||h))return T.abort();if(u="abort",b.add(v.complete),T.done(v.success),T.fail(v.error),c=Vt(_t,v,t,T)){if(T.readyState=1,g&&m.trigger("ajaxSend",[T,v]),h)return T;v.async&&0<v.timeout&&(d=ie.setTimeout(function(){T.abort("timeout")},v.timeout));try{h=!1,c.send(a,l)}catch(e){if(h)throw e;l(-1,e)}}else l(-1,"No Transport");function l(e,t,n,r){var i,o,a,s,u,l=t;h||(h=!0,d&&ie.clearTimeout(d),c=void 0,p=r||"",T.readyState=0<e?4:0,i=200<=e&&e<300||304===e,n&&(s=function(e,t,n){var r,i,o,a,s=e.contents,u=e.dataTypes;while("*"===u[0])u.shift(),void 0===r&&(r=e.mimeType||t.getResponseHeader("Content-Type"));if(r)for(i in s)if(s[i]&&s[i].test(r)){u.unshift(i);break}if(u[0]in n)o=u[0];else{for(i in n){if(!u[0]||e.converters[i+" "+u[0]]){o=i;break}a||(a=i)}o=o||a}if(o)return o!==u[0]&&u.unshift(o),n[o]}(v,T,n)),!i&&-1<ce.inArray("script",v.dataTypes)&&ce.inArray("json",v.dataTypes)<0&&(v.converters["text script"]=function(){}),s=function(e,t,n,r){var i,o,a,s,u,l={},c=e.dataTypes.slice();if(c[1])for(a in e.converters)l[a.toLowerCase()]=e.converters[a];o=c.shift();while(o)if(e.responseFields[o]&&(n[e.responseFields[o]]=t),!u&&r&&e.dataFilter&&(t=e.dataFilter(t,e.dataType)),u=o,o=c.shift())if("*"===o)o=u;else if("*"!==u&&u!==o){if(!(a=l[u+" "+o]||l["* "+o]))for(i in l)if((s=i.split(" "))[1]===o&&(a=l[u+" "+s[0]]||l["* "+s[0]])){!0===a?a=l[i]:!0!==l[i]&&(o=s[0],c.unshift(s[1]));break}if(!0!==a)if(a&&e["throws"])t=a(t);else try{t=a(t)}catch(e){return{state:"parsererror",error:a?e:"No conversion from "+u+" to "+o}}}return{state:"success",data:t}}(v,s,T,i),i?(v.ifModified&&((u=T.getResponseHeader("Last-Modified"))&&(ce.lastModified[f]=u),(u=T.getResponseHeader("etag"))&&(ce.etag[f]=u)),204===e||"HEAD"===v.type?l="nocontent":304===e?l="notmodified":(l=s.state,o=s.data,i=!(a=s.error))):(a=l,!e&&l||(l="error",e<0&&(e=0))),T.status=e,T.statusText=(t||l)+"",i?x.resolveWith(y,[o,l,T]):x.rejectWith(y,[T,l,a]),T.statusCode(w),w=void 0,g&&m.trigger(i?"ajaxSuccess":"ajaxError",[T,v,i?o:a]),b.fireWith(y,[T,l]),g&&(m.trigger("ajaxComplete",[T,v]),--ce.active||ce.event.trigger("ajaxStop")))}return T},getJSON:function(e,t,n){return ce.get(e,t,n,"json")},getScript:function(e,t){return ce.get(e,void 0,t,"script")}}),ce.each(["get","post"],function(e,i){ce[i]=function(e,t,n,r){return v(t)&&(r=r||n,n=t,t=void 0),ce.ajax(ce.extend({url:e,type:i,dataType:r,data:t,success:n},ce.isPlainObject(e)&&e))}}),ce.ajaxPrefilter(function(e){var t;for(t in e.headers)"content-type"===t.toLowerCase()&&(e.contentType=e.headers[t]||"")}),ce._evalUrl=function(e,t,n){return ce.ajax({url:e,type:"GET",dataType:"script",cache:!0,async:!1,global:!1,converters:{"text script":function(){}},dataFilter:function(e){ce.globalEval(e,t,n)}})},ce.fn.extend({wrapAll:function(e){var t;return this[0]&&(v(e)&&(e=e.call(this[0])),t=ce(e,this[0].ownerDocument).eq(0).clone(!0),this[0].parentNode&&t.insertBefore(this[0]),t.map(function(){var e=this;while(e.firstElementChild)e=e.firstElementChild;return e}).append(this)),this},wrapInner:function(n){return v(n)?this.each(function(e){ce(this).wrapInner(n.call(this,e))}):this.each(function(){var e=ce(this),t=e.contents();t.length?t.wrapAll(n):e.append(n)})},wrap:function(t){var n=v(t);return this.each(function(e){ce(this).wrapAll(n?t.call(this,e):t)})},unwrap:function(e){return this.parent(e).not("body").each(function(){ce(this).replaceWith(this.childNodes)}),this}}),ce.expr.pseudos.hidden=function(e){return!ce.expr.pseudos.visible(e)},ce.expr.pseudos.visible=function(e){return!!(e.offsetWidth||e.offsetHeight||e.getClientRects().length)},ce.ajaxSettings.xhr=function(){try{return new ie.XMLHttpRequest}catch(e){}};var Yt={0:200,1223:204},Qt=ce.ajaxSettings.xhr();le.cors=!!Qt&&"withCredentials"in Qt,le.ajax=Qt=!!Qt,ce.ajaxTransport(function(i){var o,a;if(le.cors||Qt&&!i.crossDomain)return{send:function(e,t){var n,r=i.xhr();if(r.open(i.type,i.url,i.async,i.username,i.password),i.xhrFields)for(n in i.xhrFields)r[n]=i.xhrFields[n];for(n in i.mimeType&&r.overrideMimeType&&r.overrideMimeType(i.mimeType),i.crossDomain||e["X-Requested-With"]||(e["X-Requested-With"]="XMLHttpRequest"),e)r.setRequestHeader(n,e[n]);o=function(e){return function(){o&&(o=a=r.onload=r.onerror=r.onabort=r.ontimeout=r.onreadystatechange=null,"abort"===e?r.abort():"error"===e?"number"!=typeof r.status?t(0,"error"):t(r.status,r.statusText):t(Yt[r.status]||r.status,r.statusText,"text"!==(r.responseType||"text")||"string"!=typeof r.responseText?{binary:r.response}:{text:r.responseText},r.getAllResponseHeaders()))}},r.onload=o(),a=r.onerror=r.ontimeout=o("error"),void 0!==r.onabort?r.onabort=a:r.onreadystatechange=function(){4===r.readyState&&ie.setTimeout(function(){o&&a()})},o=o("abort");try{r.send(i.hasContent&&i.data||null)}catch(e){if(o)throw e}},abort:function(){o&&o()}}}),ce.ajaxPrefilter(function(e){e.crossDomain&&(e.contents.script=!1)}),ce.ajaxSetup({accepts:{script:"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"},contents:{script:/\b(?:java|ecma)script\b/},converters:{"text script":function(e){return ce.globalEval(e),e}}}),ce.ajaxPrefilter("script",function(e){void 0===e.cache&&(e.cache=!1),e.crossDomain&&(e.type="GET")}),ce.ajaxTransport("script",function(n){var r,i;if(n.crossDomain||n.scriptAttrs)return{send:function(e,t){r=ce("<script>").attr(n.scriptAttrs||{}).prop({charset:n.scriptCharset,src:n.url}).on("load error",i=function(e){r.remove(),i=null,e&&t("error"===e.type?404:200,e.type)}),C.head.appendChild(r[0])},abort:function(){i&&i()}}});var Jt,Kt=[],Zt=/(=)\?(?=&|$)|\?\?/;ce.ajaxSetup({jsonp:"callback",jsonpCallback:function(){var e=Kt.pop()||ce.expando+"_"+jt.guid++;return this[e]=!0,e}}),ce.ajaxPrefilter("json jsonp",function(e,t,n){var r,i,o,a=!1!==e.jsonp&&(Zt.test(e.url)?"url":"string"==typeof e.data&&0===(e.contentType||"").indexOf("application/x-www-form-urlencoded")&&Zt.test(e.data)&&"data");if(a||"jsonp"===e.dataTypes[0])return r=e.jsonpCallback=v(e.jsonpCallback)?e.jsonpCallback():e.jsonpCallback,a?e[a]=e[a].replace(Zt,"$1"+r):!1!==e.jsonp&&(e.url+=(At.test(e.url)?"&":"?")+e.jsonp+"="+r),e.converters["script json"]=function(){return o||ce.error(r+" was not called"),o[0]},e.dataTypes[0]="json",i=ie[r],ie[r]=function(){o=arguments},n.always(function(){void 0===i?ce(ie).removeProp(r):ie[r]=i,e[r]&&(e.jsonpCallback=t.jsonpCallback,Kt.push(r)),o&&v(i)&&i(o[0]),o=i=void 0}),"script"}),le.createHTMLDocument=((Jt=C.implementation.createHTMLDocument("").body).innerHTML="<form></form><form></form>",2===Jt.childNodes.length),ce.parseHTML=function(e,t,n){return"string"!=typeof e?[]:("boolean"==typeof t&&(n=t,t=!1),t||(le.createHTMLDocument?((r=(t=C.implementation.createHTMLDocument("")).createElement("base")).href=C.location.href,t.head.appendChild(r)):t=C),o=!n&&[],(i=w.exec(e))?[t.createElement(i[1])]:(i=Ae([e],t,o),o&&o.length&&ce(o).remove(),ce.merge([],i.childNodes)));var r,i,o},ce.fn.load=function(e,t,n){var r,i,o,a=this,s=e.indexOf(" ");return-1<s&&(r=Tt(e.slice(s)),e=e.slice(0,s)),v(t)?(n=t,t=void 0):t&&"object"==typeof t&&(i="POST"),0<a.length&&ce.ajax({url:e,type:i||"GET",dataType:"html",data:t}).done(function(e){o=arguments,a.html(r?ce("<div>").append(ce.parseHTML(e)).find(r):e)}).always(n&&function(e,t){a.each(function(){n.apply(this,o||[e.responseText,t,e])})}),this},ce.expr.pseudos.animated=function(t){return ce.grep(ce.timers,function(e){return t===e.elem}).length},ce.offset={setOffset:function(e,t,n){var r,i,o,a,s,u,l=ce.css(e,"position"),c=ce(e),f={};"static"===l&&(e.style.position="relative"),s=c.offset(),o=ce.css(e,"top"),u=ce.css(e,"left"),("absolute"===l||"fixed"===l)&&-1<(o+u).indexOf("auto")?(a=(r=c.position()).top,i=r.left):(a=parseFloat(o)||0,i=parseFloat(u)||0),v(t)&&(t=t.call(e,n,ce.extend({},s))),null!=t.top&&(f.top=t.top-s.top+a),null!=t.left&&(f.left=t.left-s.left+i),"using"in t?t.using.call(e,f):c.css(f)}},ce.fn.extend({offset:function(t){if(arguments.length)return void 0===t?this:this.each(function(e){ce.offset.setOffset(this,t,e)});var e,n,r=this[0];return r?r.getClientRects().length?(e=r.getBoundingClientRect(),n=r.ownerDocument.defaultView,{top:e.top+n.pageYOffset,left:e.left+n.pageXOffset}):{top:0,left:0}:void 0},position:function(){if(this[0]){var e,t,n,r=this[0],i={top:0,left:0};if("fixed"===ce.css(r,"position"))t=r.getBoundingClientRect();else{t=this.offset(),n=r.ownerDocument,e=r.offsetParent||n.documentElement;while(e&&(e===n.body||e===n.documentElement)&&"static"===ce.css(e,"position"))e=e.parentNode;e&&e!==r&&1===e.nodeType&&((i=ce(e).offset()).top+=ce.css(e,"borderTopWidth",!0),i.left+=ce.css(e,"borderLeftWidth",!0))}return{top:t.top-i.top-ce.css(r,"marginTop",!0),left:t.left-i.left-ce.css(r,"marginLeft",!0)}}},offsetParent:function(){return this.map(function(){var e=this.offsetParent;while(e&&"static"===ce.css(e,"position"))e=e.offsetParent;return e||J})}}),ce.each({scrollLeft:"pageXOffset",scrollTop:"pageYOffset"},function(t,i){var o="pageYOffset"===i;ce.fn[t]=function(e){return M(this,function(e,t,n){var r;if(y(e)?r=e:9===e.nodeType&&(r=e.defaultView),void 0===n)return r?r[i]:e[t];r?r.scrollTo(o?r.pageXOffset:n,o?n:r.pageYOffset):e[t]=n},t,e,arguments.length)}}),ce.each(["top","left"],function(e,n){ce.cssHooks[n]=Ye(le.pixelPosition,function(e,t){if(t)return t=Ge(e,n),_e.test(t)?ce(e).position()[n]+"px":t})}),ce.each({Height:"height",Width:"width"},function(a,s){ce.each({padding:"inner"+a,content:s,"":"outer"+a},function(r,o){ce.fn[o]=function(e,t){var n=arguments.length&&(r||"boolean"!=typeof e),i=r||(!0===e||!0===t?"margin":"border");return M(this,function(e,t,n){var r;return y(e)?0===o.indexOf("outer")?e["inner"+a]:e.document.documentElement["client"+a]:9===e.nodeType?(r=e.documentElement,Math.max(e.body["scroll"+a],r["scroll"+a],e.body["offset"+a],r["offset"+a],r["client"+a])):void 0===n?ce.css(e,t,i):ce.style(e,t,n,i)},s,n?e:void 0,n)}})}),ce.each(["ajaxStart","ajaxStop","ajaxComplete","ajaxError","ajaxSuccess","ajaxSend"],function(e,t){ce.fn[t]=function(e){return this.on(t,e)}}),ce.fn.extend({bind:function(e,t,n){return this.on(e,null,t,n)},unbind:function(e,t){return this.off(e,null,t)},delegate:function(e,t,n,r){return this.on(t,e,n,r)},undelegate:function(e,t,n){return 1===arguments.length?this.off(e,"**"):this.off(t,e||"**",n)},hover:function(e,t){return this.on("mouseenter",e).on("mouseleave",t||e)}}),ce.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "),function(e,n){ce.fn[n]=function(e,t){return 0<arguments.length?this.on(n,null,e,t):this.trigger(n)}});var en=/^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;ce.proxy=function(e,t){var n,r,i;if("string"==typeof t&&(n=e[t],t=e,e=n),v(e))return r=ae.call(arguments,2),(i=function(){return e.apply(t||this,r.concat(ae.call(arguments)))}).guid=e.guid=e.guid||ce.guid++,i},ce.holdReady=function(e){e?ce.readyWait++:ce.ready(!0)},ce.isArray=Array.isArray,ce.parseJSON=JSON.parse,ce.nodeName=fe,ce.isFunction=v,ce.isWindow=y,ce.camelCase=F,ce.type=x,ce.now=Date.now,ce.isNumeric=function(e){var t=ce.type(e);return("number"===t||"string"===t)&&!isNaN(e-parseFloat(e))},ce.trim=function(e){return null==e?"":(e+"").replace(en,"$1")},"function"==typeof define&&define.amd&&define("jquery",[],function(){return ce});var tn=ie.jQuery,nn=ie.$;return ce.noConflict=function(e){return ie.$===ce&&(ie.$=nn),e&&ie.jQuery===ce&&(ie.jQuery=tn),ce},"undefined"==typeof e&&(ie.jQuery=ie.$=ce),ce});

; /*! jQuery UI - v1.13.3 - 2024-04-26
* https://jqueryui.com
* Includes: widget.js, position.js, keycode.js, scroll-parent.js, effect.js, effects/effect-blind.js, effects/effect-bounce.js, effects/effect-clip.js, effects/effect-drop.js, effects/effect-explode.js, effects/effect-fade.js, effects/effect-fold.js, effects/effect-highlight.js, effects/effect-size.js, effects/effect-scale.js, effects/effect-puff.js, effects/effect-pulsate.js, effects/effect-shake.js, effects/effect-slide.js, effects/effect-transfer.js, widgets/mouse.js, widgets/slider.js
* Copyright OpenJS Foundation and other contributors; Licensed MIT */

( function( factory ) {
	"use strict";
	
	if ( typeof define === "function" && define.amd ) {

		// AMD. Register as an anonymous module.
		define( [ "jquery" ], factory );
	} else {

		// Browser globals
		factory( jQuery );
	}
} )( function( $ ) {
"use strict";

$.ui = $.ui || {};

var version = $.ui.version = "1.13.3";


/*!
 * jQuery UI Widget 1.13.3
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Widget
//>>group: Core
//>>description: Provides a factory for creating stateful widgets with a common API.
//>>docs: https://api.jqueryui.com/jQuery.widget/
//>>demos: https://jqueryui.com/widget/


var widgetUuid = 0;
var widgetHasOwnProperty = Array.prototype.hasOwnProperty;
var widgetSlice = Array.prototype.slice;

$.cleanData = ( function( orig ) {
	return function( elems ) {
		var events, elem, i;
		for ( i = 0; ( elem = elems[ i ] ) != null; i++ ) {

			// Only trigger remove when necessary to save time
			events = $._data( elem, "events" );
			if ( events && events.remove ) {
				$( elem ).triggerHandler( "remove" );
			}
		}
		orig( elems );
	};
} )( $.cleanData );

$.widget = function( name, base, prototype ) {
	var existingConstructor, constructor, basePrototype;

	// ProxiedPrototype allows the provided prototype to remain unmodified
	// so that it can be used as a mixin for multiple widgets (#8876)
	var proxiedPrototype = {};

	var namespace = name.split( "." )[ 0 ];
	name = name.split( "." )[ 1 ];
	var fullName = namespace + "-" + name;

	if ( !prototype ) {
		prototype = base;
		base = $.Widget;
	}

	if ( Array.isArray( prototype ) ) {
		prototype = $.extend.apply( null, [ {} ].concat( prototype ) );
	}

	// Create selector for plugin
	$.expr.pseudos[ fullName.toLowerCase() ] = function( elem ) {
		return !!$.data( elem, fullName );
	};

	$[ namespace ] = $[ namespace ] || {};
	existingConstructor = $[ namespace ][ name ];
	constructor = $[ namespace ][ name ] = function( options, element ) {

		// Allow instantiation without "new" keyword
		if ( !this || !this._createWidget ) {
			return new constructor( options, element );
		}

		// Allow instantiation without initializing for simple inheritance
		// must use "new" keyword (the code above always passes args)
		if ( arguments.length ) {
			this._createWidget( options, element );
		}
	};

	// Extend with the existing constructor to carry over any static properties
	$.extend( constructor, existingConstructor, {
		version: prototype.version,

		// Copy the object used to create the prototype in case we need to
		// redefine the widget later
		_proto: $.extend( {}, prototype ),

		// Track widgets that inherit from this widget in case this widget is
		// redefined after a widget inherits from it
		_childConstructors: []
	} );

	basePrototype = new base();

	// We need to make the options hash a property directly on the new instance
	// otherwise we'll modify the options hash on the prototype that we're
	// inheriting from
	basePrototype.options = $.widget.extend( {}, basePrototype.options );
	$.each( prototype, function( prop, value ) {
		if ( typeof value !== "function" ) {
			proxiedPrototype[ prop ] = value;
			return;
		}
		proxiedPrototype[ prop ] = ( function() {
			function _super() {
				return base.prototype[ prop ].apply( this, arguments );
			}

			function _superApply( args ) {
				return base.prototype[ prop ].apply( this, args );
			}

			return function() {
				var __super = this._super;
				var __superApply = this._superApply;
				var returnValue;

				this._super = _super;
				this._superApply = _superApply;

				returnValue = value.apply( this, arguments );

				this._super = __super;
				this._superApply = __superApply;

				return returnValue;
			};
		} )();
	} );
	constructor.prototype = $.widget.extend( basePrototype, {

		// TODO: remove support for widgetEventPrefix
		// always use the name + a colon as the prefix, e.g., draggable:start
		// don't prefix for widgets that aren't DOM-based
		widgetEventPrefix: existingConstructor ? ( basePrototype.widgetEventPrefix || name ) : name
	}, proxiedPrototype, {
		constructor: constructor,
		namespace: namespace,
		widgetName: name,
		widgetFullName: fullName
	} );

	// If this widget is being redefined then we need to find all widgets that
	// are inheriting from it and redefine all of them so that they inherit from
	// the new version of this widget. We're essentially trying to replace one
	// level in the prototype chain.
	if ( existingConstructor ) {
		$.each( existingConstructor._childConstructors, function( i, child ) {
			var childPrototype = child.prototype;

			// Redefine the child widget using the same prototype that was
			// originally used, but inherit from the new version of the base
			$.widget( childPrototype.namespace + "." + childPrototype.widgetName, constructor,
				child._proto );
		} );

		// Remove the list of existing child constructors from the old constructor
		// so the old child constructors can be garbage collected
		delete existingConstructor._childConstructors;
	} else {
		base._childConstructors.push( constructor );
	}

	$.widget.bridge( name, constructor );

	return constructor;
};

$.widget.extend = function( target ) {
	var input = widgetSlice.call( arguments, 1 );
	var inputIndex = 0;
	var inputLength = input.length;
	var key;
	var value;

	for ( ; inputIndex < inputLength; inputIndex++ ) {
		for ( key in input[ inputIndex ] ) {
			value = input[ inputIndex ][ key ];
			if ( widgetHasOwnProperty.call( input[ inputIndex ], key ) && value !== undefined ) {

				// Clone objects
				if ( $.isPlainObject( value ) ) {
					target[ key ] = $.isPlainObject( target[ key ] ) ?
						$.widget.extend( {}, target[ key ], value ) :

						// Don't extend strings, arrays, etc. with objects
						$.widget.extend( {}, value );

				// Copy everything else by reference
				} else {
					target[ key ] = value;
				}
			}
		}
	}
	return target;
};

$.widget.bridge = function( name, object ) {
	var fullName = object.prototype.widgetFullName || name;
	$.fn[ name ] = function( options ) {
		var isMethodCall = typeof options === "string";
		var args = widgetSlice.call( arguments, 1 );
		var returnValue = this;

		if ( isMethodCall ) {

			// If this is an empty collection, we need to have the instance method
			// return undefined instead of the jQuery instance
			if ( !this.length && options === "instance" ) {
				returnValue = undefined;
			} else {
				this.each( function() {
					var methodValue;
					var instance = $.data( this, fullName );

					if ( options === "instance" ) {
						returnValue = instance;
						return false;
					}

					if ( !instance ) {
						return $.error( "cannot call methods on " + name +
							" prior to initialization; " +
							"attempted to call method '" + options + "'" );
					}

					if ( typeof instance[ options ] !== "function" ||
						options.charAt( 0 ) === "_" ) {
						return $.error( "no such method '" + options + "' for " + name +
							" widget instance" );
					}

					methodValue = instance[ options ].apply( instance, args );

					if ( methodValue !== instance && methodValue !== undefined ) {
						returnValue = methodValue && methodValue.jquery ?
							returnValue.pushStack( methodValue.get() ) :
							methodValue;
						return false;
					}
				} );
			}
		} else {

			// Allow multiple hashes to be passed on init
			if ( args.length ) {
				options = $.widget.extend.apply( null, [ options ].concat( args ) );
			}

			this.each( function() {
				var instance = $.data( this, fullName );
				if ( instance ) {
					instance.option( options || {} );
					if ( instance._init ) {
						instance._init();
					}
				} else {
					$.data( this, fullName, new object( options, this ) );
				}
			} );
		}

		return returnValue;
	};
};

$.Widget = function( /* options, element */ ) {};
$.Widget._childConstructors = [];

$.Widget.prototype = {
	widgetName: "widget",
	widgetEventPrefix: "",
	defaultElement: "<div>",

	options: {
		classes: {},
		disabled: false,

		// Callbacks
		create: null
	},

	_createWidget: function( options, element ) {
		element = $( element || this.defaultElement || this )[ 0 ];
		this.element = $( element );
		this.uuid = widgetUuid++;
		this.eventNamespace = "." + this.widgetName + this.uuid;

		this.bindings = $();
		this.hoverable = $();
		this.focusable = $();
		this.classesElementLookup = {};

		if ( element !== this ) {
			$.data( element, this.widgetFullName, this );
			this._on( true, this.element, {
				remove: function( event ) {
					if ( event.target === element ) {
						this.destroy();
					}
				}
			} );
			this.document = $( element.style ?

				// Element within the document
				element.ownerDocument :

				// Element is window or document
				element.document || element );
			this.window = $( this.document[ 0 ].defaultView || this.document[ 0 ].parentWindow );
		}

		this.options = $.widget.extend( {},
			this.options,
			this._getCreateOptions(),
			options );

		this._create();

		if ( this.options.disabled ) {
			this._setOptionDisabled( this.options.disabled );
		}

		this._trigger( "create", null, this._getCreateEventData() );
		this._init();
	},

	_getCreateOptions: function() {
		return {};
	},

	_getCreateEventData: $.noop,

	_create: $.noop,

	_init: $.noop,

	destroy: function() {
		var that = this;

		this._destroy();
		$.each( this.classesElementLookup, function( key, value ) {
			that._removeClass( value, key );
		} );

		// We can probably remove the unbind calls in 2.0
		// all event bindings should go through this._on()
		this.element
			.off( this.eventNamespace )
			.removeData( this.widgetFullName );
		this.widget()
			.off( this.eventNamespace )
			.removeAttr( "aria-disabled" );

		// Clean up events and states
		this.bindings.off( this.eventNamespace );
	},

	_destroy: $.noop,

	widget: function() {
		return this.element;
	},

	option: function( key, value ) {
		var options = key;
		var parts;
		var curOption;
		var i;

		if ( arguments.length === 0 ) {

			// Don't return a reference to the internal hash
			return $.widget.extend( {}, this.options );
		}

		if ( typeof key === "string" ) {

			// Handle nested keys, e.g., "foo.bar" => { foo: { bar: ___ } }
			options = {};
			parts = key.split( "." );
			key = parts.shift();
			if ( parts.length ) {
				curOption = options[ key ] = $.widget.extend( {}, this.options[ key ] );
				for ( i = 0; i < parts.length - 1; i++ ) {
					curOption[ parts[ i ] ] = curOption[ parts[ i ] ] || {};
					curOption = curOption[ parts[ i ] ];
				}
				key = parts.pop();
				if ( arguments.length === 1 ) {
					return curOption[ key ] === undefined ? null : curOption[ key ];
				}
				curOption[ key ] = value;
			} else {
				if ( arguments.length === 1 ) {
					return this.options[ key ] === undefined ? null : this.options[ key ];
				}
				options[ key ] = value;
			}
		}

		this._setOptions( options );

		return this;
	},

	_setOptions: function( options ) {
		var key;

		for ( key in options ) {
			this._setOption( key, options[ key ] );
		}

		return this;
	},

	_setOption: function( key, value ) {
		if ( key === "classes" ) {
			this._setOptionClasses( value );
		}

		this.options[ key ] = value;

		if ( key === "disabled" ) {
			this._setOptionDisabled( value );
		}

		return this;
	},

	_setOptionClasses: function( value ) {
		var classKey, elements, currentElements;

		for ( classKey in value ) {
			currentElements = this.classesElementLookup[ classKey ];
			if ( value[ classKey ] === this.options.classes[ classKey ] ||
					!currentElements ||
					!currentElements.length ) {
				continue;
			}

			// We are doing this to create a new jQuery object because the _removeClass() call
			// on the next line is going to destroy the reference to the current elements being
			// tracked. We need to save a copy of this collection so that we can add the new classes
			// below.
			elements = $( currentElements.get() );
			this._removeClass( currentElements, classKey );

			// We don't use _addClass() here, because that uses this.options.classes
			// for generating the string of classes. We want to use the value passed in from
			// _setOption(), this is the new value of the classes option which was passed to
			// _setOption(). We pass this value directly to _classes().
			elements.addClass( this._classes( {
				element: elements,
				keys: classKey,
				classes: value,
				add: true
			} ) );
		}
	},

	_setOptionDisabled: function( value ) {
		this._toggleClass( this.widget(), this.widgetFullName + "-disabled", null, !!value );

		// If the widget is becoming disabled, then nothing is interactive
		if ( value ) {
			this._removeClass( this.hoverable, null, "ui-state-hover" );
			this._removeClass( this.focusable, null, "ui-state-focus" );
		}
	},

	enable: function() {
		return this._setOptions( { disabled: false } );
	},

	disable: function() {
		return this._setOptions( { disabled: true } );
	},

	_classes: function( options ) {
		var full = [];
		var that = this;

		options = $.extend( {
			element: this.element,
			classes: this.options.classes || {}
		}, options );

		function bindRemoveEvent() {
			var nodesToBind = [];

			options.element.each( function( _, element ) {
				var isTracked = $.map( that.classesElementLookup, function( elements ) {
					return elements;
				} )
					.some( function( elements ) {
						return elements.is( element );
					} );

				if ( !isTracked ) {
					nodesToBind.push( element );
				}
			} );

			that._on( $( nodesToBind ), {
				remove: "_untrackClassesElement"
			} );
		}

		function processClassString( classes, checkOption ) {
			var current, i;
			for ( i = 0; i < classes.length; i++ ) {
				current = that.classesElementLookup[ classes[ i ] ] || $();
				if ( options.add ) {
					bindRemoveEvent();
					current = $( $.uniqueSort( current.get().concat( options.element.get() ) ) );
				} else {
					current = $( current.not( options.element ).get() );
				}
				that.classesElementLookup[ classes[ i ] ] = current;
				full.push( classes[ i ] );
				if ( checkOption && options.classes[ classes[ i ] ] ) {
					full.push( options.classes[ classes[ i ] ] );
				}
			}
		}

		if ( options.keys ) {
			processClassString( options.keys.match( /\S+/g ) || [], true );
		}
		if ( options.extra ) {
			processClassString( options.extra.match( /\S+/g ) || [] );
		}

		return full.join( " " );
	},

	_untrackClassesElement: function( event ) {
		var that = this;
		$.each( that.classesElementLookup, function( key, value ) {
			if ( $.inArray( event.target, value ) !== -1 ) {
				that.classesElementLookup[ key ] = $( value.not( event.target ).get() );
			}
		} );

		this._off( $( event.target ) );
	},

	_removeClass: function( element, keys, extra ) {
		return this._toggleClass( element, keys, extra, false );
	},

	_addClass: function( element, keys, extra ) {
		return this._toggleClass( element, keys, extra, true );
	},

	_toggleClass: function( element, keys, extra, add ) {
		add = ( typeof add === "boolean" ) ? add : extra;
		var shift = ( typeof element === "string" || element === null ),
			options = {
				extra: shift ? keys : extra,
				keys: shift ? element : keys,
				element: shift ? this.element : element,
				add: add
			};
		options.element.toggleClass( this._classes( options ), add );
		return this;
	},

	_on: function( suppressDisabledCheck, element, handlers ) {
		var delegateElement;
		var instance = this;

		// No suppressDisabledCheck flag, shuffle arguments
		if ( typeof suppressDisabledCheck !== "boolean" ) {
			handlers = element;
			element = suppressDisabledCheck;
			suppressDisabledCheck = false;
		}

		// No element argument, shuffle and use this.element
		if ( !handlers ) {
			handlers = element;
			element = this.element;
			delegateElement = this.widget();
		} else {
			element = delegateElement = $( element );
			this.bindings = this.bindings.add( element );
		}

		$.each( handlers, function( event, handler ) {
			function handlerProxy() {

				// Allow widgets to customize the disabled handling
				// - disabled as an array instead of boolean
				// - disabled class as method for disabling individual parts
				if ( !suppressDisabledCheck &&
						( instance.options.disabled === true ||
						$( this ).hasClass( "ui-state-disabled" ) ) ) {
					return;
				}
				return ( typeof handler === "string" ? instance[ handler ] : handler )
					.apply( instance, arguments );
			}

			// Copy the guid so direct unbinding works
			if ( typeof handler !== "string" ) {
				handlerProxy.guid = handler.guid =
					handler.guid || handlerProxy.guid || $.guid++;
			}

			var match = event.match( /^([\w:-]*)\s*(.*)$/ );
			var eventName = match[ 1 ] + instance.eventNamespace;
			var selector = match[ 2 ];

			if ( selector ) {
				delegateElement.on( eventName, selector, handlerProxy );
			} else {
				element.on( eventName, handlerProxy );
			}
		} );
	},

	_off: function( element, eventName ) {
		eventName = ( eventName || "" ).split( " " ).join( this.eventNamespace + " " ) +
			this.eventNamespace;
		element.off( eventName );

		// Clear the stack to avoid memory leaks (#10056)
		this.bindings = $( this.bindings.not( element ).get() );
		this.focusable = $( this.focusable.not( element ).get() );
		this.hoverable = $( this.hoverable.not( element ).get() );
	},

	_delay: function( handler, delay ) {
		function handlerProxy() {
			return ( typeof handler === "string" ? instance[ handler ] : handler )
				.apply( instance, arguments );
		}
		var instance = this;
		return setTimeout( handlerProxy, delay || 0 );
	},

	_hoverable: function( element ) {
		this.hoverable = this.hoverable.add( element );
		this._on( element, {
			mouseenter: function( event ) {
				this._addClass( $( event.currentTarget ), null, "ui-state-hover" );
			},
			mouseleave: function( event ) {
				this._removeClass( $( event.currentTarget ), null, "ui-state-hover" );
			}
		} );
	},

	_focusable: function( element ) {
		this.focusable = this.focusable.add( element );
		this._on( element, {
			focusin: function( event ) {
				this._addClass( $( event.currentTarget ), null, "ui-state-focus" );
			},
			focusout: function( event ) {
				this._removeClass( $( event.currentTarget ), null, "ui-state-focus" );
			}
		} );
	},

	_trigger: function( type, event, data ) {
		var prop, orig;
		var callback = this.options[ type ];

		data = data || {};
		event = $.Event( event );
		event.type = ( type === this.widgetEventPrefix ?
			type :
			this.widgetEventPrefix + type ).toLowerCase();

		// The original event may come from any element
		// so we need to reset the target on the new event
		event.target = this.element[ 0 ];

		// Copy original event properties over to the new event
		orig = event.originalEvent;
		if ( orig ) {
			for ( prop in orig ) {
				if ( !( prop in event ) ) {
					event[ prop ] = orig[ prop ];
				}
			}
		}

		this.element.trigger( event, data );
		return !( typeof callback === "function" &&
			callback.apply( this.element[ 0 ], [ event ].concat( data ) ) === false ||
			event.isDefaultPrevented() );
	}
};

$.each( { show: "fadeIn", hide: "fadeOut" }, function( method, defaultEffect ) {
	$.Widget.prototype[ "_" + method ] = function( element, options, callback ) {
		if ( typeof options === "string" ) {
			options = { effect: options };
		}

		var hasOptions;
		var effectName = !options ?
			method :
			options === true || typeof options === "number" ?
				defaultEffect :
				options.effect || defaultEffect;

		options = options || {};
		if ( typeof options === "number" ) {
			options = { duration: options };
		} else if ( options === true ) {
			options = {};
		}

		hasOptions = !$.isEmptyObject( options );
		options.complete = callback;

		if ( options.delay ) {
			element.delay( options.delay );
		}

		if ( hasOptions && $.effects && $.effects.effect[ effectName ] ) {
			element[ method ]( options );
		} else if ( effectName !== method && element[ effectName ] ) {
			element[ effectName ]( options.duration, options.easing, callback );
		} else {
			element.queue( function( next ) {
				$( this )[ method ]();
				if ( callback ) {
					callback.call( element[ 0 ] );
				}
				next();
			} );
		}
	};
} );

var widget = $.widget;


/*!
 * jQuery UI Position 1.13.3
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 *
 * https://api.jqueryui.com/position/
 */

//>>label: Position
//>>group: Core
//>>description: Positions elements relative to other elements.
//>>docs: https://api.jqueryui.com/position/
//>>demos: https://jqueryui.com/position/


( function() {
var cachedScrollbarWidth,
	max = Math.max,
	abs = Math.abs,
	rhorizontal = /left|center|right/,
	rvertical = /top|center|bottom/,
	roffset = /[\+\-]\d+(\.[\d]+)?%?/,
	rposition = /^\w+/,
	rpercent = /%$/,
	_position = $.fn.position;

function getOffsets( offsets, width, height ) {
	return [
		parseFloat( offsets[ 0 ] ) * ( rpercent.test( offsets[ 0 ] ) ? width / 100 : 1 ),
		parseFloat( offsets[ 1 ] ) * ( rpercent.test( offsets[ 1 ] ) ? height / 100 : 1 )
	];
}

function parseCss( element, property ) {
	return parseInt( $.css( element, property ), 10 ) || 0;
}

function isWindow( obj ) {
	return obj != null && obj === obj.window;
}

function getDimensions( elem ) {
	var raw = elem[ 0 ];
	if ( raw.nodeType === 9 ) {
		return {
			width: elem.width(),
			height: elem.height(),
			offset: { top: 0, left: 0 }
		};
	}
	if ( isWindow( raw ) ) {
		return {
			width: elem.width(),
			height: elem.height(),
			offset: { top: elem.scrollTop(), left: elem.scrollLeft() }
		};
	}
	if ( raw.preventDefault ) {
		return {
			width: 0,
			height: 0,
			offset: { top: raw.pageY, left: raw.pageX }
		};
	}
	return {
		width: elem.outerWidth(),
		height: elem.outerHeight(),
		offset: elem.offset()
	};
}

$.position = {
	scrollbarWidth: function() {
		if ( cachedScrollbarWidth !== undefined ) {
			return cachedScrollbarWidth;
		}
		var w1, w2,
			div = $( "<div style=" +
				"'display:block;position:absolute;width:200px;height:200px;overflow:hidden;'>" +
				"<div style='height:300px;width:auto;'></div></div>" ),
			innerDiv = div.children()[ 0 ];

		$( "body" ).append( div );
		w1 = innerDiv.offsetWidth;
		div.css( "overflow", "scroll" );

		w2 = innerDiv.offsetWidth;

		if ( w1 === w2 ) {
			w2 = div[ 0 ].clientWidth;
		}

		div.remove();

		return ( cachedScrollbarWidth = w1 - w2 );
	},
	getScrollInfo: function( within ) {
		var overflowX = within.isWindow || within.isDocument ? "" :
				within.element.css( "overflow-x" ),
			overflowY = within.isWindow || within.isDocument ? "" :
				within.element.css( "overflow-y" ),
			hasOverflowX = overflowX === "scroll" ||
				( overflowX === "auto" && within.width < within.element[ 0 ].scrollWidth ),
			hasOverflowY = overflowY === "scroll" ||
				( overflowY === "auto" && within.height < within.element[ 0 ].scrollHeight );
		return {
			width: hasOverflowY ? $.position.scrollbarWidth() : 0,
			height: hasOverflowX ? $.position.scrollbarWidth() : 0
		};
	},
	getWithinInfo: function( element ) {
		var withinElement = $( element || window ),
			isElemWindow = isWindow( withinElement[ 0 ] ),
			isDocument = !!withinElement[ 0 ] && withinElement[ 0 ].nodeType === 9,
			hasOffset = !isElemWindow && !isDocument;
		return {
			element: withinElement,
			isWindow: isElemWindow,
			isDocument: isDocument,
			offset: hasOffset ? $( element ).offset() : { left: 0, top: 0 },
			scrollLeft: withinElement.scrollLeft(),
			scrollTop: withinElement.scrollTop(),
			width: withinElement.outerWidth(),
			height: withinElement.outerHeight()
		};
	}
};

$.fn.position = function( options ) {
	if ( !options || !options.of ) {
		return _position.apply( this, arguments );
	}

	// Make a copy, we don't want to modify arguments
	options = $.extend( {}, options );

	var atOffset, targetWidth, targetHeight, targetOffset, basePosition, dimensions,

		// Make sure string options are treated as CSS selectors
		target = typeof options.of === "string" ?
			$( document ).find( options.of ) :
			$( options.of ),

		within = $.position.getWithinInfo( options.within ),
		scrollInfo = $.position.getScrollInfo( within ),
		collision = ( options.collision || "flip" ).split( " " ),
		offsets = {};

	dimensions = getDimensions( target );
	if ( target[ 0 ].preventDefault ) {

		// Force left top to allow flipping
		options.at = "left top";
	}
	targetWidth = dimensions.width;
	targetHeight = dimensions.height;
	targetOffset = dimensions.offset;

	// Clone to reuse original targetOffset later
	basePosition = $.extend( {}, targetOffset );

	// Force my and at to have valid horizontal and vertical positions
	// if a value is missing or invalid, it will be converted to center
	$.each( [ "my", "at" ], function() {
		var pos = ( options[ this ] || "" ).split( " " ),
			horizontalOffset,
			verticalOffset;

		if ( pos.length === 1 ) {
			pos = rhorizontal.test( pos[ 0 ] ) ?
				pos.concat( [ "center" ] ) :
				rvertical.test( pos[ 0 ] ) ?
					[ "center" ].concat( pos ) :
					[ "center", "center" ];
		}
		pos[ 0 ] = rhorizontal.test( pos[ 0 ] ) ? pos[ 0 ] : "center";
		pos[ 1 ] = rvertical.test( pos[ 1 ] ) ? pos[ 1 ] : "center";

		// Calculate offsets
		horizontalOffset = roffset.exec( pos[ 0 ] );
		verticalOffset = roffset.exec( pos[ 1 ] );
		offsets[ this ] = [
			horizontalOffset ? horizontalOffset[ 0 ] : 0,
			verticalOffset ? verticalOffset[ 0 ] : 0
		];

		// Reduce to just the positions without the offsets
		options[ this ] = [
			rposition.exec( pos[ 0 ] )[ 0 ],
			rposition.exec( pos[ 1 ] )[ 0 ]
		];
	} );

	// Normalize collision option
	if ( collision.length === 1 ) {
		collision[ 1 ] = collision[ 0 ];
	}

	if ( options.at[ 0 ] === "right" ) {
		basePosition.left += targetWidth;
	} else if ( options.at[ 0 ] === "center" ) {
		basePosition.left += targetWidth / 2;
	}

	if ( options.at[ 1 ] === "bottom" ) {
		basePosition.top += targetHeight;
	} else if ( options.at[ 1 ] === "center" ) {
		basePosition.top += targetHeight / 2;
	}

	atOffset = getOffsets( offsets.at, targetWidth, targetHeight );
	basePosition.left += atOffset[ 0 ];
	basePosition.top += atOffset[ 1 ];

	return this.each( function() {
		var collisionPosition, using,
			elem = $( this ),
			elemWidth = elem.outerWidth(),
			elemHeight = elem.outerHeight(),
			marginLeft = parseCss( this, "marginLeft" ),
			marginTop = parseCss( this, "marginTop" ),
			collisionWidth = elemWidth + marginLeft + parseCss( this, "marginRight" ) +
				scrollInfo.width,
			collisionHeight = elemHeight + marginTop + parseCss( this, "marginBottom" ) +
				scrollInfo.height,
			position = $.extend( {}, basePosition ),
			myOffset = getOffsets( offsets.my, elem.outerWidth(), elem.outerHeight() );

		if ( options.my[ 0 ] === "right" ) {
			position.left -= elemWidth;
		} else if ( options.my[ 0 ] === "center" ) {
			position.left -= elemWidth / 2;
		}

		if ( options.my[ 1 ] === "bottom" ) {
			position.top -= elemHeight;
		} else if ( options.my[ 1 ] === "center" ) {
			position.top -= elemHeight / 2;
		}

		position.left += myOffset[ 0 ];
		position.top += myOffset[ 1 ];

		collisionPosition = {
			marginLeft: marginLeft,
			marginTop: marginTop
		};

		$.each( [ "left", "top" ], function( i, dir ) {
			if ( $.ui.position[ collision[ i ] ] ) {
				$.ui.position[ collision[ i ] ][ dir ]( position, {
					targetWidth: targetWidth,
					targetHeight: targetHeight,
					elemWidth: elemWidth,
					elemHeight: elemHeight,
					collisionPosition: collisionPosition,
					collisionWidth: collisionWidth,
					collisionHeight: collisionHeight,
					offset: [ atOffset[ 0 ] + myOffset[ 0 ], atOffset [ 1 ] + myOffset[ 1 ] ],
					my: options.my,
					at: options.at,
					within: within,
					elem: elem
				} );
			}
		} );

		if ( options.using ) {

			// Adds feedback as second argument to using callback, if present
			using = function( props ) {
				var left = targetOffset.left - position.left,
					right = left + targetWidth - elemWidth,
					top = targetOffset.top - position.top,
					bottom = top + targetHeight - elemHeight,
					feedback = {
						target: {
							element: target,
							left: targetOffset.left,
							top: targetOffset.top,
							width: targetWidth,
							height: targetHeight
						},
						element: {
							element: elem,
							left: position.left,
							top: position.top,
							width: elemWidth,
							height: elemHeight
						},
						horizontal: right < 0 ? "left" : left > 0 ? "right" : "center",
						vertical: bottom < 0 ? "top" : top > 0 ? "bottom" : "middle"
					};
				if ( targetWidth < elemWidth && abs( left + right ) < targetWidth ) {
					feedback.horizontal = "center";
				}
				if ( targetHeight < elemHeight && abs( top + bottom ) < targetHeight ) {
					feedback.vertical = "middle";
				}
				if ( max( abs( left ), abs( right ) ) > max( abs( top ), abs( bottom ) ) ) {
					feedback.important = "horizontal";
				} else {
					feedback.important = "vertical";
				}
				options.using.call( this, props, feedback );
			};
		}

		elem.offset( $.extend( position, { using: using } ) );
	} );
};

$.ui.position = {
	fit: {
		left: function( position, data ) {
			var within = data.within,
				withinOffset = within.isWindow ? within.scrollLeft : within.offset.left,
				outerWidth = within.width,
				collisionPosLeft = position.left - data.collisionPosition.marginLeft,
				overLeft = withinOffset - collisionPosLeft,
				overRight = collisionPosLeft + data.collisionWidth - outerWidth - withinOffset,
				newOverRight;

			// Element is wider than within
			if ( data.collisionWidth > outerWidth ) {

				// Element is initially over the left side of within
				if ( overLeft > 0 && overRight <= 0 ) {
					newOverRight = position.left + overLeft + data.collisionWidth - outerWidth -
						withinOffset;
					position.left += overLeft - newOverRight;

				// Element is initially over right side of within
				} else if ( overRight > 0 && overLeft <= 0 ) {
					position.left = withinOffset;

				// Element is initially over both left and right sides of within
				} else {
					if ( overLeft > overRight ) {
						position.left = withinOffset + outerWidth - data.collisionWidth;
					} else {
						position.left = withinOffset;
					}
				}

			// Too far left -> align with left edge
			} else if ( overLeft > 0 ) {
				position.left += overLeft;

			// Too far right -> align with right edge
			} else if ( overRight > 0 ) {
				position.left -= overRight;

			// Adjust based on position and margin
			} else {
				position.left = max( position.left - collisionPosLeft, position.left );
			}
		},
		top: function( position, data ) {
			var within = data.within,
				withinOffset = within.isWindow ? within.scrollTop : within.offset.top,
				outerHeight = data.within.height,
				collisionPosTop = position.top - data.collisionPosition.marginTop,
				overTop = withinOffset - collisionPosTop,
				overBottom = collisionPosTop + data.collisionHeight - outerHeight - withinOffset,
				newOverBottom;

			// Element is taller than within
			if ( data.collisionHeight > outerHeight ) {

				// Element is initially over the top of within
				if ( overTop > 0 && overBottom <= 0 ) {
					newOverBottom = position.top + overTop + data.collisionHeight - outerHeight -
						withinOffset;
					position.top += overTop - newOverBottom;

				// Element is initially over bottom of within
				} else if ( overBottom > 0 && overTop <= 0 ) {
					position.top = withinOffset;

				// Element is initially over both top and bottom of within
				} else {
					if ( overTop > overBottom ) {
						position.top = withinOffset + outerHeight - data.collisionHeight;
					} else {
						position.top = withinOffset;
					}
				}

			// Too far up -> align with top
			} else if ( overTop > 0 ) {
				position.top += overTop;

			// Too far down -> align with bottom edge
			} else if ( overBottom > 0 ) {
				position.top -= overBottom;

			// Adjust based on position and margin
			} else {
				position.top = max( position.top - collisionPosTop, position.top );
			}
		}
	},
	flip: {
		left: function( position, data ) {
			var within = data.within,
				withinOffset = within.offset.left + within.scrollLeft,
				outerWidth = within.width,
				offsetLeft = within.isWindow ? within.scrollLeft : within.offset.left,
				collisionPosLeft = position.left - data.collisionPosition.marginLeft,
				overLeft = collisionPosLeft - offsetLeft,
				overRight = collisionPosLeft + data.collisionWidth - outerWidth - offsetLeft,
				myOffset = data.my[ 0 ] === "left" ?
					-data.elemWidth :
					data.my[ 0 ] === "right" ?
						data.elemWidth :
						0,
				atOffset = data.at[ 0 ] === "left" ?
					data.targetWidth :
					data.at[ 0 ] === "right" ?
						-data.targetWidth :
						0,
				offset = -2 * data.offset[ 0 ],
				newOverRight,
				newOverLeft;

			if ( overLeft < 0 ) {
				newOverRight = position.left + myOffset + atOffset + offset + data.collisionWidth -
					outerWidth - withinOffset;
				if ( newOverRight < 0 || newOverRight < abs( overLeft ) ) {
					position.left += myOffset + atOffset + offset;
				}
			} else if ( overRight > 0 ) {
				newOverLeft = position.left - data.collisionPosition.marginLeft + myOffset +
					atOffset + offset - offsetLeft;
				if ( newOverLeft > 0 || abs( newOverLeft ) < overRight ) {
					position.left += myOffset + atOffset + offset;
				}
			}
		},
		top: function( position, data ) {
			var within = data.within,
				withinOffset = within.offset.top + within.scrollTop,
				outerHeight = within.height,
				offsetTop = within.isWindow ? within.scrollTop : within.offset.top,
				collisionPosTop = position.top - data.collisionPosition.marginTop,
				overTop = collisionPosTop - offsetTop,
				overBottom = collisionPosTop + data.collisionHeight - outerHeight - offsetTop,
				top = data.my[ 1 ] === "top",
				myOffset = top ?
					-data.elemHeight :
					data.my[ 1 ] === "bottom" ?
						data.elemHeight :
						0,
				atOffset = data.at[ 1 ] === "top" ?
					data.targetHeight :
					data.at[ 1 ] === "bottom" ?
						-data.targetHeight :
						0,
				offset = -2 * data.offset[ 1 ],
				newOverTop,
				newOverBottom;
			if ( overTop < 0 ) {
				newOverBottom = position.top + myOffset + atOffset + offset + data.collisionHeight -
					outerHeight - withinOffset;
				if ( newOverBottom < 0 || newOverBottom < abs( overTop ) ) {
					position.top += myOffset + atOffset + offset;
				}
			} else if ( overBottom > 0 ) {
				newOverTop = position.top - data.collisionPosition.marginTop + myOffset + atOffset +
					offset - offsetTop;
				if ( newOverTop > 0 || abs( newOverTop ) < overBottom ) {
					position.top += myOffset + atOffset + offset;
				}
			}
		}
	},
	flipfit: {
		left: function() {
			$.ui.position.flip.left.apply( this, arguments );
			$.ui.position.fit.left.apply( this, arguments );
		},
		top: function() {
			$.ui.position.flip.top.apply( this, arguments );
			$.ui.position.fit.top.apply( this, arguments );
		}
	}
};

} )();

var position = $.ui.position;


/*!
 * jQuery UI Keycode 1.13.3
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Keycode
//>>group: Core
//>>description: Provide keycodes as keynames
//>>docs: https://api.jqueryui.com/jQuery.ui.keyCode/


var keycode = $.ui.keyCode = {
	BACKSPACE: 8,
	COMMA: 188,
	DELETE: 46,
	DOWN: 40,
	END: 35,
	ENTER: 13,
	ESCAPE: 27,
	HOME: 36,
	LEFT: 37,
	PAGE_DOWN: 34,
	PAGE_UP: 33,
	PERIOD: 190,
	RIGHT: 39,
	SPACE: 32,
	TAB: 9,
	UP: 38
};


/*!
 * jQuery UI Scroll Parent 1.13.3
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: scrollParent
//>>group: Core
//>>description: Get the closest ancestor element that is scrollable.
//>>docs: https://api.jqueryui.com/scrollParent/


var scrollParent = $.fn.scrollParent = function( includeHidden ) {
	var position = this.css( "position" ),
		excludeStaticParent = position === "absolute",
		overflowRegex = includeHidden ? /(auto|scroll|hidden)/ : /(auto|scroll)/,
		scrollParent = this.parents().filter( function() {
			var parent = $( this );
			if ( excludeStaticParent && parent.css( "position" ) === "static" ) {
				return false;
			}
			return overflowRegex.test( parent.css( "overflow" ) + parent.css( "overflow-y" ) +
				parent.css( "overflow-x" ) );
		} ).eq( 0 );

	return position === "fixed" || !scrollParent.length ?
		$( this[ 0 ].ownerDocument || document ) :
		scrollParent;
};


/*!
 * jQuery Color Animations v2.2.0
 * https://github.com/jquery/jquery-color
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 *
 * Date: Sun May 10 09:02:36 2020 +0200
 */



	var stepHooks = "backgroundColor borderBottomColor borderLeftColor borderRightColor " +
		"borderTopColor color columnRuleColor outlineColor textDecorationColor textEmphasisColor",

	class2type = {},
	toString = class2type.toString,

	// plusequals test for += 100 -= 100
	rplusequals = /^([\-+])=\s*(\d+\.?\d*)/,

	// a set of RE's that can match strings and generate color tuples.
	stringParsers = [ {
			re: /rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
			parse: function( execResult ) {
				return [
					execResult[ 1 ],
					execResult[ 2 ],
					execResult[ 3 ],
					execResult[ 4 ]
				];
			}
		}, {
			re: /rgba?\(\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
			parse: function( execResult ) {
				return [
					execResult[ 1 ] * 2.55,
					execResult[ 2 ] * 2.55,
					execResult[ 3 ] * 2.55,
					execResult[ 4 ]
				];
			}
		}, {

			// this regex ignores A-F because it's compared against an already lowercased string
			re: /#([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})?/,
			parse: function( execResult ) {
				return [
					parseInt( execResult[ 1 ], 16 ),
					parseInt( execResult[ 2 ], 16 ),
					parseInt( execResult[ 3 ], 16 ),
					execResult[ 4 ] ?
						( parseInt( execResult[ 4 ], 16 ) / 255 ).toFixed( 2 ) :
						1
				];
			}
		}, {

			// this regex ignores A-F because it's compared against an already lowercased string
			re: /#([a-f0-9])([a-f0-9])([a-f0-9])([a-f0-9])?/,
			parse: function( execResult ) {
				return [
					parseInt( execResult[ 1 ] + execResult[ 1 ], 16 ),
					parseInt( execResult[ 2 ] + execResult[ 2 ], 16 ),
					parseInt( execResult[ 3 ] + execResult[ 3 ], 16 ),
					execResult[ 4 ] ?
						( parseInt( execResult[ 4 ] + execResult[ 4 ], 16 ) / 255 )
							.toFixed( 2 ) :
						1
				];
			}
		}, {
			re: /hsla?\(\s*(\d+(?:\.\d+)?)\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
			space: "hsla",
			parse: function( execResult ) {
				return [
					execResult[ 1 ],
					execResult[ 2 ] / 100,
					execResult[ 3 ] / 100,
					execResult[ 4 ]
				];
			}
		} ],

	// jQuery.Color( )
	color = jQuery.Color = function( color, green, blue, alpha ) {
		return new jQuery.Color.fn.parse( color, green, blue, alpha );
	},
	spaces = {
		rgba: {
			props: {
				red: {
					idx: 0,
					type: "byte"
				},
				green: {
					idx: 1,
					type: "byte"
				},
				blue: {
					idx: 2,
					type: "byte"
				}
			}
		},

		hsla: {
			props: {
				hue: {
					idx: 0,
					type: "degrees"
				},
				saturation: {
					idx: 1,
					type: "percent"
				},
				lightness: {
					idx: 2,
					type: "percent"
				}
			}
		}
	},
	propTypes = {
		"byte": {
			floor: true,
			max: 255
		},
		"percent": {
			max: 1
		},
		"degrees": {
			mod: 360,
			floor: true
		}
	},
	support = color.support = {},

	// element for support tests
	supportElem = jQuery( "<p>" )[ 0 ],

	// colors = jQuery.Color.names
	colors,

	// local aliases of functions called often
	each = jQuery.each;

// determine rgba support immediately
supportElem.style.cssText = "background-color:rgba(1,1,1,.5)";
support.rgba = supportElem.style.backgroundColor.indexOf( "rgba" ) > -1;

// define cache name and alpha properties
// for rgba and hsla spaces
each( spaces, function( spaceName, space ) {
	space.cache = "_" + spaceName;
	space.props.alpha = {
		idx: 3,
		type: "percent",
		def: 1
	};
} );

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( _i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );

function getType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	return typeof obj === "object" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}

function clamp( value, prop, allowEmpty ) {
	var type = propTypes[ prop.type ] || {};

	if ( value == null ) {
		return ( allowEmpty || !prop.def ) ? null : prop.def;
	}

	// ~~ is an short way of doing floor for positive numbers
	value = type.floor ? ~~value : parseFloat( value );

	// IE will pass in empty strings as value for alpha,
	// which will hit this case
	if ( isNaN( value ) ) {
		return prop.def;
	}

	if ( type.mod ) {

		// we add mod before modding to make sure that negatives values
		// get converted properly: -10 -> 350
		return ( value + type.mod ) % type.mod;
	}

	// for now all property types without mod have min and max
	return Math.min( type.max, Math.max( 0, value ) );
}

function stringParse( string ) {
	var inst = color(),
		rgba = inst._rgba = [];

	string = string.toLowerCase();

	each( stringParsers, function( _i, parser ) {
		var parsed,
			match = parser.re.exec( string ),
			values = match && parser.parse( match ),
			spaceName = parser.space || "rgba";

		if ( values ) {
			parsed = inst[ spaceName ]( values );

			// if this was an rgba parse the assignment might happen twice
			// oh well....
			inst[ spaces[ spaceName ].cache ] = parsed[ spaces[ spaceName ].cache ];
			rgba = inst._rgba = parsed._rgba;

			// exit each( stringParsers ) here because we matched
			return false;
		}
	} );

	// Found a stringParser that handled it
	if ( rgba.length ) {

		// if this came from a parsed string, force "transparent" when alpha is 0
		// chrome, (and maybe others) return "transparent" as rgba(0,0,0,0)
		if ( rgba.join() === "0,0,0,0" ) {
			jQuery.extend( rgba, colors.transparent );
		}
		return inst;
	}

	// named colors
	return colors[ string ];
}

color.fn = jQuery.extend( color.prototype, {
	parse: function( red, green, blue, alpha ) {
		if ( red === undefined ) {
			this._rgba = [ null, null, null, null ];
			return this;
		}
		if ( red.jquery || red.nodeType ) {
			red = jQuery( red ).css( green );
			green = undefined;
		}

		var inst = this,
			type = getType( red ),
			rgba = this._rgba = [];

		// more than 1 argument specified - assume ( red, green, blue, alpha )
		if ( green !== undefined ) {
			red = [ red, green, blue, alpha ];
			type = "array";
		}

		if ( type === "string" ) {
			return this.parse( stringParse( red ) || colors._default );
		}

		if ( type === "array" ) {
			each( spaces.rgba.props, function( _key, prop ) {
				rgba[ prop.idx ] = clamp( red[ prop.idx ], prop );
			} );
			return this;
		}

		if ( type === "object" ) {
			if ( red instanceof color ) {
				each( spaces, function( _spaceName, space ) {
					if ( red[ space.cache ] ) {
						inst[ space.cache ] = red[ space.cache ].slice();
					}
				} );
			} else {
				each( spaces, function( _spaceName, space ) {
					var cache = space.cache;
					each( space.props, function( key, prop ) {

						// if the cache doesn't exist, and we know how to convert
						if ( !inst[ cache ] && space.to ) {

							// if the value was null, we don't need to copy it
							// if the key was alpha, we don't need to copy it either
							if ( key === "alpha" || red[ key ] == null ) {
								return;
							}
							inst[ cache ] = space.to( inst._rgba );
						}

						// this is the only case where we allow nulls for ALL properties.
						// call clamp with alwaysAllowEmpty
						inst[ cache ][ prop.idx ] = clamp( red[ key ], prop, true );
					} );

					// everything defined but alpha?
					if ( inst[ cache ] && jQuery.inArray( null, inst[ cache ].slice( 0, 3 ) ) < 0 ) {

						// use the default of 1
						if ( inst[ cache ][ 3 ] == null ) {
							inst[ cache ][ 3 ] = 1;
						}

						if ( space.from ) {
							inst._rgba = space.from( inst[ cache ] );
						}
					}
				} );
			}
			return this;
		}
	},
	is: function( compare ) {
		var is = color( compare ),
			same = true,
			inst = this;

		each( spaces, function( _, space ) {
			var localCache,
				isCache = is[ space.cache ];
			if ( isCache ) {
				localCache = inst[ space.cache ] || space.to && space.to( inst._rgba ) || [];
				each( space.props, function( _, prop ) {
					if ( isCache[ prop.idx ] != null ) {
						same = ( isCache[ prop.idx ] === localCache[ prop.idx ] );
						return same;
					}
				} );
			}
			return same;
		} );
		return same;
	},
	_space: function() {
		var used = [],
			inst = this;
		each( spaces, function( spaceName, space ) {
			if ( inst[ space.cache ] ) {
				used.push( spaceName );
			}
		} );
		return used.pop();
	},
	transition: function( other, distance ) {
		var end = color( other ),
			spaceName = end._space(),
			space = spaces[ spaceName ],
			startColor = this.alpha() === 0 ? color( "transparent" ) : this,
			start = startColor[ space.cache ] || space.to( startColor._rgba ),
			result = start.slice();

		end = end[ space.cache ];
		each( space.props, function( _key, prop ) {
			var index = prop.idx,
				startValue = start[ index ],
				endValue = end[ index ],
				type = propTypes[ prop.type ] || {};

			// if null, don't override start value
			if ( endValue === null ) {
				return;
			}

			// if null - use end
			if ( startValue === null ) {
				result[ index ] = endValue;
			} else {
				if ( type.mod ) {
					if ( endValue - startValue > type.mod / 2 ) {
						startValue += type.mod;
					} else if ( startValue - endValue > type.mod / 2 ) {
						startValue -= type.mod;
					}
				}
				result[ index ] = clamp( ( endValue - startValue ) * distance + startValue, prop );
			}
		} );
		return this[ spaceName ]( result );
	},
	blend: function( opaque ) {

		// if we are already opaque - return ourself
		if ( this._rgba[ 3 ] === 1 ) {
			return this;
		}

		var rgb = this._rgba.slice(),
			a = rgb.pop(),
			blend = color( opaque )._rgba;

		return color( jQuery.map( rgb, function( v, i ) {
			return ( 1 - a ) * blend[ i ] + a * v;
		} ) );
	},
	toRgbaString: function() {
		var prefix = "rgba(",
			rgba = jQuery.map( this._rgba, function( v, i ) {
				if ( v != null ) {
					return v;
				}
				return i > 2 ? 1 : 0;
			} );

		if ( rgba[ 3 ] === 1 ) {
			rgba.pop();
			prefix = "rgb(";
		}

		return prefix + rgba.join() + ")";
	},
	toHslaString: function() {
		var prefix = "hsla(",
			hsla = jQuery.map( this.hsla(), function( v, i ) {
				if ( v == null ) {
					v = i > 2 ? 1 : 0;
				}

				// catch 1 and 2
				if ( i && i < 3 ) {
					v = Math.round( v * 100 ) + "%";
				}
				return v;
			} );

		if ( hsla[ 3 ] === 1 ) {
			hsla.pop();
			prefix = "hsl(";
		}
		return prefix + hsla.join() + ")";
	},
	toHexString: function( includeAlpha ) {
		var rgba = this._rgba.slice(),
			alpha = rgba.pop();

		if ( includeAlpha ) {
			rgba.push( ~~( alpha * 255 ) );
		}

		return "#" + jQuery.map( rgba, function( v ) {

			// default to 0 when nulls exist
			v = ( v || 0 ).toString( 16 );
			return v.length === 1 ? "0" + v : v;
		} ).join( "" );
	},
	toString: function() {
		return this._rgba[ 3 ] === 0 ? "transparent" : this.toRgbaString();
	}
} );
color.fn.parse.prototype = color.fn;

// hsla conversions adapted from:
// https://code.google.com/p/maashaack/source/browse/packages/graphics/trunk/src/graphics/colors/HUE2RGB.as?r=5021

function hue2rgb( p, q, h ) {
	h = ( h + 1 ) % 1;
	if ( h * 6 < 1 ) {
		return p + ( q - p ) * h * 6;
	}
	if ( h * 2 < 1 ) {
		return q;
	}
	if ( h * 3 < 2 ) {
		return p + ( q - p ) * ( ( 2 / 3 ) - h ) * 6;
	}
	return p;
}

spaces.hsla.to = function( rgba ) {
	if ( rgba[ 0 ] == null || rgba[ 1 ] == null || rgba[ 2 ] == null ) {
		return [ null, null, null, rgba[ 3 ] ];
	}
	var r = rgba[ 0 ] / 255,
		g = rgba[ 1 ] / 255,
		b = rgba[ 2 ] / 255,
		a = rgba[ 3 ],
		max = Math.max( r, g, b ),
		min = Math.min( r, g, b ),
		diff = max - min,
		add = max + min,
		l = add * 0.5,
		h, s;

	if ( min === max ) {
		h = 0;
	} else if ( r === max ) {
		h = ( 60 * ( g - b ) / diff ) + 360;
	} else if ( g === max ) {
		h = ( 60 * ( b - r ) / diff ) + 120;
	} else {
		h = ( 60 * ( r - g ) / diff ) + 240;
	}

	// chroma (diff) == 0 means greyscale which, by definition, saturation = 0%
	// otherwise, saturation is based on the ratio of chroma (diff) to lightness (add)
	if ( diff === 0 ) {
		s = 0;
	} else if ( l <= 0.5 ) {
		s = diff / add;
	} else {
		s = diff / ( 2 - add );
	}
	return [ Math.round( h ) % 360, s, l, a == null ? 1 : a ];
};

spaces.hsla.from = function( hsla ) {
	if ( hsla[ 0 ] == null || hsla[ 1 ] == null || hsla[ 2 ] == null ) {
		return [ null, null, null, hsla[ 3 ] ];
	}
	var h = hsla[ 0 ] / 360,
		s = hsla[ 1 ],
		l = hsla[ 2 ],
		a = hsla[ 3 ],
		q = l <= 0.5 ? l * ( 1 + s ) : l + s - l * s,
		p = 2 * l - q;

	return [
		Math.round( hue2rgb( p, q, h + ( 1 / 3 ) ) * 255 ),
		Math.round( hue2rgb( p, q, h ) * 255 ),
		Math.round( hue2rgb( p, q, h - ( 1 / 3 ) ) * 255 ),
		a
	];
};


each( spaces, function( spaceName, space ) {
	var props = space.props,
		cache = space.cache,
		to = space.to,
		from = space.from;

	// makes rgba() and hsla()
	color.fn[ spaceName ] = function( value ) {

		// generate a cache for this space if it doesn't exist
		if ( to && !this[ cache ] ) {
			this[ cache ] = to( this._rgba );
		}
		if ( value === undefined ) {
			return this[ cache ].slice();
		}

		var ret,
			type = getType( value ),
			arr = ( type === "array" || type === "object" ) ? value : arguments,
			local = this[ cache ].slice();

		each( props, function( key, prop ) {
			var val = arr[ type === "object" ? key : prop.idx ];
			if ( val == null ) {
				val = local[ prop.idx ];
			}
			local[ prop.idx ] = clamp( val, prop );
		} );

		if ( from ) {
			ret = color( from( local ) );
			ret[ cache ] = local;
			return ret;
		} else {
			return color( local );
		}
	};

	// makes red() green() blue() alpha() hue() saturation() lightness()
	each( props, function( key, prop ) {

		// alpha is included in more than one space
		if ( color.fn[ key ] ) {
			return;
		}
		color.fn[ key ] = function( value ) {
			var local, cur, match, fn,
				vtype = getType( value );

			if ( key === "alpha" ) {
				fn = this._hsla ? "hsla" : "rgba";
			} else {
				fn = spaceName;
			}
			local = this[ fn ]();
			cur = local[ prop.idx ];

			if ( vtype === "undefined" ) {
				return cur;
			}

			if ( vtype === "function" ) {
				value = value.call( this, cur );
				vtype = getType( value );
			}
			if ( value == null && prop.empty ) {
				return this;
			}
			if ( vtype === "string" ) {
				match = rplusequals.exec( value );
				if ( match ) {
					value = cur + parseFloat( match[ 2 ] ) * ( match[ 1 ] === "+" ? 1 : -1 );
				}
			}
			local[ prop.idx ] = value;
			return this[ fn ]( local );
		};
	} );
} );

// add cssHook and .fx.step function for each named hook.
// accept a space separated string of properties
color.hook = function( hook ) {
	var hooks = hook.split( " " );
	each( hooks, function( _i, hook ) {
		jQuery.cssHooks[ hook ] = {
			set: function( elem, value ) {
				var parsed, curElem,
					backgroundColor = "";

				if ( value !== "transparent" && ( getType( value ) !== "string" || ( parsed = stringParse( value ) ) ) ) {
					value = color( parsed || value );
					if ( !support.rgba && value._rgba[ 3 ] !== 1 ) {
						curElem = hook === "backgroundColor" ? elem.parentNode : elem;
						while (
							( backgroundColor === "" || backgroundColor === "transparent" ) &&
							curElem && curElem.style
						) {
							try {
								backgroundColor = jQuery.css( curElem, "backgroundColor" );
								curElem = curElem.parentNode;
							} catch ( e ) {
							}
						}

						value = value.blend( backgroundColor && backgroundColor !== "transparent" ?
							backgroundColor :
							"_default" );
					}

					value = value.toRgbaString();
				}
				try {
					elem.style[ hook ] = value;
				} catch ( e ) {

					// wrapped to prevent IE from throwing errors on "invalid" values like 'auto' or 'inherit'
				}
			}
		};
		jQuery.fx.step[ hook ] = function( fx ) {
			if ( !fx.colorInit ) {
				fx.start = color( fx.elem, hook );
				fx.end = color( fx.end );
				fx.colorInit = true;
			}
			jQuery.cssHooks[ hook ].set( fx.elem, fx.start.transition( fx.end, fx.pos ) );
		};
	} );

};

color.hook( stepHooks );

jQuery.cssHooks.borderColor = {
	expand: function( value ) {
		var expanded = {};

		each( [ "Top", "Right", "Bottom", "Left" ], function( _i, part ) {
			expanded[ "border" + part + "Color" ] = value;
		} );
		return expanded;
	}
};

// Basic color names only.
// Usage of any of the other color names requires adding yourself or including
// jquery.color.svg-names.js.
colors = jQuery.Color.names = {

	// 4.1. Basic color keywords
	aqua: "#00ffff",
	black: "#000000",
	blue: "#0000ff",
	fuchsia: "#ff00ff",
	gray: "#808080",
	green: "#008000",
	lime: "#00ff00",
	maroon: "#800000",
	navy: "#000080",
	olive: "#808000",
	purple: "#800080",
	red: "#ff0000",
	silver: "#c0c0c0",
	teal: "#008080",
	white: "#ffffff",
	yellow: "#ffff00",

	// 4.2.3. "transparent" color keyword
	transparent: [ null, null, null, 0 ],

	_default: "#ffffff"
};


/*!
 * jQuery UI Effects 1.13.3
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Effects Core
//>>group: Effects
/* eslint-disable max-len */
//>>description: Extends the internal jQuery effects. Includes morphing and easing. Required by all other effects.
/* eslint-enable max-len */
//>>docs: https://api.jqueryui.com/category/effects-core/
//>>demos: https://jqueryui.com/effect/


var dataSpace = "ui-effects-",
	dataSpaceStyle = "ui-effects-style",
	dataSpaceAnimated = "ui-effects-animated";

$.effects = {
	effect: {}
};

/******************************************************************************/
/****************************** CLASS ANIMATIONS ******************************/
/******************************************************************************/
( function() {

var classAnimationActions = [ "add", "remove", "toggle" ],
	shorthandStyles = {
		border: 1,
		borderBottom: 1,
		borderColor: 1,
		borderLeft: 1,
		borderRight: 1,
		borderTop: 1,
		borderWidth: 1,
		margin: 1,
		padding: 1
	};

$.each(
	[ "borderLeftStyle", "borderRightStyle", "borderBottomStyle", "borderTopStyle" ],
	function( _, prop ) {
		$.fx.step[ prop ] = function( fx ) {
			if ( fx.end !== "none" && !fx.setAttr || fx.pos === 1 && !fx.setAttr ) {
				jQuery.style( fx.elem, prop, fx.end );
				fx.setAttr = true;
			}
		};
	}
);

function camelCase( string ) {
	return string.replace( /-([\da-z])/gi, function( all, letter ) {
		return letter.toUpperCase();
	} );
}

function getElementStyles( elem ) {
	var key, len,
		style = elem.ownerDocument.defaultView ?
			elem.ownerDocument.defaultView.getComputedStyle( elem, null ) :
			elem.currentStyle,
		styles = {};

	if ( style && style.length && style[ 0 ] && style[ style[ 0 ] ] ) {
		len = style.length;
		while ( len-- ) {
			key = style[ len ];
			if ( typeof style[ key ] === "string" ) {
				styles[ camelCase( key ) ] = style[ key ];
			}
		}

	// Support: Opera, IE <9
	} else {
		for ( key in style ) {
			if ( typeof style[ key ] === "string" ) {
				styles[ key ] = style[ key ];
			}
		}
	}

	return styles;
}

function styleDifference( oldStyle, newStyle ) {
	var diff = {},
		name, value;

	for ( name in newStyle ) {
		value = newStyle[ name ];
		if ( oldStyle[ name ] !== value ) {
			if ( !shorthandStyles[ name ] ) {
				if ( $.fx.step[ name ] || !isNaN( parseFloat( value ) ) ) {
					diff[ name ] = value;
				}
			}
		}
	}

	return diff;
}

// Support: jQuery <1.8
if ( !$.fn.addBack ) {
	$.fn.addBack = function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	};
}

$.effects.animateClass = function( value, duration, easing, callback ) {
	var o = $.speed( duration, easing, callback );

	return this.queue( function() {
		var animated = $( this ),
			baseClass = animated.attr( "class" ) || "",
			applyClassChange,
			allAnimations = o.children ? animated.find( "*" ).addBack() : animated;

		// Map the animated objects to store the original styles.
		allAnimations = allAnimations.map( function() {
			var el = $( this );
			return {
				el: el,
				start: getElementStyles( this )
			};
		} );

		// Apply class change
		applyClassChange = function() {
			$.each( classAnimationActions, function( i, action ) {
				if ( value[ action ] ) {
					animated[ action + "Class" ]( value[ action ] );
				}
			} );
		};
		applyClassChange();

		// Map all animated objects again - calculate new styles and diff
		allAnimations = allAnimations.map( function() {
			this.end = getElementStyles( this.el[ 0 ] );
			this.diff = styleDifference( this.start, this.end );
			return this;
		} );

		// Apply original class
		animated.attr( "class", baseClass );

		// Map all animated objects again - this time collecting a promise
		allAnimations = allAnimations.map( function() {
			var styleInfo = this,
				dfd = $.Deferred(),
				opts = $.extend( {}, o, {
					queue: false,
					complete: function() {
						dfd.resolve( styleInfo );
					}
				} );

			this.el.animate( this.diff, opts );
			return dfd.promise();
		} );

		// Once all animations have completed:
		$.when.apply( $, allAnimations.get() ).done( function() {

			// Set the final class
			applyClassChange();

			// For each animated element,
			// clear all css properties that were animated
			$.each( arguments, function() {
				var el = this.el;
				$.each( this.diff, function( key ) {
					el.css( key, "" );
				} );
			} );

			// This is guarnteed to be there if you use jQuery.speed()
			// it also handles dequeuing the next anim...
			o.complete.call( animated[ 0 ] );
		} );
	} );
};

$.fn.extend( {
	addClass: ( function( orig ) {
		return function( classNames, speed, easing, callback ) {
			return speed ?
				$.effects.animateClass.call( this,
					{ add: classNames }, speed, easing, callback ) :
				orig.apply( this, arguments );
		};
	} )( $.fn.addClass ),

	removeClass: ( function( orig ) {
		return function( classNames, speed, easing, callback ) {
			return arguments.length > 1 ?
				$.effects.animateClass.call( this,
					{ remove: classNames }, speed, easing, callback ) :
				orig.apply( this, arguments );
		};
	} )( $.fn.removeClass ),

	toggleClass: ( function( orig ) {
		return function( classNames, force, speed, easing, callback ) {
			if ( typeof force === "boolean" || force === undefined ) {
				if ( !speed ) {

					// Without speed parameter
					return orig.apply( this, arguments );
				} else {
					return $.effects.animateClass.call( this,
						( force ? { add: classNames } : { remove: classNames } ),
						speed, easing, callback );
				}
			} else {

				// Without force parameter
				return $.effects.animateClass.call( this,
					{ toggle: classNames }, force, speed, easing );
			}
		};
	} )( $.fn.toggleClass ),

	switchClass: function( remove, add, speed, easing, callback ) {
		return $.effects.animateClass.call( this, {
			add: add,
			remove: remove
		}, speed, easing, callback );
	}
} );

} )();

/******************************************************************************/
/*********************************** EFFECTS **********************************/
/******************************************************************************/

( function() {

if ( $.expr && $.expr.pseudos && $.expr.pseudos.animated ) {
	$.expr.pseudos.animated = ( function( orig ) {
		return function( elem ) {
			return !!$( elem ).data( dataSpaceAnimated ) || orig( elem );
		};
	} )( $.expr.pseudos.animated );
}

if ( $.uiBackCompat !== false ) {
	$.extend( $.effects, {

		// Saves a set of properties in a data storage
		save: function( element, set ) {
			var i = 0, length = set.length;
			for ( ; i < length; i++ ) {
				if ( set[ i ] !== null ) {
					element.data( dataSpace + set[ i ], element[ 0 ].style[ set[ i ] ] );
				}
			}
		},

		// Restores a set of previously saved properties from a data storage
		restore: function( element, set ) {
			var val, i = 0, length = set.length;
			for ( ; i < length; i++ ) {
				if ( set[ i ] !== null ) {
					val = element.data( dataSpace + set[ i ] );
					element.css( set[ i ], val );
				}
			}
		},

		setMode: function( el, mode ) {
			if ( mode === "toggle" ) {
				mode = el.is( ":hidden" ) ? "show" : "hide";
			}
			return mode;
		},

		// Wraps the element around a wrapper that copies position properties
		createWrapper: function( element ) {

			// If the element is already wrapped, return it
			if ( element.parent().is( ".ui-effects-wrapper" ) ) {
				return element.parent();
			}

			// Wrap the element
			var props = {
					width: element.outerWidth( true ),
					height: element.outerHeight( true ),
					"float": element.css( "float" )
				},
				wrapper = $( "<div></div>" )
					.addClass( "ui-effects-wrapper" )
					.css( {
						fontSize: "100%",
						background: "transparent",
						border: "none",
						margin: 0,
						padding: 0
					} ),

				// Store the size in case width/height are defined in % - Fixes #5245
				size = {
					width: element.width(),
					height: element.height()
				},
				active = document.activeElement;

			// Support: Firefox
			// Firefox incorrectly exposes anonymous content
			// https://bugzilla.mozilla.org/show_bug.cgi?id=561664
			try {
				// eslint-disable-next-line no-unused-expressions
				active.id;
			} catch ( e ) {
				active = document.body;
			}

			element.wrap( wrapper );

			// Fixes #7595 - Elements lose focus when wrapped.
			if ( element[ 0 ] === active || $.contains( element[ 0 ], active ) ) {
				$( active ).trigger( "focus" );
			}

			// Hotfix for jQuery 1.4 since some change in wrap() seems to actually
			// lose the reference to the wrapped element
			wrapper = element.parent();

			// Transfer positioning properties to the wrapper
			if ( element.css( "position" ) === "static" ) {
				wrapper.css( { position: "relative" } );
				element.css( { position: "relative" } );
			} else {
				$.extend( props, {
					position: element.css( "position" ),
					zIndex: element.css( "z-index" )
				} );
				$.each( [ "top", "left", "bottom", "right" ], function( i, pos ) {
					props[ pos ] = element.css( pos );
					if ( isNaN( parseInt( props[ pos ], 10 ) ) ) {
						props[ pos ] = "auto";
					}
				} );
				element.css( {
					position: "relative",
					top: 0,
					left: 0,
					right: "auto",
					bottom: "auto"
				} );
			}
			element.css( size );

			return wrapper.css( props ).show();
		},

		removeWrapper: function( element ) {
			var active = document.activeElement;

			if ( element.parent().is( ".ui-effects-wrapper" ) ) {
				element.parent().replaceWith( element );

				// Fixes #7595 - Elements lose focus when wrapped.
				if ( element[ 0 ] === active || $.contains( element[ 0 ], active ) ) {
					$( active ).trigger( "focus" );
				}
			}

			return element;
		}
	} );
}

$.extend( $.effects, {
	version: "1.13.3",

	define: function( name, mode, effect ) {
		if ( !effect ) {
			effect = mode;
			mode = "effect";
		}

		$.effects.effect[ name ] = effect;
		$.effects.effect[ name ].mode = mode;

		return effect;
	},

	scaledDimensions: function( element, percent, direction ) {
		if ( percent === 0 ) {
			return {
				height: 0,
				width: 0,
				outerHeight: 0,
				outerWidth: 0
			};
		}

		var x = direction !== "horizontal" ? ( ( percent || 100 ) / 100 ) : 1,
			y = direction !== "vertical" ? ( ( percent || 100 ) / 100 ) : 1;

		return {
			height: element.height() * y,
			width: element.width() * x,
			outerHeight: element.outerHeight() * y,
			outerWidth: element.outerWidth() * x
		};

	},

	clipToBox: function( animation ) {
		return {
			width: animation.clip.right - animation.clip.left,
			height: animation.clip.bottom - animation.clip.top,
			left: animation.clip.left,
			top: animation.clip.top
		};
	},

	// Injects recently queued functions to be first in line (after "inprogress")
	unshift: function( element, queueLength, count ) {
		var queue = element.queue();

		if ( queueLength > 1 ) {
			queue.splice.apply( queue,
				[ 1, 0 ].concat( queue.splice( queueLength, count ) ) );
		}
		element.dequeue();
	},

	saveStyle: function( element ) {
		element.data( dataSpaceStyle, element[ 0 ].style.cssText );
	},

	restoreStyle: function( element ) {
		element[ 0 ].style.cssText = element.data( dataSpaceStyle ) || "";
		element.removeData( dataSpaceStyle );
	},

	mode: function( element, mode ) {
		var hidden = element.is( ":hidden" );

		if ( mode === "toggle" ) {
			mode = hidden ? "show" : "hide";
		}
		if ( hidden ? mode === "hide" : mode === "show" ) {
			mode = "none";
		}
		return mode;
	},

	// Translates a [top,left] array into a baseline value
	getBaseline: function( origin, original ) {
		var y, x;

		switch ( origin[ 0 ] ) {
		case "top":
			y = 0;
			break;
		case "middle":
			y = 0.5;
			break;
		case "bottom":
			y = 1;
			break;
		default:
			y = origin[ 0 ] / original.height;
		}

		switch ( origin[ 1 ] ) {
		case "left":
			x = 0;
			break;
		case "center":
			x = 0.5;
			break;
		case "right":
			x = 1;
			break;
		default:
			x = origin[ 1 ] / original.width;
		}

		return {
			x: x,
			y: y
		};
	},

	// Creates a placeholder element so that the original element can be made absolute
	createPlaceholder: function( element ) {
		var placeholder,
			cssPosition = element.css( "position" ),
			position = element.position();

		// Lock in margins first to account for form elements, which
		// will change margin if you explicitly set height
		// see: https://jsfiddle.net/JZSMt/3/ https://bugs.webkit.org/show_bug.cgi?id=107380
		// Support: Safari
		element.css( {
			marginTop: element.css( "marginTop" ),
			marginBottom: element.css( "marginBottom" ),
			marginLeft: element.css( "marginLeft" ),
			marginRight: element.css( "marginRight" )
		} )
		.outerWidth( element.outerWidth() )
		.outerHeight( element.outerHeight() );

		if ( /^(static|relative)/.test( cssPosition ) ) {
			cssPosition = "absolute";

			placeholder = $( "<" + element[ 0 ].nodeName + ">" ).insertAfter( element ).css( {

				// Convert inline to inline block to account for inline elements
				// that turn to inline block based on content (like img)
				display: /^(inline|ruby)/.test( element.css( "display" ) ) ?
					"inline-block" :
					"block",
				visibility: "hidden",

				// Margins need to be set to account for margin collapse
				marginTop: element.css( "marginTop" ),
				marginBottom: element.css( "marginBottom" ),
				marginLeft: element.css( "marginLeft" ),
				marginRight: element.css( "marginRight" ),
				"float": element.css( "float" )
			} )
			.outerWidth( element.outerWidth() )
			.outerHeight( element.outerHeight() )
			.addClass( "ui-effects-placeholder" );

			element.data( dataSpace + "placeholder", placeholder );
		}

		element.css( {
			position: cssPosition,
			left: position.left,
			top: position.top
		} );

		return placeholder;
	},

	removePlaceholder: function( element ) {
		var dataKey = dataSpace + "placeholder",
				placeholder = element.data( dataKey );

		if ( placeholder ) {
			placeholder.remove();
			element.removeData( dataKey );
		}
	},

	// Removes a placeholder if it exists and restores
	// properties that were modified during placeholder creation
	cleanUp: function( element ) {
		$.effects.restoreStyle( element );
		$.effects.removePlaceholder( element );
	},

	setTransition: function( element, list, factor, value ) {
		value = value || {};
		$.each( list, function( i, x ) {
			var unit = element.cssUnit( x );
			if ( unit[ 0 ] > 0 ) {
				value[ x ] = unit[ 0 ] * factor + unit[ 1 ];
			}
		} );
		return value;
	}
} );

// Return an effect options object for the given parameters:
function _normalizeArguments( effect, options, speed, callback ) {

	// Allow passing all options as the first parameter
	if ( $.isPlainObject( effect ) ) {
		options = effect;
		effect = effect.effect;
	}

	// Convert to an object
	effect = { effect: effect };

	// Catch (effect, null, ...)
	if ( options == null ) {
		options = {};
	}

	// Catch (effect, callback)
	if ( typeof options === "function" ) {
		callback = options;
		speed = null;
		options = {};
	}

	// Catch (effect, speed, ?)
	if ( typeof options === "number" || $.fx.speeds[ options ] ) {
		callback = speed;
		speed = options;
		options = {};
	}

	// Catch (effect, options, callback)
	if ( typeof speed === "function" ) {
		callback = speed;
		speed = null;
	}

	// Add options to effect
	if ( options ) {
		$.extend( effect, options );
	}

	speed = speed || options.duration;
	effect.duration = $.fx.off ? 0 :
		typeof speed === "number" ? speed :
		speed in $.fx.speeds ? $.fx.speeds[ speed ] :
		$.fx.speeds._default;

	effect.complete = callback || options.complete;

	return effect;
}

function standardAnimationOption( option ) {

	// Valid standard speeds (nothing, number, named speed)
	if ( !option || typeof option === "number" || $.fx.speeds[ option ] ) {
		return true;
	}

	// Invalid strings - treat as "normal" speed
	if ( typeof option === "string" && !$.effects.effect[ option ] ) {
		return true;
	}

	// Complete callback
	if ( typeof option === "function" ) {
		return true;
	}

	// Options hash (but not naming an effect)
	if ( typeof option === "object" && !option.effect ) {
		return true;
	}

	// Didn't match any standard API
	return false;
}

$.fn.extend( {
	effect: function( /* effect, options, speed, callback */ ) {
		var args = _normalizeArguments.apply( this, arguments ),
			effectMethod = $.effects.effect[ args.effect ],
			defaultMode = effectMethod.mode,
			queue = args.queue,
			queueName = queue || "fx",
			complete = args.complete,
			mode = args.mode,
			modes = [],
			prefilter = function( next ) {
				var el = $( this ),
					normalizedMode = $.effects.mode( el, mode ) || defaultMode;

				// Sentinel for duck-punching the :animated pseudo-selector
				el.data( dataSpaceAnimated, true );

				// Save effect mode for later use,
				// we can't just call $.effects.mode again later,
				// as the .show() below destroys the initial state
				modes.push( normalizedMode );

				// See $.uiBackCompat inside of run() for removal of defaultMode in 1.14
				if ( defaultMode && ( normalizedMode === "show" ||
						( normalizedMode === defaultMode && normalizedMode === "hide" ) ) ) {
					el.show();
				}

				if ( !defaultMode || normalizedMode !== "none" ) {
					$.effects.saveStyle( el );
				}

				if ( typeof next === "function" ) {
					next();
				}
			};

		if ( $.fx.off || !effectMethod ) {

			// Delegate to the original method (e.g., .show()) if possible
			if ( mode ) {
				return this[ mode ]( args.duration, complete );
			} else {
				return this.each( function() {
					if ( complete ) {
						complete.call( this );
					}
				} );
			}
		}

		function run( next ) {
			var elem = $( this );

			function cleanup() {
				elem.removeData( dataSpaceAnimated );

				$.effects.cleanUp( elem );

				if ( args.mode === "hide" ) {
					elem.hide();
				}

				done();
			}

			function done() {
				if ( typeof complete === "function" ) {
					complete.call( elem[ 0 ] );
				}

				if ( typeof next === "function" ) {
					next();
				}
			}

			// Override mode option on a per element basis,
			// as toggle can be either show or hide depending on element state
			args.mode = modes.shift();

			if ( $.uiBackCompat !== false && !defaultMode ) {
				if ( elem.is( ":hidden" ) ? mode === "hide" : mode === "show" ) {

					// Call the core method to track "olddisplay" properly
					elem[ mode ]();
					done();
				} else {
					effectMethod.call( elem[ 0 ], args, done );
				}
			} else {
				if ( args.mode === "none" ) {

					// Call the core method to track "olddisplay" properly
					elem[ mode ]();
					done();
				} else {
					effectMethod.call( elem[ 0 ], args, cleanup );
				}
			}
		}

		// Run prefilter on all elements first to ensure that
		// any showing or hiding happens before placeholder creation,
		// which ensures that any layout changes are correctly captured.
		return queue === false ?
			this.each( prefilter ).each( run ) :
			this.queue( queueName, prefilter ).queue( queueName, run );
	},

	show: ( function( orig ) {
		return function( option ) {
			if ( standardAnimationOption( option ) ) {
				return orig.apply( this, arguments );
			} else {
				var args = _normalizeArguments.apply( this, arguments );
				args.mode = "show";
				return this.effect.call( this, args );
			}
		};
	} )( $.fn.show ),

	hide: ( function( orig ) {
		return function( option ) {
			if ( standardAnimationOption( option ) ) {
				return orig.apply( this, arguments );
			} else {
				var args = _normalizeArguments.apply( this, arguments );
				args.mode = "hide";
				return this.effect.call( this, args );
			}
		};
	} )( $.fn.hide ),

	toggle: ( function( orig ) {
		return function( option ) {
			if ( standardAnimationOption( option ) || typeof option === "boolean" ) {
				return orig.apply( this, arguments );
			} else {
				var args = _normalizeArguments.apply( this, arguments );
				args.mode = "toggle";
				return this.effect.call( this, args );
			}
		};
	} )( $.fn.toggle ),

	cssUnit: function( key ) {
		var style = this.css( key ),
			val = [];

		$.each( [ "em", "px", "%", "pt" ], function( i, unit ) {
			if ( style.indexOf( unit ) > 0 ) {
				val = [ parseFloat( style ), unit ];
			}
		} );
		return val;
	},

	cssClip: function( clipObj ) {
		if ( clipObj ) {
			return this.css( "clip", "rect(" + clipObj.top + "px " + clipObj.right + "px " +
				clipObj.bottom + "px " + clipObj.left + "px)" );
		}
		return parseClip( this.css( "clip" ), this );
	},

	transfer: function( options, done ) {
		var element = $( this ),
			target = $( options.to ),
			targetFixed = target.css( "position" ) === "fixed",
			body = $( "body" ),
			fixTop = targetFixed ? body.scrollTop() : 0,
			fixLeft = targetFixed ? body.scrollLeft() : 0,
			endPosition = target.offset(),
			animation = {
				top: endPosition.top - fixTop,
				left: endPosition.left - fixLeft,
				height: target.innerHeight(),
				width: target.innerWidth()
			},
			startPosition = element.offset(),
			transfer = $( "<div class='ui-effects-transfer'></div>" );

		transfer
			.appendTo( "body" )
			.addClass( options.className )
			.css( {
				top: startPosition.top - fixTop,
				left: startPosition.left - fixLeft,
				height: element.innerHeight(),
				width: element.innerWidth(),
				position: targetFixed ? "fixed" : "absolute"
			} )
			.animate( animation, options.duration, options.easing, function() {
				transfer.remove();
				if ( typeof done === "function" ) {
					done();
				}
			} );
	}
} );

function parseClip( str, element ) {
		var outerWidth = element.outerWidth(),
			outerHeight = element.outerHeight(),
			clipRegex = /^rect\((-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto)\)$/,
			values = clipRegex.exec( str ) || [ "", 0, outerWidth, outerHeight, 0 ];

		return {
			top: parseFloat( values[ 1 ] ) || 0,
			right: values[ 2 ] === "auto" ? outerWidth : parseFloat( values[ 2 ] ),
			bottom: values[ 3 ] === "auto" ? outerHeight : parseFloat( values[ 3 ] ),
			left: parseFloat( values[ 4 ] ) || 0
		};
}

$.fx.step.clip = function( fx ) {
	if ( !fx.clipInit ) {
		fx.start = $( fx.elem ).cssClip();
		if ( typeof fx.end === "string" ) {
			fx.end = parseClip( fx.end, fx.elem );
		}
		fx.clipInit = true;
	}

	$( fx.elem ).cssClip( {
		top: fx.pos * ( fx.end.top - fx.start.top ) + fx.start.top,
		right: fx.pos * ( fx.end.right - fx.start.right ) + fx.start.right,
		bottom: fx.pos * ( fx.end.bottom - fx.start.bottom ) + fx.start.bottom,
		left: fx.pos * ( fx.end.left - fx.start.left ) + fx.start.left
	} );
};

} )();

/******************************************************************************/
/*********************************** EASING ***********************************/
/******************************************************************************/

( function() {

// Based on easing equations from Robert Penner (http://robertpenner.com/easing)

var baseEasings = {};

$.each( [ "Quad", "Cubic", "Quart", "Quint", "Expo" ], function( i, name ) {
	baseEasings[ name ] = function( p ) {
		return Math.pow( p, i + 2 );
	};
} );

$.extend( baseEasings, {
	Sine: function( p ) {
		return 1 - Math.cos( p * Math.PI / 2 );
	},
	Circ: function( p ) {
		return 1 - Math.sqrt( 1 - p * p );
	},
	Elastic: function( p ) {
		return p === 0 || p === 1 ? p :
			-Math.pow( 2, 8 * ( p - 1 ) ) * Math.sin( ( ( p - 1 ) * 80 - 7.5 ) * Math.PI / 15 );
	},
	Back: function( p ) {
		return p * p * ( 3 * p - 2 );
	},
	Bounce: function( p ) {
		var pow2,
			bounce = 4;

		while ( p < ( ( pow2 = Math.pow( 2, --bounce ) ) - 1 ) / 11 ) {}
		return 1 / Math.pow( 4, 3 - bounce ) - 7.5625 * Math.pow( ( pow2 * 3 - 2 ) / 22 - p, 2 );
	}
} );

$.each( baseEasings, function( name, easeIn ) {
	$.easing[ "easeIn" + name ] = easeIn;
	$.easing[ "easeOut" + name ] = function( p ) {
		return 1 - easeIn( 1 - p );
	};
	$.easing[ "easeInOut" + name ] = function( p ) {
		return p < 0.5 ?
			easeIn( p * 2 ) / 2 :
			1 - easeIn( p * -2 + 2 ) / 2;
	};
} );

} )();

var effect = $.effects;


/*!
 * jQuery UI Effects Blind 1.13.3
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Blind Effect
//>>group: Effects
//>>description: Blinds the element.
//>>docs: https://api.jqueryui.com/blind-effect/
//>>demos: https://jqueryui.com/effect/


var effectsEffectBlind = $.effects.define( "blind", "hide", function( options, done ) {
	var map = {
			up: [ "bottom", "top" ],
			vertical: [ "bottom", "top" ],
			down: [ "top", "bottom" ],
			left: [ "right", "left" ],
			horizontal: [ "right", "left" ],
			right: [ "left", "right" ]
		},
		element = $( this ),
		direction = options.direction || "up",
		start = element.cssClip(),
		animate = { clip: $.extend( {}, start ) },
		placeholder = $.effects.createPlaceholder( element );

	animate.clip[ map[ direction ][ 0 ] ] = animate.clip[ map[ direction ][ 1 ] ];

	if ( options.mode === "show" ) {
		element.cssClip( animate.clip );
		if ( placeholder ) {
			placeholder.css( $.effects.clipToBox( animate ) );
		}

		animate.clip = start;
	}

	if ( placeholder ) {
		placeholder.animate( $.effects.clipToBox( animate ), options.duration, options.easing );
	}

	element.animate( animate, {
		queue: false,
		duration: options.duration,
		easing: options.easing,
		complete: done
	} );
} );


/*!
 * jQuery UI Effects Bounce 1.13.3
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Bounce Effect
//>>group: Effects
//>>description: Bounces an element horizontally or vertically n times.
//>>docs: https://api.jqueryui.com/bounce-effect/
//>>demos: https://jqueryui.com/effect/


var effectsEffectBounce = $.effects.define( "bounce", function( options, done ) {
	var upAnim, downAnim, refValue,
		element = $( this ),

		// Defaults:
		mode = options.mode,
		hide = mode === "hide",
		show = mode === "show",
		direction = options.direction || "up",
		distance = options.distance,
		times = options.times || 5,

		// Number of internal animations
		anims = times * 2 + ( show || hide ? 1 : 0 ),
		speed = options.duration / anims,
		easing = options.easing,

		// Utility:
		ref = ( direction === "up" || direction === "down" ) ? "top" : "left",
		motion = ( direction === "up" || direction === "left" ),
		i = 0,

		queuelen = element.queue().length;

	$.effects.createPlaceholder( element );

	refValue = element.css( ref );

	// Default distance for the BIGGEST bounce is the outer Distance / 3
	if ( !distance ) {
		distance = element[ ref === "top" ? "outerHeight" : "outerWidth" ]() / 3;
	}

	if ( show ) {
		downAnim = { opacity: 1 };
		downAnim[ ref ] = refValue;

		// If we are showing, force opacity 0 and set the initial position
		// then do the "first" animation
		element
			.css( "opacity", 0 )
			.css( ref, motion ? -distance * 2 : distance * 2 )
			.animate( downAnim, speed, easing );
	}

	// Start at the smallest distance if we are hiding
	if ( hide ) {
		distance = distance / Math.pow( 2, times - 1 );
	}

	downAnim = {};
	downAnim[ ref ] = refValue;

	// Bounces up/down/left/right then back to 0 -- times * 2 animations happen here
	for ( ; i < times; i++ ) {
		upAnim = {};
		upAnim[ ref ] = ( motion ? "-=" : "+=" ) + distance;

		element
			.animate( upAnim, speed, easing )
			.animate( downAnim, speed, easing );

		distance = hide ? distance * 2 : distance / 2;
	}

	// Last Bounce when Hiding
	if ( hide ) {
		upAnim = { opacity: 0 };
		upAnim[ ref ] = ( motion ? "-=" : "+=" ) + distance;

		element.animate( upAnim, speed, easing );
	}

	element.queue( done );

	$.effects.unshift( element, queuelen, anims + 1 );
} );


/*!
 * jQuery UI Effects Clip 1.13.3
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Clip Effect
//>>group: Effects
//>>description: Clips the element on and off like an old TV.
//>>docs: https://api.jqueryui.com/clip-effect/
//>>demos: https://jqueryui.com/effect/


var effectsEffectClip = $.effects.define( "clip", "hide", function( options, done ) {
	var start,
		animate = {},
		element = $( this ),
		direction = options.direction || "vertical",
		both = direction === "both",
		horizontal = both || direction === "horizontal",
		vertical = both || direction === "vertical";

	start = element.cssClip();
	animate.clip = {
		top: vertical ? ( start.bottom - start.top ) / 2 : start.top,
		right: horizontal ? ( start.right - start.left ) / 2 : start.right,
		bottom: vertical ? ( start.bottom - start.top ) / 2 : start.bottom,
		left: horizontal ? ( start.right - start.left ) / 2 : start.left
	};

	$.effects.createPlaceholder( element );

	if ( options.mode === "show" ) {
		element.cssClip( animate.clip );
		animate.clip = start;
	}

	element.animate( animate, {
		queue: false,
		duration: options.duration,
		easing: options.easing,
		complete: done
	} );

} );


/*!
 * jQuery UI Effects Drop 1.13.3
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Drop Effect
//>>group: Effects
//>>description: Moves an element in one direction and hides it at the same time.
//>>docs: https://api.jqueryui.com/drop-effect/
//>>demos: https://jqueryui.com/effect/


var effectsEffectDrop = $.effects.define( "drop", "hide", function( options, done ) {

	var distance,
		element = $( this ),
		mode = options.mode,
		show = mode === "show",
		direction = options.direction || "left",
		ref = ( direction === "up" || direction === "down" ) ? "top" : "left",
		motion = ( direction === "up" || direction === "left" ) ? "-=" : "+=",
		oppositeMotion = ( motion === "+=" ) ? "-=" : "+=",
		animation = {
			opacity: 0
		};

	$.effects.createPlaceholder( element );

	distance = options.distance ||
		element[ ref === "top" ? "outerHeight" : "outerWidth" ]( true ) / 2;

	animation[ ref ] = motion + distance;

	if ( show ) {
		element.css( animation );

		animation[ ref ] = oppositeMotion + distance;
		animation.opacity = 1;
	}

	// Animate
	element.animate( animation, {
		queue: false,
		duration: options.duration,
		easing: options.easing,
		complete: done
	} );
} );


/*!
 * jQuery UI Effects Explode 1.13.3
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Explode Effect
//>>group: Effects
/* eslint-disable max-len */
//>>description: Explodes an element in all directions into n pieces. Implodes an element to its original wholeness.
/* eslint-enable max-len */
//>>docs: https://api.jqueryui.com/explode-effect/
//>>demos: https://jqueryui.com/effect/


var effectsEffectExplode = $.effects.define( "explode", "hide", function( options, done ) {

	var i, j, left, top, mx, my,
		rows = options.pieces ? Math.round( Math.sqrt( options.pieces ) ) : 3,
		cells = rows,
		element = $( this ),
		mode = options.mode,
		show = mode === "show",

		// Show and then visibility:hidden the element before calculating offset
		offset = element.show().css( "visibility", "hidden" ).offset(),

		// Width and height of a piece
		width = Math.ceil( element.outerWidth() / cells ),
		height = Math.ceil( element.outerHeight() / rows ),
		pieces = [];

	// Children animate complete:
	function childComplete() {
		pieces.push( this );
		if ( pieces.length === rows * cells ) {
			animComplete();
		}
	}

	// Clone the element for each row and cell.
	for ( i = 0; i < rows; i++ ) { // ===>
		top = offset.top + i * height;
		my = i - ( rows - 1 ) / 2;

		for ( j = 0; j < cells; j++ ) { // |||
			left = offset.left + j * width;
			mx = j - ( cells - 1 ) / 2;

			// Create a clone of the now hidden main element that will be absolute positioned
			// within a wrapper div off the -left and -top equal to size of our pieces
			element
				.clone()
				.appendTo( "body" )
				.wrap( "<div></div>" )
				.css( {
					position: "absolute",
					visibility: "visible",
					left: -j * width,
					top: -i * height
				} )

				// Select the wrapper - make it overflow: hidden and absolute positioned based on
				// where the original was located +left and +top equal to the size of pieces
				.parent()
					.addClass( "ui-effects-explode" )
					.css( {
						position: "absolute",
						overflow: "hidden",
						width: width,
						height: height,
						left: left + ( show ? mx * width : 0 ),
						top: top + ( show ? my * height : 0 ),
						opacity: show ? 0 : 1
					} )
					.animate( {
						left: left + ( show ? 0 : mx * width ),
						top: top + ( show ? 0 : my * height ),
						opacity: show ? 1 : 0
					}, options.duration || 500, options.easing, childComplete );
		}
	}

	function animComplete() {
		element.css( {
			visibility: "visible"
		} );
		$( pieces ).remove();
		done();
	}
} );


/*!
 * jQuery UI Effects Fade 1.13.3
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Fade Effect
//>>group: Effects
//>>description: Fades the element.
//>>docs: https://api.jqueryui.com/fade-effect/
//>>demos: https://jqueryui.com/effect/


var effectsEffectFade = $.effects.define( "fade", "toggle", function( options, done ) {
	var show = options.mode === "show";

	$( this )
		.css( "opacity", show ? 0 : 1 )
		.animate( {
			opacity: show ? 1 : 0
		}, {
			queue: false,
			duration: options.duration,
			easing: options.easing,
			complete: done
		} );
} );


/*!
 * jQuery UI Effects Fold 1.13.3
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Fold Effect
//>>group: Effects
//>>description: Folds an element first horizontally and then vertically.
//>>docs: https://api.jqueryui.com/fold-effect/
//>>demos: https://jqueryui.com/effect/


var effectsEffectFold = $.effects.define( "fold", "hide", function( options, done ) {

	// Create element
	var element = $( this ),
		mode = options.mode,
		show = mode === "show",
		hide = mode === "hide",
		size = options.size || 15,
		percent = /([0-9]+)%/.exec( size ),
		horizFirst = !!options.horizFirst,
		ref = horizFirst ? [ "right", "bottom" ] : [ "bottom", "right" ],
		duration = options.duration / 2,

		placeholder = $.effects.createPlaceholder( element ),

		start = element.cssClip(),
		animation1 = { clip: $.extend( {}, start ) },
		animation2 = { clip: $.extend( {}, start ) },

		distance = [ start[ ref[ 0 ] ], start[ ref[ 1 ] ] ],

		queuelen = element.queue().length;

	if ( percent ) {
		size = parseInt( percent[ 1 ], 10 ) / 100 * distance[ hide ? 0 : 1 ];
	}
	animation1.clip[ ref[ 0 ] ] = size;
	animation2.clip[ ref[ 0 ] ] = size;
	animation2.clip[ ref[ 1 ] ] = 0;

	if ( show ) {
		element.cssClip( animation2.clip );
		if ( placeholder ) {
			placeholder.css( $.effects.clipToBox( animation2 ) );
		}

		animation2.clip = start;
	}

	// Animate
	element
		.queue( function( next ) {
			if ( placeholder ) {
				placeholder
					.animate( $.effects.clipToBox( animation1 ), duration, options.easing )
					.animate( $.effects.clipToBox( animation2 ), duration, options.easing );
			}

			next();
		} )
		.animate( animation1, duration, options.easing )
		.animate( animation2, duration, options.easing )
		.queue( done );

	$.effects.unshift( element, queuelen, 4 );
} );


/*!
 * jQuery UI Effects Highlight 1.13.3
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Highlight Effect
//>>group: Effects
//>>description: Highlights the background of an element in a defined color for a custom duration.
//>>docs: https://api.jqueryui.com/highlight-effect/
//>>demos: https://jqueryui.com/effect/


var effectsEffectHighlight = $.effects.define( "highlight", "show", function( options, done ) {
	var element = $( this ),
		animation = {
			backgroundColor: element.css( "backgroundColor" )
		};

	if ( options.mode === "hide" ) {
		animation.opacity = 0;
	}

	$.effects.saveStyle( element );

	element
		.css( {
			backgroundImage: "none",
			backgroundColor: options.color || "#ffff99"
		} )
		.animate( animation, {
			queue: false,
			duration: options.duration,
			easing: options.easing,
			complete: done
		} );
} );


/*!
 * jQuery UI Effects Size 1.13.3
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Size Effect
//>>group: Effects
//>>description: Resize an element to a specified width and height.
//>>docs: https://api.jqueryui.com/size-effect/
//>>demos: https://jqueryui.com/effect/


var effectsEffectSize = $.effects.define( "size", function( options, done ) {

	// Create element
	var baseline, factor, temp,
		element = $( this ),

		// Copy for children
		cProps = [ "fontSize" ],
		vProps = [ "borderTopWidth", "borderBottomWidth", "paddingTop", "paddingBottom" ],
		hProps = [ "borderLeftWidth", "borderRightWidth", "paddingLeft", "paddingRight" ],

		// Set options
		mode = options.mode,
		restore = mode !== "effect",
		scale = options.scale || "both",
		origin = options.origin || [ "middle", "center" ],
		position = element.css( "position" ),
		pos = element.position(),
		original = $.effects.scaledDimensions( element ),
		from = options.from || original,
		to = options.to || $.effects.scaledDimensions( element, 0 );

	$.effects.createPlaceholder( element );

	if ( mode === "show" ) {
		temp = from;
		from = to;
		to = temp;
	}

	// Set scaling factor
	factor = {
		from: {
			y: from.height / original.height,
			x: from.width / original.width
		},
		to: {
			y: to.height / original.height,
			x: to.width / original.width
		}
	};

	// Scale the css box
	if ( scale === "box" || scale === "both" ) {

		// Vertical props scaling
		if ( factor.from.y !== factor.to.y ) {
			from = $.effects.setTransition( element, vProps, factor.from.y, from );
			to = $.effects.setTransition( element, vProps, factor.to.y, to );
		}

		// Horizontal props scaling
		if ( factor.from.x !== factor.to.x ) {
			from = $.effects.setTransition( element, hProps, factor.from.x, from );
			to = $.effects.setTransition( element, hProps, factor.to.x, to );
		}
	}

	// Scale the content
	if ( scale === "content" || scale === "both" ) {

		// Vertical props scaling
		if ( factor.from.y !== factor.to.y ) {
			from = $.effects.setTransition( element, cProps, factor.from.y, from );
			to = $.effects.setTransition( element, cProps, factor.to.y, to );
		}
	}

	// Adjust the position properties based on the provided origin points
	if ( origin ) {
		baseline = $.effects.getBaseline( origin, original );
		from.top = ( original.outerHeight - from.outerHeight ) * baseline.y + pos.top;
		from.left = ( original.outerWidth - from.outerWidth ) * baseline.x + pos.left;
		to.top = ( original.outerHeight - to.outerHeight ) * baseline.y + pos.top;
		to.left = ( original.outerWidth - to.outerWidth ) * baseline.x + pos.left;
	}
	delete from.outerHeight;
	delete from.outerWidth;
	element.css( from );

	// Animate the children if desired
	if ( scale === "content" || scale === "both" ) {

		vProps = vProps.concat( [ "marginTop", "marginBottom" ] ).concat( cProps );
		hProps = hProps.concat( [ "marginLeft", "marginRight" ] );

		// Only animate children with width attributes specified
		// TODO: is this right? should we include anything with css width specified as well
		element.find( "*[width]" ).each( function() {
			var child = $( this ),
				childOriginal = $.effects.scaledDimensions( child ),
				childFrom = {
					height: childOriginal.height * factor.from.y,
					width: childOriginal.width * factor.from.x,
					outerHeight: childOriginal.outerHeight * factor.from.y,
					outerWidth: childOriginal.outerWidth * factor.from.x
				},
				childTo = {
					height: childOriginal.height * factor.to.y,
					width: childOriginal.width * factor.to.x,
					outerHeight: childOriginal.height * factor.to.y,
					outerWidth: childOriginal.width * factor.to.x
				};

			// Vertical props scaling
			if ( factor.from.y !== factor.to.y ) {
				childFrom = $.effects.setTransition( child, vProps, factor.from.y, childFrom );
				childTo = $.effects.setTransition( child, vProps, factor.to.y, childTo );
			}

			// Horizontal props scaling
			if ( factor.from.x !== factor.to.x ) {
				childFrom = $.effects.setTransition( child, hProps, factor.from.x, childFrom );
				childTo = $.effects.setTransition( child, hProps, factor.to.x, childTo );
			}

			if ( restore ) {
				$.effects.saveStyle( child );
			}

			// Animate children
			child.css( childFrom );
			child.animate( childTo, options.duration, options.easing, function() {

				// Restore children
				if ( restore ) {
					$.effects.restoreStyle( child );
				}
			} );
		} );
	}

	// Animate
	element.animate( to, {
		queue: false,
		duration: options.duration,
		easing: options.easing,
		complete: function() {

			var offset = element.offset();

			if ( to.opacity === 0 ) {
				element.css( "opacity", from.opacity );
			}

			if ( !restore ) {
				element
					.css( "position", position === "static" ? "relative" : position )
					.offset( offset );

				// Need to save style here so that automatic style restoration
				// doesn't restore to the original styles from before the animation.
				$.effects.saveStyle( element );
			}

			done();
		}
	} );

} );


/*!
 * jQuery UI Effects Scale 1.13.3
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Scale Effect
//>>group: Effects
//>>description: Grows or shrinks an element and its content.
//>>docs: https://api.jqueryui.com/scale-effect/
//>>demos: https://jqueryui.com/effect/


var effectsEffectScale = $.effects.define( "scale", function( options, done ) {

	// Create element
	var el = $( this ),
		mode = options.mode,
		percent = parseInt( options.percent, 10 ) ||
			( parseInt( options.percent, 10 ) === 0 ? 0 : ( mode !== "effect" ? 0 : 100 ) ),

		newOptions = $.extend( true, {
			from: $.effects.scaledDimensions( el ),
			to: $.effects.scaledDimensions( el, percent, options.direction || "both" ),
			origin: options.origin || [ "middle", "center" ]
		}, options );

	// Fade option to support puff
	if ( options.fade ) {
		newOptions.from.opacity = 1;
		newOptions.to.opacity = 0;
	}

	$.effects.effect.size.call( this, newOptions, done );
} );


/*!
 * jQuery UI Effects Puff 1.13.3
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Puff Effect
//>>group: Effects
//>>description: Creates a puff effect by scaling the element up and hiding it at the same time.
//>>docs: https://api.jqueryui.com/puff-effect/
//>>demos: https://jqueryui.com/effect/


var effectsEffectPuff = $.effects.define( "puff", "hide", function( options, done ) {
	var newOptions = $.extend( true, {}, options, {
		fade: true,
		percent: parseInt( options.percent, 10 ) || 150
	} );

	$.effects.effect.scale.call( this, newOptions, done );
} );


/*!
 * jQuery UI Effects Pulsate 1.13.3
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Pulsate Effect
//>>group: Effects
//>>description: Pulsates an element n times by changing the opacity to zero and back.
//>>docs: https://api.jqueryui.com/pulsate-effect/
//>>demos: https://jqueryui.com/effect/


var effectsEffectPulsate = $.effects.define( "pulsate", "show", function( options, done ) {
	var element = $( this ),
		mode = options.mode,
		show = mode === "show",
		hide = mode === "hide",
		showhide = show || hide,

		// Showing or hiding leaves off the "last" animation
		anims = ( ( options.times || 5 ) * 2 ) + ( showhide ? 1 : 0 ),
		duration = options.duration / anims,
		animateTo = 0,
		i = 1,
		queuelen = element.queue().length;

	if ( show || !element.is( ":visible" ) ) {
		element.css( "opacity", 0 ).show();
		animateTo = 1;
	}

	// Anims - 1 opacity "toggles"
	for ( ; i < anims; i++ ) {
		element.animate( { opacity: animateTo }, duration, options.easing );
		animateTo = 1 - animateTo;
	}

	element.animate( { opacity: animateTo }, duration, options.easing );

	element.queue( done );

	$.effects.unshift( element, queuelen, anims + 1 );
} );


/*!
 * jQuery UI Effects Shake 1.13.3
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Shake Effect
//>>group: Effects
//>>description: Shakes an element horizontally or vertically n times.
//>>docs: https://api.jqueryui.com/shake-effect/
//>>demos: https://jqueryui.com/effect/


var effectsEffectShake = $.effects.define( "shake", function( options, done ) {

	var i = 1,
		element = $( this ),
		direction = options.direction || "left",
		distance = options.distance || 20,
		times = options.times || 3,
		anims = times * 2 + 1,
		speed = Math.round( options.duration / anims ),
		ref = ( direction === "up" || direction === "down" ) ? "top" : "left",
		positiveMotion = ( direction === "up" || direction === "left" ),
		animation = {},
		animation1 = {},
		animation2 = {},

		queuelen = element.queue().length;

	$.effects.createPlaceholder( element );

	// Animation
	animation[ ref ] = ( positiveMotion ? "-=" : "+=" ) + distance;
	animation1[ ref ] = ( positiveMotion ? "+=" : "-=" ) + distance * 2;
	animation2[ ref ] = ( positiveMotion ? "-=" : "+=" ) + distance * 2;

	// Animate
	element.animate( animation, speed, options.easing );

	// Shakes
	for ( ; i < times; i++ ) {
		element
			.animate( animation1, speed, options.easing )
			.animate( animation2, speed, options.easing );
	}

	element
		.animate( animation1, speed, options.easing )
		.animate( animation, speed / 2, options.easing )
		.queue( done );

	$.effects.unshift( element, queuelen, anims + 1 );
} );


/*!
 * jQuery UI Effects Slide 1.13.3
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Slide Effect
//>>group: Effects
//>>description: Slides an element in and out of the viewport.
//>>docs: https://api.jqueryui.com/slide-effect/
//>>demos: https://jqueryui.com/effect/


var effectsEffectSlide = $.effects.define( "slide", "show", function( options, done ) {
	var startClip, startRef,
		element = $( this ),
		map = {
			up: [ "bottom", "top" ],
			down: [ "top", "bottom" ],
			left: [ "right", "left" ],
			right: [ "left", "right" ]
		},
		mode = options.mode,
		direction = options.direction || "left",
		ref = ( direction === "up" || direction === "down" ) ? "top" : "left",
		positiveMotion = ( direction === "up" || direction === "left" ),
		distance = options.distance ||
			element[ ref === "top" ? "outerHeight" : "outerWidth" ]( true ),
		animation = {};

	$.effects.createPlaceholder( element );

	startClip = element.cssClip();
	startRef = element.position()[ ref ];

	// Define hide animation
	animation[ ref ] = ( positiveMotion ? -1 : 1 ) * distance + startRef;
	animation.clip = element.cssClip();
	animation.clip[ map[ direction ][ 1 ] ] = animation.clip[ map[ direction ][ 0 ] ];

	// Reverse the animation if we're showing
	if ( mode === "show" ) {
		element.cssClip( animation.clip );
		element.css( ref, animation[ ref ] );
		animation.clip = startClip;
		animation[ ref ] = startRef;
	}

	// Actually animate
	element.animate( animation, {
		queue: false,
		duration: options.duration,
		easing: options.easing,
		complete: done
	} );
} );


/*!
 * jQuery UI Effects Transfer 1.13.3
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Transfer Effect
//>>group: Effects
//>>description: Displays a transfer effect from one element to another.
//>>docs: https://api.jqueryui.com/transfer-effect/
//>>demos: https://jqueryui.com/effect/


var effect;
if ( $.uiBackCompat !== false ) {
	effect = $.effects.define( "transfer", function( options, done ) {
		$( this ).transfer( options, done );
	} );
}
var effectsEffectTransfer = effect;


/*!
 * jQuery UI Mouse 1.13.3
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Mouse
//>>group: Widgets
//>>description: Abstracts mouse-based interactions to assist in creating certain widgets.
//>>docs: https://api.jqueryui.com/mouse/


var mouseHandled = false;
$( document ).on( "mouseup", function() {
	mouseHandled = false;
} );

var widgetsMouse = $.widget( "ui.mouse", {
	version: "1.13.3",
	options: {
		cancel: "input, textarea, button, select, option",
		distance: 1,
		delay: 0
	},
	_mouseInit: function() {
		var that = this;

		this.element
			.on( "mousedown." + this.widgetName, function( event ) {
				return that._mouseDown( event );
			} )
			.on( "click." + this.widgetName, function( event ) {
				if ( true === $.data( event.target, that.widgetName + ".preventClickEvent" ) ) {
					$.removeData( event.target, that.widgetName + ".preventClickEvent" );
					event.stopImmediatePropagation();
					return false;
				}
			} );

		this.started = false;
	},

	// TODO: make sure destroying one instance of mouse doesn't mess with
	// other instances of mouse
	_mouseDestroy: function() {
		this.element.off( "." + this.widgetName );
		if ( this._mouseMoveDelegate ) {
			this.document
				.off( "mousemove." + this.widgetName, this._mouseMoveDelegate )
				.off( "mouseup." + this.widgetName, this._mouseUpDelegate );
		}
	},

	_mouseDown: function( event ) {

		// don't let more than one widget handle mouseStart
		if ( mouseHandled ) {
			return;
		}

		this._mouseMoved = false;

		// We may have missed mouseup (out of window)
		if ( this._mouseStarted ) {
			this._mouseUp( event );
		}

		this._mouseDownEvent = event;

		var that = this,
			btnIsLeft = ( event.which === 1 ),

			// event.target.nodeName works around a bug in IE 8 with
			// disabled inputs (#7620)
			elIsCancel = ( typeof this.options.cancel === "string" && event.target.nodeName ?
				$( event.target ).closest( this.options.cancel ).length : false );
		if ( !btnIsLeft || elIsCancel || !this._mouseCapture( event ) ) {
			return true;
		}

		this.mouseDelayMet = !this.options.delay;
		if ( !this.mouseDelayMet ) {
			this._mouseDelayTimer = setTimeout( function() {
				that.mouseDelayMet = true;
			}, this.options.delay );
		}

		if ( this._mouseDistanceMet( event ) && this._mouseDelayMet( event ) ) {
			this._mouseStarted = ( this._mouseStart( event ) !== false );
			if ( !this._mouseStarted ) {
				event.preventDefault();
				return true;
			}
		}

		// Click event may never have fired (Gecko & Opera)
		if ( true === $.data( event.target, this.widgetName + ".preventClickEvent" ) ) {
			$.removeData( event.target, this.widgetName + ".preventClickEvent" );
		}

		// These delegates are required to keep context
		this._mouseMoveDelegate = function( event ) {
			return that._mouseMove( event );
		};
		this._mouseUpDelegate = function( event ) {
			return that._mouseUp( event );
		};

		this.document
			.on( "mousemove." + this.widgetName, this._mouseMoveDelegate )
			.on( "mouseup." + this.widgetName, this._mouseUpDelegate );

		event.preventDefault();

		mouseHandled = true;
		return true;
	},

	_mouseMove: function( event ) {

		// Only check for mouseups outside the document if you've moved inside the document
		// at least once. This prevents the firing of mouseup in the case of IE<9, which will
		// fire a mousemove event if content is placed under the cursor. See #7778
		// Support: IE <9
		if ( this._mouseMoved ) {

			// IE mouseup check - mouseup happened when mouse was out of window
			if ( $.ui.ie && ( !document.documentMode || document.documentMode < 9 ) &&
					!event.button ) {
				return this._mouseUp( event );

			// Iframe mouseup check - mouseup occurred in another document
			} else if ( !event.which ) {

				// Support: Safari <=8 - 9
				// Safari sets which to 0 if you press any of the following keys
				// during a drag (#14461)
				if ( event.originalEvent.altKey || event.originalEvent.ctrlKey ||
						event.originalEvent.metaKey || event.originalEvent.shiftKey ) {
					this.ignoreMissingWhich = true;
				} else if ( !this.ignoreMissingWhich ) {
					return this._mouseUp( event );
				}
			}
		}

		if ( event.which || event.button ) {
			this._mouseMoved = true;
		}

		if ( this._mouseStarted ) {
			this._mouseDrag( event );
			return event.preventDefault();
		}

		if ( this._mouseDistanceMet( event ) && this._mouseDelayMet( event ) ) {
			this._mouseStarted =
				( this._mouseStart( this._mouseDownEvent, event ) !== false );
			if ( this._mouseStarted ) {
				this._mouseDrag( event );
			} else {
				this._mouseUp( event );
			}
		}

		return !this._mouseStarted;
	},

	_mouseUp: function( event ) {
		this.document
			.off( "mousemove." + this.widgetName, this._mouseMoveDelegate )
			.off( "mouseup." + this.widgetName, this._mouseUpDelegate );

		if ( this._mouseStarted ) {
			this._mouseStarted = false;

			if ( event.target === this._mouseDownEvent.target ) {
				$.data( event.target, this.widgetName + ".preventClickEvent", true );
			}

			this._mouseStop( event );
		}

		if ( this._mouseDelayTimer ) {
			clearTimeout( this._mouseDelayTimer );
			delete this._mouseDelayTimer;
		}

		this.ignoreMissingWhich = false;
		mouseHandled = false;
		event.preventDefault();
	},

	_mouseDistanceMet: function( event ) {
		return ( Math.max(
				Math.abs( this._mouseDownEvent.pageX - event.pageX ),
				Math.abs( this._mouseDownEvent.pageY - event.pageY )
			) >= this.options.distance
		);
	},

	_mouseDelayMet: function( /* event */ ) {
		return this.mouseDelayMet;
	},

	// These are placeholder methods, to be overriden by extending plugin
	_mouseStart: function( /* event */ ) {},
	_mouseDrag: function( /* event */ ) {},
	_mouseStop: function( /* event */ ) {},
	_mouseCapture: function( /* event */ ) {
		return true;
	}
} );



// $.ui.plugin is deprecated. Use $.widget() extensions instead.
var plugin = $.ui.plugin = {
	add: function( module, option, set ) {
		var i,
			proto = $.ui[ module ].prototype;
		for ( i in set ) {
			proto.plugins[ i ] = proto.plugins[ i ] || [];
			proto.plugins[ i ].push( [ option, set[ i ] ] );
		}
	},
	call: function( instance, name, args, allowDisconnected ) {
		var i,
			set = instance.plugins[ name ];

		if ( !set ) {
			return;
		}

		if ( !allowDisconnected && ( !instance.element[ 0 ].parentNode ||
				instance.element[ 0 ].parentNode.nodeType === 11 ) ) {
			return;
		}

		for ( i = 0; i < set.length; i++ ) {
			if ( instance.options[ set[ i ][ 0 ] ] ) {
				set[ i ][ 1 ].apply( instance.element, args );
			}
		}
	}
};



var safeBlur = $.ui.safeBlur = function( element ) {

	// Support: IE9 - 10 only
	// If the <body> is blurred, IE will switch windows, see #9420
	if ( element && element.nodeName.toLowerCase() !== "body" ) {
		$( element ).trigger( "blur" );
	}
};


/*!
 * jQuery UI Slider 1.13.3
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Slider
//>>group: Widgets
//>>description: Displays a flexible slider with ranges and accessibility via keyboard.
//>>docs: https://api.jqueryui.com/slider/
//>>demos: https://jqueryui.com/slider/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/slider.css
//>>css.theme: ../../themes/base/theme.css


var widgetsSlider = $.widget( "ui.slider", $.ui.mouse, {
	version: "1.13.3",
	widgetEventPrefix: "slide",

	options: {
		animate: false,
		classes: {
			"ui-slider": "ui-corner-all",
			"ui-slider-handle": "ui-corner-all",

			// Note: ui-widget-header isn't the most fittingly semantic framework class for this
			// element, but worked best visually with a variety of themes
			"ui-slider-range": "ui-corner-all ui-widget-header"
		},
		distance: 0,
		max: 100,
		min: 0,
		orientation: "horizontal",
		range: false,
		step: 1,
		value: 0,
		values: null,

		// Callbacks
		change: null,
		slide: null,
		start: null,
		stop: null
	},

	// Number of pages in a slider
	// (how many times can you page up/down to go through the whole range)
	numPages: 5,

	_create: function() {
		this._keySliding = false;
		this._mouseSliding = false;
		this._animateOff = true;
		this._handleIndex = null;
		this._detectOrientation();
		this._mouseInit();
		this._calculateNewMax();

		this._addClass( "ui-slider ui-slider-" + this.orientation,
			"ui-widget ui-widget-content" );

		this._refresh();

		this._animateOff = false;
	},

	_refresh: function() {
		this._createRange();
		this._createHandles();
		this._setupEvents();
		this._refreshValue();
	},

	_createHandles: function() {
		var i, handleCount,
			options = this.options,
			existingHandles = this.element.find( ".ui-slider-handle" ),
			handle = "<span tabindex='0'></span>",
			handles = [];

		handleCount = ( options.values && options.values.length ) || 1;

		if ( existingHandles.length > handleCount ) {
			existingHandles.slice( handleCount ).remove();
			existingHandles = existingHandles.slice( 0, handleCount );
		}

		for ( i = existingHandles.length; i < handleCount; i++ ) {
			handles.push( handle );
		}

		this.handles = existingHandles.add( $( handles.join( "" ) ).appendTo( this.element ) );

		this._addClass( this.handles, "ui-slider-handle", "ui-state-default" );

		this.handle = this.handles.eq( 0 );

		this.handles.each( function( i ) {
			$( this )
				.data( "ui-slider-handle-index", i )
				.attr( "tabIndex", 0 );
		} );
	},

	_createRange: function() {
		var options = this.options;

		if ( options.range ) {
			if ( options.range === true ) {
				if ( !options.values ) {
					options.values = [ this._valueMin(), this._valueMin() ];
				} else if ( options.values.length && options.values.length !== 2 ) {
					options.values = [ options.values[ 0 ], options.values[ 0 ] ];
				} else if ( Array.isArray( options.values ) ) {
					options.values = options.values.slice( 0 );
				}
			}

			if ( !this.range || !this.range.length ) {
				this.range = $( "<div>" )
					.appendTo( this.element );

				this._addClass( this.range, "ui-slider-range" );
			} else {
				this._removeClass( this.range, "ui-slider-range-min ui-slider-range-max" );

				// Handle range switching from true to min/max
				this.range.css( {
					"left": "",
					"bottom": ""
				} );
			}
			if ( options.range === "min" || options.range === "max" ) {
				this._addClass( this.range, "ui-slider-range-" + options.range );
			}
		} else {
			if ( this.range ) {
				this.range.remove();
			}
			this.range = null;
		}
	},

	_setupEvents: function() {
		this._off( this.handles );
		this._on( this.handles, this._handleEvents );
		this._hoverable( this.handles );
		this._focusable( this.handles );
	},

	_destroy: function() {
		this.handles.remove();
		if ( this.range ) {
			this.range.remove();
		}

		this._mouseDestroy();
	},

	_mouseCapture: function( event ) {
		var position, normValue, distance, closestHandle, index, allowed, offset, mouseOverHandle,
			that = this,
			o = this.options;

		if ( o.disabled ) {
			return false;
		}

		this.elementSize = {
			width: this.element.outerWidth(),
			height: this.element.outerHeight()
		};
		this.elementOffset = this.element.offset();

		position = { x: event.pageX, y: event.pageY };
		normValue = this._normValueFromMouse( position );
		distance = this._valueMax() - this._valueMin() + 1;
		this.handles.each( function( i ) {
			var thisDistance = Math.abs( normValue - that.values( i ) );
			if ( ( distance > thisDistance ) ||
				( distance === thisDistance &&
					( i === that._lastChangedValue || that.values( i ) === o.min ) ) ) {
				distance = thisDistance;
				closestHandle = $( this );
				index = i;
			}
		} );

		allowed = this._start( event, index );
		if ( allowed === false ) {
			return false;
		}
		this._mouseSliding = true;

		this._handleIndex = index;

		this._addClass( closestHandle, null, "ui-state-active" );
		closestHandle.trigger( "focus" );

		offset = closestHandle.offset();
		mouseOverHandle = !$( event.target ).parents().addBack().is( ".ui-slider-handle" );
		this._clickOffset = mouseOverHandle ? { left: 0, top: 0 } : {
			left: event.pageX - offset.left - ( closestHandle.width() / 2 ),
			top: event.pageY - offset.top -
				( closestHandle.height() / 2 ) -
				( parseInt( closestHandle.css( "borderTopWidth" ), 10 ) || 0 ) -
				( parseInt( closestHandle.css( "borderBottomWidth" ), 10 ) || 0 ) +
				( parseInt( closestHandle.css( "marginTop" ), 10 ) || 0 )
		};

		if ( !this.handles.hasClass( "ui-state-hover" ) ) {
			this._slide( event, index, normValue );
		}
		this._animateOff = true;
		return true;
	},

	_mouseStart: function() {
		return true;
	},

	_mouseDrag: function( event ) {
		var position = { x: event.pageX, y: event.pageY },
			normValue = this._normValueFromMouse( position );

		this._slide( event, this._handleIndex, normValue );

		return false;
	},

	_mouseStop: function( event ) {
		this._removeClass( this.handles, null, "ui-state-active" );
		this._mouseSliding = false;

		this._stop( event, this._handleIndex );
		this._change( event, this._handleIndex );

		this._handleIndex = null;
		this._clickOffset = null;
		this._animateOff = false;

		return false;
	},

	_detectOrientation: function() {
		this.orientation = ( this.options.orientation === "vertical" ) ? "vertical" : "horizontal";
	},

	_normValueFromMouse: function( position ) {
		var pixelTotal,
			pixelMouse,
			percentMouse,
			valueTotal,
			valueMouse;

		if ( this.orientation === "horizontal" ) {
			pixelTotal = this.elementSize.width;
			pixelMouse = position.x - this.elementOffset.left -
				( this._clickOffset ? this._clickOffset.left : 0 );
		} else {
			pixelTotal = this.elementSize.height;
			pixelMouse = position.y - this.elementOffset.top -
				( this._clickOffset ? this._clickOffset.top : 0 );
		}

		percentMouse = ( pixelMouse / pixelTotal );
		if ( percentMouse > 1 ) {
			percentMouse = 1;
		}
		if ( percentMouse < 0 ) {
			percentMouse = 0;
		}
		if ( this.orientation === "vertical" ) {
			percentMouse = 1 - percentMouse;
		}

		valueTotal = this._valueMax() - this._valueMin();
		valueMouse = this._valueMin() + percentMouse * valueTotal;

		return this._trimAlignValue( valueMouse );
	},

	_uiHash: function( index, value, values ) {
		var uiHash = {
			handle: this.handles[ index ],
			handleIndex: index,
			value: value !== undefined ? value : this.value()
		};

		if ( this._hasMultipleValues() ) {
			uiHash.value = value !== undefined ? value : this.values( index );
			uiHash.values = values || this.values();
		}

		return uiHash;
	},

	_hasMultipleValues: function() {
		return this.options.values && this.options.values.length;
	},

	_start: function( event, index ) {
		return this._trigger( "start", event, this._uiHash( index ) );
	},

	_slide: function( event, index, newVal ) {
		var allowed, otherVal,
			currentValue = this.value(),
			newValues = this.values();

		if ( this._hasMultipleValues() ) {
			otherVal = this.values( index ? 0 : 1 );
			currentValue = this.values( index );

			if ( this.options.values.length === 2 && this.options.range === true ) {
				newVal =  index === 0 ? Math.min( otherVal, newVal ) : Math.max( otherVal, newVal );
			}

			newValues[ index ] = newVal;
		}

		if ( newVal === currentValue ) {
			return;
		}

		allowed = this._trigger( "slide", event, this._uiHash( index, newVal, newValues ) );

		// A slide can be canceled by returning false from the slide callback
		if ( allowed === false ) {
			return;
		}

		if ( this._hasMultipleValues() ) {
			this.values( index, newVal );
		} else {
			this.value( newVal );
		}
	},

	_stop: function( event, index ) {
		this._trigger( "stop", event, this._uiHash( index ) );
	},

	_change: function( event, index ) {
		if ( !this._keySliding && !this._mouseSliding ) {

			//store the last changed value index for reference when handles overlap
			this._lastChangedValue = index;
			this._trigger( "change", event, this._uiHash( index ) );
		}
	},

	value: function( newValue ) {
		if ( arguments.length ) {
			this.options.value = this._trimAlignValue( newValue );
			this._refreshValue();
			this._change( null, 0 );
			return;
		}

		return this._value();
	},

	values: function( index, newValue ) {
		var vals,
			newValues,
			i;

		if ( arguments.length > 1 ) {
			this.options.values[ index ] = this._trimAlignValue( newValue );
			this._refreshValue();
			this._change( null, index );
			return;
		}

		if ( arguments.length ) {
			if ( Array.isArray( arguments[ 0 ] ) ) {
				vals = this.options.values;
				newValues = arguments[ 0 ];
				for ( i = 0; i < vals.length; i += 1 ) {
					vals[ i ] = this._trimAlignValue( newValues[ i ] );
					this._change( null, i );
				}
				this._refreshValue();
			} else {
				if ( this._hasMultipleValues() ) {
					return this._values( index );
				} else {
					return this.value();
				}
			}
		} else {
			return this._values();
		}
	},

	_setOption: function( key, value ) {
		var i,
			valsLength = 0;

		if ( key === "range" && this.options.range === true ) {
			if ( value === "min" ) {
				this.options.value = this._values( 0 );
				this.options.values = null;
			} else if ( value === "max" ) {
				this.options.value = this._values( this.options.values.length - 1 );
				this.options.values = null;
			}
		}

		if ( Array.isArray( this.options.values ) ) {
			valsLength = this.options.values.length;
		}

		this._super( key, value );

		switch ( key ) {
			case "orientation":
				this._detectOrientation();
				this._removeClass( "ui-slider-horizontal ui-slider-vertical" )
					._addClass( "ui-slider-" + this.orientation );
				this._refreshValue();
				if ( this.options.range ) {
					this._refreshRange( value );
				}

				// Reset positioning from previous orientation
				this.handles.css( value === "horizontal" ? "bottom" : "left", "" );
				break;
			case "value":
				this._animateOff = true;
				this._refreshValue();
				this._change( null, 0 );
				this._animateOff = false;
				break;
			case "values":
				this._animateOff = true;
				this._refreshValue();

				// Start from the last handle to prevent unreachable handles (#9046)
				for ( i = valsLength - 1; i >= 0; i-- ) {
					this._change( null, i );
				}
				this._animateOff = false;
				break;
			case "step":
			case "min":
			case "max":
				this._animateOff = true;
				this._calculateNewMax();
				this._refreshValue();
				this._animateOff = false;
				break;
			case "range":
				this._animateOff = true;
				this._refresh();
				this._animateOff = false;
				break;
		}
	},

	_setOptionDisabled: function( value ) {
		this._super( value );

		this._toggleClass( null, "ui-state-disabled", !!value );
	},

	//internal value getter
	// _value() returns value trimmed by min and max, aligned by step
	_value: function() {
		var val = this.options.value;
		val = this._trimAlignValue( val );

		return val;
	},

	//internal values getter
	// _values() returns array of values trimmed by min and max, aligned by step
	// _values( index ) returns single value trimmed by min and max, aligned by step
	_values: function( index ) {
		var val,
			vals,
			i;

		if ( arguments.length ) {
			val = this.options.values[ index ];
			val = this._trimAlignValue( val );

			return val;
		} else if ( this._hasMultipleValues() ) {

			// .slice() creates a copy of the array
			// this copy gets trimmed by min and max and then returned
			vals = this.options.values.slice();
			for ( i = 0; i < vals.length; i += 1 ) {
				vals[ i ] = this._trimAlignValue( vals[ i ] );
			}

			return vals;
		} else {
			return [];
		}
	},

	// Returns the step-aligned value that val is closest to, between (inclusive) min and max
	_trimAlignValue: function( val ) {
		if ( val <= this._valueMin() ) {
			return this._valueMin();
		}
		if ( val >= this._valueMax() ) {
			return this._valueMax();
		}
		var step = ( this.options.step > 0 ) ? this.options.step : 1,
			valModStep = ( val - this._valueMin() ) % step,
			alignValue = val - valModStep;

		if ( Math.abs( valModStep ) * 2 >= step ) {
			alignValue += ( valModStep > 0 ) ? step : ( -step );
		}

		// Since JavaScript has problems with large floats, round
		// the final value to 5 digits after the decimal point (see #4124)
		return parseFloat( alignValue.toFixed( 5 ) );
	},

	_calculateNewMax: function() {
		var max = this.options.max,
			min = this._valueMin(),
			step = this.options.step,
			aboveMin = Math.round( ( max - min ) / step ) * step;
		max = aboveMin + min;
		if ( max > this.options.max ) {

			//If max is not divisible by step, rounding off may increase its value
			max -= step;
		}
		this.max = parseFloat( max.toFixed( this._precision() ) );
	},

	_precision: function() {
		var precision = this._precisionOf( this.options.step );
		if ( this.options.min !== null ) {
			precision = Math.max( precision, this._precisionOf( this.options.min ) );
		}
		return precision;
	},

	_precisionOf: function( num ) {
		var str = num.toString(),
			decimal = str.indexOf( "." );
		return decimal === -1 ? 0 : str.length - decimal - 1;
	},

	_valueMin: function() {
		return this.options.min;
	},

	_valueMax: function() {
		return this.max;
	},

	_refreshRange: function( orientation ) {
		if ( orientation === "vertical" ) {
			this.range.css( { "width": "", "left": "" } );
		}
		if ( orientation === "horizontal" ) {
			this.range.css( { "height": "", "bottom": "" } );
		}
	},

	_refreshValue: function() {
		var lastValPercent, valPercent, value, valueMin, valueMax,
			oRange = this.options.range,
			o = this.options,
			that = this,
			animate = ( !this._animateOff ) ? o.animate : false,
			_set = {};

		if ( this._hasMultipleValues() ) {
			this.handles.each( function( i ) {
				valPercent = ( that.values( i ) - that._valueMin() ) / ( that._valueMax() -
					that._valueMin() ) * 100;
				_set[ that.orientation === "horizontal" ? "left" : "bottom" ] = valPercent + "%";
				$( this ).stop( 1, 1 )[ animate ? "animate" : "css" ]( _set, o.animate );
				if ( that.options.range === true ) {
					if ( that.orientation === "horizontal" ) {
						if ( i === 0 ) {
							that.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( {
								left: valPercent + "%"
							}, o.animate );
						}
						if ( i === 1 ) {
							that.range[ animate ? "animate" : "css" ]( {
								width: ( valPercent - lastValPercent ) + "%"
							}, {
								queue: false,
								duration: o.animate
							} );
						}
					} else {
						if ( i === 0 ) {
							that.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( {
								bottom: ( valPercent ) + "%"
							}, o.animate );
						}
						if ( i === 1 ) {
							that.range[ animate ? "animate" : "css" ]( {
								height: ( valPercent - lastValPercent ) + "%"
							}, {
								queue: false,
								duration: o.animate
							} );
						}
					}
				}
				lastValPercent = valPercent;
			} );
		} else {
			value = this.value();
			valueMin = this._valueMin();
			valueMax = this._valueMax();
			valPercent = ( valueMax !== valueMin ) ?
					( value - valueMin ) / ( valueMax - valueMin ) * 100 :
					0;
			_set[ this.orientation === "horizontal" ? "left" : "bottom" ] = valPercent + "%";
			this.handle.stop( 1, 1 )[ animate ? "animate" : "css" ]( _set, o.animate );

			if ( oRange === "min" && this.orientation === "horizontal" ) {
				this.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( {
					width: valPercent + "%"
				}, o.animate );
			}
			if ( oRange === "max" && this.orientation === "horizontal" ) {
				this.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( {
					width: ( 100 - valPercent ) + "%"
				}, o.animate );
			}
			if ( oRange === "min" && this.orientation === "vertical" ) {
				this.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( {
					height: valPercent + "%"
				}, o.animate );
			}
			if ( oRange === "max" && this.orientation === "vertical" ) {
				this.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( {
					height: ( 100 - valPercent ) + "%"
				}, o.animate );
			}
		}
	},

	_handleEvents: {
		keydown: function( event ) {
			var allowed, curVal, newVal, step,
				index = $( event.target ).data( "ui-slider-handle-index" );

			switch ( event.keyCode ) {
				case $.ui.keyCode.HOME:
				case $.ui.keyCode.END:
				case $.ui.keyCode.PAGE_UP:
				case $.ui.keyCode.PAGE_DOWN:
				case $.ui.keyCode.UP:
				case $.ui.keyCode.RIGHT:
				case $.ui.keyCode.DOWN:
				case $.ui.keyCode.LEFT:
					event.preventDefault();
					if ( !this._keySliding ) {
						this._keySliding = true;
						this._addClass( $( event.target ), null, "ui-state-active" );
						allowed = this._start( event, index );
						if ( allowed === false ) {
							return;
						}
					}
					break;
			}

			step = this.options.step;
			if ( this._hasMultipleValues() ) {
				curVal = newVal = this.values( index );
			} else {
				curVal = newVal = this.value();
			}

			switch ( event.keyCode ) {
				case $.ui.keyCode.HOME:
					newVal = this._valueMin();
					break;
				case $.ui.keyCode.END:
					newVal = this._valueMax();
					break;
				case $.ui.keyCode.PAGE_UP:
					newVal = this._trimAlignValue(
						curVal + ( ( this._valueMax() - this._valueMin() ) / this.numPages )
					);
					break;
				case $.ui.keyCode.PAGE_DOWN:
					newVal = this._trimAlignValue(
						curVal - ( ( this._valueMax() - this._valueMin() ) / this.numPages ) );
					break;
				case $.ui.keyCode.UP:
				case $.ui.keyCode.RIGHT:
					if ( curVal === this._valueMax() ) {
						return;
					}
					newVal = this._trimAlignValue( curVal + step );
					break;
				case $.ui.keyCode.DOWN:
				case $.ui.keyCode.LEFT:
					if ( curVal === this._valueMin() ) {
						return;
					}
					newVal = this._trimAlignValue( curVal - step );
					break;
			}

			this._slide( event, index, newVal );
		},
		keyup: function( event ) {
			var index = $( event.target ).data( "ui-slider-handle-index" );

			if ( this._keySliding ) {
				this._keySliding = false;
				this._stop( event, index );
				this._change( event, index );
				this._removeClass( $( event.target ), null, "ui-state-active" );
			}
		}
	}
} );



} );

; var browser = {
    init: function () {
        this.id = this.searchString(this.dataBrowser) || "An unknown browser";
        this[this.id] = true;
        this.version = this.searchVersion(navigator.userAgent)
        || this.searchVersion(navigator.appVersion)
        || "an unknown version";
        this.OS = this.searchString(this.dataOS) || "an unknown OS";
        this.lang = navigator.userLanguage || navigator.language || navigator.language || "en";
    },
    searchString: function (data) {
        for (var i = 0; i < data.length; i++) {
            var dataString = data[i].string;
            var dataProp = data[i].prop;
            this.versionSearchString = data[i].versionSearch || data[i].identity;
            if (dataString) {
                if (dataString.indexOf(data[i].subString) != -1)
                    return data[i].identity;
            } else if (dataProp)
                return data[i].identity;
        }
    },
    searchVersion: function (dataString) {
        var index = dataString.indexOf(this.versionSearchString);
        if (index == -1) return;
        return parseFloat(dataString.substring(index + this.versionSearchString.length + 1));
    },
    dataBrowser: [
        {
            string: navigator.userAgent,
            subString: "Edge",
            identity: "ie",
            versionSearch: "Edge"
        },
        {
            string: navigator.userAgent,
            prop: window.opera,
            subString: "OPR",
            identity: "op",
            versionSearch: "OPR"
        },
        {
            string: navigator.userAgent,
            subString: "Chrome",
            versionSearch: "Chrome",
            identity: "gc"
        },
        {
            string: navigator.userAgent,
            subString: "OmniWeb",
            versionSearch: "OmniWeb/",
            identity: "ow"
        },
        {
            string: navigator.vendor,
            subString: "Apple",
            identity: "sf",
            versionSearch: "Version"
        },
        {
            string: navigator.vendor,
            subString: "iCab",
            versionSearch: "iCab",
            identity: "ic"
        },
        {
            string: navigator.vendor,
            subString: "KDE",
            versionSearch: "Konqueror",
            identity: "kq"
        },
        {
            string: navigator.userAgent,
            subString: "Firefox",
            versionSearch: "Firefox",
            identity: "ff"
        },
        {
            string: navigator.vendor,
            subString: "Camino",
            versionSearch: "Camino",
            identity: "cn"
        },
        {		// for newer Netscapes (6+)
            string: navigator.userAgent,
            subString: "Netscape",
            versionSearch: "Netscape",
            identity: "ns"
        },
        {
            string: navigator.userAgent,
            subString: "MSIE",
            identity: "ie",
            versionSearch: "MSIE"
        },
        {
            string: navigator.userAgent,
            subString: ".NET",
            identity: "ie",
            versionSearch: "rv"
        },
        {
            string: navigator.userAgent,
            subString: "Gecko",
            identity: "mz",
            versionSearch: "rv"
        },
        { 		// for older Netscapes (4-)
            string: navigator.userAgent,
            subString: "Mozilla",
            identity: "mz",
            versionSearch: "Mozilla"
        }
    ],
    dataOS: [
        {
            string: navigator.platform,
            subString: "Win",
            identity: "Windows"
        },
        {
            string: navigator.platform,
            subString: "Mac",
            identity: "Mac"
        },
        {
            string: navigator.userAgent,
            subString: "iPhone",
            identity: "iPhone/iPod"
        },
        {
            string: navigator.platform,
            subString: "Linux",
            identity: "Linux"
        }
    ]
};
browser.init();
$(function () {
    $(document.body).addClass(browser.id);
    $(document.body).addClass(browser.id + browser.version);
    browser.key = {
        isDigit: function(code) {
            return code >= 48 && code <= 57
        },
        BACKSPACE: 8,
        TAB: 9,
        DELETE: 46,
        isArrows: function(key) {
            return (key >= 37 && key <= 40) || (key >= 96 && key <= 105)
        },
        is: function(char, key) {
            return char.charCodeAt(0) == key
        },
        NUM_MINUS: 109,
        MINUS: browser.ff ? 173 : 189,
        NUM_POINT: 110,
        POINT: 190,
        isReturn: function(code) {
            return code == 10 || code == 13
        }
    }
    browser.event_capture = $("<div></div>")[0].setCapture
});
; var bm = {
    cache: {}
};

if (!window.console || !window.console.log) {
    (window.console || (window.console = {})).log = function (message) {
        var logContainer = $(".log-container")
        if (!logContainer.length) {
            logContainer = $("<div class='log-container'></div>").appendTo(document.body)
        }
        logContainer.append($("<div class='log-entry'></div>").append("" + message))
    }
}
window.log = function () {
    Function.prototype.apply.call(console.log, console, arguments) //console.log is not a true function in ie
}

if (!console.dir) {
    console.dir = console.log
}
window.dir = function () {
    Function.prototype.apply.call(console.dir, console, arguments)
}

function QueueManager(queueThreshold, afterPop, synchronous) {
    var _running_count = 0
    var _queue = []
    var timer

    function checkFreeAndCall() {
        timer = null
        while (this.hasFreeSlot() && _queue.length) {
            var obj = this.pop()
            if (synchronous) {
                instance.inc()
                setTimeout(function () {
                    afterPop(obj)
                    instance.dec()
                }, 1)
            } else {
                afterPop(obj)
            }
        }
        if (_queue.length) {
            timer = setTimeout($.proxy(checkFreeAndCall, this), 1000)
        }
    }

    var instance = {
        push: function (obj, placeInTop) {
            if (placeInTop) {
                _queue.unshift(obj)
            } else {
                _queue.push(obj)
            }
            if (!this.hasFreeSlot()) {
                if (timer) {
                    return
                }
                timer = setTimeout($.proxy(checkFreeAndCall, this), 1000)
            } else if (synchronous) {
                checkFreeAndCall()
            }
        },
        pop: function () {
            return _queue.shift()
        },
        inc: function () {
            _running_count++
        },
        dec: function () {
            _running_count--
        },
        hasFreeSlot: function () {
            return _running_count < queueThreshold
        },
        index: function (matcher) {
            var foundIndex = null
            $.each(_queue, function (index) {
                if (matcher.call(this, index)) {
                    foundIndex = index
                    return false
                }
            })
            return foundIndex
        },
        top: function (index) {
            if (_queue.length > index && index >= 0) {
                var obj = _queue[index]
                _queue.splice(index, 1)
                _queue.unshift(obj)
            }
        },
        remove: function (matcher) {
            $.each(_queue, function (index) {
                if (matcher.call(this, index)) {
                    _queue.splice(index, 1)
                    return false
                }
            })
        },
        clear: function () {
            if (timer) {
                clearTimeout(timer)
            }
            _queue = []
        }
    }

    if (this instanceof QueueManager) {
        $.extend(this, instance)
    } else {
        return instance
    }
}

bm.ajax_queue_manager = QueueManager(30, function (entry) {
    bm.ajax_queue_manager.inc()
    var settings = entry.settings
    var xhr = $.ajax(settings)
    bm.chainDeffereds(xhr, settings.deferred_interceptor)
})

function CacheManager() {
    this.cache = {}
}

CacheManager.prototype = {
    get: function (flag) {
        var entry = this.cache[flag]
        if (entry) {
            if (entry.duration) {
                var timeDiff = Date.now().getTime() - entry.time
                if (timeDiff > entry.duration) {
                    delete this.cache[flag]
                    return undefined
                } else {
                    return entry.entry
                }
            }
            return entry.entry
        }
        return undefined
    },
    set: function (flag, duration, entry) {
        this.cache[flag] = {duration: duration, entry: entry, time: Date.now().getTime()}
    }
}

bm.ajax_cache_manager = new CacheManager()
bm.show_response_status = true
window.on_login_call_queue = []
// SINGLE source for "am I inside the FEE editor canvas?" — used by the 401 handler below and
// customer/session_redirect.gsp. Canvas = editor-stamped body class, with a parent-editor-shell
// fallback because the class lands only after editor init while early AJAX can 401 before it.
window.wcIsFeeEditorCanvas = function () {
    try {
        return !!((document.body && document.body.classList.contains("fee-editor-active"))
            || (window.top !== window.self && window.top.app && window.top.app.FrontEndEditor))
    } catch (canvasProbeError) {
        return false
    }
}

$.extend(bm, {
    enableBackgroundScroll: function(){
        $("#webcommander-page").removeClass("wc-popup-open");
        $("body.new-editor-body").removeClass("wc-popup-open");
        // var iframe = $("iframe.content-editor-iframe");
        // if(iframe.length){
        //     var iframeContent = iframe.contents();
        //     pageBody = iframeContent.find("body");
        //     pageBody.removeClass("wc-popup-open");
        // }
    },
    disableBackgroundScroll: function(){
        $("#webcommander-page").addClass("wc-popup-open");
        $("body.new-editor-body").addClass("wc-popup-open");
        // var iframe = $("iframe.content-editor-iframe");
        // if(iframe.length){
        //     var iframeContent = iframe.contents();
        //     pageBody = iframeContent.find("body");
        //     pageBody.addClass("wc-popup-open");
        // }

    },
    _modified_ajax_settings: function (settings) {
        var defaults = {
            traditional: true,
            show_response_status: bm.show_response_status,
            show_error_status: true,
            show_success_status: true,
            dataType: "json",
            type: settings.type || (settings.data ? "post" : "get")
        }
        settings = $.extend(defaults, settings)
        if (settings.fill) {
            settings.dataType = "html"
        }
        var caller_error = settings.error
        var caller_success = settings.success
        settings.error = function (xhr, status) {
            function jsonParse(json) {
                try {
                    return JSON.parse(json)
                } catch (k) {
                    return {status: "error", message: json, code: xhr.status}
                }
            }

            if (xhr.status == 310) {
                if (settings.dataType == "json") {
                    var response = jsonParse(xhr.responseText)
                    window.location.href = response.url
                } else {
                    window.location.href = xhr.responseText
                }
                throw $.error("Redirect Action Processing")
            }
            if (xhr.status == 403) {
                // A LICENSE block (feature-disabled / limit-exceeded) is tagged with the X-License-Error header
                // by SecurityInterceptor.provisionCheck and surfaced as the upgrade popup by the global
                // ajaxComplete hook below. That hook runs AFTER this error callback, so firing a generic toast
                // here would (a) pre-empt the popup with a raw "Error" showing the forbidden body, and (b)
                // duplicate the block UI. Detect the license block from the header and skip the toast — the
                // global popup is the sole, correct UI. Non-license 403s (plain permission denials) still toast.
                var isLicenseBlock = false
                try { isLicenseBlock = !!(xhr.getResponseHeader && xhr.getResponseHeader("X-License-Error")) } catch (e) {}
                if (!isLicenseBlock) {
                    var message
                    if (settings.dataType == "json") {
                        var response = jsonParse(xhr.responseText)
                        message = response.message
                    } else {
                        message = xhr.responseText
                    }
                    bm.notify(message, "error")
                }
            }
            var response = xhr.responseText
            // FEE canvas preview: a 401 here is preview AJAX (e.g. profile tabs) hitting customer-session endpoints —
            // never dump the login page into a fill target nor block editing with a login popup.
            var isCanvas401 = xhr.status == 401 && window.wcIsFeeEditorCanvas()
            if (settings.fill) {
                if (isLicenseBlock) {
                    // A license block must NOT dump the raw 403 body into the fill target (that is the
                    // "{license_feature_disabled …}" JSON leak). Leave the loader mask ON and the panel empty so the
                    // global ajaxComplete handler (parseEnvelope → showBlockPopup → clearBlockedLoaders) fills it with
                    // the SAME locked empty-state every other blocked panel shows. Reuses the central mechanism — no
                    // per-caller handling, and it fixes EVERY .fill() caller (document editor, currency, …) at once.
                    delete settings.fill.nat.filling_xhr
                } else {
                    if (settings.loader !== false) {
                        settings.fill.loader(false)
                    }
                    // the dev-mode raw dump would paint the login page inside canvas preview tabs — skip it there
                    if (!app.production && !isCanvas401) {
                        settings.fill.html(response)
                    }
                    delete settings.fill.nat.filling_xhr
                }
            }
            if (xhr.status == 401) {
                if (isCanvas401) {
                    return
                }
                if (settings.dataType == "json") {
                    response = JSON.parse(response).login_html
                }
                if (settings.on_login) {
                    window.on_login_call_queue.push(function () {
                        setInterceptor()
                        settings.on_login()
                    })
                }
                if (window.inline_login_displaying) {
                    return
                }
                window.inline_login_displaying = true
                var willEmbeddedLogin = true
                var embeddedLoginConfig = {content: response}
                if (app.is_front_end) {
                    if (!app.edit_mode) {
                        // Customer session expiry - show login popup
                        embeddedLoginConfig = {content: response, title: $.i18n.prop("session.timed.out")}
                    } else {
                        embeddedLoginConfig = {ajax_url: app.baseUrl + "page/embeddedLogin", title: undefined}
                    }
                }
                if (willEmbeddedLogin && !window.popup_initialized) {
                    $(response).find("input[name=email]").val(app.login_email).prop('disabled', true)
                    bm.embeddedLogin(embeddedLoginConfig, function () {
                        window.on_login_call_queue.everyCustomFunc(function () {
                            this.call(window)
                        })
                        window.on_login_call_queue = []
                        window.inline_login_displaying = false
                    })
                }
                return
            }
            //if any success response get jquery error then status will be 200
            if (settings.dataType == "json") {
                if (xhr.status == 200) {
                    response = $.i18n.prop("server.response.unrecongnized")
                    response = {status: "error", code: "500", message: response}
                } else {
                    if (response) {
                        response = jsonParse(response)
                    } else {
                        response = {status: "error", code: "500"}
                    }
                }
                if (settings.response) {
                    settings.response.apply(this, ["error", response, status, xhr])
                }
                if (settings.show_response_status && settings.show_error_status && response.message) {
                    bm.notify(response.message, response.status)
                }
            } else if (settings.response) {
                settings.response.apply(this, ["error", response, status, xhr])
            }
            if (caller_error) {
                caller_error.apply(this, [xhr, status, response])
            }
        }
        settings.success = function (response, status, xhr) {
            if (settings.response) {
                settings.response.apply(this, [settings.dataType == "json" && response.status == "error" ? "error" : "success", response, status, xhr])
            }
            if (settings.dataType == "json" && settings.show_response_status && response.message) {
                if ((response.status == "error" && settings.show_error_status) || settings.show_success_status) {
                    bm.notify(response.message, response.status)
                }
            }
            if (settings.dataType == "json" && response.status == "error") {
                if (caller_error) {
                    caller_error.apply(this, [xhr, status, response])
                }
                return
            }
            if (settings.fill) {
                if (settings.loader !== false) {
                    settings.fill.loader(false)
                }
                delete settings.fill.nat.filling_xhr
                settings.fill.html(response).updateUi()
                if (settings.processor) {
                    if (settings.processor.isString) {
                        var category, processor
                        if (settings.processor.contains(":")) {
                            var splitted = settings.processor.split(":")
                            category = splitted[0]
                            processor = splitted[1]
                        } else {
                            processor = category = settings.processor
                        }
                        bm.onReady(app.processors, processor, {
                            ready: function () {
                                app.processors[processor](settings.fill)
                            },
                            not: function () {
                                bm.loadScript(app.base + "js/app/processors/" + (category || processor) + ".js")
                            }
                        })
                    } else if ($.isFunction(settings.processor)) {
                        settings.processor(settings.fill)
                    }
                }
                bm.handleUrlNavigation(settings.url || settings.controller + "/" + settings.action, settings.fill)
            }
            if (caller_success) {
                caller_success.apply(this, [response, status, xhr])
            }
        }

        function setInterceptor() {
            settings.deferred_interceptor = $.Deferred()
            settings.deferred_interceptor.done(function (response) {
                if (window.inline_login_displaying) {
                    return
                }
                var returns = Array.prototype.slice.call(arguments)
                returns.push(settings)
                if (settings.dataType == "json" && response.status == "error") {
                    settings.consumer_deferred.reject.apply(settings.consumer_deferred, returns)
                } else {
                    settings.consumer_deferred.resolve.apply(settings.consumer_deferred, returns)
                }
            }).fail(function () {
                if (window.inline_login_displaying) {
                    return
                }
                var returns = Array.prototype.slice.call(arguments)
                var response = returns[0].responseText
                if (settings.dataType == "json") {
                    if (returns[0].status == 404) {
                        response = {error: true, message: $.i18n.prop("expected.resource.not.found"), code: "404"}
                    } else if (returns[0].status == 200) {
                        response = {error: true, message: $.i18n.prop("server.response.unrecongnized"), code: "500"}
                    } else {
                        if (response) {
                            // The body isn't guaranteed to be JSON on the error path — an HTML 500 / redirect /
                            // auth page would make JSON.parse throw an UNCAUGHT SyntaxError (crashing the reject
                            // chain). Guard it and fall back to a generic error object like the 404/200 branches.
                            try {
                                response = JSON.parse(response)
                            } catch (parseError) {
                                response = {error: true, message: $.i18n.prop("error.occurred.in.server"), code: "500"}
                            }
                        } else {
                            response = {error: true, message: $.i18n.prop("error.occurred.in.server"), code: "500"}
                        }
                    }
                }
                returns[2] = response
                returns.push(settings)
                settings.consumer_deferred.reject.apply(settings.consumer_deferred, returns)
            }).progress(function () {
                var returns = Array.prototype.slice.call(arguments)
                returns.push(settings)
                settings.consumer_deferred.notify.apply(settings.consumer_deferred, returns)
            })
        }

        setInterceptor()
        return settings
    },
    addScript: function (src, async, scriptType ='general' ) {
        var head = $("head")
        var script = document.createElement('script')
        script.setAttribute("type", "text/javascript")
        if (!src.startsWith("http") && !src.startsWith("/")) {
            src = app.baseUrl + src
        }
        script.setAttribute("src", src)
        if (async) {
            script.setAttribute("async", "")
        }
        script.setAttribute("scriptType", scriptType)
        head[0].appendChild(script)
    },
    addStyle: function (href) {
        var head = $("head"), link = document.createElement("link")
        link.setAttribute("rel", "stylesheet")
        link.setAttribute("type", "text/css")
        link.setAttribute("href", app.baseUrl + href)
        head[0].appendChild(link)
    },
    ajax: function (settings) {
        // Admin abuse-ceiling "paused" pre-empt: while the panel is paused (P1 admin ceiling), don't fire a
        // doomed state-changing request — it would just 429 and leave the caller's loader spinning. GETs
        // (navigation / list reloads) still go through. Fail-safe: any error here falls through to a normal call.
        try {
            var __tw = (window.top || window);
            var __pausedUntil = (__tw && __tw.__adminPausedUntil) || 0;
            if (__pausedUntil && (new Date()).getTime() < __pausedUntil) {
                var __m = (settings.type || settings.method || "GET").toString().toUpperCase();
                if (__m !== "GET" && __m !== "HEAD" && __m !== "OPTIONS") {
                    try { if (__tw.__wcShowAdminPausedBanner) { __tw.__wcShowAdminPausedBanner(); } } catch (e) {}
                    // A COMPLETE jqXHR-like stub — error/complete handlers (incl. the license-header sniff in
                    // this file) call xhr.getResponseHeader / read responseText, so the pre-empt must not hand
                    // back a bare object or those handlers throw. readyState 4 + empty body + null headers.
                    var __fakeXhr = {
                        status: 429, statusText: "error", readyState: 4, responseText: "", responseJSON: null,
                        __adminPaused: true,
                        getResponseHeader: function () { return null; },
                        getAllResponseHeaders: function () { return ""; }
                    };
                    // Run the caller's error+complete so ITS loader/button state resets, then reject the promise.
                    try { if (settings.error) { settings.error.call(settings, __fakeXhr, "error", "error"); } } catch (e) {}
                    try { if (settings.complete) { settings.complete.call(settings, __fakeXhr, "error"); } } catch (e) {}
                    var __d = $.Deferred();
                    __d.reject(__fakeXhr, "error", "error");
                    return __d.promise();
                }
            }
        } catch (e) {}
        var caller_response = settings.response
        settings.response = function () {
            bm.ajax_queue_manager.dec()
            if (caller_response) {
                caller_response.apply(this, arguments)
            }
        }
        settings = bm._modified_ajax_settings(settings)
        if (settings.cache_flag || settings.cache_duration) {
            var flag = settings.cache_flag
            if (!flag) {
                flag = settings.url
                if (settings.data) {
                    flag += "?" + $.param(settings.data)
                }
            }
            var deferred = bm.ajax_cache_manager.get(flag)

            function xhrCopy(xhr) {
                return {status: xhr.status, responseText: xhr.responseText}
            }

            if (deferred) {
                var newDeffered = $.Deferred()
                deferred.done(function (data, status, xhr) {
                    settings.response = caller_response
                    if (settings.success) {
                        settings.success.call(settings, data, status)
                    }
                    if (settings.complete) {
                        settings.complete.call(settings, xhrCopy(xhr), status)
                    }
                    newDeffered.resolve(data, status)
                })
                deferred.fail(function (xhr, status) {
                    settings.response = caller_response
                    var copyXhr = xhrCopy(xhr)
                    if (settings.error) {
                        settings.error.call(settings, copyXhr, status)
                    }
                    if (settings.complete) {
                        settings.complete.call(settings, copyXhr, status)
                    }
                    newDeffered.reject(copyXhr, status)
                })
                return newDeffered
            }
        }
        var cache_deferred
        if (settings.cache_flag || settings.cache_duration) {
            cache_deferred = $.Deferred()
            var duration = settings.cache_duration
            var flag = settings.cache_flag
            if (!flag) {
                flag = settings.url
                if (settings.data) {
                    flag += "?" + $.param(settings.data)
                }
            }
            if (!duration) {
                duration = 400
            }
            if (duration == -1) {
                duration = undefined
            }
            bm.ajax_cache_manager.set(flag, duration, cache_deferred)
        }
        var queueId = bm.getUUID()
        bm.ajax_queue_manager.push({id: queueId, settings: settings})
        if (!bm.ajax_queue_manager.hasFreeSlot()) {
            var deferred = cache_deferred || $.Deferred()
            settings.consumer_deferred = $.extend(deferred, {
                aborted: 0,
                responseText: null,
                responseXML: null,
                status: 0,
                statusText: 'n/a',
                getAllResponseHeaders: function () {
                },
                getResponseHeader: function () {
                },
                setRequestHeader: function () {
                },
                abort: function () {
                    bm.ajax_queue_manager.remove(function () {
                        return this.id == queueId
                    })
                }
            })
            return settings.consumer_deferred
        }
        var entry = bm.ajax_queue_manager.pop()
        bm.ajax_queue_manager.inc()
        settings = entry.settings
        if ((browser.ie || browser.ed) && settings.type.toLowerCase().equals("get", false)) {
            if (settings.data) {
                settings.data._ = Date.now()
            } else {
                settings.data = {_: Date.now()}
            }
        }
        settings.on_login = function () {
            if (settings.url) {
                xhr = $.ajax(settings)
            } else {
                xhr = $.ajax(app.baseUrl + settings.controller + "/" + (settings.action || 'index'), settings)
            }
            bm.chainDeffereds(xhr, settings.deferred_interceptor)
        }
        settings.consumer_deferred = $.Deferred()
        var xhr
        if (settings.fill) {
            if (settings.fill.isString) {
                settings.fill = $(settings.fill)
            }
        }
        if (settings.beforeAjax) {
            settings.beforeAjax(settings)
        }
        if (settings.url) {
            xhr = $.ajax(settings)
        } else {
            xhr = $.ajax(app.baseUrl + settings.controller + "/" + (settings.action || 'index'), settings)
        }
        if (settings.fill) {
            if (settings.fill.nat.filling_xhr) {
                settings.fill.nat.filling_xhr.abort()
            }
            settings.fill.nat.filling_xhr = xhr
            settings.fill.one("remove.xhr", function () {
                xhr.abort()
            })
            xhr.always(function () {
                settings.fill.off("remove.xhr")
            })
            if (settings.loader !== false) {
                settings.fill.loader()
            }
        }
        bm.chainDeffereds(xhr, settings.deferred_interceptor)
        if (cache_deferred) {
            bm.chainDeffereds(settings.consumer_deferred, cache_deferred)
        }
        xhr.success = function (handler) {
            settings.consumer_deferred.done(handler)
            return xhr
        }
        xhr.error = function (handler) {
            settings.consumer_deferred.fail(handler)
            return xhr
        }
        xhr.complete = function (handler) {
            settings.consumer_deferred.always(handler)
            return xhr
        }
        return $.extend({}, xhr, settings.consumer_deferred)
    },
    autoType: function (value) {
        if (value == "{}") {
            return {}
        }
        if (value == "[]") {
            return []
        }
        if (/^\[("[^"]+"[^=:]|\d+)/.test(value)) {
            return JSON.parse(value)
        }
        if (/^({|\[{)"[^"]+":/.test(value)) {
            return JSON.parse(value)
        }
        if (/^\s*-?\d+(\.\d*)?\s*$/.test(value)) {
            return +value
        }
        if (/^\s*(true|yes|on)\s*$/.test(value)) {
            return true
        }
        if (/^\s*(false|no|off)\s*$/.test(value)) {
            return false
        }
        return value
    },
    baseUrl: (window.app && app.baseUrl) || "/",
    center: function (width, height, is_fixed) {
        var scrHeight = $(window).height()
        var scrWidth = $(window).width()
        var popHeight = height
        var popWidth = width
        var left = scrWidth / 2 - popWidth / 2
        var top = scrHeight / 2 - popHeight / 2
        if (!is_fixed) {
            var scrollTop = $(window).scrollTop()
            var scrollLeft = $(window).scrollLeft()
            left = left + scrollLeft
            top = top + scrollTop
        }
        return {
            left: Math.max(20, left),
            top: Math.max(20, top)
        }
    },
    chainDeffereds: function (from, to) {
        from.done(to.resolve).fail(to.reject).progress(to.notify)
    },
    creteCookie: function (name, value, expires, path, domain) {
        var cookie = name + "=" + value + ""
        if (expires) {
            if (!expires instanceof Date) {
                expires = new Date(new Date().getTime() + parseInt(expires) * 1000 * 60 * 60 * 24)
            }
            cookie += "expires=" + expires.gmtString() + ""
        }
        if (path) {
            cookie += "path=" + path + ""
        }
        if (domain) {
            cookie += "domain=" + domain + ""
        }
        document.cookie = cookie
    },
    encodePath: function (path) {
        return path.replace(/%/g, "%25").replace(/ /g, "%20").replace(/#/g, "%23")
    },
    embeddedLogin: function (config, success) {
        return new POPUP($.extend({
            clazz: "login-popup",
            title: $.i18n.prop("session.timed.out"),
            show_close: false,
            close_on_escape: false,
            is_always_up: true,
            events: {
                content_loaded: function (popup) {
                    bm.disableBackgroundScroll()
                    var form = this.find("form")
                    if (app.login_email) {
                        form.find("input[name=email]").prop('disabled', true).val(app.login_email)
                        form.append('<input type="hidden" name="email" value="' + app.login_email + '">')
                        form.find(".not-admin").html($.i18n.prop("not.x.operator", ["<span class='user'>" + app.login_email + "</span>"]))
                    }
                    form.form({
                        ajax: {
                            success: function (resp) {
                                if (resp.status == "error") {
                                    bm.notify($.i18n.prop("invalid.email.password"), "alert")
                                    return
                                }
                                popup.close()
                                bm.enableBackgroundScroll();
                                success(resp)
                            },
                            error: function () {
                                bm.notify($.i18n.prop("invalid.email.password"), "alert")
                            }
                        }
                    })
                }
            }
        }, config))

    },
    fileExtension: function (name) {
        var indexof = name.lastIndexOf(".")
        if (indexof > 0) {
            return name.substring(indexof + 1)
        }
        return ""
    },
    filter: function (_this, filter) {
        var rt = {}
        $.each(_this, function (k, v) {
            if (filter(k, v)) {
                rt[k] = v
            }
        })
        return rt
    },
    filterOwnProperties: function (obj) {
        var props = {}
        for (key in obj) {
            if (obj.hasOwnProperty(key)) {
                props[key] = obj[key]
            }
        }
        return props
    },
    getAbsoluteURL: function (relativeURL) {
        var port = location.port
        var host = location.host
        return host + bm.baseUrl + (port ? ":" + port : "") + relativeURL
    },
    getBaseURLProtocol: function () {
        return location.protocol
    },
    getCookie: function (name) {
        var regexp = new RegExp("(?:^" + name + "|\s*" + name + ")=(.*?)(?:|$)", "g")
        var result = regexp.exec(document.cookie)
        return (result === null) ? null : result[1]
    },
    getUUID: function () {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8)
            return v.toString(16).toUpperCase()
        })
    },
    handleUrlNavigation: function (url, panel) {
        var route
        var params
        if (url.startsWith(app.base)) {
            url = url.substring(app.base.length)
        }
        Object.keys(app.routes || {}).revery(function () {
            params = url.match(new RegExp(this))
            if (params) {
                route = app.routes[this]
                return false
            }
        })
        if (route) {
            if (route.isString) {
                params.shift()
                params.everyCustomFunc(function (ind, v) {
                    route = route.replace("{" + ind + "}", v)
                })
                if (app.processors && $.isFunction(app.processors[route])) {
                    app.processors[route](panel)
                }
            } else if ($.isFunction(route)) {
                route(panel)
            } else {
                params.shift()
                route = $.extend({}, route)
                $.each(route, function (k, v) {
                    params.everyCustomFunc(function (ind, _v) {
                        v = v.replace("{" + (ind + 1) + "}", _v)
                    })
                    route[k] = v
                })
                if (route.controller && route.action) {
                    var controller = route.controller.capitalize() + "Controller"
                    if (app.controllers[controller] && app.controllers[controller].prototype[route.action]) {
                        new app.controllers[controller]()[route.action](panel, route)
                    }
                }
            }
        }
    },
    hash: function (a) {
        var mapHash = function (a) {
            var hash = 0
            $.each(a, function (k, v) {
                hash += bm.hash(k)
                hash += bm.hash(v)
            })
            return hash
        }
        var hash = 0
        if (!a) {
            return hash
        }
        if ($.isFunction(a)) {
            return hash
        }
        if ($.isFunction(a.hash)) {
            return a.hash()
        }
        if ($.isArray(a) || $.isPlainObject(a)) {
            return mapHash(a)
        }
        return ("" + a).hash()
    },
    htmlEncode: function (toEncode) {
        return ("" + toEncode).htmlEncode()
    },
    i18n: function (prop, args) {
        return $.i18n.prop(prop, args)
    },
    intersect: function (rect1, rect2) {
        var x_total = rect2.right - rect2.left
        var x_match = rect1.right - rect1.left + rect2.right - rect2.left - (rect1.right > rect2.right ? rect1.right : rect2.right) + (rect1.left < rect2.left ? rect1.left : rect2.left)
        if (x_match <= 0) {
            return 0
        }
        x_match = x_match / x_total * 100

        var y_total = rect2.bottom - rect2.top
        var y_match = rect1.bottom - rect1.top + rect2.bottom - rect2.top - (rect1.bottom > rect2.bottom ? rect1.bottom : rect2.bottom) + (rect1.top < rect2.top ? rect1.top : rect2.top)
        if (y_match <= 0) {
            return 0
        }
        y_match = y_match / y_total * 100

        return x_match < y_match ? x_match : y_match
    },
    isString: function (m) {
        return m instanceof String || typeof m == "string"
    },
    iterate: function (obj, iterator) {
        var indices = []
        $.each(obj, function (ind) {
            indices.push(ind)
        })
        var iter_caller = function (handler, index) {
            iterator.call(obj[index], handler, index)
        }
        indices.iterate(function (handler) {
            iter_caller(handler, this)
        })
    },
    /**
     * @param {} name
     * @param {} clazz
     * @param {} configs options are {common_for_multi_element, markup_config_key}
     * @returns {}
     */
    jquerify: function (name, clazz, configs) {
        if (!configs) {
            configs = {}
        }
        var plugin = name.camelCase(false)
        if (window.jquery_conflict_prefix) {
            plugin = window.jquery_conflict_prefix + plugin
        }
        var destroyer = clazz.prototype.destroy
        var _destroyer = function () {
            this.elm.tag("bmui-" + name + "-obj", undefined)
            this.elm.trigger(name + "-uninitialized")
        }
        if (destroyer) {
            destroyer = destroyer.blend(_destroyer)
        } else {
            destroyer = _destroyer
        }
        clazz.prototype.destroy = destroyer
        $.prototype[plugin] = function (options) {
            if (!this.length) {
                if (options == "inst") {
                    return null
                }
                if (options == "isInitialized") {
                    return false
                }
                return this
            }
            if (options && options.isString) {
                var returnable = undefined
                var invokerForEach = function() {
                    var obj = this.tag("bmui-" + name + "-obj")
                    if (options == "inst") {
                        return obj
                    }
                    if (obj) {
                        if (options == "isInitialized") {
                            return true
                        }
                        if (options == "option") {
                            if (arguments.length == 2) {
                                if ($.isFunction(obj._getOption)) {
                                    return obj._getOption(arguments[1])
                                }
                                return obj.options[arguments[1]]
                            }
                            if ($.isFunction(obj._setOption)) {
                                obj._setOption(arguments[1], arguments[2])
                            } else {
                                bm.prop(obj.options, arguments[1], arguments[2])
                            }
                            return this
                        }
                        if (options == "extendObjElement") {
                            arguments[1].tag("bmui-" + name + "-obj", obj)
                        }
                        if (options == "removeObjElement") {
                            arguments[1].tag("bmui-" + name + "-obj", undefined)
                        }
                        if (!$.isFunction(obj[options]) || options.startsWith("_")) {
                            throw new Error((($.i18n.prop('undefined.function') || "Undefined function")) + " " + options)
                        }
                        return obj[options].apply(obj, Array.prototype.splice.call(arguments, 1))
                    } else if (options == "isInitialized") {
                        return false
                    } else {
                        throw $.error("Function is called prior to initialization")
                    }
                }
                var copiedArgs = Array.prototype.splice.call(arguments, 0)
                this.each(function() {
                    var retCode = invokerForEach.apply(this.jqObject, copiedArgs)
                    if (retCode !== undefined) {
                        returnable = retCode
                        return false
                    }
                })
                if(returnable === undefined) {
                    return this
                }
                return returnable
            }
            var create = function () {
                var _options = $.extend({}, options, this.config(configs.markup_config_key || name))
                var obj = new clazz(this, _options)
                obj.elm = this
                if (!obj.options) {
                    obj.options = _options
                }
                this.tag("bmui-" + name + "-obj", obj)
                this.trigger(name + "-initialized")
            }
            if (this.length > 1 && !configs.common_for_multi_element) {
                this.each(function () {
                    create.call($(this))
                })
            } else {
                create.call(this)
            }
            return this
        }
        if (!clazz.prototype.trigger) {
            clazz.prototype.trigger = function () {
                Array.prototype.unshift.call(arguments, name)
                bm.trigger.apply(this, arguments)
            }
        }
    },
    localFileUrlDataKey: "bm-local-file-url",
    /**
     * Object URL to preview a local file in owner, reused per file and revoked when replaced.
     * Chrome refuses data URLs of types such as video/quicktime, so media previews must not use FileReader.
     */
    localFileUrl: function (owner, file) {
        var $owner = $(owner)
        var current = $owner.data(bm.localFileUrlDataKey)
        if (current && current.file === file) {
            return current.url
        }
        bm.releaseLocalFileUrl($owner)
        var url = URL.createObjectURL(file)
        $owner.data(bm.localFileUrlDataKey, {file: file, url: url})
        return url
    },
    releaseLocalFileUrl: function (owner) {
        var $owner = $(owner)
        var current = $owner.data(bm.localFileUrlDataKey)
        if (current) {
            URL.revokeObjectURL(current.url)
            $owner.removeData(bm.localFileUrlDataKey)
        }
    },
    /**
     * @param elem
     * @returns {number}
     * 0 left top
     * 1 right top
     * 2 left right top
     * 3 left bottom
     * 4 right bottom
     * 5 left right bottom
     * 6 left top bottom
     * 7 right top bottom
     */
    positionReference: function (elem) {
        var ref = 0
        var left = elem.acss("left")
        var right = elem.acss("right")
        var top = elem.acss("top")
        var bottom = elem.acss("bottom")
        if (left == "auto") {
            if (right != "auto") {
                ref = 1
            }
        } else {
            if (right != "auto") {
                ref = 2
            }
        }
        if (top == "auto") {
            if (bottom != "auto") {
                ref += 3
            }
        } else {
            if (bottom != "auto") {
                ref += 6
            }
        }
        if (elem.css("position") == "static") {
            if (ref > 5) {
                ref -= 6
            } else if ((ref + 1) % 3 == 0) {
                ref -= 2
            }
        }
        return ref
    },
    omit: function (map, props, excludeFunctions) {
        var nmap = {}
        for (var k in map) {
            if (!props.contains(k) && (!excludeFunctions || !$.isFunction(nmap[k]))) {
                nmap[k] = map[k]
            }
        }
        return nmap
    },
    onReady: function (obj, prop, callback, maxAttempt) {
        if (typeof maxAttempt == "undefined") {
            maxAttempt = 10
        }
        if (maxAttempt > 0) {
            if (typeof obj[prop] == "undefined") {
                if ($.isPlainObject(callback) && callback.not) {
                    callback = $.extend({}, callback)
                    callback.not.call(obj)
                    callback.not = undefined
                }
                setTimeout(function () {
                    bm.onReady(obj, prop, callback, --maxAttempt)
                }, 2000)
            } else {
                ($.isPlainObject(callback) ? callback.ready : callback).call(obj[prop])
            }
        } else {
            if ($.isPlainObject(callback) && callback.fail) {
                callback.fail.call(obj)
            }
        }
    },
    path: function (path) {
        var parts = path.split(/[\\\/]/)
        var protocol
        if (!parts.length) {
            return {}
        }
        if (parts[0].endsWith(":")) {
            protocol = parts[0].substring(0, parts[0].length - 1)
        }
        var namePart = parts[parts.length - 1]
        var queryIndex = namePart.indexOf("?")
        var queryPart
        if (queryIndex > -1) {
            queryPart = namePart.substring(queryIndex + 1)
            namePart = namePart.substring(0, queryIndex)
        }
        var fragmentPart = queryPart || namePart
        var fragmentIndex = fragmentPart.indexOf("#")
        if (fragmentIndex > -1 && queryPart) {
            queryPart = fragmentPart.substring(0, fragmentIndex)
        }
        if (fragmentIndex > -1) {
            fragmentPart = fragmentPart.substring(fragmentIndex + 1)
        } else {
            fragmentPart = null
        }
        var dotIndex = namePart.lastIndexOf(".")
        var ext = dotIndex > -1 ? namePart.substring(dotIndex + 1) : null
        var name = dotIndex > -1 ? namePart.substring(0, dotIndex) : namePart
        var query = queryPart ? bm.query(queryPart) : {}
        var path_obj
        var host_exists = protocol || (parts.length > 2 && parts[0] == "" && parts[1] == "")
        return path_obj = {
            host: host_exists ? parts[2] : null,
            protocol: protocol,
            full: function () {
                var url = path_obj.protocol ? path_obj.protocol + "://" : ""
                url = url + (path_obj.host ? (url ? "" : "//") + path_obj.host + "/" : "")
                var joinableParts = parts.slice(host_exists ? 3 : 0, parts.length - 1)
                url = url + (joinableParts.length ? (joinableParts.join("/") + "/") : "") + path_obj.file_name()
                var query = $.param(path_obj.query)
                return url + (query ? "?" + query : "") + (path_obj.fragmentPart ? "#" + path_obj.fragmentPart : "")
            },
            name: name,
            file_name: function () {
                return this.name + (this.ext ? "." + this.ext : "")
            },
            ext: ext,
            query: query,
            fragment: fragmentPart
        }
    },
    pick: function (map, props) {
        var nmap = {}
        for (var k in map) {
            if (props.contains(k)) {
                nmap[k] = map[k]
            }
        }
        return nmap
    },
    prop: function (obj, name, value) {
        var ids = name.split(/\./)
        var isSet = arguments.length == 3
        for (var g = 0; g < ids.length - 1; g++) {
            var nProp = "" + ids[g]
            if (!(nProp in obj)) {
                if (isSet) {
                    obj[nProp] = {}
                } else {
                    return
                }
            }
            obj = obj[nProp]
            if (typeof obj != "object") {
                return
            }
        }
        if (value == undefined) {
            return obj[ids[ids.length - 1]]
        } else {
            obj[ids[ids.length - 1]] = value
        }
    },
    query: function (query) {
        var returnMap = {}
        query = decodeURIComponent(query)
        query = query.split("&")
        $(query).each(function (i) {
            var nameValue = query[i].split("=")
            nameValue[1] = nameValue[1].replace(/\+/g, " ")
            if (returnMap[nameValue[0]] == undefined) {
                returnMap[nameValue[0]] = nameValue[1]
            } else {
                if ($.isArray(returnMap[nameValue[0]])) {
                    returnMap[nameValue[0]].push(nameValue[1])
                } else {
                    returnMap[nameValue[0]] = [returnMap[nameValue[0]], nameValue[1]]
                }
            }
        })
        return returnMap
    },
    removeAll: function (target, object) {
        var flag
        for (var key in target) {
            flag = false
            for (var objectKey in object) {
                if (key == objectKey) {
                    flag = true
                    break
                }

            }
            if (flag) {
                delete target[key]
            }
        }
    },
    serializeMix: function (a, b) {
        var k = {}
        $.each(a, function (i, v) {
            if (typeof b[i] == "undefined") {
                k[i] = v
            } else {
                if ($.isArray(v)) {
                    k[i] = v.concat(b[i])
                } else if ($.isArray(b[i])) {
                    k[i] = b[i].concat(v)
                } else {
                    k[i] = [v, b[i]]
                }
            }
        })
        $.each(b, function (i, v) {
            if (typeof k[i] == "undefined") {
                k[i] = v
            }
        })
        return k
    },
    template: function (template, args) {
        if (!args) {
            return template
        }
        var l = args.length;
        for (var f = 0; f < l; f++) {
            template = template.replaceAll("{" + f + "}", args[f])
        }
        return template
    },
    /**
     * 'this' should refer some sort of dom dependent object (element should have dom)
     */
    trigger: function (dom, base, name, args) {
        if (base instanceof $) {
            return bm.trigger.call(dom, base, name, args, arguments[4]);
        }
        var returnValue;
        if (!$.isArray(args)) {
            args = [args];
        }
        if (dom.isString) {
            args = name
            name = base
            base = dom
            dom = this.elm
        }
        if ($.isFunction(this["on" + name.capitalize()])) {
            returnValue = this["on" + name.capitalize()].apply(this, args);
        }
        if (returnValue === false) {
            return false;
        }
        if (this.options) {
            if (this.options.events) {
                if ($.isFunction(this.options.events[name])) {
                    returnValue = this.options.events[name].apply(this, args);
                }
            } else if ($.isFunction(this.options[name])) {
                returnValue = this.options[name].apply(this, args);
            }
            if (returnValue === false) {
                return false;
            }
        } else if (this.events) {
            if ($.isFunction(this.events[name])) {
                returnValue = this.events[name].apply(this, args);
            }
            if (returnValue === false) {
                return false;
            }
        }
        return dom.trigger(base + ":" + name, args);
    },
    copy: function (textToCopy, options) {
        var $temp = $("<textarea>"); // an <input> would drop line breaks
        $("body").append($temp);
        $temp.val(textToCopy).select();
        var status = document.execCommand("copy");
        $temp.remove();
        return status
    },
    copyText: function (text, done) {
        var finish = $.isFunction(done) ? done : $.noop;
        var copyByCommand = function () { finish(bm.copy(text)); };
        if (navigator.clipboard && window.isSecureContext) {
            navigator.clipboard.writeText(text).then(function () { finish(true); }, copyByCommand);
            return;
        }
        copyByCommand();
    },
    validateHtmlSelector: function (selector) {
        return new RegExp(/^[A-Za-z]+[\w\-\:\.]*$/).test(selector)
    }
})

bm.expando = "BM" + bm.getUUID();

// True when a license upgrade popup was shown within the last ~2.5s — the notify/feeNotify layer
// (view.js) calls this to suppress the duplicate error/alert toast that accompanies the same 403 block.
// window.__lvBlockActive is stamped by showBlockPopup / the ajax-submit-error hook in the popup module.
bm.__lvLicenseBlockActive = function (type) {
    try {
        var active = window.__lvBlockActive && ((new Date()).getTime() - window.__lvBlockActive < 2500);
        if (!active) { return false; }
        var t = (type || "").toString().toLowerCase();
        return t === "" || t === "error" || t === "alert" || t === "warning";
    } catch (e) { return false; }
};


/* ── License limit / feature-gate block popup (universal) ────────────────────────────────────────
   bm.ajax uses $.ajax, so this ajaxComplete fires in EVERY document that loads utility.js — the FEE
   shell AND the editor iframe. A 403 carrying the license envelope (SecurityInterceptor.provisionCheck:
   errorCode = license_limit_exceeded | license_feature_disabled) shows the upgrade popup, rendered on
   window.top so it covers the whole viewport even when the blocked call came from inside the iframe.
   Current plan + Hykmah URL are read from the top window (set server-side by the FEE shell). */
;(function () {
    // Setup runs once jQuery ($ in this app) is available. utility.js can parse BEFORE jquery.min.js has
    // defined the global $, so we poll briefly instead of bailing (bailing was why this silently no-op'd —
    // __lvLicensePopupBound never got set even though the served file was correct).
    function lvBoot(jQuery) {
        if (window.__lvLicensePopupBound) { return; }
        window.__lvLicensePopupBound = true;

    function topWin() { try { return window.top || window; } catch (e) { return window; } }
    function topDoc() { try { return topWin().document; } catch (e) { return document; } }
    function esc(s) { return jQuery("<div/>").text(s == null ? "" : String(s)).html(); }

    // Endpoints that render their OWN inline license-block UI (an in-body "Upgrade" card) instead of the global
    // upgrade modal. Showing BOTH stacks two copies of the same message (the modal's "Not Now" just reveals the
    // identical card underneath), so for these we suppress the modal and let the section body be the sole block
    // UI — the card's "Upgrade Now" opens the same upgrade flow. Covers the FEE Version History panel plus every
    // full-screen gated shell (Settings/Analytics/Customers/Orders/Marketing), whose open*Tab error handlers fill
    // the shell via app.feeLicenseBlockPanel. Matched on the request URL (the only block context available at
    // every popup entry point). Keep in sync with the open*Tab endpoints in fee.editor.events.js.
    function inlineBlockUrl(url) {
        if (!url) { return false; }
        var u = String(url);
        var inline = [
            "loadPageVersionHistory",   // FEE Version History panel
            "loadEditorSettingTab",     // Settings shell
            "loaAnalyticsDetails",      // Analytics (v1)
            "loadAnalyticsInfo",        // Analytics (v2)
            "loadCustomerDetails",      // Customers shell
            "loaOrderDetails",          // Orders shell
            "loadMarketingTab"          // Marketing shell
        ];
        for (var i = 0; i < inline.length; i++) {
            if (u.indexOf(inline[i]) !== -1) { return true; }
        }
        return false;
    }

    // Background integration status probes ("<plugin>Admin/getConnections", fanned out by the plugins/packages
    // list via myPackagePlugins) must NOT raise the global upgrade popup when the plugin's feature is disabled —
    // a disabled integration simply reads as "not connected" and its probe renders no UI of its own. So the
    // license block on these is swallowed SILENTLY (no popup, no toast), unlike a user-initiated feature action.
    function silentBlockUrl(url) {
        return !!(url && /\/getConnections(\?|$)/.test(String(url)));
    }

    // C3/F4 — shared i18n resolver for the license-popup subsystem: $.i18n.prop against the CLIENT bundle
    // (wc/7.0.0/js/i18n/messages.properties) with a safe English fallback, so a missing / late-loaded key never
    // renders "[key]". args substitute {0},{1},… (both via i18n and in the fallback). Replaces the ad-hoc local
    // `tr` that the version-history card used (its keys were the R4 bug — server-only; now in the client bundle).
    function lvTr(key, fallback, args) {
        try {
            if (window.jQuery && jQuery.i18n && jQuery.i18n.prop) {
                var v = jQuery.i18n.prop.apply(jQuery.i18n, [key].concat(args || []));
                if (v && v !== key && v.charAt(0) !== "[") { return v; }
            }
        } catch (e) {}
        return (args && args.length)
            ? String(fallback).replace(/\{(\d+)\}/g, function (m, i) { return args[i] != null ? args[i] : m; })
            : fallback;
    }
    topWin().lvTr = lvTr;

    // NOTE: the old client-side tier helpers (planTierOrder / nextTier, which read the LV_PLAN_TIERS cache) and the
    // per-plan feature fallbacks were removed — every license/limit/upgrade popup now gets its plan / price /
    // features / checkout URL from the backend (license/upgradeContext via lvFetchUpgradeContext), so nothing here
    // reads the frontend-cached LV_* globals.

    function ensureStyle() {
        var d = topDoc();
        if (d.getElementById("lv-lic-popup-style")) { return; }
        var css =
            ".lv-lic-overlay{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;background:rgba(48,50,51,.7);padding:20px;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Helvetica,Arial,sans-serif;}" +
            /* Open animation — matches the shared POPUP widget (popup.js wcui-popup-enter / wcui-mask-fade): the
               backdrop fades in and the card scales up from .3. One-shot per fresh popup element, so it never loops. */
            "@keyframes lvPopupEnter{from{opacity:0;scale:.3}50%{opacity:1}}" +
            "@keyframes lvMaskFade{from{opacity:0}}" +
            ".lv-lic-overlay{animation:lvMaskFade .25s ease-out;}" +
            ".lv-lic-card,.lv-up-card,.lv-fu-card{animation:lvPopupEnter .3s ease-out both;}" +
            ".lv-lic-sub{margin:0 0 28px;font-size:13px;color:#6b7280;font-weight:500;text-align:center;}" +
            /* P3 plan-card popup (per the reference mock) */
            ".lv-lic-card{width:100%;max-width:440px;background:#fff;border-radius:16px;overflow:hidden;box-shadow:0 20px 40px -8px rgba(16,24,40,.35);box-sizing:border-box;}" +
            ".lv-lic-card__head{position:relative;background:#2f56dd;background-image:radial-gradient(rgba(255,255,255,.15) 1px,transparent 0);background-size:12px 12px;color:#fff;padding:22px 28px 26px;text-align:center;}" +
            ".lv-lic-card__close{position:absolute;top:12px;right:14px;background:transparent;border:none;color:#fff;font-size:22px;line-height:1;cursor:pointer;opacity:.85;padding:2px 6px;}" +
            ".lv-lic-card__close:hover{opacity:1;}" +
            ".lv-lic-card__badge{width:56px;height:56px;border-radius:50%;background:#fde8c8;display:inline-flex;align-items:center;justify-content:center;margin-bottom:12px;}" +
            ".lv-lic-card__title{margin:0 0 8px;font-size:22px;font-weight:800;letter-spacing:-.01em;}" +
            ".lv-lic-card__sub{margin:0;font-size:14px;line-height:1.45;color:rgba(255,255,255,.92);}" +
            ".lv-lic-card__body{padding:22px 28px 26px;}" +
            ".lv-lic-plan{display:flex;align-items:baseline;justify-content:space-between;gap:12px;margin-bottom:18px;}" +
            ".lv-lic-plan__name{font-size:20px;font-weight:700;color:#101828;}" +
            ".lv-lic-plan__price{font-size:22px;font-weight:800;color:#101828;white-space:nowrap;}" +
            ".lv-lic-feats{display:flex;flex-direction:column;gap:12px;margin-bottom:24px;}" +
            ".lv-lic-feat{display:flex;align-items:center;gap:10px;font-size:14.5px;color:#344054;}" +
            ".lv-lic-card__foot{display:flex;gap:12px;}" +
            ".lv-lic-cancel{flex:0 0 auto;background:#fff;color:#344054;border:1px solid #d0d5dd;border-radius:999px;padding:12px 28px;font-size:15px;font-weight:600;cursor:pointer;}" +
            ".lv-lic-cancel:hover{background:#f9fafb;}" +
            ".lv-lic-upgrade{flex:1 1 auto;background:#0084ff;color:#fff;border:none;border-radius:999px;padding:12px 24px;font-size:15px;font-weight:700;cursor:pointer;}" +
            ".lv-lic-upgrade:hover{background:#0072e6;}" +
            ".lv-lic-topup-wrap{margin-top:14px;}" +
            ".lv-lic-topup{width:100%;background:#fff;color:#0084ff;border:1.5px solid #0084ff;border-radius:999px;padding:11px 20px;font-size:14px;font-weight:700;cursor:pointer;}" +
            ".lv-lic-topup:hover{background:#f0f7ff;}" +
            ".lv-lic-topup__price{opacity:.8;font-weight:600;margin-left:2px;}" +
            ".lv-up-card{width:100%;max-width:550px;background:#fff;border-radius:16px;overflow:hidden;box-shadow:0 20px 25px -5px rgba(0,0,0,.2),0 8px 10px -6px rgba(0,0,0,.1);box-sizing:border-box;font-family:'Source Sans 3','Source Sans Pro',-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Helvetica,Arial,sans-serif;}" +
            ".lv-up-head{background:#3b5bf6;background-image:radial-gradient(rgba(255,255,255,.16) 1px,transparent 0);background-size:12px 12px;padding:28px 24px;text-align:center;color:#fff;position:relative;}" +
            ".lv-up-brands{display:flex;align-items:center;justify-content:center;gap:14px;margin-bottom:18px;}" +
            ".lv-up-badge{width:56px;height:56px;border-radius:50%;background:#fff;display:flex;align-items:center;justify-content:center;box-shadow:0 2px 8px rgba(0,0,0,.18);}" +
            ".lv-up-badge svg{display:block;}" +
            ".lv-up-arrows{display:flex;align-items:center;}" +
            ".lv-up-price{font-size:24px;line-height:28px;font-weight:700;color:#000;white-space:nowrap;}" +
            ".lv-up-price__int{font-size:13px;font-weight:600;letter-spacing:-.2px;color:#828282;margin-left:2px;}" +
            ".lv-up-close{position:absolute;top:16px;right:18px;background:transparent;border:none;color:#fff;font-size:18px;cursor:pointer;opacity:.9;line-height:1;padding:4px;}" +
            ".lv-up-title{margin:0 0 8px;font-size:32px;line-height:1.05;font-weight:700;letter-spacing:-.01em;}" +
            ".lv-up-sub{margin:0;font-size:16px;line-height:24px;color:rgba(255,255,255,.92);}" +
            ".lv-up-bodywrap{padding:24px;}" +
            ".lv-up-planrow{display:flex;justify-content:space-between;align-items:center;margin-bottom:20px;}" +
            ".lv-up-planname{font-size:20px;line-height:32px;font-weight:600;letter-spacing:0;color:#000;}.lv-up-tagline{font-size:16px;font-weight:700;color:#111827;}" +
            ".lv-up-features{display:flex;flex-direction:column;gap:14px;margin-bottom:28px;}" +
            ".lv-up-feature{display:flex;align-items:center;gap:10px;font-size:16px;line-height:20px;color:#323B48;font-weight:400;}.lv-up-feature svg{flex-shrink:0;}" +
            ".lv-up-actions{display:flex;gap:14px;}" +
            ".lv-up-cancel{flex:1;background:#fff;color:#1f2937;border:1px solid #D0D5DD;border-radius:99px;padding:12px 20px;font-size:16px;font-weight:700;cursor:pointer;box-shadow:0 1px 2px rgba(16,24,40,.05);}" +
            ".lv-up-manage{flex:1;background:#008DF2;color:#fff;border:none;border-radius:99px;padding:12px 20px;font-size:16px;font-weight:700;cursor:pointer;box-shadow:0 1px 2px rgba(16,24,40,.05);}.lv-up-manage:hover{background:#0079d6;}" +
            // Note line under the feature list — used by the purchase-confirmation popup (shares the .lv-up-* chrome).
            ".lv-up-note{margin:-12px 0 22px;font-size:13px;line-height:1.55;color:#667085;}" +
            // Feature add-on chooser popup (lvOpenFeatureUnlockPopup) — WC→hykma header + selectable priced options.
            ".lv-fu-card{width:100%;max-width:550px;background:#fff;border-radius:16px;overflow:hidden;box-shadow:0 20px 25px -5px rgba(0,0,0,.2),0 8px 10px -6px rgba(0,0,0,.1);box-sizing:border-box;font-family:'Source Sans 3','Source Sans Pro',-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Helvetica,Arial,sans-serif;}" +
            ".lv-fu-head{background:#3b5bf6;background-image:radial-gradient(rgba(255,255,255,.16) 1px,transparent 0);background-size:12px 12px;padding:28px 24px;text-align:center;color:#fff;position:relative;}" +
            ".lv-fu-close{position:absolute;top:16px;right:18px;background:transparent;border:none;color:#fff;font-size:18px;cursor:pointer;opacity:.9;line-height:1;padding:4px;}" +
            ".lv-fu-brands{display:flex;align-items:center;justify-content:center;gap:14px;margin-bottom:18px;}" +
            ".lv-fu-warn{width:56px;height:56px;border-radius:50%;background:#fde8c8;display:inline-flex;align-items:center;justify-content:center;margin-bottom:18px;}" +
            ".lv-fu-warn svg{display:block;}" +
            ".lv-fu-badge{width:56px;height:56px;border-radius:50%;background:#fff;display:flex;align-items:center;justify-content:center;box-shadow:0 2px 8px rgba(0,0,0,.18);}" +
            ".lv-fu-badge svg{display:block;}" +
            ".lv-fu-arrows{display:flex;align-items:center;}" +
            ".lv-fu-title{margin:0 0 8px;font-size:32px;line-height:1.05;font-weight:700;letter-spacing:-.01em;}" +
            ".lv-fu-sub{margin:0;font-size:16px;line-height:24px;color:rgba(255,255,255,.92);}" +
            ".lv-fu-body{padding:22px 24px 6px;display:flex;flex-direction:column;gap:14px;}" +
            ".lv-fu-opt{border:1px solid #D0D5DD;border-radius:12px;padding:12px 16px;cursor:pointer;background:#fff;transition:border-color .15s,box-shadow .15s,background .15s;}" +
            ".lv-fu-opt.selected{border-color:#008DF2;box-shadow:0 0 0 3px rgba(0,141,242,.12);background:#fafcff;}" +
            ".lv-fu-opt__top{display:flex;align-items:center;gap:12px;}" +
            ".lv-fu-opt__radio{width:16px;height:16px;border-radius:50%;border:1.5px solid #D0D5DD;flex-shrink:0;position:relative;}" +
            ".lv-fu-opt.selected .lv-fu-opt__radio{border-color:#008DF2;}" +
            ".lv-fu-opt.selected .lv-fu-opt__radio::after{content:'';position:absolute;top:4px;left:4px;right:4px;bottom:4px;border-radius:50%;background:#008DF2;}" +
            ".lv-fu-opt__label{text-transform: capitalize;font-size:18px;line-height:28px;font-weight:700;letter-spacing:-.02em;color:#000;flex:1;}" +
            ".lv-fu-opt__price{font-size:22px;line-height:28px;font-weight:700;color:#000;white-space:nowrap;}" +
            ".lv-fu-opt__price span{font-size:13px;font-weight:600;letter-spacing:-.2px;color:#828282;margin-left:2px;}" +
            ".lv-fu-opt__feat{display:flex;align-items:center;gap:10px;font-size:15px;line-height:20px;color:#323B48;padding-left:28px;margin-top:8px;}" +
            ".lv-fu-opt__feat svg{flex-shrink:0;}" +
            ".lv-fu-actions{display:flex;gap:14px;padding:20px 24px 24px;}" +
            ".lv-fu-card button{font-family:inherit;}" +   // buttons do not inherit the page font on their own
            ".lv-fu-cancel{flex:1;display:inline-flex;align-items:center;justify-content:center;min-height:40px;background:#fff;color:#262626;border:1px solid #DDDDDD;border-radius:42px;padding:8px 12px;font-size:14px;font-weight:600;letter-spacing:-.4px;cursor:pointer;}" +
            ".lv-fu-cta{flex:1.4;display:inline-flex;align-items:center;justify-content:center;gap:8px;min-height:40px;background:#008DF2;color:#fff;border:none;border-radius:28px;padding:8px 24px;font-size:14px;font-weight:700;letter-spacing:-.16px;cursor:pointer;box-shadow:0 2px 6px rgba(0,0,0,.25);}.lv-fu-cta:hover{background:#0072d6;}" +
            // Import limit pre-flight popup (wcShowImportLimitPopup) — "Some of your data exceeds your plan's limits".
            ".wc-il-card{width:100%;max-width:560px;background:#fff;border-radius:16px;overflow:hidden;box-shadow:0 20px 25px -5px rgba(0,0,0,.2),0 8px 10px -6px rgba(0,0,0,.1);box-sizing:border-box;}" +
            ".wc-il-head{position:relative;background:linear-gradient(103deg,#5b53e6,#2563eb);padding:24px 28px 22px;color:#fff;}" +
            ".wc-il-close{position:absolute;top:16px;right:18px;background:transparent;border:none;color:#fff;font-size:18px;cursor:pointer;opacity:.9;line-height:1;padding:4px;}" +
            ".wc-il-title{margin:0 0 6px;font-size:20px;font-weight:700;letter-spacing:-.01em;}" +
            ".wc-il-sub{margin:0;font-size:13.5px;color:#dfe6ff;line-height:1.45;}" +
            ".wc-il-body{padding:18px 28px 6px;}" +
            ".wc-il-table{width:100%;border-collapse:collapse;font-size:14px;}" +
            ".wc-il-table th{text-align:left;font-size:11px;font-weight:600;letter-spacing:.04em;text-transform:uppercase;color:#98a2b3;padding:8px 12px 8px 0;border-bottom:1px solid #eef0f3;}" +
            // Kill a stray ::after inherited from a global admin th/td rule (rendered an empty pseudo-element under
            // the header cells). Scoped to this popup's table only. Same fix as .lv-urls-table in _urls.gsp.
            ".wc-il-table th::after,.wc-il-table td::after{content:none !important;}" +
            ".wc-il-table th.wc-il-num,.wc-il-table td.wc-il-num{text-align:left;}" +
            ".wc-il-table td{padding:12px 12px 12px 0;border-bottom:1px solid #f4f4f5;color:#1f2937;font-variant-numeric:tabular-nums;}" +
            ".wc-il-table tr:last-child td{border-bottom:0;}" +
            ".wc-il-ent{font-weight:600;color:#1a1a1a;}" +
            ".wc-il-status--over{color:#d93838;font-weight:600;}" +
            ".wc-il-status--within{color:#12923b;font-weight:600;}" +
            ".wc-il-actions{display:flex;gap:14px;padding:18px 28px 26px;}" +
            ".wc-il-secondary{flex:1;background:#fff;color:#1f2937;border:1px solid #d1d5db;border-radius:24px;padding:12px 18px;font-size:15px;font-weight:700;cursor:pointer;box-shadow:0 1px 2px rgba(0,0,0,.05);}" +
            ".wc-il-secondary:hover{background:#f7f9fa;border-color:#cbd2da;}" +
            ".wc-il-secondary:disabled{opacity:.45;cursor:not-allowed;background:#fff;border-color:#e5e7eb;box-shadow:none;}" +
            ".wc-il-primary{flex:1.35;background:#2563eb;color:#fff;border:none;border-radius:24px;padding:12px 18px;font-size:15px;font-weight:700;cursor:pointer;box-shadow:0 4px 12px rgba(37,99,235,.3);}" +
            ".wc-il-primary:hover{background:#1d4fd7;}";
        var s = d.createElement("style"); s.id = "lv-lic-popup-style"; s.innerHTML = css;
        (d.head || d.getElementsByTagName("head")[0]).appendChild(s);
    }

    // (Removed upgradePackage/fmtUpgradePrice — they read the LV_PACKAGES cache. Popups now use the backend
    // upgrade context instead; see lvFetchUpgradeContext below.)

    // Last-resort pricing link (NOT cached data — a static default) used only when the backend upgrade context is
    // unreachable, so a CTA is never a dead click.
    var LV_PRICING_FALLBACK = "https://www.hykmah.com/pricing#platform-pricing";

    // Shared brand marks + green check for the license popups: WebCommander → swap arrows → provider (hub), and the
    // feature check. Defined ONCE here so the "Upgrade to next plan" popup (renderUpgradePopup) AND the
    // purchase-confirmation popup (fee.license-confirmation.js, via window.lvLicenseChrome) render the exact same
    // chrome from a single source — no duplicated SVG.
    var LV_WC_LOGO = '<svg width="28" height="21" viewBox="0 0 28 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="0.9" fill-rule="evenodd" clip-rule="evenodd" d="M25.9193 9.44321C24.2639 12.374 23.599 13.8604 22.683 13.8587C21.4942 13.8563 21.0757 12.9234 20.9813 6.56994C20.9388 3.63215 19.949 1.93169 17.9309 2.71946C16.4173 3.30998 15.2139 6.52803 14.4818 8.16068C12.2847 13.0603 11.6863 10.4911 10.3201 7.95521C4.04992 -3.68047 -1.19723 0.917905 0.239042 0.794623C1.84102 0.65737 5.83787 2.89781 8.80198 12.5359C10.7269 17.4857 13.5018 17.7117 16.0482 13.5053C17.0132 11.9113 19.2667 7.36839 19.2351 9.94537C19.2035 12.5224 19.5592 17.0081 22.0339 17.3529C23.9021 17.613 24.9291 15.8633 26.3691 11.5632C26.7133 10.3731 27.2546 9.25096 27.9698 8.24492C28.1692 7.95972 27.369 6.87897 25.9193 9.44321Z" fill="black"/><path d="M16.1123 18.9594C16.1124 19.2371 16.0313 19.5086 15.8792 19.7396C15.7272 19.9706 15.511 20.1506 15.2581 20.257C15.0051 20.3633 14.7268 20.3912 14.4582 20.3371C14.1897 20.283 13.9429 20.1493 13.7493 19.953C13.5556 19.7567 13.4237 19.5065 13.3702 19.2342C13.3167 18.9618 13.344 18.6795 13.4487 18.4229C13.5534 18.1663 13.7308 17.9469 13.9584 17.7925C14.1861 17.6382 14.4537 17.5557 14.7275 17.5557C15.0946 17.5557 15.4468 17.7035 15.7064 17.9668C15.9661 18.23 16.1121 18.5871 16.1123 18.9594Z" fill="black"/><path d="M20.7683 18.9594C20.7684 19.2372 20.6873 19.5087 20.5352 19.7397C20.3831 19.9706 20.167 20.1507 19.914 20.257C19.661 20.3633 19.3827 20.3912 19.1141 20.3371C18.8455 20.2829 18.5988 20.1492 18.4051 19.9529C18.2115 19.7565 18.0796 19.5063 18.0261 19.2339C17.9727 18.9615 18.0001 18.6792 18.1049 18.4226C18.2096 18.166 18.3871 17.9466 18.6147 17.7923C18.8424 17.638 19.1101 17.5557 19.3839 17.5557C19.751 17.5557 20.1031 17.7035 20.3627 17.9668C20.6223 18.23 20.7682 18.5871 20.7683 18.9594Z" fill="black"/></svg>';
    var LV_PROV_LOGO = '<svg width="30" height="19" viewBox="0 0 30 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M24.5032 0.000138856C19.7756 0.0278018 18.5381 3.74202 17.758 7.73655C16.5823 7.74024 15.5865 7.74301 15.0931 7.74485C14.7907 7.74209 13.9211 7.73563 12.7907 7.7301C13.5182 4.24641 14.4394 2.3893 17.1771 0.0305683C17.1771 0.0305683 10.7224 0.522049 9.7385 6.76189C9.68686 7.09201 9.63615 7.41013 9.58728 7.71903C7.80855 7.71626 6.02613 7.7218 4.94359 7.74577C2.14686 7.80755 0.547938 10.2354 0.118239 11.8334C-0.312381 13.4314 0.210451 18.4108 5.49685 18.3803C10.2244 18.3527 11.4619 14.6385 12.242 10.6439C13.4177 10.6402 14.4135 10.6375 14.9069 10.6356C15.2093 10.6384 16.0789 10.6449 17.2094 10.6504C16.4818 14.1341 15.5606 15.9912 12.8229 18.3499C12.8229 18.3499 19.2776 17.8584 20.2615 11.6186C20.3131 11.2885 20.3639 10.9704 20.4127 10.6614C22.1915 10.6642 23.9739 10.6587 25.0564 10.6347C27.8531 10.5729 29.4521 8.14504 29.8818 6.54704C30.3124 4.94905 29.7896 -0.0302904 24.5032 0.000138856ZM5.25065 15.4296C3.49866 15.4601 2.23815 13.3392 3.34467 11.7717C3.89793 10.9722 4.6356 10.6651 5.12708 10.6651C5.32994 10.6651 7.08378 10.6596 9.07644 10.6541C8.39961 14.0271 7.59923 15.4066 5.25065 15.4296ZM26.6544 6.6079C26.1012 7.40736 25.3635 7.71442 24.872 7.71442C24.6691 7.71442 22.9153 7.71995 20.9226 7.72549C21.5995 4.35245 22.3998 2.97299 24.7484 2.94994C26.5004 2.91951 27.7609 5.04033 26.6544 6.6079Z" fill="url(#lvUpProvGrad)"/><defs><linearGradient id="lvUpProvGrad" x1="4.54315" y1="24.4066" x2="14.8132" y2="-1.49368" gradientUnits="userSpaceOnUse"><stop stop-color="#FF547C"/><stop offset="0.509586" stop-color="#0079F2"/><stop offset="1" stop-color="#8C67FF"/></linearGradient></defs></svg>';
    var LV_ARROWS = '<span class="lv-up-arrows"><svg width="24" height="19" viewBox="0 0 24 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.84934 13.2964H0.666676C0.477342 13.2964 0.318676 13.2328 0.190676 13.1057C0.0626757 12.9786 -0.000879693 12.8199 9.19542e-06 12.6297C0.000898084 12.4395 0.0644535 12.2808 0.190676 12.1537C0.316898 12.0266 0.475565 11.963 0.666676 11.963H9.84934L6.19601 8.30971C6.07067 8.18526 6.00401 8.03326 5.99601 7.85371C5.98712 7.67593 6.05379 7.51327 6.19601 7.36571C6.34267 7.21904 6.5009 7.14571 6.67067 7.14571C6.84045 7.14571 6.99912 7.21904 7.14667 7.36571L11.656 11.8764C11.7725 11.9919 11.8542 12.1106 11.9013 12.2324C11.9485 12.3542 11.972 12.4866 11.972 12.6297C11.972 12.7728 11.9485 12.9053 11.9013 13.027C11.8542 13.1488 11.7725 13.2675 11.656 13.383L7.13867 17.9017C7.0089 18.0315 6.85601 18.0995 6.68001 18.1057C6.50312 18.1119 6.34134 18.0413 6.19467 17.8937C6.05245 17.747 5.98045 17.5897 5.97867 17.4217C5.9769 17.2537 6.0489 17.0968 6.19467 16.951L9.84934 13.2964ZM14.1507 6.14304L17.804 9.79638C17.9293 9.92082 17.996 10.0724 18.004 10.251C18.012 10.4297 17.9453 10.5928 17.804 10.7404C17.6582 10.887 17.5 10.9604 17.3293 10.9604C17.1587 10.9604 17.0005 10.887 16.8547 10.7404L12.344 6.22971C12.2276 6.11415 12.1458 5.99549 12.0987 5.87371C12.0516 5.75193 12.028 5.61949 12.028 5.47638C12.028 5.33326 12.0516 5.20082 12.0987 5.07904C12.1458 4.95727 12.2276 4.83815 12.344 4.72171L16.8613 0.204377C16.9911 0.0745997 17.1445 0.00659987 17.3213 0.00037765C17.4982 -0.00584457 17.6596 0.064822 17.8053 0.212378C17.9476 0.359044 18.0196 0.515933 18.0213 0.683044C18.024 0.851044 17.952 1.00838 17.8053 1.15504L14.152 4.80838H23.3333C23.5236 4.80838 23.6822 4.87238 23.8093 5.00038C23.9365 5.12838 24 5.28704 24 5.47638C24 5.66571 23.9365 5.82438 23.8093 5.95238C23.6822 6.08038 23.5236 6.14393 23.3333 6.14304H14.1507Z" fill="#c3d0ff"/></svg></span>';
    var LV_CHECK = '<svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.8248 15.8346H15.8327M15.8248 15.8346C15.3058 16.3492 14.3654 16.2211 13.7059 16.2211C12.8964 16.2211 12.5066 16.3794 11.9288 16.9571C11.4369 17.4491 10.7774 18.3346 9.99935 18.3346C9.22127 18.3346 8.56177 17.4491 8.06982 16.9571C7.49208 16.3794 7.10226 16.2211 6.29273 16.2211C5.63325 16.2211 4.69283 16.3492 4.17392 15.8346C3.65086 15.316 3.77958 14.3716 3.77958 13.7079C3.77958 12.8691 3.59615 12.4835 2.99883 11.8861C2.1103 10.9976 1.66603 10.5533 1.66602 10.0013C1.66602 9.44922 2.11028 9.00497 2.99881 8.11644C3.53202 7.58323 3.77958 7.05487 3.77958 6.29469C3.77958 5.63518 3.65142 4.69475 4.16602 4.17584C4.68471 3.65279 5.62902 3.78152 6.29275 3.78152C7.05291 3.78152 7.58128 3.53397 8.11447 3.00078C9.00302 2.11224 9.44727 1.66797 9.99935 1.66797C10.5514 1.66797 10.9957 2.11224 11.8842 3.00078C12.4173 3.53386 12.9456 3.78152 13.7059 3.78152C14.3654 3.78152 15.3059 3.65336 15.8248 4.16797C16.3478 4.68666 16.2191 5.63096 16.2191 6.29469C16.2191 7.13345 16.4026 7.51911 16.9998 8.11644C17.8884 9.00497 18.3327 9.44922 18.3327 10.0013C18.3327 10.5533 17.8884 10.9976 16.9998 11.8861C16.4025 12.4835 16.2191 12.8691 16.2191 13.7079C16.2191 14.3716 16.3478 15.316 15.8248 15.8346Z" stroke="#10C05F" stroke-width="1.25"/><path d="M7.5 10.7454C7.5 10.7454 8.5 11.2886 9 12.0846C9 12.0846 10.5 8.95964 12.5 7.91797" stroke="#10C05F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    // Expose the shared license-popup chrome so other modules (fee.license-confirmation.js) render in the EXACT
    // same style — reusing these styles + marks, never re-implementing them.
    try {
        topWin().lvEnsureLicenseStyles = ensureStyle;
        topWin().lvLicenseChrome = { wcLogo: LV_WC_LOGO, provLogo: LV_PROV_LOGO, arrows: LV_ARROWS, check: LV_CHECK };
    }
    catch (e) {}

    // SINGLE backend source for every license/limit/upgrade popup: GET license/upgradeContext →
    // { currentPlan, nextPlan:{name,priceDisplay,interval,feats,url}, purchaseUrl }. Calls cb(ctx) on success or
    // cb(null) on failure. This is how the popups get their data — NOTHING is read from the frontend-cached LV_*
    // globals anymore, so the plan/price/features/URL can never be stale or mis-resolved client-side.
    function lvFetchUpgradeContext(cb) {
        try {
            var base = (topWin().app && topWin().app.baseUrl) || (window.app && app.baseUrl) || "/";
            jQuery.ajax({
                url: base + "license/upgradeContext", dataType: "json",
                success: function (resp) { cb((resp && resp.status === "success") ? resp : null); },
                error: function () { cb(null); }
            });
        }
        catch (e) { cb(null); }
    }

    // Fetch a per-key add-on "unlock" offer LIVE from the backend (GET license/unlockOffer?key=X) — banners + badge
    // use this instead of baking the offer into the page. cb(offer) on success (offer.popup carries the options),
    // cb(null) on failure.
    function lvFetchUnlockOffer(key, cb) {
        try {
            var base = (topWin().app && topWin().app.baseUrl) || (window.app && app.baseUrl) || "/";
            jQuery.ajax({
                url: base + "license/unlockOffer", data: { key: key }, dataType: "json",
                success: function (resp) { cb((resp && resp.status === "success") ? resp : null); },
                error: function () { cb(null); }
            });
        }
        catch (e) { cb(null); }
    }

    // Open the add-on chooser for a license key, fetching the offer LIVE: an add-on offer → the chooser
    // (showFeatureUnlockPopup, which appends the next plan from license/upgradeContext); no add-on → the plain
    // next-plan upgrade popup. Exposed as topWin().lvOpenUnlockPopup for the banners + storefront badge.
    function lvOpenUnlockPopup(key, trigger) {
        if (!key) { showUpgradePopup({ trigger: trigger }); return; }
        lvBtnLoading(trigger, true);   // inline spinner on the banner CTA while the offer is fetched
        lvFetchUnlockOffer(key, function (offer) {
            lvBtnLoading(trigger, false);
            if (offer && offer.popup && offer.popup.options && offer.popup.options.length) {
                showFeatureUnlockPopup(offer.popup);
            }
            else {
                showUpgradePopup();
            }
        });
    }
    topWin().lvOpenUnlockPopup = lvOpenUnlockPopup;

    // Inline button loader (WC convention): spin the clicked CTA while the async upgrade-context / unlock-offer
    // fetch is in flight, so the click gives immediate feedback before the popup opens. Self-contained — injects
    // its own keyframe into the button's OWN document (the banner/badge lives in the page frame, which is not
    // always topDoc()). No-ops gracefully when no trigger element was passed (programmatic opens).
    function lvBtnLoading(btn, on) {
        if (!btn) { return; }
        var $btn = jQuery(btn);
        if (!$btn.length) { return; }
        var od = btn.ownerDocument || document;
        if (!od.getElementById("lv-btn-spin-style")) {
            var st = od.createElement("style");
            st.id = "lv-btn-spin-style";
            st.innerHTML = "@keyframes lvBtnSpin{to{transform:rotate(360deg)}}" +
                ".lv-btn--loading{pointer-events:none;opacity:.75;}" +
                ".lv-btn-spin{display:inline-block;width:13px;height:13px;margin-right:7px;vertical-align:-2px;" +
                "border:2px solid currentColor;border-right-color:transparent;border-radius:50%;" +
                "animation:lvBtnSpin .6s linear infinite;}";
            (od.head || od.getElementsByTagName("head")[0]).appendChild(st);
        }
        if (on) {
            if ($btn.data("lvLoading")) { return; }
            $btn.data("lvLoading", true).data("lvWasDisabled", !!btn.disabled);
            $btn.addClass("lv-btn--loading").prepend('<span class="lv-btn-spin" aria-hidden="true"></span>');
            try { btn.disabled = true; }
            catch (e) { /* non-button element — class-only spin */ }
        }
        else {
            if (!$btn.data("lvLoading")) { return; }
            $btn.find(".lv-btn-spin").remove();
            $btn.removeClass("lv-btn--loading");
            try { btn.disabled = !!$btn.data("lvWasDisabled"); }
            catch (e) { /* non-button element */ }
            $btn.removeData("lvLoading").removeData("lvWasDisabled");
        }
    }

    // opts (optional): { feature: "<blocked feature label>", trigger: <clicked button el> } — feature is shown
    // FIRST so the offer is relevant to what the user just hit; trigger gets an inline spinner during the fetch.
    // Opens the "upgrade to the next package" popup. FIRST fetches the SERVER-computed current→next-tier options
    // (license/planUpgradeOptions — hub-driven, the same source the settings upsell chooser uses) so it shows the
    // ACTUAL next package with real name/price/features. Falls back to the client-side tier guess only if that
    // fetch is unavailable — so it no longer defaults to the top tier ("Enterprise") when the current plan can't
    // be resolved client-side.
    // Canonical billing-interval display so every popup shows the SAME cadence text — never a "/mo" vs "monthly"
    // mix. Accepts whatever the hub/server sends (/mo, mo, month, /month, monthly, m → "/month"; /yr, yr, year,
    // yearly, annual → "/year"); one-time / lifetime / blank → "" (no suffix, e.g. one-time add-ons). An unknown
    // value is shown as-is with a single leading slash so it's at least uniform.
    function lvNormalizeInterval(raw) {
        var s = (raw == null ? "" : String(raw)).trim().toLowerCase().replace(/^\//, "");
        if (!s) { return ""; }
        if (s === "onetime" || s === "one-time" || s === "one_time" || s === "lifetime" || s === "once") { return ""; }
        if (s.indexOf("year") === 0 || s.indexOf("annual") === 0 || s === "yr" || s === "y" || s === "yearly") {
            return lvTr("lv.interval.year", "/year");
        }
        if (s.indexOf("month") === 0 || s === "mo" || s === "m" || s === "monthly") {
            return lvTr("lv.interval.month", "/month");
        }
        return "/" + s;
    }

    function showUpgradePopup(opts) {
        opts = opts || {};
        if (topDoc().getElementById("lv-up-popup")) { return; }
        // A caller that already has the SERVER offer (e.g. the AI-credits widget, whose aiCreditsUsage backend call
        // returns the full next-plan offer) passes it as opts.nextOpt — AUTHORITATIVE, so we skip the fetch.
        if (opts.nextOpt && opts.nextOpt.name) { renderUpgradePopup(opts, opts.nextOpt, (opts.nextOpt.url || LV_PRICING_FALLBACK)); return; }
        // Otherwise get everything from the backend (license/upgradeContext) — never from frontend-cached globals.
        // Spin the clicked CTA (opts.trigger) inline while that call is in flight; clear it before the popup opens.
        var trigger = opts.trigger || null;
        lvBtnLoading(trigger, true);
        lvFetchUpgradeContext(function (ctx) {
            lvBtnLoading(trigger, false);
            var np = (ctx && ctx.nextPlan && ctx.nextPlan.name) ? ctx.nextPlan : null;
            if (ctx && ctx.currentPlan) { opts.currentPlan = ctx.currentPlan; }   // drives the "<current> to <next>" subtitle
            renderUpgradePopup(opts, np, (ctx && ctx.purchaseUrl) || LV_PRICING_FALLBACK);
        });
    }

    function renderUpgradePopup(opts, nextOpt, fallbackUrl) {
        ensureStyle();
        var d = topDoc();
        if (d.getElementById("lv-up-popup")) { return; }
        opts = opts || {};
        fallbackUrl = fallbackUrl || LV_PRICING_FALLBACK;
        // ALL data is server-supplied (nextOpt = the backend next-tier offer). When the backend gives no next tier
        // (top tier / unavailable), fall back to a GENERIC "upgrade" prompt pointing at the pricing page — never a
        // client-side tier/package guess, so the plan is never mis-named.
        var hasPlan = !!(nextOpt && nextOpt.name);
        var target = hasPlan ? nextOpt.name : "";
        var priceStr = hasPlan ? (nextOpt.priceDisplay || "") : "";
        var intervalTxt = hasPlan ? (lvNormalizeInterval(nextOpt.interval) || lvTr("lv.interval.month", "/month")) : "";
        var hubFeats = (hasPlan && nextOpt.feats && nextOpt.feats.length) ? nextOpt.feats : [];
        var hykmah = (hasPlan && nextOpt.url) ? nextOpt.url : fallbackUrl;

        // Keep the feature list SHORT — a plan can carry hundreds. Blocked feature first (if given), then a few
        // from the server offer, capped at MAX, then a generic "Plus the full <plan> feature set" closing line.
        var MAX = 4, picked = [], seen = {};
        var addFeat = function (f) {
            f = (f || "").toString().trim();
            var k = f.toLowerCase();
            if (f && !seen[k] && picked.length < MAX) { seen[k] = 1; picked.push(f); }
        };
        if (opts.feature) { addFeat(opts.feature); }
        hubFeats.forEach(addFeat);
        if (hasPlan) { picked.push(lvTr("lv.upgrade.plus.full.set", "Plus the full {0} feature set", [target])); }

        var titleTxt = hasPlan ? lvTr("lv.upgrade.to", "Upgrade to {0}", [target]) : lvTr("lv.upgrade.generic", "Upgrade your plan");
        var curPlan = (opts.currentPlan || "").toString().trim();
        // "<current> to <next>" when we know the current plan (e.g. "Professional to Premium"); otherwise the
        // generic value-prop copy. Falls back to a plain upgrade prompt when there's no resolvable next tier.
        var subTxt = hasPlan
                ? (curPlan ? lvTr("lv.upgrade.transition", "{0} to {1}", [curPlan, target])
                           : lvTr("lv.upgrade.sub", "{0} lifts the cap and adds more across the board.", [target]))
                : lvTr("lv.upgrade.generic.sub", "Move to a plan with higher limits and more features.");
        // Feature-GATE mode (a premium panel opened in preview, e.g. Approval / Languages / User & Access): the
        // caller passes gateFeatureLabel (and optional subtitle) so this ONE popup reads "<Feature> is a <Plan>
        // feature" with the panel's own blurb — no separate second popup. Falls back to the plain upgrade copy when
        // no plan resolves so it's never a bare "is a  feature".
        if (opts.gateFeatureLabel && hasPlan) {
            titleTxt = lvTr("lv.gate.feature.title", "{0} is a {1} feature", [opts.gateFeatureLabel, target]);
        }
        else if (opts.gateFeatureLabel) {
            titleTxt = lvTr("lv.gate.feature.generic", "{0} is a premium feature", [opts.gateFeatureLabel]);
        }
        if (opts.subtitle) {
            subTxt = String(opts.subtitle);
        }
        var ctaTxt = hasPlan ? lvTr("lv.upgrade.to", "Upgrade to {0}", [target]) : lvTr("lv.upgrade.view.plans", "View plans");
        var planNameTxt = hasPlan ? lvTr("lv.upgrade.plan.name", "{0} Plan", [target]) : "";

        // Header brands: WebCommander mark → swap arrows → hub/provider mark, each in a white circle (.lv-up-badge).
        // The SVGs are the SHARED license-popup chrome (LV_WC_LOGO/…) so the purchase-confirmation popup
        // (fee.license-confirmation.js, via window.lvLicenseChrome) renders from the same source — no duplication.
        var circle = function (inner) { return '<div class="lv-up-badge">' + inner + '</div>'; };
        var wcLogo = LV_WC_LOGO;
        var provLogo = LV_PROV_LOGO;
        var arrows = LV_ARROWS;
        var check = LV_CHECK;
        var featHtml = ""; picked.forEach(function (f) { featHtml += '<div class="lv-up-feature">' + check + '<span>' + esc(f) + '</span></div>'; });
        var priceHtml = priceStr ? ('<span class="lv-up-price">' + esc(priceStr) + '<span class="lv-up-price__int">' + esc(intervalTxt) + '</span></span>') : '';

        var $o = jQuery('<div id="lv-up-popup" class="lv-lic-overlay" style="z-index:2147483001;"></div>');
        var $card = jQuery(
            '<div class="lv-up-card"><div class="lv-up-head"><button type="button" class="lv-up-close" aria-label="Close">✕</button>' +
            '<div class="lv-up-brands">' + circle(wcLogo) + arrows + circle(provLogo) + '</div>' +
            '<h2 class="lv-up-title">' + esc(titleTxt) + '</h2>' +
            '<p class="lv-up-sub">' + esc(subTxt) + '</p></div>' +
            '<div class="lv-up-bodywrap"><div class="lv-up-planrow"><span class="lv-up-planname">' + esc(planNameTxt) + '</span>' + priceHtml + '</div>' +
            '<div class="lv-up-features">' + featHtml + '</div>' +
            '<div class="lv-up-actions"><button type="button" class="lv-up-cancel">' + esc(lvTr("lv.common.cancel", "Cancel")) + '</button>' +
            '<button type="button" class="lv-up-manage">' + esc(ctaTxt) + '</button></div></div></div>');
        $o.append($card); jQuery(d.body).append($o);
        var close = function () { $o.remove(); };
        $card.find(".lv-up-cancel, .lv-up-close").on("click", close);
        $o.on("click", function (e) { if (e.target === this) { close(); } });
        $card.find(".lv-up-manage").on("click", function () { if (hykmah) { topWin().open(hykmah, "_blank"); } close(); });
    }
    topWin().lvOpenUpgradePopup = showUpgradePopup;

    // Feature-specific add-on chooser popup (image: WC→hykma header + selectable priced options). Opened from
    // an inline locked state (e.g. the FEE Version History card's "Unlock" CTA). Every string/price/bullet
    // comes from `popup` — the offer served per license key (SecurityInterceptor → LicenseManager.unlockMeta,
    // fed by hykma) — never hardcoded here. Shape:
    //   { title, subtitle, options: [ { id, label, price, interval, ctaLabel, selected, bullets:[...] }, ... ] }
    function showFeatureUnlockPopup(popup) {
        popup = popup || {};
        var options = (popup.options && popup.options.length) ? popup.options.slice() : [];
        // If the offer ALREADY carries a plan option — a tailored "plan" card (badgeUnlockOffer / unlockMeta,
        // "Includes badge removal") or a server-appended next-plan ("__upgrade_plan__", from
        // LicenseManager.meteredUpgradeOffer for the allowance banners) — render immediately. Otherwise append the
        // NEXT PLAN as a radio choice, fetched from the BACKEND (license/upgradeContext) — never from LV_* cache.
        var hasPlanOption = false;
        for (var _pi = 0; _pi < options.length; _pi++) {
            var _oid = options[_pi] && options[_pi].id;
            if (_oid === "plan" || _oid === "__upgrade_plan__") { hasPlanOption = true; break; }
        }
        if (hasPlanOption) { renderFeatureUnlockPopup(popup, options); return; }
        lvFetchUpgradeContext(function (ctx) {
            var np = (ctx && ctx.nextPlan && ctx.nextPlan.name && ctx.nextPlan.url) ? ctx.nextPlan : null;
            if (np) {
                var planBullets = (np.feats && np.feats.length) ? np.feats.slice(0, 3) : [];
                planBullets.push(lvTr("lv.upgrade.plus.full.set", "Plus the full {0} feature set", [np.name]));
                options.push({
                    id: "__upgrade_plan__",
                    label: lvTr("lv.upgrade.to", "Upgrade to {0}", [np.name]),
                    price: (np.priceDisplay || ""),
                    interval: (np.interval || lvTr("lv.interval.month", "/month")),
                    ctaLabel: lvTr("lv.upgrade.to", "Upgrade to {0}", [np.name]),
                    purchaseUrl: np.url,
                    bullets: planBullets
                });
            }
            renderFeatureUnlockPopup(popup, options);
        });
    }

    function renderFeatureUnlockPopup(popup, options) {
        popup = popup || {};
        options = options || [];
        // Nothing to offer at all (no add-on option AND no resolvable next plan) → the plain tier upgrade modal.
        if (!options.length) { showUpgradePopup(); return; }
        ensureStyle();
        var d = topDoc();
        if (d.getElementById("lv-fu-popup")) { return; }

        // Header brands: WebCommander mark → swap arrows → hub/provider mark, each in a white circle (.lv-fu-badge).
        var circle = function (inner) { return '<div class="lv-fu-badge">' + inner + '</div>'; };
        var wcLogo = '<svg width="28" height="21" viewBox="0 0 28 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="0.9" fill-rule="evenodd" clip-rule="evenodd" d="M25.9193 9.44321C24.2639 12.374 23.599 13.8604 22.683 13.8587C21.4942 13.8563 21.0757 12.9234 20.9813 6.56994C20.9388 3.63215 19.949 1.93169 17.9309 2.71946C16.4173 3.30998 15.2139 6.52803 14.4818 8.16068C12.2847 13.0603 11.6863 10.4911 10.3201 7.95521C4.04992 -3.68047 -1.19723 0.917905 0.239042 0.794623C1.84102 0.65737 5.83787 2.89781 8.80198 12.5359C10.7269 17.4857 13.5018 17.7117 16.0482 13.5053C17.0132 11.9113 19.2667 7.36839 19.2351 9.94537C19.2035 12.5224 19.5592 17.0081 22.0339 17.3529C23.9021 17.613 24.9291 15.8633 26.3691 11.5632C26.7133 10.3731 27.2546 9.25096 27.9698 8.24492C28.1692 7.95972 27.369 6.87897 25.9193 9.44321Z" fill="black"/><path d="M16.1123 18.9594C16.1124 19.2371 16.0313 19.5086 15.8792 19.7396C15.7272 19.9706 15.511 20.1506 15.2581 20.257C15.0051 20.3633 14.7268 20.3912 14.4582 20.3371C14.1897 20.283 13.9429 20.1493 13.7493 19.953C13.5556 19.7567 13.4237 19.5065 13.3702 19.2342C13.3167 18.9618 13.344 18.6795 13.4487 18.4229C13.5534 18.1663 13.7308 17.9469 13.9584 17.7925C14.1861 17.6382 14.4537 17.5557 14.7275 17.5557C15.0946 17.5557 15.4468 17.7035 15.7064 17.9668C15.9661 18.23 16.1121 18.5871 16.1123 18.9594Z" fill="black"/><path d="M20.7683 18.9594C20.7684 19.2372 20.6873 19.5087 20.5352 19.7397C20.3831 19.9706 20.167 20.1507 19.914 20.257C19.661 20.3633 19.3827 20.3912 19.1141 20.3371C18.8455 20.2829 18.5988 20.1492 18.4051 19.9529C18.2115 19.7565 18.0796 19.5063 18.0261 19.2339C17.9727 18.9615 18.0001 18.6792 18.1049 18.4226C18.2096 18.166 18.3871 17.9466 18.6147 17.7923C18.8424 17.638 19.1101 17.5557 19.3839 17.5557C19.751 17.5557 20.1031 17.7035 20.3627 17.9668C20.6223 18.23 20.7682 18.5871 20.7683 18.9594Z" fill="black"/></svg>';
        var provLogo = '<svg width="30" height="19" viewBox="0 0 30 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M24.5032 0.000138856C19.7756 0.0278018 18.5381 3.74202 17.758 7.73655C16.5823 7.74024 15.5865 7.74301 15.0931 7.74485C14.7907 7.74209 13.9211 7.73563 12.7907 7.7301C13.5182 4.24641 14.4394 2.3893 17.1771 0.0305683C17.1771 0.0305683 10.7224 0.522049 9.7385 6.76189C9.68686 7.09201 9.63615 7.41013 9.58728 7.71903C7.80855 7.71626 6.02613 7.7218 4.94359 7.74577C2.14686 7.80755 0.547938 10.2354 0.118239 11.8334C-0.312381 13.4314 0.210451 18.4108 5.49685 18.3803C10.2244 18.3527 11.4619 14.6385 12.242 10.6439C13.4177 10.6402 14.4135 10.6375 14.9069 10.6356C15.2093 10.6384 16.0789 10.6449 17.2094 10.6504C16.4818 14.1341 15.5606 15.9912 12.8229 18.3499C12.8229 18.3499 19.2776 17.8584 20.2615 11.6186C20.3131 11.2885 20.3639 10.9704 20.4127 10.6614C22.1915 10.6642 23.9739 10.6587 25.0564 10.6347C27.8531 10.5729 29.4521 8.14504 29.8818 6.54704C30.3124 4.94905 29.7896 -0.0302904 24.5032 0.000138856ZM5.25065 15.4296C3.49866 15.4601 2.23815 13.3392 3.34467 11.7717C3.89793 10.9722 4.6356 10.6651 5.12708 10.6651C5.32994 10.6651 7.08378 10.6596 9.07644 10.6541C8.39961 14.0271 7.59923 15.4066 5.25065 15.4296ZM26.6544 6.6079C26.1012 7.40736 25.3635 7.71442 24.872 7.71442C24.6691 7.71442 22.9153 7.71995 20.9226 7.72549C21.5995 4.35245 22.3998 2.97299 24.7484 2.94994C26.5004 2.91951 27.7609 5.04033 26.6544 6.6079Z" fill="url(#lvFuProvGrad)"/><defs><linearGradient id="lvFuProvGrad" x1="4.54315" y1="24.4066" x2="14.8132" y2="-1.49368" gradientUnits="userSpaceOnUse"><stop stop-color="#FF547C"/><stop offset="0.509586" stop-color="#0079F2"/><stop offset="1" stop-color="#8C67FF"/></linearGradient></defs></svg>';
        var arrows = '<span class="lv-fu-arrows"><svg width="24" height="19" viewBox="0 0 24 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.84934 13.2964H0.666676C0.477342 13.2964 0.318676 13.2328 0.190676 13.1057C0.0626757 12.9786 -0.000879693 12.8199 9.19542e-06 12.6297C0.000898084 12.4395 0.0644535 12.2808 0.190676 12.1537C0.316898 12.0266 0.475565 11.963 0.666676 11.963H9.84934L6.19601 8.30971C6.07067 8.18526 6.00401 8.03326 5.99601 7.85371C5.98712 7.67593 6.05379 7.51327 6.19601 7.36571C6.34267 7.21904 6.5009 7.14571 6.67067 7.14571C6.84045 7.14571 6.99912 7.21904 7.14667 7.36571L11.656 11.8764C11.7725 11.9919 11.8542 12.1106 11.9013 12.2324C11.9485 12.3542 11.972 12.4866 11.972 12.6297C11.972 12.7728 11.9485 12.9053 11.9013 13.027C11.8542 13.1488 11.7725 13.2675 11.656 13.383L7.13867 17.9017C7.0089 18.0315 6.85601 18.0995 6.68001 18.1057C6.50312 18.1119 6.34134 18.0413 6.19467 17.8937C6.05245 17.747 5.98045 17.5897 5.97867 17.4217C5.9769 17.2537 6.0489 17.0968 6.19467 16.951L9.84934 13.2964ZM14.1507 6.14304L17.804 9.79638C17.9293 9.92082 17.996 10.0724 18.004 10.251C18.012 10.4297 17.9453 10.5928 17.804 10.7404C17.6582 10.887 17.5 10.9604 17.3293 10.9604C17.1587 10.9604 17.0005 10.887 16.8547 10.7404L12.344 6.22971C12.2276 6.11415 12.1458 5.99549 12.0987 5.87371C12.0516 5.75193 12.028 5.61949 12.028 5.47638C12.028 5.33326 12.0516 5.20082 12.0987 5.07904C12.1458 4.95727 12.2276 4.83815 12.344 4.72171L16.8613 0.204377C16.9911 0.0745997 17.1445 0.00659987 17.3213 0.00037765C17.4982 -0.00584457 17.6596 0.064822 17.8053 0.212378C17.9476 0.359044 18.0196 0.515933 18.0213 0.683044C18.024 0.851044 17.952 1.00838 17.8053 1.15504L14.152 4.80838H23.3333C23.5236 4.80838 23.6822 4.87238 23.8093 5.00038C23.9365 5.12838 24 5.28704 24 5.47638C24 5.66571 23.9365 5.82438 23.8093 5.95238C23.6822 6.08038 23.5236 6.14393 23.3333 6.14304H14.1507Z" fill="#c3d0ff"/></svg></span>';
        var check = '<svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.8248 15.8346H15.8327M15.8248 15.8346C15.3058 16.3492 14.3654 16.2211 13.7059 16.2211C12.8964 16.2211 12.5066 16.3794 11.9288 16.9571C11.4369 17.4491 10.7774 18.3346 9.99935 18.3346C9.22127 18.3346 8.56177 17.4491 8.06982 16.9571C7.49208 16.3794 7.10226 16.2211 6.29273 16.2211C5.63325 16.2211 4.69283 16.3492 4.17392 15.8346C3.65086 15.316 3.77958 14.3716 3.77958 13.7079C3.77958 12.8691 3.59615 12.4835 2.99883 11.8861C2.1103 10.9976 1.66603 10.5533 1.66602 10.0013C1.66602 9.44922 2.11028 9.00497 2.99881 8.11644C3.53202 7.58323 3.77958 7.05487 3.77958 6.29469C3.77958 5.63518 3.65142 4.69475 4.16602 4.17584C4.68471 3.65279 5.62902 3.78152 6.29275 3.78152C7.05291 3.78152 7.58128 3.53397 8.11447 3.00078C9.00302 2.11224 9.44727 1.66797 9.99935 1.66797C10.5514 1.66797 10.9957 2.11224 11.8842 3.00078C12.4173 3.53386 12.9456 3.78152 13.7059 3.78152C14.3654 3.78152 15.3059 3.65336 15.8248 4.16797C16.3478 4.68666 16.2191 5.63096 16.2191 6.29469C16.2191 7.13345 16.4026 7.51911 16.9998 8.11644C17.8884 9.00497 18.3327 9.44922 18.3327 10.0013C18.3327 10.5533 17.8884 10.9976 16.9998 11.8861C16.4025 12.4835 16.2191 12.8691 16.2191 13.7079C16.2191 14.3716 16.3478 15.316 15.8248 15.8346Z" stroke="#10C05F" stroke-width="1.25"/><path d="M7.5 10.7454C7.5 10.7454 8.5 11.2886 9 12.0846C9 12.0846 10.5 8.95964 12.5 7.91797" stroke="#10C05F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        var warnSvg = '<svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#d97706" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path><line x1="12" y1="9" x2="12" y2="13"></line><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>';
        // Header art: the amber warning triangle for a hit-limit block (popup.warn), else the WC→provider brand circles.
        var headerArt = popup.warn ? ('<div class="lv-fu-warn">' + warnSvg + '</div>') : ('<div class="lv-fu-brands">' + circle(wcLogo) + arrows + circle(provLogo) + '</div>');

        var selectedIdx = 0;
        options.forEach(function (o, i) { if (o && o.selected) { selectedIdx = i; } });

        // On the hit-limit ("Oops") chooser keep each option compact — at most 2 bullet lines; unlimited otherwise.
        var maxBullets = popup.warn ? 2 : 0;
        var optsHtml = "";
        options.forEach(function (o, i) {
            var bullets = "";
            var blist = o.bullets || [];
            if (maxBullets && blist.length > maxBullets) { blist = blist.slice(0, maxBullets); }
            blist.forEach(function (b) {
                bullets += '<div class="lv-fu-opt__feat">' + check + '<span>' + esc(b) + '</span></div>';
            });
            // Show the interval for RECURRING add-on/plan options (monthly/yearly); one-time add-ons normalise to
            // "" so no cadence is shown. Same canonical text as the other popups (no /mo vs monthly mix).
            var optInterval = lvNormalizeInterval(o.interval);
            var priceHtml = esc(o.price || "") + (optInterval ? '<span>' + esc(optInterval) + '</span>' : '');
            optsHtml += '<div class="lv-fu-opt' + (i === selectedIdx ? ' selected' : '') + '" data-idx="' + i + '">' +
                '<div class="lv-fu-opt__top"><span class="lv-fu-opt__radio"></span>' +
                '<span class="lv-fu-opt__label">' + esc(o.label || "") + '</span>' +
                '<span class="lv-fu-opt__price">' + priceHtml + '</span></div>' + bullets +
            '</div>';
        });

        var $o = jQuery('<div id="lv-fu-popup" class="lv-lic-overlay" style="z-index:2147483002;"></div>');
        var $card = jQuery(
            '<div class="lv-fu-card"><div class="lv-fu-head"><button type="button" class="lv-fu-close" aria-label="Close">✕</button>' +
            headerArt +
            '<h2 class="lv-fu-title">' + esc(popup.title || lvTr("lv.unlock.title", "Unlock feature")) + '</h2>' +
            (popup.subtitle ? '<p class="lv-fu-sub">' + esc(popup.subtitle) + '</p>' : '') + '</div>' +
            '<div class="lv-fu-body">' + optsHtml + '</div>' +
            '<div class="lv-fu-actions"><button type="button" class="lv-fu-cancel">' + esc(lvTr("lv.common.cancel", "Cancel")) + '</button>' +
            '<button type="button" class="lv-fu-cta"></button></div></div>');

        var syncCta = function () {
            var o = options[selectedIdx] || {};
            $card.find(".lv-fu-cta").text(o.ctaLabel || lvTr("lv.unlock.add", "Add {0}", [o.price || ""]));
        };
        syncCta();

        $card.find(".lv-fu-opt").on("click", function () {
            selectedIdx = parseInt(jQuery(this).attr("data-idx"), 10) || 0;
            $card.find(".lv-fu-opt").removeClass("selected");
            jQuery(this).addClass("selected");
            syncCta();
        });

        $o.append($card); jQuery(d.body).append($o);
        var close = function () { $o.remove(); };
        $card.find(".lv-fu-cancel, .lv-fu-close").on("click", close);
        $o.on("click", function (e) { if (e.target === this) { close(); } });
        // Go straight to hykma's checkout for the selected option — the purchase payload is carried by the
        // purchaseUrl hykma served in the offer. No intermediate popup. Falls back to the pricing page only
        // if an option arrived without a checkout link.
        $card.find(".lv-fu-cta").on("click", function () {
            var o = options[selectedIdx] || {};
            var url = o.purchaseUrl || LV_PRICING_FALLBACK;
            close();
            try { topWin().open(url, "_blank"); } catch (e) { topWin().location.href = url; }
        });
    }
    topWin().lvOpenFeatureUnlockPopup = showFeatureUnlockPopup;

    // Shared "Version history is locked" in-panel card. Renders the lock badge + price/plan copy + CTA into
    // `container` from a 403 license block body (loadPageVersionHistory), returning true when it rendered (the
    // body was a license_feature_disabled block) and false otherwise so the caller can fall back. Used by BOTH
    // the editor right panel (fee.editor.right-panel.js) and the full-screen viewer's history drawer
    // (fee.website-tabs.js) so the locked-state markup + wiring live in ONE place. `onClose` is invoked by the
    // card's × (each caller closes its own container: hide the right panel / close the drawer).
    function renderVersionHistoryLockedCard(container, xhr, onClose) {
        var data = null;
        try {
            var body = xhr && xhr.responseText;
            if (body && typeof body === "string" && body.indexOf("license_feature_disabled") !== -1) { data = JSON.parse(body); }
        } catch (e) { data = null; }
        if (!data || data.errorCode !== "license_feature_disabled") { return false; }
        var lic = data.license || {}, unlock = lic.unlock || {};
        var esc = function (t) { return jQuery("<div></div>").text(t == null ? "" : t).html(); };
        var tr = (topWin().lvTr || lvTr);   // shared resolver (R4: keys now in the client bundle)
        var price = unlock.price ? ("<b>" + esc(unlock.price) + "</b>") : "";
        var plan = unlock.freeOnPlan ? ("<b>" + esc(unlock.freeOnPlan) + "</b>") : "";
        var title = tr("version.history.locked.title", "Version history is locked");
        var desc = price
            ? tr("version.history.locked.desc.priced", "Unlock it for {0} to see and restore any past version", [price])
            : tr("version.history.locked.desc.plain", "Unlock version history to see and restore any past version");
        if (plan) { desc += " " + tr("version.history.locked.free.on", "or get it free on {0}", [plan]); }
        desc += ".";
        var cta = tr("version.history.locked.cta", "Unlock version history");
        // Lock glyph — blue, driven by the icon badge's `color` (currentColor). Redesign spec: rounded-square
        // 48×48 badge, #008DF2 @10% fill, #008DF2 stroke.
        var lock = '<svg width="34" height="34" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">' +
            '<path d="M7.58333 11.9168V7.58312C7.58333 6.14641 8.15402 4.76855 9.16984 3.75265C10.1857 2.73674 11.5634 2.16602 13 2.16602C14.4366 2.16602 15.8143 2.73674 16.8302 3.75265C17.846 4.76855 18.4167 6.14641 18.4167 7.58312V11.9168M5.41667 11.9168H20.5833C21.78 11.9168 22.75 12.8869 22.75 14.0836V21.6676C22.75 22.8643 21.78 23.8344 20.5833 23.8344H5.41667C4.22005 23.8344 3.25 22.8643 3.25 21.6676V14.0836C3.25 12.8869 4.22005 11.9168 5.41667 11.9168Z" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>' +
            '</svg>';
        // Chrome rendered sharp behind the card so the locked state reads as the real Version History panel
        // (matches the mockup). Icons mirror versionHistory.gsp so the backdrop is byte-identical to the live
        // panel. The × closes the panel (onClose); Compare is inert here (it is UI-only even when unlocked).
        var closeIcon = '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.33339 11.5449L0.4552 10.6667L5.12187 6.00005L0.4552 1.33339L1.33339 0.4552L6.00005 5.12187L10.6667 0.4552L11.5449 1.33339L6.87824 6.00005L11.5449 10.6667L10.6667 11.5449L6.00005 6.87824L1.33339 11.5449Z" fill="currentColor"/></svg>';
        var compareIcon = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 3.5H13M13 3.5L10.5 1M13 3.5L10.5 6" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/><path d="M11 12.5H3M3 12.5L5.5 10M3 12.5L5.5 15" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        var searchIcon = '<svg width="14" height="14" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.2667 12.9833L6.88333 8.59994C6.55 8.88883 6.16111 9.11383 5.71667 9.27494C5.27222 9.43605 4.8 9.51661 4.3 9.51661C3.1 9.51661 2.08333 9.09994 1.25 8.26661C0.416667 7.43328 0 6.42772 0 5.24994C0 4.07217 0.416667 3.06661 1.25 2.23328C2.08333 1.39994 3.09444 0.983276 4.28333 0.983276C5.46111 0.983276 6.46389 1.39994 7.29167 2.23328C8.11944 3.06661 8.53333 4.07217 8.53333 5.24994C8.53333 5.72772 8.45556 6.18883 8.3 6.63328C8.14444 7.07772 7.91111 7.49439 7.6 7.88328L12 12.2499L11.2667 12.9833ZM4.28333 8.51661C5.18333 8.51661 5.95 8.19717 6.58333 7.55828C7.21667 6.91939 7.53333 6.14994 7.53333 5.24994C7.53333 4.34994 7.21667 3.5805 6.58333 2.94161C5.95 2.30272 5.18333 1.98328 4.28333 1.98328C3.37222 1.98328 2.59722 2.30272 1.95833 2.94161C1.31944 3.5805 1 4.34994 1 5.24994C1 6.14994 1.31944 6.91939 1.95833 7.55828C2.59722 8.19717 3.37222 8.51661 4.28333 8.51661Z" fill="#828282"/></svg>';
        // One decorative skeleton row. No real version data is returned while the feature is locked, so these
        // are shape-only placeholders (blurred by CSS) — never fabricated names/counts. First row is
        // "selected" (blue outline) to mirror the mockup.
        var skelRow = function (selected, headW, metaW) {
            return '<div class="version-item' + (selected ? ' selected' : '') + '">' +
                '<span class="vh-radio"><span class="vh-radio-mark"></span></span>' +
                '<div class="version-info">' +
                    '<div class="vh-item-head"><span class="fee-rsp-vh-skel-line" style="width:' + headW + '"></span></div>' +
                    '<div class="version-author"><span class="fee-rsp-vh-skel-line" style="width:' + metaW + '"></span></div>' +
                '</div>' +
            '</div>';
        };
        var skelGroup = function (labelW, rows) {
            return '<div class="vh-date-group">' +
                '<div class="vh-group-header"><span class="fee-rsp-vh-skel-line" style="width:' + labelW + '"></span>' +
                '<span class="fee-rsp-vh-skel-line" style="width:66px;height:18px;border-radius:20px"></span></div>' +
                rows + '</div>';
        };
        var skelList = skelGroup('58px', skelRow(true, '58%', '42%') + skelRow(false, '46%', '36%') + skelRow(false, '52%', '30%')) +
                       skelGroup('82px', skelRow(false, '50%', '34%') + skelRow(false, '44%', '40%'));
        var $c = jQuery(container);
        $c.html(
            '<div class="fee-rsp-vh-locked-shell">' +
                '<div class="version-history-slide-in fee-rsp-vh-backdrop">' +
                    '<div class="vh-header">' +
                        '<div class="vh-header-row">' +
                            '<h2 class="vh-title">' + esc(tr("version.history", "Version History")) + '</h2>' +
                            '<div class="vh-header-actions">' +
                                '<button type="button" class="vh-compare-btn" tabindex="-1">' + compareIcon + '<span>' + esc(tr("compare", "Compare")) + '</span></button>' +
                                '<button type="button" class="close-btn vh-close-btn fee-rsp-vh-locked__close" aria-label="Close">' + closeIcon + '</button>' +
                            '</div>' +
                        '</div>' +
                        '<div class="vh-subtitle"><span class="fee-rsp-vh-skel-line" style="width:120px"></span></div>' +
                    '</div>' +
                    '<div class="vh-search"><div class="search-box"><span class="vh-search-icon">' + searchIcon + '</span>' +
                        '<input type="text" tabindex="-1" readonly placeholder="' + esc(tr("search", "Search")) + '"></div></div>' +
                    '<div class="version-list fee-rsp-vh-skel-list" aria-hidden="true">' + skelList + '</div>' +
                '</div>' +
                '<div class="fee-rsp-vh-locked" role="dialog" aria-label="' + esc(title) + '">' +
                    '<div class="fee-rsp-vh-locked__icon">' + lock + '</div>' +
                    '<div class="fee-rsp-vh-locked__title">' + esc(title) + '</div>' +
                    '<div class="fee-rsp-vh-locked__desc">' + desc + '</div>' +
                    '<button type="button" class="fee-rsp-vh-locked__cta">' + esc(cta) + '</button>' +
                '</div>' +
            '</div>'
        );
        $c.find(".fee-rsp-vh-locked__close").on("click", function () { if (typeof onClose === "function") { onClose(); } });
        $c.find(".fee-rsp-vh-locked__cta").on("click", function () {
            var win = (window.top || window);
            if (unlock.popup && typeof win.lvOpenFeatureUnlockPopup === "function") { win.lvOpenFeatureUnlockPopup(unlock.popup); }
            else if (typeof win.lvOpenUpgradePopup === "function") { win.lvOpenUpgradePopup(); }
        });
        return true;
    }
    topWin().wcRenderVersionHistoryLockedCard = renderVersionHistoryLockedCard;

    // Import limit pre-flight popup — "Some of your data exceeds your plan's limits" (the mockup). Shown BEFORE
    // a bulk/store import writes anything, when ImportLimitPreflightService reports any entity over its cap.
    // `data` is that service's result: { rows:[{label,source,limit,status}], anyOver, planName }. `opts`:
    //   onImportUpToLimit()  — proceed, capping each entity to its remaining headroom (skip the overflow)
    //   onUpgrade()          — open the upgrade flow, then import everything
    // Returns without showing (and does nothing) when nothing is over the cap.
    function showImportLimitPopup(data, opts) {
        data = data || {}; opts = opts || {};
        var rows = data.rows || [];
        if (!data.anyOver || !rows.length) { return false; }
        ensureStyle();
        var d = topDoc();
        if (d.getElementById("wc-il-popup")) { return true; }
        var fmt = function (n) { n = Number(n); return isNaN(n) ? "—" : n.toLocaleString(); };
        var plan = (data.planName || "").toString();

        var body = "";
        // How many rows "Import up to my limit" would actually write: within-limit entities import in full;
        // over-limit entities import only their remaining headroom (limit − current). If the total is 0 — every
        // over-limit entity is already AT/OVER its cap with no room — that button does nothing, so we disable it
        // and only "Upgrade and import everything" remains.
        var importable = 0;
        rows.forEach(function (r) {
            var over = r.status === "over";
            var limitTxt = (r.limit == null) ? lvTr("lv.import.unlimited", "Unlimited") : fmt(r.limit);
            importable += over ? (r.remaining == null ? (Number(r.source) || 0) : (Number(r.remaining) || 0))
                               : (Number(r.source) || 0);
            body += '<tr>' +
                '<td class="wc-il-ent">' + esc(r.label) + '</td>' +
                '<td class="wc-il-num">' + fmt(r.source) + '</td>' +
                '<td class="wc-il-num">' + esc(limitTxt) + '</td>' +
                '<td class="wc-il-status--' + (over ? 'over' : 'within') + '">' + (over ? esc(lvTr("lv.import.over", "Over limit")) : esc(lvTr("lv.import.within", "Within limit"))) + '</td>' +
            '</tr>';
        });
        var upToLimitDisabled = importable <= 0;

        var $o = jQuery('<div id="wc-il-popup" class="lv-lic-overlay" style="z-index:2147483050;"></div>');
        var $card = jQuery(
            '<div class="wc-il-card"><div class="wc-il-head"><button type="button" class="wc-il-close" aria-label="Close">✕</button>' +
            '<h2 class="wc-il-title">' + esc(lvTr("lv.import.title", "Some of your data exceeds your plan’s limits")) + '</h2>' +
            '<p class="wc-il-sub">' + (plan ? (esc(lvTr("lv.import.sub.plan", "You’re on the {0} plan.", [plan])) + " ") : "") + esc(lvTr("lv.import.sub.rest", "Here’s what we found before importing anything.")) + '</p></div>' +
            '<div class="wc-il-body"><table class="wc-il-table"><thead><tr>' +
            '<th>' + esc(lvTr("lv.import.col.entity", "Entity")) + '</th><th class="wc-il-num">' + esc(lvTr("lv.import.col.source", "Source")) + '</th><th class="wc-il-num">' + esc(lvTr("lv.import.col.limit", "Your limit")) + '</th><th>' + esc(lvTr("lv.import.col.status", "Status")) + '</th>' +
            '</tr></thead><tbody>' + body + '</tbody></table></div>' +
            '<div class="wc-il-actions">' +
            '<button type="button" class="wc-il-secondary"' + (upToLimitDisabled ? ' disabled title="' + esc(lvTr("lv.import.up.to.limit.disabled", "You’re already at your plan limit — nothing left to import. Upgrade to add more.")) + '"' : '') + '>' + esc(lvTr("lv.import.up.to.limit", "Import up to my limit")) + '</button>' +
            '<button type="button" class="wc-il-primary">' + esc(lvTr("lv.import.upgrade.all", "Upgrade and import everything")) + '</button>' +
            '</div></div>');
        $o.append($card); jQuery(d.body).append($o);
        var close = function () { $o.remove(); };
        $o.on("click", function (e) { if (e.target === this) { close(); } });
        $card.find(".wc-il-close").on("click", close);
        if (!upToLimitDisabled) {
            $card.find(".wc-il-secondary").on("click", function () { close(); if (typeof opts.onImportUpToLimit === "function") { opts.onImportUpToLimit(); } });
        }
        $card.find(".wc-il-primary").on("click", function () { close(); if (typeof opts.onUpgrade === "function") { opts.onUpgrade(); } else { showUpgradePopup(); } });
        return true;
    }
    topWin().wcShowImportLimitPopup = showImportLimitPopup;

    // A hard license block means the underlying request FAILED (403/429). Many callers (e.g. the FEE settings
    // panels) attach only a success handler and show popup.loader() up-front, so on the error path their mask
    // (.div-mask, added by bm.mask via .loader()) is never cleared and the panel spins forever behind the
    // popup. Recover it: drop the WC mask overlay + spinners, unblockUI, and re-enable stuck submit buttons —
    // in the top doc AND this doc (the block may have come from inside the FEE editor iframe).
    function clearBlockedLoaders(data, triggerEl) {
        try {
            // Recovery scope: when the caller knows WHICH element triggered the blocked request (e.g. a form
            // submit → evt.target), confine the destructive sweep to that element's host popup/form subtree, so
            // an unrelated in-flight feature elsewhere on the page keeps its loader/disabled buttons. Only when
            // the trigger is unknown do we fall back to the page-wide sweep (top doc + this doc) — preserving the
            // original recovery for the many callers that can't identify a trigger.
            var scopes = [];
            var $trigger = null;
            try { if (triggerEl) { $trigger = jQuery(triggerEl); if (!$trigger.length) { $trigger = null; } } } catch (e) { $trigger = null; }
            if ($trigger) {
                // Nearest host that would carry the loader mask (popup that hosts the blocked action, else the
                // form, else the element itself). .find() searches its descendants, where bm.mask appends .div-mask.
                var $host = $trigger.closest(".fee-non-editor-popup, .popup");
                if (!$host.length) { $host = $trigger.closest("form"); }
                if (!$host.length) { $host = $trigger; }
                scopes.push($host);
            }
            else {
                var docs = [];
                try { docs.push(topDoc()); } catch (e) {}
                if (typeof document !== "undefined" && docs.indexOf(document) === -1) { docs.push(document); }
                docs.forEach(function (dd) { scopes.push(jQuery(dd)); });
            }
            // A panel still LOADING when a block hit is now blank behind the popup. Render the SAME locked
            // empty-state the tab/customer pages show, reusing tab.js's builder (exposed as wcBuildLicenseBlockPanel).
            // Only for a feature/limit block (data present) — not abuse ceilings, whose copy wouldn't fit.
            var panelHtml = null;
            try {
                var build = (topWin() || window).wcBuildLicenseBlockPanel;
                if (data && typeof build === "function") { panelHtml = build(data); }
            } catch (e) {}
            var __POP = null;
            try { __POP = (topWin() || window).POPUP; } catch (e) {}
            scopes.forEach(function ($scope) {
                try {
                    // Both mask kinds: bm.mask/.loader() on a PANEL emits ".div-mask"; popup.loader() on the
                    // bespoke full-screen shell popups (Settings/Analytics/Customers/Orders/Marketing) emits a
                    // ".wc-loader-overlay" instead. Without the second selector those shell popups were never
                    // processed here, so a gated shell was left blank (its mask/close/fill logic never ran).
                    $scope.find(".div-mask, .wc-loader-overlay").each(function () {
                        var $mask = jQuery(this);
                        var $host = $mask.parent();
                        $mask.remove();
                        // A full-screen FEE route popup opened BLANK just to host the blocked content — every
                        // settings sub-tab (price-display / search / payment-gateway / checkout / currency / …),
                        // the settings landing, marketing/newsletter, the approval tab, etc. These load via
                        // popup.loader() on the POPUP ELEMENT itself, so the loader mask's parent IS the
                        // .fee-non-editor-popup. Close it so the user is left cleanly on the prior screen with just
                        // the upgrade popup. (Distinguished from a POPULATED plugin editor whose SUB-tab load is
                        // blocked — there the mask sits on an INNER element, so $host is not the popup, and the
                        // branch below keeps it open. Route-popup loads are @License-gated → only ever blocked at
                        // load, so a masked full-screen popup is a safe close signal.)
                        var $settingsPopup = $host.hasClass("fee-non-editor-popup") ? $host : jQuery();
                        if ($settingsPopup.length) {
                            // A POPULATED manager whose multi-tab shell is already rendered must NOT be closed.
                            // The website manager's Blog / Owl-Carousel sub-tabs mask the WHOLE popup via
                            // popup.loader() before fetching their gated content, so the mask's host IS the
                            // .fee-non-editor-popup even though it is not blank — closing it would yank the user out
                            // of the whole manager. A truly blank route popup (opened purely to host the now-blocked
                            // load) has no rendered tab headers yet, so it still closes below as intended.
                            if ($settingsPopup.find(".bmui-tab-header").length) {
                                try { if (jQuery.unblockUI) { jQuery.unblockUI(); } } catch (e) {}
                                try { bm.enableBackgroundScroll(); } catch (e) {}
                                return;   // stay in the manager; the tab's locked panel + upgrade popup are the UI
                            }
                            // A gated FULL-SCREEN SHELL popup (Settings/Analytics/Customers/Orders/Marketing): NEVER
                            // close it on a feature block. bm.ajax SWALLOWS the license 403 for dataType:'html' loads
                            // (the shell's own success/error never runs), so this global path is the ONLY thing that
                            // renders the panel — and closing the shell here removed the whole section, leaving it
                            // blank. Keep it and let the backstop (end of this loop) fill the shell element. Recognise
                            // the shell whether $settingsPopup IS it, CONTAINS it, or is INSIDE it (its .fee-*-popup
                            // class can sit on a wrapper). Also keep a popup that already shows the panel. Only for a
                            // feature block (panelHtml present); a LIMIT block (panelHtml == "") still closes below.
                            // NOTE: no panelHtml condition — clearBlockedLoaders fires in EVERY frame (ajaxComplete);
                            // in the editor iframe wcBuildLicenseBlockPanel is undefined so panelHtml is empty THERE,
                            // and gating on it let the iframe's pass close the shell before the top frame could fill
                            // it (docShellPopups→0). A full-screen shell is NEVER closed here; the top frame's backstop
                            // fills it once (a duplicate no-op fill in another frame is harmless).
                            var _SHELL_SEL = ".fee-editor-setting-popup, .fee-analytics-v2-popup, .fee-analytics-popup, .fee-customer-details-popup, .fee-order-list-popup, .fee-marketing-popup";
                            if ($settingsPopup.find(".wc-lic-panel").length ||
                                $settingsPopup.is(_SHELL_SEL) || $settingsPopup.find(_SHELL_SEL).length || $settingsPopup.closest(_SHELL_SEL).length) {
                                try { if (jQuery.unblockUI) { jQuery.unblockUI(); } } catch (e) {}
                                try { bm.enableBackgroundScroll(); } catch (e) {}
                                return;   // keep the shell; the backstop below fills it with the panel
                            }
                            try {
                                if (__POP && $settingsPopup.obj && $settingsPopup.obj(__POP)) {
                                    $settingsPopup.obj(__POP).close();
                                } else {
                                    $settingsPopup.remove();
                                }
                            } catch (e) {
                                try { $settingsPopup.remove(); } catch (e2) {}
                            }
                            try { if (jQuery.unblockUI) { jQuery.unblockUI(); } } catch (e) {}
                            try { bm.enableBackgroundScroll(); } catch (e) {}
                            return;   // popup-only: no locked panel behind the upgrade popup
                        }
                        // A plugin "Manage" / editor popup (.fee-non-editor-popup — preorder / gift-card / …). The
                        // user must STAY where they are with ONLY the upgrade popup on top: do NOT close it (the
                        // popup often already shows its tab shell, with just a SUB-tab load — e.g. preorder
                        // loadPreOrderList — blocked; closing would yank them out of the view), and do NOT fill it
                        // with a locked panel. The loader mask was already removed above, so nothing spins.
                        if ($host.closest(".fee-non-editor-popup").length) {
                            try { if (jQuery.unblockUI) { jQuery.unblockUI(); } } catch (e) {}
                            return;   // stay in place; the upgrade popup is the sole added UI
                        }
                        // Fill ONLY a host that held nothing but the mask (a fresh panel load); never wipe a panel
                        // that already has content (e.g. a blocked save on a populated form).
                        if (panelHtml && $host.length && $host.children().length === 0 && jQuery.trim($host.text()) === "") {
                            try { $host.html(panelHtml); } catch (e) {}
                        }
                    });
                    $scope.find(".loader, .spinner").hide();
                    $scope.find("[type=submit][disabled], .submit-row button[disabled]").removeAttr("disabled");
                    // Backstop: directly fill any gated FULL-SCREEN SHELL popup (Settings/Analytics/Customers/
                    // Orders/Marketing) that a block left blank — no dependence on the loader-mask→popup resolution
                    // above (which can miss when the mask isn't a direct child). Only when the popup has no locked
                    // panel and no rendered tab shell yet, so a populated manager is never overwritten.
                    if (panelHtml) {
                        $scope.find(".fee-editor-setting-popup, .fee-analytics-v2-popup, .fee-analytics-popup, .fee-customer-details-popup, .fee-order-list-popup, .fee-marketing-popup").each(function () {
                            var $sp = jQuery(this);
                            // Skip a popup already showing the panel, or a real (licensed) manager with a tab shell.
                            if ($sp.find(".wc-lic-panel, .bmui-tab-header").length) { return; }
                            try {
                                $sp.html(panelHtml);
                                // Clear the stuck load state so the filled panel actually shows: the ".loading"
                                // class overlays/hides content, and a leftover loader mask would sit on top.
                                $sp.removeClass("loading");
                                $sp.find(".wc-loader-overlay, .div-mask, .loader, .spinner").remove();
                            } catch (e) {}
                        });
                    }
                } catch (e) {}
            });
            try { if (jQuery.unblockUI) { jQuery.unblockUI(); } } catch (e) {}
        } catch (e) {}
    }

    function showBlockPopup(data, triggerEl) {
        try { window.__lvBlockActive = (new Date()).getTime(); } catch (e) {}
        clearBlockedLoaders(data, triggerEl);
        // A license block supersedes any dialog open for the blocked action:
        //  - a confirm dialog (e.g. a status toggle's "Are you sure...?"), and
        //  - an asset-library popup still stuck in its .loading state, whose content load WAS the blocked 403
        //    (otherwise it shows a raw "Error" behind the upgrade popup — the asset library loads via bm.ajax
        //    across many entry points, so this global close is more reliable than patching each error handler).
        // Close them so ONLY the upgrade popup shows — the action can't proceed under the block anyway.
        try {
            jQuery(".confirm-popup, .fee-editor-asset-library-popup.loading").each(function () {
                try {
                    var $p = jQuery(this);
                    var inst = (typeof $p.obj === "function") ? $p.obj() : null;
                    if (inst && typeof inst.close === "function") { inst.close(); } else { $p.remove(); }
                } catch (eOne) {}
            });
        } catch (eAll) {}
        ensureStyle();
        var d = topDoc();
        if (d.getElementById("lv-block-popup")) { return; }
        var lic = data.license || {};
        // Defensive label prettify: the server sends a HUMAN label in `feature` (X-License-Feature), but if a raw
        // license key/dotted code ever leaks through (e.g. "settings.panel" / "allow_settings_panel_feature") it
        // reads badly in the popup title. A value with no "." or "_" is treated as already-human and left as-is;
        // otherwise strip allow_/_feature/_limit, split on ._ and Title-Case → "Settings Panel".
        function prettyFeature(f) {
            f = (f == null ? "" : String(f)).trim();
            if (!f || (f.indexOf(".") === -1 && f.indexOf("_") === -1)) { return f; }
            return f.replace(/^allow[._]/, "").replace(/[._](feature|limit)$/, "")
                    .split(/[._]/).filter(Boolean)
                    .map(function (w) { return w.charAt(0).toUpperCase() + w.slice(1); })
                    .join(" ");
        }
        var feature = prettyFeature(lic.feature), featLower = feature.toLowerCase();
        var isLimit = data.errorCode === "license_limit_exceeded";
        var plan = (lic.planName || "").toString();
        var limitN = (lic.limit != null && !isNaN(lic.limit)) ? Number(lic.limit) : null;
        var countN = (lic.count != null && !isNaN(lic.count)) ? Number(lic.count) : limitN;   // at a hard block, count == limit
        var up = lic.upgrade || null;
        var topup = lic.topup || null;   // compact "buy a top-up now" offer (metered keys); null when none applies
        var WARN_SVG = '<svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#d97706" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path><line x1="12" y1="9" x2="12" y2="13"></line><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>';

        // Generic top-up buy button: rendered on ANY limit block whose key has a top-up SKU (email / AI credits /
        // storage), so the buyer can top up instantly instead of only upgrading the plan. closeFn dismisses the block
        // popup after opening the hub checkout in a new tab. Returns null when no top-up applies (button omitted).
        function buildTopupBtn(closeFn) {
            if (!topup || !topup.url) { return null; }
            var iv = lvNormalizeInterval(topup.interval);
            var label = topup.label || lvTr("lv.block.topup.default", "a top-up");
            // Prefer the server-composed CTA (e.g. "Add a seat" for operator seats); else "Buy {label}".
            var ctaText = topup.cta || lvTr("lv.block.topup.cta", "Buy {0}", [label]);
            var priceHtml = topup.price ? (' <span class="lv-lic-topup__price">' + esc(topup.price) + esc(iv) + '</span>') : "";
            var $wrap = jQuery('<div class="lv-lic-topup-wrap"></div>');
            var $btn = jQuery('<button type="button" class="lv-lic-topup">' + esc(ctaText) + priceHtml + '</button>');
            $btn.on("click", function () {
                try { (topWin() || window).open(topup.url, "_blank"); } catch (e) { window.open(topup.url, "_blank"); }
                if (typeof closeFn === "function") { closeFn(); }
            });
            return $wrap.append($btn);
        }

        // Top-up balance line mirroring the allowance banner: "Plus N top-up X still available (c of g used)" when any
        // top-up remains, else "Top-up also used up (c of g)". Returns "" (no <br>) when the key has no top-up balance,
        // so the base "You are using all N emails" line stays truthful about the top-up that was ALSO consumed.
        function topupUsageLine(noun) {
            var tu = lic.topupUsage;
            if (!tu || !tu.granted) { return ""; }
            if (tu.remaining > 0) {
                return " " + lvTr("lv.block.topup.remaining", "Plus {0} top-up {1} still available ({2} of {3} used).", [tu.remaining, esc(noun), tu.consumed, tu.granted]);
            }
            return " " + lvTr("lv.block.topup.usedup", "Top-up also used up ({0} of {1}).", [tu.consumed, tu.granted]);
        }

        // Plain-text usage summary (no HTML — the chooser esc()s it) mirroring the banner: "You are using all 7
        // emails. Top-up also used up (3 of 3)." Used as the chooser subtitle so the block keeps its context.
        function usageSummaryPlain() {
            var nounX = lic.entityNoun || (featLower ? (featLower + "s") : lvTr("lv.block.items", "items"));
            var parts = [];
            if (lic.limitDisplay) {
                parts.push(lvTr("lv.block.using.of", "You are using {0} of {1}", [lic.countDisplay || "0", lic.limitDisplay]) + ".");
            }
            else if (limitN != null) {
                parts.push(lvTr("lv.block.using.all", "You are using all {0} {1}", [limitN.toLocaleString(), nounX]) + ".");
            }
            var tu = lic.topupUsage;
            if (tu && tu.granted) {
                parts.push(tu.remaining > 0
                    ? lvTr("lv.block.topup.remaining", "Plus {0} top-up {1} still available ({2} of {3} used).", [tu.remaining, nounX, tu.consumed, tu.granted])
                    : lvTr("lv.block.topup.usedup", "Top-up also used up ({0} of {1}).", [tu.consumed, tu.granted]));
            }
            return parts.join(" ");
        }

        // ── Metered limit WITH a top-up (email / AI credits / storage / operator seats) → the SAME radio chooser as
        //    the allowance banner / AI-credit modal: the top-up add-on pre-selected, the next plan appended below
        //    (showFeatureUnlockPopup auto-appends it when only the add-on option is supplied). Preferred over the
        //    plain plan card because it lets the buyer top up instantly OR upgrade, from one popup. ──
        if (isLimit && topup && topup.url && typeof showFeatureUnlockPopup === "function") {
            showFeatureUnlockPopup({
                warn    : true,   // hit-limit context → keep the amber warning triangle (not the brand circles)
                title   : lvTr("lv.block.hit.limit", "Oops, you have hit your {0} limit", [featLower || "plan"]),
                subtitle: usageSummaryPlain(),
                options : [{
                    id         : "addon",
                    label      : topup.label,
                    price      : topup.price,
                    interval   : topup.interval,
                    ctaLabel   : topup.cta,
                    selected   : true,
                    purchaseUrl: topup.url,
                    bullets    : []
                }]
            });
            return;
        }

        // ── Limit block WITH an upgrade offer → the plan-card popup (per the reference mock). The plan / price /
        //    this-feature limit / checkout URL all come from the server envelope (LicenseManager.upgradeOffer,
        //    hykma-backed), so the card is dynamic on the tenant's current package. ──
        if (isLimit && up && up.plan) {
            var noun = lic.entityNoun || (featLower ? (featLower + "s") : lvTr("lv.block.items", "items"));
            var usedTxt = lic.limitDisplay
                ? lvTr("lv.block.using.of", "You are using {0} of {1}", [esc(lic.countDisplay || "0"), esc(lic.limitDisplay)])
                : lvTr("lv.block.using.all", "You are using all {0} {1}", [(limitN != null ? limitN.toLocaleString() : ""), esc(noun)]);
            var headSub = usedTxt + (plan ? (" " + lvTr("lv.block.included.plan", "included in your {0} plan", [esc(plan)])) : "") + "." + topupUsageLine(noun) + " " + esc(lvTr("lv.block.upgrade.more", "Upgrade to add more."));
            var planShort = up.planShort || (up.plan || "").replace(/ Plan$/, "");
            var checkSvg = "<svg width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='#16b364' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><path d='M22 11.08V12a10 10 0 1 1-5.93-9.14'></path><polyline points='22 4 12 14.01 9 11.01'></polyline></svg>";
            var feats = "";
            if (up.feature) { feats += "<div class='lv-lic-feat'>" + checkSvg + "<span>" + esc(up.feature) + "</span></div>"; }
            // Data-driven: the next plan's REAL feature labels from the hub (X-License-Upgrade-Features). Fall back
            // to the generic "Plus the full <plan> feature set" line only when the hub returned no bullets.
            if (up.features && up.features.length) {
                up.features.forEach(function (f) { feats += "<div class='lv-lic-feat'>" + checkSvg + "<span>" + esc(f) + "</span></div>"; });
            } else {
                feats += "<div class='lv-lic-feat'>" + checkSvg + "<span>" + esc(lvTr("lv.upgrade.plus.full.set", "Plus the full {0} feature set", [planShort])) + "</span></div>";
            }
            var $oc = jQuery('<div id="lv-block-popup" class="lv-lic-overlay"></div>');
            var $cc = jQuery(
                '<div class="lv-lic-card">' +
                  '<div class="lv-lic-card__head">' +
                    '<button type="button" class="lv-lic-card__close" aria-label="Close">&times;</button>' +
                    '<div class="lv-lic-card__badge">' + WARN_SVG + '</div>' +
                    '<h2 class="lv-lic-card__title"></h2><p class="lv-lic-card__sub"></p>' +
                  '</div>' +
                  '<div class="lv-lic-card__body">' +
                    '<div class="lv-lic-plan"><span class="lv-lic-plan__name"></span><span class="lv-lic-plan__price"></span></div>' +
                    '<div class="lv-lic-feats"></div>' +
                    '<div class="lv-lic-card__foot"><button type="button" class="lv-lic-cancel">' + esc(lvTr("lv.common.cancel", "Cancel")) + '</button><button type="button" class="lv-lic-upgrade"></button></div>' +
                  '</div>' +
                '</div>');
            $cc.find(".lv-lic-card__title").text(lvTr("lv.block.hit.limit", "Oops, you have hit your {0} limit", [featLower || "plan"]));
            $cc.find(".lv-lic-card__sub").html(headSub);
            $cc.find(".lv-lic-plan__name").text(up.plan);
            // Show the billing interval after the price (e.g. "$52.00/month"), matching the upgrade popup — the
            // server supplies up.interval; fall back to /month so the cadence is never missing.
            var blockInterval = lvNormalizeInterval(up.interval) || lvTr("lv.interval.month", "/month");
            $cc.find(".lv-lic-plan__price").html(up.price ? (esc(up.price) + '<span class="lv-up-price__int">' + esc(blockInterval) + '</span>') : "");
            $cc.find(".lv-lic-feats").html(feats);
            $cc.find(".lv-lic-upgrade").text(lvTr("lv.upgrade.to", "Upgrade to {0}", [planShort]));
            $oc.append($cc); jQuery(d.body).append($oc);
            var closeC = function () { $oc.remove(); };
            // Instant top-up option below the plan card (when the hit key has a top-up SKU) — buy more now vs upgrade.
            var $tbCard = buildTopupBtn(closeC);
            if ($tbCard) { $cc.find(".lv-lic-feats").after($tbCard); }
            $cc.find(".lv-lic-cancel, .lv-lic-card__close").on("click", closeC);
            $oc.on("click", function (e) { if (e.target === this) { closeC(); } });
            $cc.find(".lv-lic-upgrade").on("click", function () {
                // Straight to hykma's checkout for the upgrade plan (no intermediate modal).
                if (up.url) { try { (topWin() || window).open(up.url, "_blank"); } catch (e) { window.open(up.url, "_blank"); } }
                else { showUpgradePopup({ feature: up.feature || "" }); }   // carry the hit feature (e.g. order limit) into the modal
                closeC();
            });
            return;
        }

        // ── Fallback (no upgrade offer, or P4 feature-not-in-plan) → the simple popup ──
        var title, body, primaryLabel;
        if (isLimit) {
            title = lvTr("lv.block.hit.limit", "Oops, you have hit your {0} limit", [featLower || "plan"]);
            var incl = plan ? (" " + lvTr("lv.block.included.plan", "included in your {0} plan", [esc(plan)])) : "";
            var noun2 = lic.entityNoun || (featLower ? (featLower + "s") : lvTr("lv.block.items", "items"));
            // "." + optional top-up usage line (mirrors the banner) + the upgrade prompt — all one line.
            var more = "." + topupUsageLine(noun2) + " " + esc(lvTr("lv.block.upgrade.more", "Upgrade to add more."));
            if (lic.limitDisplay) {
                body = lvTr("lv.block.using.of", "You are using {0} of {1}", [esc(lic.countDisplay || "0"), esc(lic.limitDisplay)]) + incl + more;
            } else {
                body = (limitN != null) ? (lvTr("lv.block.using.all", "You are using all {0} {1}", [limitN.toLocaleString(), esc(noun2)]) + incl + more) : lvTr("lv.block.upgrade.plan.more", "Upgrade your plan to add more.");
            }
            // Generic label (no client-side tier guess) — the button opens showUpgradePopup, which fetches the
            // real next plan from the backend. This branch has no server upgrade offer to name the tier from.
            primaryLabel = lvTr("lv.upgrade.generic", "Upgrade your plan");
        } else {
            title = lvTr("lv.block.feature.not.included", "{0} isn’t included in your plan", [feature || lvTr("lv.block.feature.default", "This feature")]);
            body = esc(data.message || "");
            primaryLabel = lvTr("lv.block.upgrade.now", "Upgrade Now");
        }
        var $o = jQuery('<div id="lv-block-popup" class="lv-lic-overlay"></div>');
        // Same chrome as the add-on / upgrade popups (.lv-fu-*: CMS font, blue dotted head, pill buttons);
        // the lv-lic-* names are hooks only, unstyled.
        var $card = jQuery(
            '<div class="lv-fu-card">' +
              '<div class="lv-fu-head">' +
                '<button type="button" class="lv-fu-close lv-lic-later" aria-label="Close">&times;</button>' +
                '<div class="lv-fu-warn">' + WARN_SVG + '</div>' +
                '<h2 class="lv-fu-title lv-lic-title"></h2><p class="lv-fu-sub lv-lic-body"></p>' +
              '</div>' +
              '<div class="lv-fu-actions">' +
                '<button type="button" class="lv-fu-cancel lv-lic-later">' + esc(lvTr("lv.block.not.now", "Not Now")) + '</button>' +
                '<button type="button" class="lv-fu-cta lv-lic-primary"></button>' +
              '</div>' +
            '</div>');
        $card.find(".lv-lic-title").text(title);
        if (body) { $card.find(".lv-lic-body").html(body); } else { $card.find(".lv-lic-body").remove(); }
        $card.find(".lv-lic-primary").text(primaryLabel);
        $o.append($card); jQuery(d.body).append($o);
        var close = function () { $o.remove(); };
        // Instant top-up option (when the hit key has a top-up SKU), shown above the Upgrade/Not-now actions.
        var $tbSimple = buildTopupBtn(close);
        if ($tbSimple) { $card.find(".lv-fu-actions").before(jQuery('<div class="lv-fu-body"></div>').append($tbSimple)); }
        $card.find(".lv-lic-later").on("click", close);
        $o.on("click", function (e) { if (e.target === this) { close(); } });
        $card.find(".lv-lic-primary").on("click", function () {
            close();
            // Carry the feature the user just hit into the upgrade modal so it's listed FIRST — the same relevance
            // the limit plan-card gives (an order-limit block surfaces the order-limit line, a page-limit block the
            // page-limit line, etc.). Prefer the server's upgrade-offer feature; else humanize the raw key.
            var relFeat = (up && up.feature)
                ? up.feature
                : (feature ? (feature.charAt(0).toUpperCase() + feature.slice(1) + (isLimit ? " limit" : "")) : "");
            showUpgradePopup({ feature: relFeat });
        });
    }

    // P1 (doc) — Category-1 abuse ceiling: a HARD block with NO upgrade path. These ceilings are identical on
    // every plan (incl. Enterprise), so upgrading wouldn't help — hence a single dismiss ("Cancel") and no
    // "Upgrade" CTA. Triggered by X-License-Error = "abuse_ceiling_exceeded" on a 429.
    // "42" -> "42 seconds", "90" -> "2 minutes", "7200" -> "2 hours" (rounded up, singular/plural).
    function humanizeSeconds(s) {
        s = Math.max(1, Math.round(Number(s)));
        if (s < 60) { return lvTr(s === 1 ? "lv.time.second" : "lv.time.seconds", (s === 1 ? "{0} second" : "{0} seconds"), [s]); }
        if (s < 3600) { var m = Math.ceil(s / 60); return lvTr(m === 1 ? "lv.time.minute" : "lv.time.minutes", (m === 1 ? "{0} minute" : "{0} minutes"), [m]); }
        var h = Math.ceil(s / 3600); return lvTr(h === 1 ? "lv.time.hour" : "lv.time.hours", (h === 1 ? "{0} hour" : "{0} hours"), [h]);
    }

    // P1 abuse ceiling — a compact top-left toast (amber warning badge, concise headline + one-line copy,
    // close button). The per-key copy comes from the server (X-License-Ceiling-Title/-Message headers →
    // data.title/data.message, sourced from messages.properties); falls back to a generic line if absent.
    function showAbuseCeilingPopup(data, triggerEl) {
        try { window.__lvBlockActive = (new Date()).getTime(); } catch (e) {}
        clearBlockedLoaders(null, triggerEl);
        var d = topDoc();
        var prev = d.getElementById("lv-abuse-toast");
        if (prev && prev.parentNode) { prev.parentNode.removeChild(prev); }
        var title = (data && data.title) ? data.title : lvTr("lv.abuse.title", "Too many requests");
        var body = (data && data.message) ? data.message : lvTr("lv.abuse.body", "Please wait a moment and try again.");
        var warnIcon = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#d97706" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path><line x1="12" y1="9" x2="12" y2="13"></line><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>';
        var $t = jQuery(
            '<div id="lv-abuse-toast" role="alert" style="position:fixed;top:16px;left:50%;transform:translateX(-50%);z-index:2147483000;max-width:380px;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,sans-serif;">' +
              '<div style="display:flex;align-items:flex-start;gap:12px;background:#fff;border:1px solid #ececec;border-radius:12px;box-shadow:0 10px 30px rgba(0,0,0,.18);padding:14px 12px 14px 14px;">' +
                '<span style="flex:0 0 auto;width:34px;height:34px;border-radius:50%;background:#fef3c7;display:flex;align-items:center;justify-content:center;">' + warnIcon + '</span>' +
                '<div style="flex:1 1 auto;min-width:0;padding-top:1px;">' +
                  '<div class="lv-abuse-toast__title" style="font-weight:700;font-size:14px;color:#1f2937;line-height:1.35;"></div>' +
                  '<div class="lv-abuse-toast__body" style="font-size:13px;color:#6b7280;line-height:1.45;margin-top:2px;"></div>' +
                '</div>' +
                '<button type="button" class="lv-abuse-toast__close" aria-label="Close" style="flex:0 0 auto;background:transparent;border:0;color:#9ca3af;cursor:pointer;font-size:20px;line-height:1;padding:0 2px;margin:-2px -2px 0 0;">&times;</button>' +
              '</div>' +
            '</div>');
        $t.find(".lv-abuse-toast__title").text(title);
        $t.find(".lv-abuse-toast__body").text(body);
        jQuery(d.body).append($t);
        var remove = function () { if ($t && $t.remove) { $t.remove(); } };
        $t.find(".lv-abuse-toast__close").on("click", remove);
        try { setTimeout(remove, 8000); } catch (e) {}
    }

    // ── Admin "actions paused" panel state (P1 admin abuse ceiling) ──────────────────────────────────
    // A hard admin ceiling blocks every state-changing action for up to the Retry-After window, so instead
    // of a popup-per-action + pages left spinning/blank, we enter a panel-wide paused state: a persistent
    // banner, recovery of stuck loaders/buttons, and (via the bm.ajax guard) pre-empting further doomed
    // POSTs. State + the banner live on the TOP window so it's shared across the FEE shell + editor iframe.
    function showAdminPausedBanner(retrySeconds) {
        try {
            var d = topDoc();
            var untilTxt = "";
            if (retrySeconds && retrySeconds > 0) {
                var when = new Date((new Date()).getTime() + retrySeconds * 1000);
                untilTxt = " " + lvTr("lv.admin.paused.retry", "— try again in {0} (around {1})", [humanizeSeconds(retrySeconds), when.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })]);
            }
            var markup = '<div id="wc-admin-paused-banner" style="position:fixed;top:0;left:0;right:0;z-index:100050;background:#b45309;color:#fff;font:600 13.5px/1.4 -apple-system,Segoe UI,sans-serif;padding:10px 16px;display:flex;align-items:center;gap:12px;box-shadow:0 2px 8px rgba(0,0,0,.2);">' +
                '<span style="flex:1;">' + esc(lvTr("lv.admin.paused", "Admin actions are paused (usage limit reached)")) + untilTxt + '.</span>' +
                '<button type="button" class="wc-admin-paused-reload" style="background:#fff;color:#b45309;border:0;border-radius:5px;padding:6px 14px;font-weight:700;cursor:pointer;">' + esc(lvTr("lv.admin.paused.reload", "Reload")) + '</button>' +
                '</div>';
            var existing = d.getElementById("wc-admin-paused-banner");
            if (existing) { jQuery(existing).replaceWith(markup); }
            else { jQuery(d.body).prepend(markup); }
            jQuery(d).off("click.wcAdminPaused").on("click.wcAdminPaused", ".wc-admin-paused-reload", function () {
                try { (topWin() || window).location.reload(); } catch (e) { window.location.reload(); }
            });
        } catch (e) {}
    }

    function clearAdminPaused() {
        try {
            var tw = topWin() || window;
            tw.__adminPausedUntil = 0;
            var d = topDoc(); var b = d.getElementById("wc-admin-paused-banner");
            if (b && b.parentNode) { b.parentNode.removeChild(b); }
        } catch (e) {}
    }

    function enterAdminPaused(retrySeconds) {
        try {
            var tw = topWin() || window;
            var until = (retrySeconds && retrySeconds > 0) ? ((new Date()).getTime() + retrySeconds * 1000) : ((new Date()).getTime() + 60000);
            tw.__adminPausedUntil = until;
            tw.__wcShowAdminPausedBanner = showAdminPausedBanner;   // so bm.ajax (any frame) can pre-empt + surface it
            showAdminPausedBanner(retrySeconds);
            // Recovery: clear stuck loaders/spinners + re-enable submit buttons + unblockUI, in the top doc AND
            // this doc — the request that hit the ceiling left them mid-flight (its success never ran).
            var docs = [];
            try { docs.push(topDoc()); } catch (e) {}
            if (typeof document !== "undefined" && docs.indexOf(document) === -1) { docs.push(document); }
            docs.forEach(function (dd) {
                try {
                    jQuery(dd).find(".loader, .spinner").hide();
                    jQuery(dd).find(".loading, .is-loading").removeClass("loading is-loading");
                    jQuery(dd).find("[type=submit][disabled], .submit-row button[disabled]").removeAttr("disabled");
                } catch (e) {}
            });
            try { if (jQuery.unblockUI) { jQuery.unblockUI(); } } catch (e) {}
            // Auto-clear when the window elapses (banner + flag).
            try { if (tw.__adminPausedTimer) { clearTimeout(tw.__adminPausedTimer); } } catch (e) {}
            var ms = until - (new Date()).getTime();
            if (ms > 0 && ms < 2147483647) { tw.__adminPausedTimer = setTimeout(clearAdminPaused, ms + 500); }
        } catch (e) {}
    }

    // Route a parsed license envelope to the right popup: P1 abuse ceiling, else the P3/P4 block. (There is no
    // approaching-limit POPUP — the 75% state is shown by the on-page <license:limitBanner>, never a popup.)
    // triggerEl (optional): the element/subtree that made the blocked request — threaded to clearBlockedLoaders
    // so loader/button recovery targets ONLY that subtree when known (else it falls back to a page-wide sweep).
    function dispatchLicensePopup(data, triggerEl) {
        if (!data) { return; }
        if (data.errorCode === "abuse_ceiling_exceeded") {
            showAbuseCeilingPopup(data, triggerEl);
            // Only ADMIN ceilings (admin_action_*) lock the panel — storefront ceilings share this code but
            // must not pause the admin UI, so gate on the key carried in X-License-Feature.
            try {
                var feat = (data.license && data.license.feature) ? String(data.license.feature) : "";
                if (feat.indexOf("admin_action") === 0) {
                    enterAdminPaused((data.retryAfter != null && !isNaN(data.retryAfter)) ? Number(data.retryAfter) : null);
                }
            } catch (e) {}
        }
        else { showBlockPopup(data, triggerEl); }
    }

    // Client-side gate hook: a purely client-side control (e.g. the "+ Add Language" button, which opens a
    // popup without a server round-trip) can render the exact P2/P3/P4 license dialog by passing the same
    // parsed-envelope shape the ajax hooks build ({errorCode, license:{feature,key,limit,count,planName}, ...}).
    try { (topWin() || window).lvShowLicenseBlock = function (data) { dispatchLicensePopup(data); }; } catch (e) {}

    // Dev/test hook: the License Viewer "Popups" tab renders ANY license popup on demand. It calls the SAME
    // runtime code path production uses — NO duplicated popup markup here, only representative sample data:
    //   • P1–P4 go through dispatchLicensePopup(envelope) — the exact router the ajax layer feeds from the
    //     X-License-* response headers (parseEnvelope), so the dialog shown is byte-for-byte production's.
    //   • upgrade / unlock / import call the same trigger functions their production CTAs call (showUpgradePopup /
    //     lvOpenUnlockPopup / showImportLimitPopup) — the first two make their real backend call so the preview
    //     matches THIS instance.
    // No real limit is hit and no counter changes. One entry point keyed by popup type; unknown types are ignored.
    try { (topWin() || window).lvPreviewPopup = function (type) {
        switch (String(type)) {
            case "p3_limit":   // P3 — structural limit reached (create blocked) → real block-popup router.
                // Sample data matches the PRODUCTION envelope shape (SecurityInterceptor + LicenseLabels.blockExtras):
                // `feature` is the HUMAN label (X-License-Feature = localized featureName), `key` the raw key, and
                // upgrade.feature is the human "next-plan limit" phrase (featureLine = "5,000 products"), NEVER a raw key.
                dispatchLicensePopup({ errorCode: "license_limit_exceeded", license: {
                    feature: "products", key: "product_limit", limit: 1000, count: 1000,
                    limitDisplay: "1,000", countDisplay: "1,000", entityNoun: "products", planName: "Professional",
                    upgrade: { plan: "Premium Plan", planShort: "Premium", price: "$99", interval: "/month", url: "",
                        feature: "5,000 products", features: ["Unlimited products", "Priority support", "Advanced reports"] },
                    blocked: true } });
                break;
            case "p4_feature": // P4 — feature not in the current plan (disabled) → real block-popup router.
                // Production sends the HUMAN label as `feature` (X-License-Feature), and `message` = the server's
                // localized body (the @License message, default i18n `feature.disabled` = "{0} feature is disabled").
                // A feature-disabled block carries NO `upgrade` object (blockExtras adds upgrade only for LIMIT
                // blocks), so the preview omits it too — the popup shows the simple "…isn't included in your plan" card.
                dispatchLicensePopup({ errorCode: "license_feature_disabled", license: {
                    feature: "Approval workflow", key: "allow_approval_feature", planName: "Professional",
                    blocked: true }, message: "Approval workflow feature is disabled." });
                break;
            case "p1_ceiling": // P1 — abuse ceiling → real router. Storefront feature (NOT admin_action_*) so the
                               // preview never triggers the admin-pause branch dispatchLicensePopup runs for admin ceilings.
                dispatchLicensePopup({ errorCode: "abuse_ceiling_exceeded", retryAfter: 42,
                    title: "Too many attempts", message: "You’ve hit a temporary safety limit. Please wait a moment and try again.",
                    license: { feature: "review_submissions_daily", key: "review_submissions_daily" } });
                break;
            case "upgrade":    // Upgrade-to-next-plan popup — same trigger the banner/AI-credit CTAs use (live: upgradeContext)
                showUpgradePopup({ feature: "product limit" });
                break;
            case "unlock":     // Add-on unlock chooser — same trigger the allowance-banner CTA uses (live: unlockOffer)
                lvOpenUnlockPopup("email_limit");
                break;
            case "import":     // Import-over-limit chooser — same function the import flow calls
                showImportLimitPopup({ anyOver: true, planName: "Professional", rows: [
                    { label: "Products", source: 1500, limit: 1000, status: "over", remaining: 0 },
                    { label: "Categories", source: 20, limit: 50, status: "within" },
                    { label: "Customers", source: 60, limit: 50, status: "over", remaining: 0 }
                ] });
                break;
            default: break;
        }
    }; } catch (e) {}

    function parseEnvelope(xhr) {
        if (!xhr) { return null; }
        // Robust path: clean response headers set by SecurityInterceptor (no HTML-encoding / format issues).
        try {
            var ec = xhr.getResponseHeader && xhr.getResponseHeader("X-License-Error");
            if (ec) {
                var limHdr = xhr.getResponseHeader("X-License-Limit");
                var raHdr = xhr.getResponseHeader("Retry-After");
                var ceilTitleHdr = xhr.getResponseHeader("X-License-Ceiling-Title");
                var ceilMsgHdr = xhr.getResponseHeader("X-License-Ceiling-Message");
                var decodeHdr = function (v) { if (!v) { return ""; } try { return decodeURIComponent(v); } catch (e) { return v; } };
                return {
                    errorCode: ec,
                    title: decodeHdr(ceilTitleHdr),
                    message: decodeHdr(ceilMsgHdr),
                    retryAfter: (raHdr ? parseInt(raHdr, 10) : null),
                    license: {
                        feature: xhr.getResponseHeader("X-License-Feature") || "",
                        limit: (limHdr ? parseInt(limHdr, 10) : null),
                        count: ((xhr.getResponseHeader("X-License-Count")) ? parseInt(xhr.getResponseHeader("X-License-Count"), 10) : null),
                        limitDisplay: xhr.getResponseHeader("X-License-Limit-Display") || null,
                        countDisplay: xhr.getResponseHeader("X-License-Count-Display") || null,
                        entityNoun: xhr.getResponseHeader("X-License-Entity-Noun") || null,
                        upgrade: (function () {
                            var p = xhr.getResponseHeader("X-License-Upgrade-Plan");
                            return p ? { plan: p, planShort: p.replace(/ Plan$/, ""), price: xhr.getResponseHeader("X-License-Upgrade-Price") || "", feature: xhr.getResponseHeader("X-License-Upgrade-Feature") || "", url: xhr.getResponseHeader("X-License-Upgrade-Url") || "", features: (function () { var f = xhr.getResponseHeader("X-License-Upgrade-Features"); return f ? f.split("||") : []; })() } : null;
                        })(),
                        // Compact "buy a top-up now" offer for metered keys (server: LicenseManager.topupOffer). Present
                        // only when the key has a top-up SKU; the block popup renders a buy button when it is.
                        topup: (function () {
                            var u = xhr.getResponseHeader("X-License-Topup-Url");
                            return u ? { label: decodeHdr(xhr.getResponseHeader("X-License-Topup-Label")), price: decodeHdr(xhr.getResponseHeader("X-License-Topup-Price")), interval: decodeHdr(xhr.getResponseHeader("X-License-Topup-Interval")), cta: decodeHdr(xhr.getResponseHeader("X-License-Topup-Cta")), url: u } : null;
                        })(),
                        // Current top-up balance usage (email / AI credits) so the block popup mirrors the banner's
                        // "plus N top-up …" / "top-up also used up" line instead of hiding the top-up consumption.
                        topupUsage: (function () {
                            var g = xhr.getResponseHeader("X-License-Topup-Granted");
                            return g ? { granted: parseInt(g, 10), consumed: parseInt(xhr.getResponseHeader("X-License-Topup-Consumed") || "0", 10), remaining: parseInt(xhr.getResponseHeader("X-License-Topup-Remaining") || "0", 10) } : null;
                        })(),
                        planName: xhr.getResponseHeader("X-License-Plan") || null,
                        blocked: true
                    }
                };
            }
            // No X-License-Warning branch: the server never emits it (the 75% approaching-limit state is an on-page
            // <license:limitBanner>, not a popup — see SecurityInterceptor). Only a 100% block returns an envelope.
        } catch (e) {}
        var data = xhr.responseJSON || null;
        if (!data && xhr.responseText) {
            var txt = xhr.responseText, raw = txt;
            var m = txt.match(/<textarea[^>]*>([\s\S]*?)<\/textarea>/i);
            if (m) { var ta = document.createElement("textarea"); ta.innerHTML = m[1]; raw = ta.value; }
            try { data = JSON.parse(raw); } catch (e) { data = null; }
            if (!data && txt.indexOf("forbidden-action-message") !== -1) {
                var $f = jQuery("<div></div>").html(txt).find(".forbidden-action-message");
                if ($f.length && $f.attr("data-error-code")) {
                    var lim = $f.attr("data-limit");
                    data = { errorCode: $f.attr("data-error-code"), message: jQuery.trim($f.text()),
                        license: { feature: $f.attr("data-feature"), limit: (lim ? parseInt(lim, 10) : null), planName: $f.attr("data-plan"), blocked: true } };
                }
            }
        }
        if (data && (data.errorCode === "license_limit_exceeded" || data.errorCode === "license_feature_disabled" || data.errorCode === "abuse_ceiling_exceeded")) { return data; }
        return null;
    }

    // Public: does this jqXHR carry a license block (feature-disabled / limit-exceeded / abuse-ceiling)? The
    // X-License-Error header is the robust signal; the body regex is the fallback for cached / header-stripped
    // transports. Used by per-call error handlers (popup loader, status toggles) to skip fallback UI — the
    // confirm dialog, a raw error toast, or an optimistic toggle flip — since the global upgrade popup owns it.
    window.__lvIsBlock = function (xhr) {
        try {
            if (xhr && xhr.getResponseHeader && xhr.getResponseHeader("X-License-Error")) { return true; }
            if (xhr && xhr.responseText &&
                /"errorCode"\s*:\s*"(license_feature_disabled|license_limit_exceeded|abuse_ceiling_exceeded)"/.test(xhr.responseText)) { return true; }
        } catch (e) {}
        return false;
    };

    // Public: surface a license/abuse block directly from a jqXHR (parse its envelope → route the popup +
    // recover stuck loaders). For per-call error handlers whose transport can't rely on the global ajaxComplete
    // hook (e.g. a bm.ajax with dataType:"html" whose own error branch would otherwise swallow the block and
    // leave its loader spinning). Idempotent with the global hook — the toast dedups by id. Returns true when a
    // block was recognized and handled, so the caller can skip its generic error toast. On a bare 429 with no
    // readable envelope (headers stripped + non-JSON body), still shows the generic abuse toast + clears loaders.
    window.__lvHandleXhr = function (xhr, triggerEl) {
        try {
            var data = parseEnvelope(xhr);
            if (data) { dispatchLicensePopup(data, triggerEl); return true; }
            if (xhr && xhr.status === 429) { showAbuseCeilingPopup(null, triggerEl); return true; }
        } catch (e) {}
        return false;
    };

    // Public: does this response BODY carry a license/abuse block? Mirrors __lvIsBlock for success-path
    // handlers that receive the parsed/raw body but no xhr (e.g. a dataType:"html" success, or a form-plugin
    // transport). Callers use it to SKIP injecting the raw JSON error into the page — the global ajaxComplete
    // popup above already surfaces the block (abuse-ceiling toast / upgrade modal). Accepts a string, a parsed
    // object, or a bm-wrapped response (reads its .responseText).
    window.__lvIsBlockBody = function (body) {
        try {
            if (!body) { return false; }
            if (typeof body === "string") {
                return /"errorCode"\s*:\s*"(license_feature_disabled|license_limit_exceeded|abuse_ceiling_exceeded)"/.test(body);
            }
            if (typeof body === "object") {
                if (body.errorCode === "abuse_ceiling_exceeded" || body.errorCode === "license_feature_disabled" || body.errorCode === "license_limit_exceeded") { return true; }
                if (typeof body.responseText === "string") { return window.__lvIsBlockBody(body.responseText); }
            }
        } catch (e) {}
        return false;
    };

    jQuery(document).ajaxComplete(function (evt, xhr, settings) {
        try {
            // Some surfaces render their OWN inline locked state for a feature block instead of the global
            // upgrade modal (e.g. the FEE Version History panel shows an in-panel "unlock" card). For those
            // endpoints, skip the global popup so the two don't stack. The inline handler reads the same body.
            var _blkUrl = settings && settings.url;
            if (inlineBlockUrl(_blkUrl) || silentBlockUrl(_blkUrl)) { return; }
            // Trigger element (for scoped loader recovery): jQuery ajaxComplete doesn't expose the DOM element
            // that fired the request, so use settings.context ONLY when a caller set it to an element/jQuery;
            // otherwise leave it null and clearBlockedLoaders falls back to the page-wide sweep.
            var trigEl = (settings && settings.context && (settings.context.nodeType || settings.context.jquery)) ? settings.context : null;
            var data = parseEnvelope(xhr); if (data) { dispatchLicensePopup(data, trigEl); }
        } catch (e) {}
    });

    // Parse a license envelope out of a raw response body (string JSON, a <textarea> wrapper, or an
    // already-parsed object). Used for transports that give us the body but no readable headers.
    function envelopeFromBody(body) {
        var data = null;
        try {
            if (body && typeof body === "object") { data = body; }
            else if (typeof body === "string") {
                var raw = body, m = body.match(/<textarea[^>]*>([\s\S]*?)<\/textarea>/i);
                if (m) { var ta = document.createElement("textarea"); ta.innerHTML = m[1]; raw = ta.value; }
                try { data = JSON.parse(raw); } catch (e) { data = null; }
            }
        } catch (e) { data = null; }
        if (data && (data.errorCode === "license_limit_exceeded" || data.errorCode === "license_feature_disabled" || data.errorCode === "abuse_ceiling_exceeded")) { return data; }
        return null;
    }

    // WC forms submit via the generic form layer (utility/form.js -> jQuery Form Plugin). For a
    // multipart/file form (e.g. the page create/edit form -> frontEndEditor/savePage) the plugin uses a
    // hidden-IFRAME transport, so there is NO XHR/fetch and NO jQuery global ajax event to catch the 403.
    // form.js fires its own "ajax-submit-error" on every submit failure (both transports); hook it so a
    // license block still shows the upgrade popup instead of a raw error toast. lvBoot runs early (utility.js
    // loads before feature scripts), so this listener is bound first — it sets __lvBlockActive before any
    // feature-level toast handler runs, which view.js's notify/feeNotify use to suppress the duplicate toast.
    jQuery(document).on("ajax-submit-error", function (evt, xhr, status, response) {
        try {
            var data = parseEnvelope(xhr) || envelopeFromBody(response) || envelopeFromBody(xhr && xhr.responseText);
            if (!data) { return; }
            window.__lvBlockActive = (new Date()).getTime();
            // The blocked form (e.g. "Create Page") lives inside a WC popup that stacks above ours; close it so
            // the upgrade popup is the sole focus — the save can't proceed under the limit anyway.
            try {
                var $popup = jQuery(evt.target).closest(".popup");
                if ($popup.length && typeof $popup.obj === "function") {
                    var inst = $popup.obj();
                    if (inst && typeof inst.close === "function") { inst.close(); }
                }
            } catch (eClose) {}
            // The failing form IS the trigger element → scope loader/button recovery to its subtree.
            dispatchLicensePopup(data, evt && evt.target);
        } catch (e) {}
    });
    // Limit + allowance banners "Upgrade Plan": ONE behaviour — fetch the add-on chooser offer LIVE by the banner's
    // data-key (lvOpenUnlockPopup → license/unlockOffer) and open the chooser. A key with a top-up SKU (user_limit →
    // operator seat, email / ai_credit / storage → metered top-up) shows BOTH the top-up option AND the next plan; a
    // key with no top-up (product / page / …) falls back to the plain next-plan upgrade popup. Nothing is baked into
    // the page. Shared selector so a stale-cached banner still resolves the current offer.
    jQuery(document).on("click", ".lic-limit-banner__upgrade, .lic-allowance-banner__upgrade", function () {
        lvOpenUnlockPopup(jQuery(this).closest("[data-key]").attr("data-key") || "", this);
    });

    // Allowance banner "Not now": hide it and remember the dismissal for THIS period (keyed by
    // data-dismiss-key, which includes the reset timestamp) so it reappears next month, not every reload.
    jQuery(document).on("click", ".lic-allowance-banner__dismiss", function () {
        var $b = jQuery(this).closest(".lic-allowance-banner");
        try {
            var k = $b.attr("data-dismiss-key");
            if (k && window.localStorage) { localStorage.setItem(k, "1"); }
        } catch (e) {}
        $b.remove();
    });
    // Re-hide any allowance banner already dismissed for the current period. Runs on ready + after every ajax
    // panel load (the newsletter section loads via ajax), independent of the bm.ui_updaters pipeline.
    function hideDismissedAllowanceBanners() {
        try {
            jQuery(".lic-allowance-banner[data-dismiss-key]").each(function () {
                var k = jQuery(this).attr("data-dismiss-key");
                if (k && window.localStorage && localStorage.getItem(k) === "1") { jQuery(this).remove(); }
            });
        } catch (e) {}
    }
    jQuery(hideDismissedAllowanceBanners);
    jQuery(document).ajaxComplete(function () { hideDismissedAllowanceBanners(); });

    // Marker classes so the layout AROUND a license banner can be styled. The banner is AJAX-loaded INTO a tab
    // panel, while the padded shell container (.bmui-tab-body-container) is rendered separately — so it cannot be
    // tagged server-side across that AJAX boundary. On ready + after every ajax panel load, tag, for each banner:
    // its closest tab panel, its body-container, AND the SIBLING tab-header-container (the tab bar above the body),
    // so CSS can react to a banner being present:
    //   .bmui-tab-body-container.wc-has-limit-banner  /  .wc-has-allowance-banner  (+ generic .wc-has-license-banner)
    //   .bmui-tab-panel.<same classes>
    //   .bmui-tab-header-container.<same classes>   (e.g. tighten the header→banner gap when a banner shows)
    // e.g. `.bmui-tab-body-container.wc-has-limit-banner { padding-top: 0; }` to close the gap above the banner.
    // `.siblings()` (not a `>` combinator) is used for the header so it stays matched regardless of the tab root's
    // exact class list. Idempotent: each run clears the markers first, then re-adds where a banner currently
    // exists, so switching to a tab without a banner also drops the class.
    function markLicenseBannerHosts() {
        try {
            jQuery(".bmui-tab-body-container, .bmui-tab-panel, .bmui-tab-header-container")
                .removeClass("wc-has-license-banner wc-has-limit-banner wc-has-allowance-banner");
            function tagBannerHosts(banner, cls) {
                var $banner = jQuery(banner);
                var $body = $banner.closest(".bmui-tab-body-container");
                $banner.closest(".bmui-tab-panel").addClass(cls);
                $body.addClass(cls);
                $body.siblings(".bmui-tab-header-container").addClass(cls);
            }
            jQuery(".lic-limit-banner").each(function () { tagBannerHosts(this, "wc-has-license-banner wc-has-limit-banner"); });
            jQuery(".lic-allowance-banner").each(function () { tagBannerHosts(this, "wc-has-license-banner wc-has-allowance-banner"); });
        } catch (e) {
            // M7: don't swallow — a selector/DOM failure here silently stops the banner host markers from applying
            // (banners then lose their layout spacing with no trace). Guarded so a missing console can't itself throw.
            if (window.console && console.warn) { console.warn("markLicenseBannerHosts failed:", e); }
        }
    }
    jQuery(markLicenseBannerHosts);
    jQuery(document).ajaxComplete(function () { markLicenseBannerHosts(); });
    // The banner lives inside a tab panel that tabify loads asynchronously — its content (and the banner) is
    // inserted when tabify fires `tab:load` (see tab.js), which the initial active-tab load does NOT route
    // through jQuery `ajaxComplete`. That's the "not styled until I resize / open devtools" bug: a resize
    // re-runs the bm.ui_updaters pipeline (the same one that (re)inits scrollbars), which is when the markers
    // finally appeared. Hook BOTH sanctioned content-update signals so the markers are applied on the FIRST
    // paint too: the bubbled `tab:load` event, and the bm.ui_updaters pipeline (guarded, same as tab.js /
    // custom-scrollbar.js). Both are additive and idempotent — markLicenseBannerHosts re-scans + re-tags.
    jQuery(document).on("tab:load", function () { markLicenseBannerHosts(); });
    if (window.bm && bm.ui_updaters && typeof bm.ui_updaters.push === "function") {
        bm.ui_updaters.push(function () { markLicenseBannerHosts(); });
    }

    // NOTE (scoping — JS "no global reach" rule): license-block detection is intentionally confined to the
    // app's OWN AJAX layer — the jQuery `ajaxComplete` hook above (covering every bm.ajax / $.ajax request via
    // parseEnvelope), plus the `ajax-submit-error` form hook. We deliberately do NOT monkey-patch the global
    // window.fetch / XMLHttpRequest.prototype.open: doing so put a header-sniffing listener on EVERY request in
    // every document — including third-party libraries' — added duplicate listeners on reused XHRs, and
    // double-processed jQuery requests (prototype listener + ajaxComplete). A non-jQuery admin surface that
    // needs block handling should route through bm.ajax or call the exposed lvShowLicenseBlock(data) itself,
    // rather than have it globally intercepted here.
    }   // end lvBoot

    // Boot now if jQuery/$ is ready, else poll up to ~5s for it (handles utility.js parsing before jquery).
    var lvJq = (typeof window !== "undefined") && (window.jQuery || window.$);
    if (lvJq) {
        lvBoot(lvJq);
    } else {
        var lvTries = 0;
        var lvTimer = setInterval(function () {
            var jq = (typeof window !== "undefined") && (window.jQuery || window.$);
            if (jq) { clearInterval(lvTimer); lvBoot(jq); }
            else if (++lvTries > 200) { clearInterval(lvTimer); }
        }, 25);
    }
})();


/*
 * wc.tr — the one client-side i18n resolver.
 *
 * jquery.i18n.properties answers a MISSING key with the key itself, so the obvious `$.i18n.prop(k) ||
 * fallback` never falls back: the operator reads "confirm.remove.submission" off the screen. Comparing the
 * answer against the key is the only reliable signal that a bundle has not caught up, and that comparison
 * had been written out by hand in three separate files. It lives here so there is one of it, in a file both
 * the storefront (fixedSiteCoreJs) and the editor already load.
 *
 * @param {string} key bundle key
 * @param {string} fallback readable English, used when the bundle has no entry
 * @param {Array} [args] values for {0}, {1}, … placeholders
 * @returns {string} the translation or the fallback, with placeholders filled
 */
;(function () {
    window.wc = window.wc || {};
    window.wc.tr = function (key, fallback, args) {
        var value = (window.$ && $.i18n && $.i18n.prop) ? $.i18n.prop(key) : null;
        var text = (!value || value === key) ? (fallback || key) : value;
        if (args && args.length) {
            for (var i = 0; i < args.length; i++) {
                text = text.replace("{" + i + "}", args[i]);
            }
        }
        return text;
    };
})();

; bm.view = {};
var isNeedToValidAddress = true;
$.extend(bm, {
    alert: function (message, type, okHandler, config) {
        var dom = $("<div class='fee-identical-sewc-elm'><div class='header-line fee-identical-sewc-elm'><span class='icon fee-identical-sewc-elm" + type + "'></span><span class='ok fee-identical-sewc-elm'></span></div><div class='body fee-identical-sewc-elm'><span class='message content fee-identical-sewc-elm'></span></div></div>");
        if(config && config.is_editor) {
            dom = $("<div class=\"confirm-popup fee-attachment-message-popup popup fee-identical-sewc-elm active\"><div class=\"header-line\"><span class=\"title\">Unable to Remove</span><span class=\"icon close\"></span></div><div class=\"body fee-identical-sewc-elm\"><span class=\"message content fee-identical-sewc-elm\"></span></div><div class=\"button-line\"><button class=\"ok ok-button no-button\"></button></div></div>");
        }
        if(config && config.is_bulk_edit) {
            dom = $("<div class=\"confirm-popup fee-attachment-message-popup popup fee-identical-sewc-elm active\"><div class=\"header-line\"><span class=\"title\">Unable to Remove</span><span class=\"icon close\"></span></div><div class=\"body fee-identical-sewc-elm\"><span class=\"message content fee-identical-sewc-elm\"></span></div><div class=\"button-line\"><button class=\"ok ok-button no-button\"></button></div></div>");
        }
        var okButton = dom.find(".ok").text($.i18n.prop("ok"));
        return dom.popup({
            is_fixed: true,
            is_always_up: true,
            hide_inactive: false, // the popup it reports on must stay readable
            clazz: "alert-popup " + type,
            content: message,
            events: {
                render: function (popup) {
                    okButton.click(function () {
                        if (okHandler) {
                            okHandler(0);
                        }
                        popup.close(0)
                    });
                    if (okHandler) {
                        popup.on("close", function (ev, code) {
                            if (code) {
                                okHandler(1);
                            }
                        })
                    }
                }
            }
        }).obj(POPUP);
    },
    attachModernUiPanel: function () { // TODO: Should be removed
        var _self = this;
        var leftPanel = _self.body.find(".modern-list-left-panel");
        if (leftPanel.length) {
            var leftPanelConfig = $.extend({
                thumbPanel: $(),
                url: "",
                thumb_menu_entries: [],
                thumbMenuClick: function (config) {
                },
                leftNavigationClick: function (type) {
                }
            }, _self.leftPanelConfig || {});

            leftPanel.find(".left-panel-btn button").click(function () {
                var newItem = leftPanel.find(".item-thumb.new-item");
                var selected = leftPanel.find(".body .selected").attr("item-id");
                if (newItem.length) {
                    newItem.find(".item-title").focus();
                    return;
                }
                var newDom = leftPanelConfig.thumbPanel.clone();
                _self.body.find(".left-panel .item-wrapper").prepend(newDom);
                var field = ValidationField.createDetachedField(newDom.find("input"), {
                    error_position: "after"
                });
                var applyClicked = false;
                newDom.find(".item-title").focus().on("keyup.key_return", function () {
                    updateName();
                }).on("blur", function () {
                    if (!applyClicked) {
                        _self.reload(selected, true);
                    }
                    applyClicked = false;
                });

                newDom.find(".tool-icon.apply").mousedown(function () {
                    applyClicked = true
                }).click(function () {
                    updateName();
                });

                function updateName() {
                    if (field.validate()) {
                        var name = field.elm.val();
                        bm.ajax({
                            show_response_status: false,
                            url: leftPanelConfig.url,
                            data: {name: name},
                            success: function (resp) {
                                _self.reload(resp.id, true, function (id) {
                                    leftPanel.find(".item-thumb[item-id=" + id + "]").trigger("click");
                                });
                            },
                            error: function (a, b, resp) {
                                field.elm.focus();
                                field.showError({
                                    msg_template: resp.message,
                                    msg_params: [],
                                    rule: undefined
                                })
                            }
                        })
                    } else {
                        field.elm.focus()
                    }
                }
            });
            bm.menu(leftPanelConfig.thumb_menu_entries, _self.body.find(".left-panel .float-menu-navigator"), null, {
                hide: function (entity) {
                    entity.parent().removeClass("float-menu-opened");
                },
                click: function (action, navigator) {
                    var config = navigator.closest(".item-thumb").config("item");
                    leftPanelConfig.thumbMenuClick.call(_self, action, config);
                }
            }, "click", ["center bottom", "right+22 top+7"]);

            _self.body.find(".item-thumb").on("click", function (e) {
                var $this = $(this);
                if ($(e.target).is(".float-menu-navigator")) { //prevent firing for childs
                    return;
                }
                _self.body.find(".item-thumb.selected").removeClass("selected");
                $this.addClass("selected");
                var selected = $this.attr("item-id");
                _self.reload(selected);
            });
            leftPanel.find(".one-line-scroll-content").scrollbar({
                show_vertical: false,
                show_horizontal: true,
                use_bar: false,
                visible_on: "auto",
                horizontal: {
                    handle: {
                        left: leftPanel.find(".left-scroller"),
                        right: leftPanel.find(".right-scroller")
                    },
                    step: "auto"
                }
            });
            leftPanel.find(".navigation-button").on("click", function () {
                var $this = $(this);
                leftPanelConfig.leftNavigationClick.call(_self, $this.attr("item-type"))
            });
            //Modern List Left Panel End
        }
    },
    autoToggle: function (box) {
        var namespace = bm.getUUID();

        function filterRadios(next_target) {
            var radios = next_target.filter(":radio");
            next_target = next_target.not(radios);
            var processed = [];
            radios.each(function () {
                var $this = $(this), name = $this.attr("name");
                if (processed.contains(name)) {
                    return;
                }
                processed.push(name);
                var win = radios.filter("[name='" + name + "']:checked");
                if (!win.length) {
                    win = box.find("[name='" + name + "']:checked")
                }
                if (!win.length) {
                    win = $this
                }
                next_target = next_target.add(win)
            });
            return next_target
        }

        function chainToggle(target, show, mainTargetSelector) {
            var next_target = target.find("[toggle-target]");
            if (target.is("[toggle-target]")) {
                next_target = next_target.add(target)
            }
            next_target = filterRadios(next_target);
            next_target.each(function () {
                var _target = $(this);
                var evName = _target.is("select, :checkbox, :radio") ? "change" : "click";
                if (show) {
                    _target.triggerHandler(evName + "." + namespace, [false, mainTargetSelector])
                } else {
                    _target.triggerHandler(evName + "." + namespace, [true, mainTargetSelector])
                }
            })
        }

        function handleToggle(target, checked, animation, mainTargetSelector) {
            target.each(function () {
                var _target = $(this);
                if (mainTargetSelector && _target.is(mainTargetSelector)) {
                    return;
                }
                var reverse = _target.is("[do-reverse-toggle]");
                var _checked = checked;
                if (reverse) {
                    _checked = !checked
                }
                var is_hide = _target.css("display") == "none";
                if (_checked && is_hide) {
                    var done = function () {
                        chainToggle(_target, true, mainTargetSelector);
                    };
                    if (animation) {
                        _target.show(animation, done);
                    } else {
                        _target.show();
                        done()
                    }
                } else if (!_checked && !is_hide) {
                    var done = function () {
                        var validatable = _target.find('[validation]:not([validate-on="call-only"])');
                        if (_target.is("[validation]")) {
                            validatable = validatable.add(_target)
                        }
                        validatable.trigger('[validation]:not([validate-on="call-only"])');
                        chainToggle(_target, false, mainTargetSelector);
                        _target.find("input").valid();
                    };
                    if (animation) {
                        _target.hide(animation, done);
                    } else {
                        _target.hide();
                        done()
                    }
                } else {
                    chainToggle(_target, _checked, mainTargetSelector);
                }
            })
        }

        function isATargetOrInChain(toggler) {
            var yes = false;
            var targets = box.find("[toggle-target]");
            targets.each(function () {
                var target = $(this).attr("toggle-target");
                if ($(this).is("select")) {
                    var options = $(this).find("option");
                    options.each(function () {
                        var targetSelector = "." + target + "-" + $(this).val();
                        if (toggler.closest(targetSelector, box[0]).length) {
                            yes = true;
                            return false;
                        }
                    })
                } else {
                    yes = toggler.closest("." + target, box[0]).length
                }
                if (yes) {
                    return false
                }
            });
            return yes;
        }

        var getAllChainedTargets = function (toggler) {
            var allTogglers = toggler;
            toggler.each(function () {
                var _toggler = $(this);
                var nextTarget;
                if (_toggler.is("select")) {
                    var type = _toggler.val().replaceAll("\\.", "_");
                    nextTarget = box.find("." + _toggler.attr("toggle-target") + "-" + type);
                } else {
                    nextTarget = box.find("." + _toggler.attr("toggle-target"))
                }
                if (nextTarget.length) {
                    var nextTogglers = nextTarget.find("[toggle-target]");
                    nextTogglers = nextTogglers.add(nextTarget.filter("[toggle-target]"));
                    if (nextTogglers.length) {
                        allTogglers = allTogglers.add(getAllChainedTargets(nextTogglers))
                    }
                }
            });
            return allTogglers
        };
        var allTargets = box.find("[toggle-target]").each(function () {
            var toggler = $(this);
            var animation = toggler.attr("toggle-anim") ? toggler.attr("toggle-anim") : "blind";
            if (animation == "none") {
                animation = null;
            }
            var evName;
            if (toggler.is("select")) {
                evName = "change";
                toggler.on(evName + "." + namespace, function (e, forceOff, excludeTargets) {
                    if (typeof forceOff != "boolean") {
                        forceOff = false;
                        excludeTargets = null
                    }
                    var type = toggler.val().replaceAll("\\.", "_");
                    var target = "." + toggler.attr("toggle-target") + "-" + type;
                    var toHideTargets = $();
                    toggler.find("option").each(function (i, opt) {
                        var option_type = $(opt).val().replaceAll("\\.", "_");
                        if (option_type != type) {
                            var selector = toggler.attr("toggle-target") + "-" + option_type;
                            var hideTarget = box.find("." + selector);
                            toHideTargets = toHideTargets.add(hideTarget.not(target))
                        }
                    });
                    target = box.find(target);
                    var subExcludeTargets = excludeTargets ? excludeTargets.add(getAllChainedTargets(target)) : getAllChainedTargets(target);
                    handleToggle(toHideTargets, false, animation, subExcludeTargets);
                    handleToggle(target, forceOff ? false : true, animation, excludeTargets)
                });
            } else if (toggler.is(":checkbox, :radio")) {
                evName = "change";
                var targetText = "." + toggler.attr("toggle-target");
                var target = box.find(targetText);

                function changeHandler(e, forceOff, excludeTargets, isMain) {
                    if (typeof forceOff != "boolean") {
                        forceOff = false;
                        excludeTargets = null
                    }
                    if (!forceOff) {
                        var otherRadios = box.find("[name='" + toggler.attr("name") + "']").not(toggler).filter("[toggle-target]:not([independent])");
                        var toHideTargets = $();
                        otherRadios.each(function (i, opt) {
                            var hideTarget = box.find("." + $(opt).attr("toggle-target"));
                            toHideTargets = toHideTargets.add(hideTarget.not(target))
                        });
                        handleToggle(toHideTargets, false, animation, isMain ? (excludeTargets ? excludeTargets.add(getAllChainedTargets(target)) : getAllChainedTargets(target)) : excludeTargets)
                    }
                    var checked = toggler.prop("checked");
                    toggler.state = checked;
                    if (toggler.is(".toggle-reverse")) {
                        checked = !checked
                    }
                    handleToggle(target, forceOff ? false : checked, animation, excludeTargets, isMain);
                }

                toggler.on(evName + "." + namespace, function (a, b, c) {
                    changeHandler(a, b, c, true)
                });
                if (toggler.is(":radio")) {
                    var otherRadios = box.find("[name='" + toggler.attr("name") + "']:radio").not("[toggle-target]");
                    otherRadios.on(evName + "." + namespace, function (e, xx, excludeTarget) {
                        if (typeof xx != "boolean") {
                            excludeTarget = null
                        }
                        if (toggler.state || toggler.state === undefined) {
                            changeHandler(e, true, excludeTarget)
                        }
                    })
                }
            } else {
                evName = "click";
                var target = box.find("." + toggler.attr("toggle-target"));
                toggler.on(evName + "." + namespace, function (e, forceOff, excludeTargets) {
                    var checked = toggler.attr("row-expanded") == "true";
                    if (typeof forceOff == "undefined") {
                        checked = !checked;
                        toggler.attr("row-expanded", "" + checked)
                    }
                    handleToggle(target, forceOff ? false : checked, animation, excludeTargets)
                })
            }
        });
        filterRadios(allTargets).each(function () {
            var toggler = $(this);
            var evName = toggler.is("select, :checkbox, :radio") ? "change" : "click";
            if (!isATargetOrInChain(toggler)) {
                toggler.triggerHandler(evName + "." + namespace, [false]);
            }
        });
        return box
    },
    cBaseDoc: function (nodes) {
        var slideDom = $("<div id='documentation-slide' style='display: none'><div class='icon-block'><span class='tool-icon close-icon' title='" + $.i18n.prop("close") + "'></span></div><iframe src='about:blank'></iframe></div>");
        var body = $(document.body);
        nodes.each(function () {
            var node = $(this);
            if (!node.attr("attached")) {
                node.click(function () {
                    var docUrl = node.attr("target-url");
                    if (slideDom.is(":hidden")) {
                        body.prepend(slideDom);
                        slideDom.css({height: window.innerHeight});
                        slideDom.find(".tool-icon.close-icon").click(function () {
                            slideDom.toggle("slide", {direction: 'right'}, function () {
                                body.find("#documentation-slide").remove();
                            });
                        });
                        slideDom.toggle("slide", {direction: 'right'});
                        slideDom.find("iframe").attr("src", docUrl);
                    } else {
                        slideDom.find("iframe").attr("src", docUrl);
                    }
                });
                node.attr("attached", true);
            }
        });
    },
    clearTextSelection: function (_document) {
        if (!_document) {
            _document = document
        }
        var selection = null;
        var _window = _document.defaultView;
        if (_window.getSelection) {
            selection = _window.getSelection();
        } else if (_document.selection) {
            selection = _document.selection;
        }
        if (selection) {
            if (selection.empty) {
                selection.empty();
            }
            if (selection.removeAllRanges) {
                selection.removeAllRanges();
            }
        }
    },
    confirm: function (message, yesHandler, noHandler, cancelHandler, config) {
        if (!config) {
            config = {}
        }
        $.extend(config, {
            focus_button_class: "yes-button"
        });
        var title = config.title ? config.title : $.i18n.prop("confirmation");
        var dom = $("<div><div class='header-line'><span class='title'></span><span class='icon close'></span></div><div class='body'><span class='message content'></span></div><div class='button-line'></div></div>");
        dom.find(".title").text(title);
        return dom.popup({
            close_on_escape: false,
            is_fixed: true,
            is_always_up: true,
            always_up_z_index: config.always_up_z_index,   // a confirm over a popup that is itself pinned high (the editors' pickers)
            // This dialog's own mask is the only dim over the popup it asks about.
            dim_inactive: false,
            hide_inactive: false, // the popup it asks about must stay readable
            clazz: "confirm-popup " + (config.clazz ? config.clazz : ""),
            content: message,
            not_enable_body_scroll: true,
            events: {
                render: function (popup) {
                    var buttonLine = this.find(".button-line");

                    var crossIcon = dom.find(".icon");
                    // Cross/close icon dismisses the dialog. The popup framework
                    // already closes it (.close handler), but the cancel callback
                    // must still run so dismissing is treated the same as "No"
                    // (e.g. reverting a toggle). Without this, a confirmed-action
                    // side effect persists when the user dismisses via the cross.
                    crossIcon.click(function () {
                        var handler = (config && $.isFunction(config.crossHandler)) ? config.crossHandler : noHandler;
                        if ($.isFunction(handler)) {
                            handler.call(popup);
                        }
                    });
                    if (yesHandler instanceof Array) {
                        yesHandler.everyCustomFunc(function () {
                            var btnObj = this;
                            var button = $("<button class='" + btnObj.clazz + "'></button>");
                            button.text($.i18n.prop(btnObj.text));
                            buttonLine.append(button);
                            button.on("click", function () {
                                btnObj.handler.call(popup);
                                popup.close();
                            });
                            button.focus();
                        });
                    } else if (yesHandler) {
                        if (noHandler) {
                            button = $("<button class='no-button'></button>");
                            var noButtonTitle = config.noButtonTitle ? config.noButtonTitle : $.i18n.prop("no");
                            button.text(noButtonTitle);
                            buttonLine.append(button);
                            button.click(function () {
                                if ($.isFunction(noHandler)) {
                                    noHandler.call(popup);
                                }
                                popup.close()
                            });
                            if (cancelHandler) {
                                var button = $("<button class='cancel-button'></button>");
                                var cancelButtonTitle = config.cancelButtonTitle ? config.cancelButtonTitle : $.i18n.prop("cancel");
                                button.text(cancelButtonTitle);
                                buttonLine.append(button);
                                button.click(function () {
                                    if ($.isFunction(cancelHandler)) {
                                        cancelHandler();
                                    }
                                    popup.close()
                                })
                            }
                        }

                        var button = $("<button class='yes-button'></button>");
                        var yesButtonTitle = config.yesButtonTitle ? config.yesButtonTitle : $.i18n.prop("yes");
                        button.text(yesButtonTitle);
                        buttonLine.append(button);
                        button.click(function () {
                            popup.close();
                            yesHandler.call(popup);
                        });
                    }

                    if (config.focus_button_class != false) {
                        var btn = buttonLine.find("." + config.focus_button_class).addClass("confirm-focus");

                        popup.el.on("keyup", function (evt) {
                            if (btn.hasClass("confirm-focus")) {
                                switch (evt.keyCode) {
                                    case 13:
                                        btn.trigger("click");
                                        break;
                                    case 37:
                                        var tmp = btn.prev("button");
                                        btn = tmp.length ? tmp : btn;
                                        break;
                                    case 39:
                                        var tmp = btn.next("button");
                                        btn = btn = tmp.length ? tmp : btn;
                                        break;
                                }
                                focusBtn(btn);
                            }
                        });

                        function focusBtn(btn) {
                            buttonLine.find("button").removeClass("confirm-focus");
                            btn.addClass("confirm-focus");
                        }
                    }

                }
            }
        }).obj(POPUP);
    },
    countryChange: function (container, config) {
        container.find("#countryId").on('change', function () {
            var name = this.name;
            var type;
            if (name.indexOf(".")) {
                type = name.split(".")[0]
            }
            var prefixed = $(this).attr("name").endsWith("default_country");
            var id = $(this).val();
            var data = $.extend({}, {
                id: id,
                inputClass: "large",
                stateLabel: prefixed ? "default.state" : "state",
                stateName: (type ? type + "." : "") + (prefixed ? "default_state" : "state"),
                noSelection: null
            }, config);
            bm.ajax({
                url: app.baseUrl + "app/loadStateForCountry",
                dataType: 'html',
                data: data,
                success: function (data) {
                    container.find(".form-row.state-selector-row").remove();
                    container.find(".form-row.country-selector-row").after(data);
                    container.find(".form-row.state-selector-row").updateUi();
                    container.trigger("state-load");
                }
            })
        });
    },
    countryChangeSelection: function (countrySelect, isMultiple, params) {
        var countryRow = countrySelect.closest(".form-row");
        var stateSelectionRow = countryRow.next('.state-selector-row');
        var postCodeRow = countryRow.siblings('.post-code');
        if (stateSelectionRow) {
            bindStateChange(stateSelectionRow);
        }
        var country = countrySelect.val();
        if (!country || country.length > 1) {
            postCodeRow.hide();
        }
        countrySelect.change(function () {
            var value = $(this).val();
            stateSelectionRow.remove();
            if ((value && value.length == 1) || !isMultiple) {
                $.extend(params, {id: isMultiple ? value[0] : value});
                bm.ajax({
                    url: app.baseUrl + "app/loadStateForCountry",
                    dataType: 'html',
                    data: params,
                    success: function (data) {
                        stateSelectionRow = $(data).insertAfter(countryRow);
                        if (stateSelectionRow) {
                            bindStateChange(stateSelectionRow);
                            stateSelectionRow.updateUi();
                        }
                        countryRow.parents("form").trigger("state-load")
                    }
                });
                postCodeRow.show();
            } else if (isMultiple) {
                postCodeRow.hide();
            }
        });
        function bindStateChange(stateSelectionRow) {
            stateSelectionRow.find("select[name=zone\\.state\\.id]").change(function () {
                var value = $(this).val();
                if (value && value.length > 1) {
                    postCodeRow.hide();
                } else if (postCodeRow) {
                    postCodeRow.show();
                }
            }).trigger("change");
        }
    },
    createMenu: function (entries, parentUiClass) {
        if (entries instanceof $) {
            return entries.addClass("floating-menu")
        }
        var menu = $("<div class='floating-menu' tabindex='0'></div>");
        $.each(entries, function () {
            var ui_class = this.ui_class;
            var item;
            if (ui_class == "item-separator") {
                item = $("<div class='" + ui_class + "'></div>");
            } else {
                item = $("<div class='menu-item'><span class='icon'></span><span class='label'></span></div>");
                if (this.href) {
                    item.addClass(this.ui_class);
                    item = item.wrap("<a></a>").parent().attr("href", this.href).attr("target", this.target || "_self")
                }
                item.find(".label").text(this.text);
                item.addClass(this.ui_class);
                // "__allow_all__" is LicenseManager.CLIENT_LICENSE_ALLOW_ALL — set when enforcement is off
                // (trial / unmanaged / provisioning off), i.e. every feature is unlocked, so don't mark restricted.
                if (this.license && app.licenses && !app.licenses[this.license] && !app.licenses["__allow_all__"]) {
                    item.addClass("restricted insufficient-provision");
                }
                if (this.permission) {
                    item.attr("permission", this.permission)
                }
                item.attr("action", (parentUiClass ? parentUiClass + ">" : "") + (this.action || ui_class));
                if (this.data) {
                    item[0].data = this.data
                }
            }
            var itemEl = item[0];
            menu.append(item);
            if (this.sub) {
                itemEl.sub = bm.createMenu(this.sub, ui_class).addClass("sub-menu")
            }
        });
        return menu;
    },
    attacheCustomEvents: function(panel){
        var _self = panel
        _self.find(".manage-access.customer").on("click", function() {
            _self.loader();
            var customerId = $(this).parent().attr("id");
            var selectedProducts = _self.find('input[name="customerAllowedProducts.'+customerId+'"]').map(function() {
                return $(this).val();
            }).get();

            bm.ajax({
                url: app.baseUrl + "frontEndEditor/loadAllowedProductsByCustomer",
                data: {selectedProducts: selectedProducts, customerId: customerId, name: $(this).parent().attr("name") },
                dataType: 'html',
                success: function(resp) {
                    _self.loader(false);

                    // Show product selector and hide customer selector
                    _self.find(".customer-selector").hide();
                    _self.find(".product-selector").show();

                    // Clear and update product selection UI
                    var productPanel = _self.find(".product-selector .product-selection-dom");
                    productPanel.html(resp);
                    _self.addClass("pre-order-customer-selection-second-popup");
                    productPanel.updateUi();

                    // Handle cancel button to switch back to customer selector
                    productPanel.find(".cancel-button").on("click", function() {
                        _self.find(".customer-selector").show();
                        _self.find(".product-selector").hide();
                        _self.removeClass("pre-order-customer-selection-second-popup");
                    });

                    // Handle assigning products to customer
                    productPanel.find(".assign-products-to-customer").on("click", function() {
                        // Retrieve selected product values
                        const selectedValues = productPanel.find("select[name='selectedProducts']").val();

                        // Ensure a unique container for each customer
                        let customerContainer = _self.find(`.hidden-inputs-container .customer-${customerId}-inputs`);
                        if (customerContainer.length === 0) {
                            // Create a container if it doesn't exist
                            customerContainer = $("<div>", {
                                class: `customer-${customerId}-inputs`
                            });
                            _self.find(".hidden-inputs-container").append(customerContainer);
                        }

                        // Clear previous inputs for the selected customer within its own container
                        customerContainer.empty();

                        // Append hidden inputs for each selected product value
                        selectedValues.forEach(function(value) {
                            const hiddenInput = $("<input>", {
                                type: "hidden",
                                name: "customerAllowedProducts." + customerId,
                                value: value
                            });
                            customerContainer.append(hiddenInput);
                        });

                        // Switch back to the customer selector view
                        _self.find(".customer-selector").show();
                        _self.find(".product-selector").hide();
                        _self.removeClass("pre-order-customer-selection-second-popup");
                    });
                }
            });
        });


        _self.find(".manage-access.customer-group").on("click", function(){
            _self.loader()
            var groupId = $(this).parent().attr("id");
            var selectedProducts = _self.find('input[name="groupAllowedProducts.'+groupId+'"]').map(function() {
                return $(this).val();
            }).get();
            bm.ajax({
                url: app.baseUrl + "frontEndEditor/loadAllowedProductsByCustomer",
                data: { selectedProducts: selectedProducts, groupId: groupId, name: $(this).parent().attr("name") },
                dataType: 'html',
                success: function(resp) {
                    _self.loader(false);

                    // Show product selector and hide customer selector
                    _self.find(".customer-selector").hide();
                    _self.find(".product-selector").show();

                    // Clear and update product selection UI
                    var productPanel = _self.find(".product-selector .product-selection-dom");
                    productPanel.html(resp);
                    _self.addClass("pre-order-customer-selection-second-popup");
                    productPanel.updateUi();

                    // Handle cancel button to switch back to customer selector
                    productPanel.find(".cancel-button").on("click", function() {
                        _self.find(".customer-selector").show();
                        _self.find(".product-selector").hide();
                        _self.removeClass("pre-order-customer-selection-second-popup");
                    });

                    // Handle assigning products to customer
                    productPanel.find(".assign-products-to-customer").on("click", function() {
                        // Retrieve selected product values
                        const selectedValues = productPanel.find("select[name='selectedProducts']").val();

                        // Ensure a unique container for each customer
                        let groupContainer = _self.find(`.hidden-inputs-container .group-${groupId}-inputs`);
                        if (groupContainer.length === 0) {
                            // Create a container if it doesn't exist
                            groupContainer = $("<div>", {
                                class: `group-${groupId}-inputs`
                            });
                            _self.find(".hidden-inputs-container").append(groupContainer);
                        }

                        // Clear previous inputs for the selected customer within its own container
                        groupContainer.empty();

                        // Append hidden inputs for each selected product value
                        selectedValues.forEach(function(value) {
                            const hiddenInput = $("<input>", {
                                type: "hidden",
                                name: "groupAllowedProducts." + groupId,
                                value: value
                            });
                            groupContainer.append(hiddenInput);
                        });

                        // Switch back to the customer selector view
                        _self.find(".customer-selector").show();
                        _self.find(".product-selector").hide();
                        _self.removeClass("pre-order-customer-selection-second-popup");
                    });
                }
            });
        })
    },
    customTooltip: function (url, count, pos, atBottom, atRight, callback) {
        config = {
            auto_close_on_success: true,
            disable_on_submit: true,
            disable_on_invalid: true,
            disable_button_text: undefined,
            modify_ui: true,
            on_load_loader: false
        };
        if (!pos[count - 1].length) {
            count = count + 1;
            atBottom = "7";
            atRight = "-7"
        }
        var events = (config.events || {});
        $(pos[count - 1]).addClass("active");
        events.content_loaded = function (popup) {
            var _self = this;
            _self.updateUi();
            if (count > 2) {
                atBottom = "7";
                atRight = "-7";
                var btn = $("<button type='button' class='submit-button-pre'></button>");
                btn.text($.i18n.prop("prev"));
                _self.find(".pop-bottom").append(btn)
            }
            if (count == 8) {
                _self.find(".submit-button-next").remove();
                var btn = $("<button type='button' class='submit-button-done'></button>");
                btn.text($.i18n.prop("done"));
                _self.find(".pop-bottom").prepend(btn);
                var div = $("<div class='show-next-wrapper'>" + "<input type='checkbox' name='remember' class='single'>" + "<span class='show-next'> Show on next login</span>" + "</div>");
                _self.find(".pop-bottom").append(div)
            }
            var check = true;
            _self.find(".single").on("change", function () {
                check = this.checked ? false : true
            });
            _self.find(".submit-button-done, .submit-button-skip").click(function () {
                bm.ajax({
                    url: app.baseUrl + "user/saveIsMatured",
                    data: {check: check},
                    success: function (resp) {
                        if (callback && callback.getStart) {
                            callback.getStart();
                        }
                    }
                });
                popup.close(1);
                $(pos[count - 1]).removeClass("active")
            });
            _self.find(".submit-button-next").click(function () {
                count++;
                popup.close(1);
                $(pos[count - 2]).removeClass("active");
                atBottom = "7";
                atRight = "-7";
                atRight = (count == 3) ? "+15" : "-7";
                if (count < pos.length + 1) {
                    bm.customTooltip(app.baseUrl + "dashboard/loadOnScreenHelp", count, pos, atBottom, atRight, callback);
                }
            });
            _self.find(".submit-button-pre").click(function () {
                popup.close(1);
                if (count > 1) {
                    $(pos[count - 1]).removeClass("active");
                    count--;
                    switch (count) {
                        case 1:
                            atBottom = "100";
                            atRight = "-100";
                            break;
                        case 3:
                            atBottom = "7";
                            atRight = "+15";
                            break;
                        default :
                            atBottom = "7";
                            atRight = "-7"
                    }
                }
                bm.customTooltip(app.baseUrl + "dashboard/loadOnScreenHelp", count, pos, atBottom, atRight, callback)
            });
            _self.find(".tool-tip-close").click(function () {
                $(pos[count - 1]).removeClass("active");
                popup.close(1);
                if (callback && callback.getStart) {
                    callback.getStart(1);
                }
            });
            _self.addClass("loaded")
        };
        delete config.events;
        return new POPUP($.extend({
            template: '<div></div>',
            show_title: false,
            width: 380,
            height: 150,
            ajax_url: url,
            ajax_settings: {
                data: {count: count, wizard: pos[0].length ? true : null}
            },
            ui_position: {
                my: "right top+10",
                at: "right" + atRight + " bottom+" + atBottom,
                of: pos[count - 1]
            },
            draggable: false
        }, config, {clazz: "tool-tip-popup", events: events}))
    },
    disableTextSelection: function (_document) {
        if (!_document) {
            _document = document
        }
        if (browser.ff) {
            bm.clearTextSelection(_document);
            _document.body.style["MozUserSelect"] = "none"
        } else {
            _document.onselectstart = function () {
                return false;
            }
        }
    },
    // HWC-4202 — the one unsaved-changes guard for widget edit popups.
    //
    // Four popups had grown their own copy of this state machine and each copy dropped a
    // different defence: the baseline read a tick late so a rich-text editor's own init does
    // not read as an edit, the try/catch that stops an unreadable snapshot trapping the user,
    // the re-entrancy flag that stops a second confirm stacking over the first, and the
    // debounce. Everything that guards a popup now shares this one.
    //
    // config:
    //   snapshot {Function} returns a String describing the popup's current content. May be
    //                       omitted and supplied later through setSnapshot() — several popups
    //                       cannot describe their content until their markup has loaded.
    //   close    {Function} called with the original exit code to actually dismiss the popup.
    //   isClosed {Function} optional; true when the popup went away before the deferred
    //                       baseline could be taken.
    //   onChange {Function} optional; called with the current dirty flag after each re-check —
    //                       where a caller enables or disables its own submit button.
    //   message  {String}   optional confirm text; defaults to the shared prompt.
    //   defer    {Boolean}  optional, default true; see setSnapshot().
    dirtyGuard: function (config) {
        var DEBOUNCE_MS = 150;
        var _snapshot = config.snapshot || null;
        var _baseline = null;
        var _armed = false;
        var _disarmed = false;
        var _confirming = false;
        var _reading = false;
        var _suspended = false;
        var _timer = null;
        var _suspend_timer = null;

        function readSnapshot() {
            if (!_snapshot) {
                return null;
            }
            _reading = true;
            try {
                return _snapshot();
            }
            catch (ex) {
                // A snapshot we cannot read must not trap the user behind a confirm they can
                // never satisfy, nor behind a permanently disabled button — log it and let the
                // popup behave as it did before the guard existed.
                log("dirty guard snapshot failed", ex);
                return null;
            }
            finally {
                // Released a tick later, not inline: a snapshot that flushes a rich-text editor
                // makes it broadcast its own change, and that must not be read as a user edit —
                // it would schedule another snapshot, which would flush again, forever.
                setTimeout(function () {
                    _reading = false;
                }, 0);
            }
        }

        function isDirty() {
            if (!_armed || _disarmed) {
                return false;
            }
            var current = readSnapshot();
            return current !== null && current !== _baseline;
        }

        // False until a baseline has been read, and false again if reading it failed. A caller
        // that disables its submit button up front must re-enable it while this stays false.
        function isArmed() {
            return _armed;
        }

        // Publishes the current state immediately. Callers bind refresh() to events and let it
        // debounce; this is for the moments that must not wait, such as the first state after a
        // baseline is taken.
        function syncNow() {
            if (config.onChange) {
                config.onChange(isDirty());
            }
        }

        function refresh() {
            // Changes the guard itself provoked while reading are not user edits, and nor is
            // anything inside a suspendWhileRewriting() window.
            if (_reading || _suspended) {
                return;
            }
            if (_timer) {
                clearTimeout(_timer);
            }
            _timer = setTimeout(syncNow, DEBOUNCE_MS);
        }

        // Adopts the popup's current content as the "unchanged" state. Callers re-take the
        // baseline when something that is NOT a user edit has rewritten the content — a
        // rich-text editor initialising late is the case this exists for.
        function rebaseline() {
            if (config.isClosed && config.isClosed()) {
                return;
            }
            // A refresh already scheduled describes the content this baseline is replacing, so
            // letting it land would report the state we are about to discard.
            if (_timer) {
                clearTimeout(_timer);
                _timer = null;
            }
            _baseline = readSnapshot();
            // An unreadable baseline is nothing later reads can be compared against: every one
            // of them would differ from null, so the popup would be dirty from the moment it
            // opened — confirming on every close and offering a submit with nothing to submit.
            // Stay disarmed instead, and the popup behaves as it did before the guard existed.
            _armed = _baseline !== null;
            syncNow();
        }

        // For a rich-text editor that initialises LATE — lazily, on a click, long after the
        // popup opened. It rewrites the content it was handed (attribute order, entities, bare
        // text wrapped in <p>) and broadcasts that rewrite as a change, which lands after the
        // baseline and would read as a user edit. Changes inside the window are dropped and the
        // rewritten content becomes the new baseline when it closes. Callers pass a window
        // longer than DEBOUNCE_MS so no refresh the init provoked can outlive it.
        //
        // Declines to open a window once the popup is already dirty: an edit the user made
        // before this point has to keep counting, and re-baselining would silently forgive it.
        function suspendWhileRewriting(durationMs) {
            // Already inside a window — a second editor initialising while the first still
            // settles. Extend it rather than re-testing isDirty(), which by now sees the first
            // init's rewrite and would refuse, leaving the second one to count as an edit.
            if (!_suspended && isDirty()) {
                return;
            }
            _suspended = true;
            if (_timer) {
                clearTimeout(_timer);
                _timer = null;
            }
            if (_suspend_timer) {
                clearTimeout(_suspend_timer);
            }
            _suspend_timer = setTimeout(function () {
                _suspended = false;
                _suspend_timer = null;
                rebaseline();
            }, durationMs);
        }

        function setSnapshot(snapshotFn) {
            _snapshot = snapshotFn;
            if (config.defer === false) {
                rebaseline();
                return;
            }
            // The baseline is read one tick later, never inline: initialising a rich-text editor
            // both broadcasts `editor.set` — bridged to a `change` on the textarea that is NOT a
            // user edit — and normalises the HTML it was handed. Reading before those settle
            // would bake a false difference into the baseline and light the submit button up on
            // open, the exact bug this guards against.
            setTimeout(rebaseline, 0);
        }

        // Only a popup framework's own `beforeClose` config callback can veto a close, because
        // that is the one whose return value is tested for `false`; handlers registered through
        // popup.on() are dispatched by jQuery .trigger(), which hands back the collection and so
        // can never cancel. One hook covers the ✕, Escape, a mask click and a cancel button
        // alike, since all of them route through close().
        function beforeClose(exitCode) {
            if (!isDirty()) {
                return;
            }
            // Escape and the backdrop stay live behind the confirm, so a second press would
            // otherwise stack a second confirm over the first.
            if (_confirming) {
                return false;
            }
            _confirming = true;
            // Yes/No only — passing a fourth (cancel) handler would render a third button, and
            // "No" and "Cancel" mean the same thing here. The dialog's ✕ falls back to the
            // no-handler, so dismissing it any way resets the flag.
            bm.confirm(config.message || $.i18n.prop("unsaved.content.will.reset.are.you.sure"), function () {
                // The user accepted losing the edits — let the re-entrant close through.
                _disarmed = true;
                config.close(exitCode);
            }, function () {
                _confirming = false;
            });
            return false;
        }

        // The edits are persisted, so a close from here on is not data loss.
        function clear() {
            _disarmed = true;
        }

        function watch(element) {
            element.on("change.wcDirtyGuard input.wcDirtyGuard keyup.wcDirtyGuard", refresh);
        }

        // Adding, copying, removing, picking an icon and renaming inline all mutate the DOM from
        // a click inside the popup, several without firing any form event. Re-checking one tick
        // after any click covers every one of them — including handlers added later — instead of
        // each one remembering to call refresh(). Anything finishing outside that window (a
        // drag-reorder, an animated removal, a picker in its own popup where this delegated
        // click never lands) still calls refresh() itself.
        function watchClicks(element) {
            element.on("click.wcDirtyGuard", function () {
                setTimeout(refresh, 0);
            });
        }

        if (_snapshot) {
            setSnapshot(_snapshot);
        }

        return {
            setSnapshot          : setSnapshot,
            suspendWhileRewriting: suspendWhileRewriting,
            refresh              : refresh,
            isDirty              : isDirty,
            isArmed              : isArmed,
            beforeClose          : beforeClose,
            clear                : clear,
            watch                : watch,
            watchClicks          : watchClicks
        };
    },
    editPopup: function (url, title, emphasized, data, config) {
        config = $.extend({}, {
            auto_close_on_success: true,
            disable_on_submit: true,
            disable_on_invalid: true,
            disable_button_text: undefined,
            modify_ui: true,
            width: 500,
            form_selector: ".edit-popup-form",
            buttonLine: "button-line",
            scroll: true
        }, config);
        var events = (config.events || {});
        var _caller_content_loaded = events ? events.content_loaded : undefined;
        // HWC-4202 — opt-in unsaved-changes guard. A caller passes
        //     dirty_guard: {snapshot: function (form) { return <string> }}
        // and the popup then (a) keeps the submit button disabled until that snapshot differs
        // from the one taken when the popup opened, and (b) confirms before closing while it
        // still differs. Opt-in on purpose: editPopup backs ~350 popups across the admin and
        // the overwhelming majority must keep opening enabled and closing silently.
        var DIRTY_GUARD_LOCK_ID = "wc-dirty-guard";
        var _dirty_guard = config.dirty_guard;
        var _dirty_guard_form = null;
        var _dirty_guard_instance = null;
        // Mirrors armDirtyGuard's opening lock, so the first refresh only acts on a real change.
        var _dirty_guard_locked = true;

        function applyDirtyGuardLock(isDirty) {
            // Unchanged content holds the lock (button disabled); an edit releases it. Keyed, so
            // validation and submit keep their own holds and the button only ever re-enables
            // once every holder has released — this composes with them instead of fighting.
            // A guard that never armed — its baseline was unreadable — releases the lock for
            // good, because the popup then has to submit exactly as it did before the guard.
            var shouldLock = !isDirty && _dirty_guard_instance != null && _dirty_guard_instance.isArmed();
            // form lock/unlock each fire an event on the form; only act on a real transition so
            // typing does not republish them every debounce tick.
            if (shouldLock === _dirty_guard_locked) {
                return;
            }
            _dirty_guard_locked = shouldLock;
            _dirty_guard_form.form(shouldLock ? "lock" : "unlock", DIRTY_GUARD_LOCK_ID);
        }

        function armDirtyGuard(popup, form) {
            _dirty_guard_form = form;
            form.form("lock", DIRTY_GUARD_LOCK_ID);
            _dirty_guard_instance = bm.dirtyGuard({
                message : _dirty_guard.message,
                isClosed: function () {
                    return popup.is_closed;
                },
                close   : function (exitCode) {
                    popup.close(exitCode);
                },
                onChange: applyDirtyGuardLock
            });
            // Deferred by the guard, never read inline: updateUi() above initialises the
            // rich-text editor, which both broadcasts `editor.set` and normalises the HTML it
            // was handed, and neither is a user edit.
            _dirty_guard_instance.setSnapshot(function () {
                return _dirty_guard.snapshot.call(form, form);
            });
            _dirty_guard_instance.watch(form);
        }

        events.content_loaded = function (popup) {
            var form = this.find(config.form_selector);
            var newSubmit;
            if (typeof(config.buttonLine) == "string") {
                var buttonLine = form.find("." + config.buttonLine);
                newSubmit = buttonLine.clone();
                buttonLine.remove();
            } else {
                newSubmit = config.buttonLine
            }
            var button = newSubmit.find(".submit-button, button[type=submit]").addClass("edit-popup-form-submit").on("click", function () {
                form.submit();
            });
            this.append(newSubmit);
            if (config.scroll) {
                this.find("> .content").scrollbar({
                    reduce_margin_from_offset: false,
                    vertical: {
                        offset: 0
                    }
                });
            }
            this.updateUi();
            var _success = (config.ajax && config.ajax.success) || config.success;
            form.form({
                ajax: this.find(".edit-popup-form").attr("no-ajax") == null,
                disable_on_submit: config.disable_on_submit,
                disable_on_invalid: config.disable_on_invalid,
                disable_button_text: config.disable_button_text,
                submitButton: button,
                preSubmit: function (ajaxSettings) {
                    $.extend(ajaxSettings, {
                        response: config.response,
                        error: config.error
                    }, config.ajax, {
                        success: function () {
                            // The edits are persisted, so the close below is not data loss.
                            if (_dirty_guard_instance) {
                                _dirty_guard_instance.clear();
                            }
                            if (config.auto_close_on_success) {
                                popup.close();
                            }
                            if (_success) {
                                _success.apply(this, arguments);
                            }
                        }
                    });
                    if (config.beforeSubmit) {
                        return config.beforeSubmit.call(popup.getDom(), form, ajaxSettings ? (ajaxSettings.data = ajaxSettings.data || {}) : null, popup);
                    }
                }
            });
            form.find("[default-focus]").focus();
            var tabs = form.find(".bmui-tab:first");
            if (tabs.length) {
                form.on("invalid", function (ev, field) {
                    if (tabs.tabs && tabs.tabs instanceof Function) {
                        tabs.tabs("activate", field.validator.elm);
                    }
                })
            }
            this.find(".cancel-button").click(function () {
                popup.close(1);
            });
            popup.on("content-change", function (ev, added, removed) {
                if (added) {
                    form.obj(ValidationPanel).attach(added.filter("[validation]").add(added.find("[validation]")));
                }
                if (removed) {
                    form.obj(ValidationPanel).detach(removed.filter("[validation]").add(removed.find("[validation]")));
                }
            });
            form.on("trash-restore", function () {
                popup.close();
            });
            if (_caller_content_loaded) {
                _caller_content_loaded.apply(this, [popup, form]);
            }
            // Armed last so the caller's own content_loaded — which may swap in the content the
            // user is meant to start from — has already run when the baseline is taken.
            if (_dirty_guard) {
                armDirtyGuard(popup, form);
            }
        };
        if (_dirty_guard) {
            var _caller_before_close = events.beforeClose;
            // This must be POPUP's own `events.beforeClose` — see bm.dirtyGuard for why no other
            // hook can veto a close.
            events.beforeClose = function (exitCode) {
                // Null until content_loaded armed it, so a popup dismissed while still loading
                // closes silently rather than throwing on the way out.
                if (_dirty_guard_instance && _dirty_guard_instance.beforeClose(exitCode) === false) {
                    return false;
                }
                // Deliberately reached only on the close that actually proceeds, so a caller's
                // own hook runs exactly once rather than firing again on the re-entrant close.
                if (_caller_before_close) {
                    return _caller_before_close.apply(this, arguments);
                }
            };
        }
        delete config.events;
        delete config.dirty_guard;
        var editPopupInstance = new POPUP($.extend({
            title: title + (emphasized ? " - <span class='emphasized'>" + bm.htmlEncode(emphasized) + "</span>" : ""),
            width: 430,
            ajax_url: url,
            ajax_settings: {
                data: data
            },
            draggable: false
        }, config, {clazz: "edit-popup" + (config.clazz ? " " + config.clazz : ""), events: events}));
        // For callers whose `beforeSubmit` runs its own ajax and closes the popup itself:
        // editPopup's success wrapper never fires for them, so they report the save here.
        editPopupInstance.clearDirtyState = function () {
            if (_dirty_guard_instance) {
                _dirty_guard_instance.clear();
            }
        };
        return editPopupInstance;
    },
    enableTextSelection: function (_document) {
        if (!_document) {
            _document = document
        }
        if (browser.ff) {
            _document.body.style["MozUserSelect"] = ""
        } else {
            _document.onselectstart = null;
        }
    },
    errorHighlight: function (item, time) {
        item.addClass("error-highlight");
        setTimeout(function () {
            item.removeClass("error-highlight");
        }, time ? time : 1000);
    },
    floatingPanel: function (ref, url, data, conf) {
        conf = conf ? conf : {};
        conf.clazz = "floating-panel-popup fee-identical-sewc-elm" + (conf.clazz ? " " + conf.clazz : "")
        var popup = new POPUP($.extend({
            ajax_url: url,
            ajax_settings: {
                data: data
            },
            show_title: false,
            masking: false,
            show_close: false,
            close_on_blur: true,
            modal: false,
            is_center: false,
            width: 350,
            ui_position: {
                my: "right top",
                at: "right+10 bottom+7",
                of: ref,
                collision: conf.position_collison
            }
        }, conf));
        return popup
    },

    toolTipPopup: function (ref, url, data, conf) {
        conf = conf ? conf : {};
        conf.clazz = "tool-tip-popup" + (conf.clazz ? " " + conf.clazz : "")
        var popup = new POPUP($.extend({
            ajax_url: url,
            ajax_settings: {
                data: data
            },
            show_title: false,
            masking: false,
            show_close: false,
            close_on_blur: true,
            modal: false,
            is_center: false,
            width: 350,
            ui_position: {
                my: "right top",
                at: "right+10 bottom+7",
                of: ref,
                collision: conf.position_collison
            }
        }, conf));
        return popup
    },
    floatingPopup: function (_content, _config) {
        _content.find(".popup-body").hide()
        _content.find(".action-navigator").click(function () {
            var config = $.extend({}, _config)
            var navigator = this.jqObject;
            var popup = navigator.data("popup")
            if(popup) {
                popup.show();
                return;
            }
            var body = navigator.next(".popup-body");
            config = $.extend({
                content: body,
                position_collison: "none",
                events: {
                    content_loaded: function (popup) {
                        body.show();
                    }
                }
            }, config);

            popup = bm.floatingPanel(navigator, null, {}, config);
            popup.close = popup.hide;
            navigator.data("popup", popup)
        })
        return _content
    },

    getTopScroller: function (_document) {
        return $(/webkit/i.test(navigator.userAgent) || _document.compatMode == 'BackCompat' ? _document.body : _document.documentElement)
    },
    highlight: function (item, time, blink) {
        item.addClass("highlight-row" + (blink ? " blink" : ""));
        setTimeout(function () {
            item.removeClass("highlight-row" + (blink ? " blink" : ""));
        }, time ? time : 3000);
    },
    initArticleSelection: function (container, fieldName, actions) {
        if (typeof fieldName == "undefined") {
            fieldName = "article"
        }
        var _actions = $.extend({
            tab: null,
            view: false,
            edit: false,
            "column-sort": true
        }, actions);
        var articleSelector = this.twoSideSelection(container, 10, "article", app.baseUrl + "content/loadArticlesForSelection", _actions, [fieldName]);
        var sectionSelector = container.find("select.section-selector").change(function () {
            articleSelector.reload();
        });
        var articleSorting = container.find("select.article-sorting").change(function () {
            articleSelector.reload();
        });
        container.find(".icon-search").click(function () {
            articleSelector.reload();
        });
        articleSelector.beforeLoadTableContent = function (params) {
            var _param = {
                searchText: container.find("input.search-text").val(),
                section: sectionSelector.val(),
                sortBy: articleSorting.val()
            };
            $.extend(params, _param)
        };
        container.find(".filter-block").form({
            disable_on_submit: false,
            preSubmit: function () {
                articleSelector.reload();
            }
        });
        articleSelector.onViewClick = function (type, value, name, row) {
            app.tabs.content.viewArticle(value["article"]);
        };
        articleSelector.onEditClick = function (type, value, name, row) {
            app.tabs.content.editArticle(value[fieldName], name, _actions.tab);
        };
        return articleSelector
    },
    initCategorySelection: function (container, fieldName, actions) {
        if (typeof fieldName == "undefined") {
            fieldName = "category"
        }
        var _actions = $.extend({
            tab: null,
            view: false,
            edit: false,
            "column-sort": true
        }, actions);
        var categorySelector = this.twoSideSelection(container, 10, "category", app.baseUrl + "categoryAdmin/loadCategoriesForSelection", _actions, [fieldName]);
        var categorySorting = container.find("select.category-sorting").change(function () {
            categorySelector.reload();
        });
        categorySelector.beforeLoadTableContent = function (params) {
            var _param = {
                searchText: container.find("input.search-text").val(),
                sortBy: categorySorting.val()
            };
            $.extend(params, _param);
        };
        container.find(".filter-block").form({
            disable_on_submit: false,
            preSubmit: function () {
                categorySelector.reload();
            }
        });
        categorySelector.onEditClick = function (type, value, name, row) {
            app.tabs.item.editCategory(value[fieldName], name, _actions.tab);
        };
        return categorySelector
    },
    initAdvancedSearchSelection: function (container, fieldName, actions) {
        if (typeof fieldName == "undefined") {
            fieldName = "search"
        }
        var _actions = $.extend({
            tab: null,
            view: false,
            edit: false,
            "column-sort": true
        }, actions);
        var itemName = "category"
        var searchSelector = this.twoSideSelection(container, 10, "category", app.baseUrl + "categoryAdmin/loadCategoriesForAdvancedSelection", _actions, [fieldName]);
        var searchSorting = container.find("select.search-sorting").change(function () {
            searchSelector.reload();
        });
        searchSelector.beforeLoadTableContent = function (params) {
            var _param = {
                searchText: container.find("input.search-text").val(),
                sortBy: searchSorting.val()
            };
            $.extend(params, _param);
        };
        container.find(".filter-block").form({
            disable_on_submit: false,
            preSubmit: function () {
                searchSelector.reload();
            }
        });
        searchSelector.onEditClick = function (type, value, name, row) {
            app.tabs.item.editCategory(value[itemName], name, _actions.tab);
        };
        return searchSelector
    },
    /**
     * HWC-4774: address type-ahead for an ADMIN (front-end editor) address form, governed by the same Site Settings
     * toggle as checkout and the customer profile (app.isAutoSuggestionAddressLineEnable). Admin forms open in
     * popups, often before the Maps script has loaded, so this waits for it instead of returning on the spot.
     *
     * @param form   the jQuery form holding the address
     * @param fields optional jQuery fields for forms that do not use the default names - addressLine1, postCode,
     *               city, country, lat, lng (see initAutoAddressSuggest)
     */
    initAdminAddressSuggest: function (form, fields) {
        // The Maps script is only injected when the setting is on, so skip the 20s wait for it otherwise.
        if (!form || !form.length || app.isAutoSuggestionAddressLineEnable != "true") {
            return;
        }
        fields = fields || {};
        bm.whenGoogleMapsPlacesReady(function () {
            form.each(function () {
                var addressForm = $(this);
                var addressLine1 = fields.addressLine1 || addressForm.find("input[name=addressLine1]");
                // Forms without an address line (e.g. a popup's search form) have nothing to suggest into.
                if (!addressLine1.length) {
                    return;
                }
                bm.initAutoAddressSuggest(addressForm, addressLine1, fields.postCode, fields.city, fields.country, fields.lat, fields.lng, false, {keepAddressOnRegionChange: true});
            });
        });
    },
    /**
     * HWC-4774: the store address (Settings -> Store Details) names its fields with an "address." prefix, so they
     * are handed over explicitly - the same set the legacy admin's feature.setting.js passes.
     */
    initStoreAddressSuggest: function (container) {
        var addressLine1 = container.find('input[name="address.addressLine1"]');
        var form = addressLine1.closest("form");
        bm.initAdminAddressSuggest(form, {
            addressLine1: addressLine1,
            postCode: form.find('input[name="address.postCode"]'),
            country: form.find('select[name="address.country"]'),
            city: form.find('input[name="city"]').length ? form.find('input[name="city"]') : form.find('select[name="city"]')
        });
    },
    /**
     * HWC-4774: runs the callback once Google Maps (with Places) is on the page, loading it if needed. The admin shell
     * only loads Maps while the address suggestion setting is on; fields that use Places regardless of that setting
     * (the shipping zone's radius origin) load it themselves through this.
     */
    withGoogleMapsPlaces: function (callback) {
        if (typeof google !== "undefined" && google.maps && google.maps.places) {
            callback();
            return;
        }
        if (!document.querySelector("script[scriptType='mapApi']")) {
            bm.addScript("https://maps.googleapis.com/maps/api/js?key=" + app.googleMapApiKey + "&libraries=places&v=weekly", true, "mapApi");
        }
        bm.whenGoogleMapsPlacesReady(callback);
    },
    /**
     * HWC-4774: waits for google.maps.places itself. bm.onReady(window, "google") is not enough - another Google script
     * (Sign-In, for one) defines window.google long before Maps lands, which fired the callback with no Places to use.
     */
    whenGoogleMapsPlacesReady: function (callback) {
        var pollIntervalMs = 500;
        var attemptsLeft = 60;
        (function poll() {
            if (typeof google !== "undefined" && google.maps && google.maps.places) {
                callback();
                return;
            }
            if (--attemptsLeft > 0) {
                setTimeout(poll, pollIntervalMs);
            }
        })();
    },
    /**
     * @param options keepAddressOnRegionChange - leave the typed address alone when the country or state changes.
     *                Checkout clears it; an admin correcting one field of a saved address must not lose the rest.
     */
    initAutoAddressSuggest: function (form, addressLine1, postCode, city, country, lat, lng, isEnable, options) {
        var keepAddressOnRegionChange = !!(options && options.keepAddressOnRegionChange);
        // The Maps script is loaded async, so the DOM-ready callers (advance-checkout2.0.js
        // reinitializeAddressFormHandlers) always reach this before the API lands. That used to throw a
        // ReferenceError on `google`, get caught below, and print a full stack on every checkout load for
        // a condition that is expected and self-correcting - the loader's onload calls this again once the
        // API is there. Return quietly instead. The places check matters too: the API can be present
        // without that library, which is exactly what a malformed libraries= parameter used to produce.
        if (typeof google === "undefined" || !google.maps || !google.maps.places) {
            return;
        }
        try {
            let resetAddress = true
            if (!form) {
                var forms = $("form")
                $.each(forms, function () {
                    var thisForm = this.jqObject
                    bm.initAutoAddressSuggest(thisForm, addressLine1, postCode, city, country, lat, lng, isEnable)
                });
                return;
            }

            if (app.isAutoSuggestionAddressLineEnable == "true" || isEnable) {
                let autocomplete;
                let address1Field;
                let address2Field;
                let postalField;
                let countryField;
                let cityField;
                let stateField;
                let latField;
                let lngField;

                function initAutocomplete() {
                    address1Field = addressLine1 ? addressLine1 : form.find("input[name=addressLine1]");
                    if (address1Field) {
                        address2Field = form.find("input[name=addressLine2]");
                        postalField = postCode ? postCode : form.find("input[name=postCode]");
                        countryField = country ? country : form.find('select[name="country.id"]');
                        cityField = city ? city : (form.find('input[name=city]').length ? form.find('input[name=city]') : form.find('select[name=city]'));
                        latField = lat ? lat : form.find('input[name=lat]');
                        lngField = lng ? lng : form.find('input[name=lng]');
                        stateField = form.find('#state');
                        // HWC-4774: the country select the caller handed in (store details names it address.country,
                        // the order editor countryId) - not always select[name="country.id"].
                        var selectedCountry = countryField.find('option:selected').text()
                        var selectedCountryCode
                        if(selectedCountry){
                            selectedCountryCode = getCountryCode(selectedCountry)
                        }
                        if (address1Field[0]) {
                            // The flag lives on the field: the no-arg call in site-editor.js can reach an admin
                            // form after the form's own call and must not turn the clearing back on.
                            if (keepAddressOnRegionChange) {
                                $.data(address1Field[0], "wcKeepAddressOnRegionChange", true);
                            }
                            else {
                                keepAddressOnRegionChange = !!$.data(address1Field[0], "wcKeepAddressOnRegionChange");
                            }
                            // HWC-4774: one Autocomplete per field. This runs more than once for the same field
                            // (the no-arg call in site-editor.js once Maps loads, the form's own call, checkout
                            // re-inits), and each new instance opened its own suggestion list. Reuse it and drop
                            // the old place_changed listener, which belongs to a stale closure.
                            autocomplete = $.data(address1Field[0], "wcAutocomplete");
                            var previousListener = $.data(address1Field[0], "wcPlaceChangedListener");
                            if (previousListener) {
                                google.maps.event.removeListener(previousListener);
                            }
                            if (!autocomplete) {
                                autocomplete = new google.maps.places.Autocomplete(address1Field[0], {
                                    fields: ["address_components", "geometry", "formatted_address"],
                                    types: ["address"],
                                });
                                $.data(address1Field[0], "wcAutocomplete", autocomplete);
                            }
                            if(autocomplete && selectedCountryCode){
                                autocomplete.setComponentRestrictions({ country: selectedCountryCode });
                            }
                            $.data(address1Field[0], "wcPlaceChangedListener", autocomplete.addListener('place_changed', function (e) {
                                fillInAddress()
                                site.hook.fire("place_changed", {form: form});
                            }));
                        }

                        // Namespaced off/on, NOT .change(): initAutoAddressSuggest runs again on every
                        // reinitializeAddressFormHandlers (checkout construction, each shipping-address
                        // toggle) and once more from the Maps loader's onload. Each run used to STACK
                        // another handler, and each closure owns its own `resetAddress`. fillInAddress
                        // clears the flag on the newest closure only, so the stale handlers still saw
                        // `true` and wiped address/state/city/postcode on the country change that
                        // fillInAddress itself triggers - which is why the FIRST address pick appeared to
                        // do nothing and the second worked (by then the country already matched, so no
                        // change event fired). The namespace keeps other listeners on the select intact.
                        countryField.off('change.wcAutoAddress').on('change.wcAutoAddress', function() {
                            selectedCountryCode = getCountryCode($(this).find("option:selected").text());
                            if (autocomplete && selectedCountryCode) {
                                autocomplete.setComponentRestrictions({ country: selectedCountryCode });
                            }
                            if(resetAddress && !keepAddressOnRegionChange){
                                address1Field.val('');
                                form.find('input[name=state]').val('');
                                cityField.val('');
                                postalField.val('');
                            }
                            resetAddress = true
                        });

                        // State change handler - reset address fields when state is manually changed
                        form.find('#state').off('change.wcAutoAddress').on('change.wcAutoAddress', function() {
                            if (resetAddress && !keepAddressOnRegionChange) {
                                if (address1Field && address1Field.length) {
                                    address1Field.val('');
                                }
                                if (postalField && postalField.length) {
                                    postalField.val('');
                                }
                                if (cityField && cityField.length) {
                                    cityField.val('');
                                }
                            }
                        });

                    }
                }

                // The suburb/city control is re-rendered by bm.initCityValidator whenever the state or the
                // postcode changes, so a value written before that ajax returns is discarded and the fresh
                // dropdown falls back to its first suburb. Stash the suggested suburb on the container too:
                // the reload posts it up and the server re-selects it.
                function stashCityName(cityName) {
                    if (cityName) {
                        form.find(".city-selector-row").data("preferred-city", cityName);
                    }
                }

                // cityField is captured once at init and goes stale on every city-selector reload, so
                // re-resolve it from the DOM before writing the suggested suburb into it.
                function applyCityName(cityName, reloadPending) {
                    stashCityName(cityName);
                    var cityContainer = form.find(".city-selector-row");
                    // Match on [name] so chosen's own search input - which carries no name - cannot be
                    // picked up here and have the suburb written into it alongside the real control.
                    var field = cityContainer.length ? cityContainer.find(":input[name]").first() : $();
                    if (!field.length) {
                        field = cityField;
                    }
                    if (!field || !field.length) {
                        return;
                    }
                    if (!field.is("select")) {
                        field.val(cityName);
                        return;
                    }
                    var option = field.find("option").filter(function () {
                        return this.value === cityName;
                    });
                    if (option.length) {
                        field.val(cityName);
                    } else if (!reloadPending && cityName && postalField.length) {
                        // The list still belongs to the previous postcode and nothing else will reload it.
                        postalField.trigger("change");
                    }
                }

                // formatted_address ends with the suburb, state, post code and country, which are filled into
                // their own fields below. Keep only the street part so they are not repeated in address line 1.
                function streetPartOfAddress(place) {
                    var formatted = place && place.formatted_address;
                    if (!formatted || !place.address_components) {
                        return formatted;
                    }
                    var localityTypes = ["locality", "postal_town", "sublocality", "sublocality_level_1", "administrative_area_level_1",
                        "administrative_area_level_2", "postal_code", "postal_code_suffix", "country"];
                    var localityParts = [];
                    var hasCountry = false;
                    place.address_components.forEach(function (component) {
                        if (component.types.some(function (type) { return localityTypes.indexOf(type) > -1; })) {
                            localityParts.push(component.long_name.toLowerCase(), component.short_name.toLowerCase());
                            hasCountry = hasCountry || component.types.indexOf("country") > -1;
                        }
                    });
                    localityParts.sort(function (a, b) { return b.length - a.length; });
                    var segments = formatted.split(",").map(function (segment) { return segment.trim(); });
                    // Google always ends the formatted address with the country, sometimes spelled differently (USA, UK)
                    if (hasCountry && segments.length > 1) {
                        segments.pop();
                    }
                    while (segments.length > 1) {
                        var rest = " " + segments[segments.length - 1].toLowerCase() + " ";
                        localityParts.forEach(function (part) {
                            rest = rest.split(" " + part + " ").join("  ");
                        });
                        if (rest.replace(/[\s.\-]+/g, "")) {
                            break;
                        }
                        segments.pop();
                    }
                    return segments.join(", ");
                }

                function fillInAddress() {
                    isNeedToValidAddress = false;
                    form.loader(false)
                    form.loader();
                    const place = autocomplete.getPlace();
                    let address1 = streetPartOfAddress(place);
                    let postcode = "";
                    let countryName = "";
                    let stateName = "";
                    let cityName = "";
                    address1Field.val(address1 || (place ? place.name : ""));
                    if (place.geometry && place.geometry.location) {
                        latField.val(place.geometry.location.lat());
                        lngField.val(place.geometry.location.lng());
                    } else {
                        latField.val("");
                        lngField.val("");
                    }


                    // address1Field.trigger("change");
                    if (place.address_components) {
                        for (const component of place.address_components) {
                            const componentType = component.types[0];
                            switch (componentType) {
                                case "postal_code":
                                    postcode = `${component.long_name}${postcode}`;
                                    break;
                                case "postal_code_suffix":
                                    postcode = `${postcode}-${component.long_name}`;
                                    break;
                                case "locality":
                                    cityName = component.long_name;
                                    break;
                                case "administrative_area_level_1":
                                    stateName = component.long_name;
                                    break;
                                case "country":
                                    countryName = component.long_name;
                                    break;
                            }
                        }
                    }
                    // Stash before any country/state change: bm.initCityValidator reloads the suburb list
                    // on those events and needs the suggested suburb in order to re-select it.
                    stashCityName(cityName);
                    var countrySelectObject = countryField;
                    var countryChanged = false;
                    if (countryField.length) {
                        resetAddress = false
                        var currentCountry = countrySelectObject.find('option:selected').text();
                        var countryItem = countrySelectObject.find('option').filter(function () {
                            if ($(this).text() == countryName) {
                                return $(this)
                            }
                        });
                        if (countryItem.length && currentCountry !== countryName) {
                            countryChanged = true;
                            countryItem.prop('selected', true);
                            countrySelectObject.trigger("change");
                            if (app.admin_id) {
                                countrySelectObject.trigger("chosen:updated");
                            }
                        }
                    }

                    // Set postal code immediately
                    if (postalField.length) {
                        postalField.val(postcode);
                    }

                    // If country changed, wait for state dropdown to load before setting state
                    if (countryChanged && stateName) {
                        form.one("state-load", function() {
                            var newStateField = form.find('#state');
                            if (newStateField.length) {
                                newStateField.find('option').each(function() {
                                    if ($(this).text() === stateName) {
                                        $(this).prop('selected', true);
                                        newStateField.change();
                                        if (app.admin_id) {
                                            newStateField.trigger("chosen:updated");
                                        }
                                        return false;
                                    }
                                });
                            }
                            // Set city after state is loaded. The reload triggered by the state change
                            // already carries the stashed suburb, so no extra reload is needed here.
                            applyCityName(cityName, true);
                            form.loader(false);
                        });
                    } else {
                        // Country didn't change, set state immediately
                        var stateChanged = false;
                        if (stateField.length && stateName) {
                            stateField.find('option').each(function() {
                                if ($(this).text() === stateName) {
                                    $(this).prop('selected', true);
                                    stateChanged = true;
                                    stateField.change();
                                    if (app.admin_id) {
                                        stateField.trigger("chosen:updated");
                                    }
                                    return false;
                                }
                            });
                        }
                        // A state change already reloads the suburb list; otherwise applyCityName asks for it.
                        applyCityName(cityName, stateChanged);
                        form.loader(false);
                    }
                    // Re-enable address reset after autocomplete completes
                    resetAddress = true;
                }
                initAutocomplete();
                if (app.isAutoAddressLineValidationEnable == "true") {
                    address1Field.unbind("change").on("change", function (evt) {
                        var address = $(this).val();
                        bm.addressValidateWithGEO(address, $(this), form)
                    })
                }
            }
        } catch (e) {
            console.error(e)
        }
    },
    addressValidateWithGEO: function(value, element, form) {
        var submitTypeButton = $("[type='submit']");
        var submitRowButton = $(".submit-row button");
        submitTypeButton.removeAttr("disabled");
        submitRowButton.removeAttr("disabled");
        var CurrentAddress = value;
        if (value.length == 0) {
            return true;
        }
        form.loader(false)
        form.loader();
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({ 'address': CurrentAddress }, function (results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
                var address = results[0].formatted_address;
                var geoValidDom = form.find(".geo-suggestion-valid-address");
                geoValidDom.remove();
                $("[type='submit']").removeAttr("disabled");
                $(".submit-row button").removeAttr("disabled");
                /*console.log("address: "+address)
                console.log("value: "+value)
                if(isNeedToValidAddress && !address.contains(value)){
                    console.log("address: "+address)
                    console.log("value: "+value)
                    element.after($("<div class=\"geo-suggestion-valid-address\"><span class=\"suggestion-title\">Please enter the correct address or select one from below</span><span class='valid-address'>"+ address +"</span></div>"))
                    geoValidDom = form.find(".geo-suggestion-valid-address");
                    var validSuggestion = geoValidDom.find(".valid-address");
                    validSuggestion.on('click', function () {
                        var validText = validSuggestion.text();
                        element.val(validText);
                        geoValidDom.remove();
                        submitTypeButton.removeAttr("disabled");
                        submitRowButton.removeAttr("disabled");
                        bm.fillInAddressWithGEO(results[0].address_components, form);
                    });
                    submitTypeButton.attr("disabled",'disabled');
                    submitRowButton.attr("disabled",'disabled');
                }*/
                isNeedToValidAddress = true;
                form.loader(false)
            } else {
                form.loader(false)
            }
        });
        return true;
    },
    fillInAddressWithGEO: function(addressComponents, form) {
        let address1 = "";
        let postcode = "";
        let countryName = "";
        let stateName = "";
        let cityName = "";

        var address1Field = form.find("input[name=addressLine1]");
        var address2Field = form.find("input[name=addressLine2]");
        var postalField = form.find("input[name=postCode]");
        var countryField = form.find('select[name="country.id"]');
        var cityField = form.find('input[name=city]').length ? form.find('input[name=city]') : form.find('select[name=city]');
        var stateField = form.find('#state');

        for (const component of addressComponents) {
            const componentType = component.types[0];
            switch (componentType) {
                case "street_number":
                    address1 = `${component.long_name} ${address1}`;
                    break;
                case "route":
                    address1 += component.short_name;
                    break;

                case "postal_code":
                    postcode = `${component.long_name}${postcode}`;
                    break;

                case "postal_code_suffix":
                    postcode = `${postcode}-${component.long_name}`;
                    break;
                case "locality":
                    cityName = component.long_name;
                    break;
                case "administrative_area_level_1":
                    stateName = component.long_name;
                    break;
                case "country":
                    countryName = component.long_name;
                    break;
            }
        }

        var countrySelectObject = countryField;
        if(countryField.length){
            var countryItem = countrySelectObject.find('option').filter(function () {
                if (this.jqObject.text() == countryName) {
                    return $(this)
                }
            });
            countryItem.prop('selected', true);
            countrySelectObject.trigger("change");
            if(app.admin_id){
                countrySelectObject.trigger("chosen:updated");
            }
        }
        if(postalField.length){
            postalField.val(postcode);
        }
        if (stateField.length) {
            stateField.find('option').each(function() {
                if ($(this).text() === stateName) {
                    $(this).prop('selected', true);
                    $('#state').change();
                    return false;
                }
            });
        }
        if(cityField.length){
            cityField.val(cityName);
        }
    },

    initCountryChangeHandlerForFixedStatePosition: function (select, stateName, afterStateEle) {
        select.change(function () {
            var _self = $(this);
            var form = _self.closest("form");
            var id = $(this).val();
            $.ajax({
                url: app.baseUrl + "app/loadStateForCountry",
                dataType: 'html',
                data: {id: id, stateName: stateName},
                success: function (data) {
                    form.find(".form-row.state-selector-row").remove();
                    var stateAfter = form.find(afterStateEle || ".form-row.city-selector-row")
                    if (stateAfter.length) {
                        stateAfter.after(data);
                    } else {
                        select.parents(".form-row").before(data);
                    }
                    form.trigger("state-load")
                    site.hook.fire("after-country-changed");
                }
            })
        });
    },

    initCountryChangeHandler: function (select, stateName) {
        select.change(function () {
            var _self = $(this);
            var form = _self.closest("form");
            var id = $(this).val();
            $.ajax({
                url: app.baseUrl + "app/loadStateForCountry",
                dataType: 'html',
                data: {id: id, stateName: stateName},
                success: function (data) {
                    form.find(".form-row.state-selector-row").remove();
                    select.parents(".form-row").after(data);
                    form.trigger("state-load")
                }
            })
        });
    },
    initProductSelection: function (container, fieldName, actions, leftTableUrl = app.baseUrl + "productAdmin/loadProductsForSelection") {
        if (typeof fieldName == "undefined") {
            fieldName = "product"
        }
        var _actions = $.extend({
            tab: null,
            view: false,
            edit: false,
            "column-sort": true
        }, actions);
        var productSelector = this.twoSideSelection(container, 10, fieldName, leftTableUrl, _actions, [fieldName]);
        var categorySelector = container.find("select.category-selector").change(function () {
            productSelector.reload();
        });
        var productSorting = container.find("select.product-sorting").change(function () {
            productSelector.reload();
        });
        var specialProducts = container.find("select.special-product-filtering").change(function () {
            productSelector.reload();
        });
        container.find(".search-text").ichange(300, function () {
            productSelector.reload();
        });
        productSelector.beforeLoadTableContent = function (params) {
            var _param = {
                searchText: container.find("input.search-text").val(),
                parent: categorySelector.val(),
                sortBy: productSorting.val(),
                specialProductsFilter: specialProducts.val(),
                priceFrom: container.find("input[name='form-amount']").val(),
                priceTo: container.find("input[name='to-amount']").val()
            };
            site.hook.fire("before-load-table-content", params, container);
            $.extend(params, _param);
        };
        container.find(".filter-block").form({
            disable_on_submit: false,
            preSubmit: function () {
                productSelector.reload();
            }
        });
        productSelector.onEditClick = function (type, value, name, row) {
            app.tabs.item.editProduct(value["product"], name, _actions.tab);
        };
        productSelector.onViewClick = function (type, value, name, row) {
            app.tabs.item.viewProduct(value[fieldName]);
        };

        if(actions.editablePart){
            bm.makeTableCellEditable(container.find(".column-content.selected-panel.table-view").find(".editable"), actions.editablePart);
        }
        return productSelector
    },
    innerHeight: function (tag, height, height_definition) {
        var sizing = tag.css("box-sizing");
        var to_reduce = 0;
        switch (height_definition) {
            case "inner":
                to_reduce = tag.innerHeight() - tag.height();
                break;
            case "outer":
            default:
                to_reduce = sizing == "border-box" ? 0 : tag.outerHeight() - tag.height();
                break;
            case "extra_outer":
                to_reduce = tag.outerHeight(true) - (sizing == "border-box" ? tag.outerHeight() : tag.height());
                break;
        }
        return height - to_reduce;
    },
    /**
     * @param tag
     * @param width
     * @param width_definition [inner | outer | extra_outer] default is outer (padding, border, margin)
     * @returns {Number} the width to set to get the same width defined by width_definition
     */
    innerWidth: function (tag, width, width_definition) {
        var sizing = tag.css("box-sizing");
        var to_reduce = 0;
        switch (width_definition) {
            case "inner":
                to_reduce = tag.innerWidth() - tag.width();
                break;
            case "outer":
            default:
                to_reduce = sizing == "border-box" ? 0 : tag.outerWidth() - tag.width();
                break;
            case "extra_outer":
                to_reduce = tag.outerWidth(true) - (sizing == "border-box" ? tag.outerWidth() : tag.width());
                break;
        }
        return width - to_reduce;
    },
    instantSearch: function (searchContext, searchForm, nodeSelector, textSelector, callback) {
        var searchBox = searchForm.find(".search-text");

        function filter() {
            var searchText = searchBox.val();
            if (searchText) {
                searchContext.addClass("search-active")
            } else {
                searchContext.removeClass("search-active")
            }
            searchContext.find(nodeSelector).each(function () {
                var $this = $(this), name = $this.find(textSelector).text().trim();
                if (name.match(new RegExp(searchText, "i"))) {
                    $this.show()
                } else {
                    $this.hide()
                }
            });
        }

        searchBox.ichange(800, function () {
            filter()
        });
        searchForm.form({
            preSubmit: function () {
                filter();
                return false
            }
        })
    },
    makeTableCellEditable: function (tds, callback) {
        function editingTd() {
            var icon = $(this);
            var td = icon.parent();
            var tr = td.parent();
            td.addClass("editing");
            var tdVal = td.find(".value");
            var oldVal = tdVal.chide().text().trim();
            var validation = td.attr("validation");
            var maxlength = td.attr("maxlength");
            td.append("<input type='text' class='td-full-width' maxlength='" + (maxlength ? maxlength : "") + "' validation='" + (validation ? validation : "") + "'>");
            var restrict = td.attr("restrict");
            var editField = td.find("input[type='text']");
            editField.val(oldVal);
            if (restrict) {
                editField[restrict]();
            }
            var input = editField.get(0);
            input.selectionStart = input.selectionEnd = input.value.length;
            input.focus();
            td.trigger("cell-edit");
            tr.siblings("tr.data-row").addBack().each(function () {
                $(this).trigger("heightChange");
            });
            function updateTd($this) {
                var editFieldVal = $this.val();
                tdVal.text(editFieldVal);
                if (editFieldVal != oldVal) {
                    if (callback && callback(td, editFieldVal, oldVal) === false) {
                        input.focus();
                        return;
                    }
                }
                editField.remove();
                td.removeClass("editing");
                tdVal.cshow();
                tr.siblings("tr.data-row").addBack().each(function () {
                    $(this).trigger("heightChange");
                })
            }

            editField.on("focusout", function () {
                updateTd($(this));
            }).on("keypress", function (e) {
                if (e.keyCode == 13) {
                    e.preventDefault();
                    updateTd($(this));
                }
            });
        }

        tds.each(function () {
            var td = $(this);
            if (!td.find(".value").length) {
                var html = td.html();
                td.html('<span class="value"></span>');
                td.find(".value").html(html)
            }
            var clazz = "edit";
            if (td.is(".custom-edit")) {
                clazz = "change-all";
                td.append('<span class="fake-link ' + clazz + '">' + $.i18n.prop("change.all") + '</span>');
            } else {
                td.append('<span class="tool-icon ' + clazz + '"></span>');
            }
            var editBtn = td.find("." + clazz);
            editBtn.on("click", editingTd);
        });
    },
    makeTableCellSelectable: function (tds, select, callback, before) {
        function editingTd() {
            var icon = $(this);
            var td = icon.parent();
            td.addClass("editing");
            var tdVal = td.find(".value");
            var tdText = td.find(".text");
            var oldVal = tdVal.chide().text().trim();
            var _select = $.isFunction(select) ? select(td) : select.clone().show();
            _select.addClass('td-full-width');
            if (td.is(".hidden-overflow-selectable")) {
                var div = $("<div class='selectable-td-proxy'></div>").appendTo(document.body);
                div.append(_select);
                div.position({
                    my: "left top",
                    at: "left top",
                    of: td,
                    collision: "none"
                });
                div.width(td.outerWidth(), true);
                div.height(td.outerHeight(), true)
            } else {
                td.append(_select);
            }
            _select.val(oldVal);
            _select.chosen();
            _select.on("chosen:hiding_dropdown", function () {
                var editFieldVal = $(this).val();
                _select.chosen("remove");
                if (oldVal != editFieldVal) {
                    tdVal.text(editFieldVal);
                    var selectedText = $(this).find("option:selected").text();
                    tdText.text(selectedText);
                    if (callback) {
                        callback(td, editFieldVal, selectedText, oldVal);
                    }
                }
                td.removeClass("editing");
                if (td.is(".hidden-overflow-selectable")) {
                    $(".selectable-td-proxy").remove()
                }
                tdVal.cshow();
            });
            _select.chosen("dropshow");
            return false;
        }

        tds.each(function () {
            var td = $(this);
            if (!td.find(".value").length) {
                var html = td.html();
                td.html('<span class="value"></span><span class="text"></span>');
                td.find(".value").html(html);
                td.find(".text").html(html)
            }
            var clazz = "edit";
            if (td.is(".custom-select")) {
                clazz = "change-all";
                td.prepend('<span class="fake-link ' + clazz + '">' + $.i18n.prop("change.all") + '</span>');
            } else {
                td.append('<span class="tool-icon ' + clazz + '"></span>');
            }
            var editBtn = td.find("." + clazz);
            editBtn.on("click", function () {
                if (before && before(td) === false) {
                    return;
                }
                editingTd.call(this)
            });
        });
    },
    mask: function (tag, maskHtml) {
        maskHtml = $(maskHtml);
        var position = tag.position();
        var positionType = tag.css("position");
        var css = {
            position: "absolute"
        };
        if (positionType == 'static') {
            $.extend(css, {
                left: position.left + tag.leftRib(true, false, false),
                top: position.top + tag.topRib(true, false, false),
                width: maskHtml.width(tag.outerWidth()),
                height: maskHtml.height(tag.outerHeight())
            });
        } else {
            $.extend(css, {
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            });
        }
        maskHtml.css(css).addClass("div-mask");
        tag.append(maskHtml);
    },
    specialLoaderWrap: function (tag, maskHtml) {
        maskHtml = $(maskHtml);
        var position = tag.position();
        var positionType = tag.css("position");
        var css = {
            position: "absolute"
        };
        if (positionType == 'static') {
            $.extend(css, {
                left: position.left + tag.leftRib(true, false, false),
                top: position.top + tag.topRib(true, false, false),
                width: maskHtml.width(tag.outerWidth()),
                height: maskHtml.height(tag.outerHeight())
            });
        } else {
            $.extend(css, {
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            });
        }
        maskHtml.css(css).addClass("wc-spinner-loader-box");
        tag.append(maskHtml);
    },

    checkoutDeliveryTypeLoaderWrap: function (tag, maskHtml) {
        maskHtml = $(maskHtml);
        var position = tag.position();
        var positionType = tag.css("position");
        var css = {
            position: "absolute"
        };
        if (positionType == 'static') {
            $.extend(css, {
                left: position.left + tag.leftRib(true, false, false),
                top: position.top + tag.topRib(true, false, false),
                width: maskHtml.width(tag.outerWidth()),
                height: maskHtml.height(tag.outerHeight())
            });
        } else {
            $.extend(css, {
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            });
        }
        maskHtml.css(css).addClass("wc-checkout-delivery-type-shimar-loader-box");
        tag.append(maskHtml);
    },

    generalLoaderWrap: function (tag, maskHtml) {
        maskHtml = $(maskHtml);
        var position = tag.position();
        var positionType = tag.css("position");
        var css = {
            position: "absolute"
        };
        if (positionType == 'static') {
            $.extend(css, {
                left: position.left + tag.leftRib(true, false, false),
                top: position.top + tag.topRib(true, false, false),
                width: maskHtml.width(tag.outerWidth()),
                height: maskHtml.height(tag.outerHeight())
            });
        } else {
            $.extend(css, {
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            });
        }
        maskHtml.css(css).addClass("wc-general-spinner-loader-box");
        tag.append(maskHtml);
    },
    unmaskSpecialLoader: function (tag) {
        tag.specialLoaderUnwrap();
    },
    unmaskCheckoutDeliveryTypeLoader: function (tag) {
        tag.find(".wc-checkout-delivery-type-shimar-loader-box").detach()
    },
    unmaskDifferentShippingLoaderTypeLoader: function (tag) {
        tag.checkoutDeliveryTypeLoaderWrap();
    },
    unmaskGeneralLoader: function (tag) {
        tag.generalLoaderUnwrap();
    },
    maskIframe: function (iframe) {
        var mask = $("<div class='iframe-mask'></div>").css($.extend({
            bottom: 0,
            left: 0,
            position: "absolute",
            right: 0,
            top: 0,
            "z-index": 500
        }, browser.ie && browser.version == 8 ? {"background-image": "url(../../images/common/transparent_00.png)"} : {"background-color": "transparent"}));
        iframe.contents().find("body").append(mask);
    },
    menu: function (menu, panel, delegate, handler, evName, position) {
        if (!menu) {
            return;
        }
        var retrieveType;
        var activeMenu;
        if (handler.multitype) {
            var _menu = {};
            $.each(menu, function (ind) {
                _menu[ind] = bm.createMenu(this)
            });
            menu = _menu;
            retrieveType = function (entity) {
                return entity.attr("content-type")
            }
        } else if ($.isArray(menu)) {
            retrieveType = function () {
                return "def"
            };
            menu = {def: bm.createMenu(menu)};
        } else {
            retrieveType = function () {
                return "def"
            };
            menu = {def: menu};
        }
        var eventId = bm.getUUID();
        if ($.isFunction(handler)) {
            handler = {click: handler};
        }
        function showMenu(_menu, entity, evt) {
            if (!_menu) {
                return;
            }
            $(document.body).append(_menu);
            activeMenu = _menu;
            var position_ref = position ? (panel.length > 1 || delegate ? entity.closest(delegate || panel) : panel) : evt;
            _menu.position({
                at: position ? position[0] : "right+10 bottom+5",
                my: position ? position[1] : "right+10 top+5",
                of: position_ref,
                collision: "fit",
                using: function (pos, info) {
                    var items = $(this);
                    var menuLeft = pos.left;
                    if (browser.ff) {
                        if(!activeMenu.is("div.app-user-menu")) {
                            menuLeft = pos.left + 50;
                        }
                    }
                    items.css({
                        left: menuLeft + 'px',
                        top: pos.top + 'px'
                    });
                    if (info.vertical == "top") {
                        items.removeClass("up-side").addClass("down-side");
                    } else {
                        items.addClass("up-side").removeClass("down-side");
                    }
                    if (handler.open) {
                        handler.open.call(_menu, entity, info)
                    }
                    items.find(".menu-item").each(function () {
                        var item = $(this), permission = item.attr("permission");
                        if (permission) {
                            app.isPermitted(permission) ? item.removeClass("disabled") : item.addClass("disabled")
                        }
                    })
                }
            }).find(".menu-item").on("click", function () {
                var item = this.jqObject;
                if (item.is(".disabled")) {
                    return;
                }
                if (handler.multitype) {
                    handler.click(retrieveType(entity), item.attr("action"), entity, this.data);
                } else {
                    handler.click(item.attr("action"), entity, this.data);
                }
                if (!item.hasClass("ignore-hide-on-select")) {
                    hideMenuWithEvent(entity);
                }
            });
            $(document).on("mousedown." + eventId, function (ev) {
                if (!_menu.isParentOf(ev.target)) {
                    hideMenuWithEvent(entity);
                }
            });
            _menu.children().each(function () {
                if (this.sub) {
                    var item = $(this);
                    var subMenu = this.sub;
                    item.hover(function () {
                        if (activeMenu.active_sub_menu) {
                            activeMenu.active_sub_menu.hide()
                        }
                        activeMenu.active_sub_menu = subMenu.show().position({
                            my: "left top",
                            at: "right+10 top",
                            of: item
                        })
                    }, function () {
                        setTimeout(function () {
                            if (!activeMenu.hover_on_submenu) {
                                subMenu.hide()
                            }
                        }, 100)
                    });
                    subMenu.hover(function () {
                        activeMenu.hover_on_submenu = true
                    }, function () {
                        activeMenu.hover_on_submenu = false
                    })
                }
            })
        }

        function hideMenu() {
            if (activeMenu) {
                $(document).off("mousedown." + eventId);
                activeMenu.remove().find(".menu-item").off("click");
                if (activeMenu.active_sub_menu) {
                    activeMenu.active_sub_menu.hide();
                    delete activeMenu.active_sub_menu;
                    delete activeMenu.hover_on_submenu
                }
            }
        }

        function hideMenuWithEvent(entity) {
            if (handler.hide && handler.hide(entity) === false) {
                return;
            }
            hideMenu()
        }

        if (!handler.multitype && position && evName == "always") {
            showMenu(menu['def'], panel, null)
        } else {
            panel.on(evName || "contextmenu", delegate, function (evt) {
                var entity = $(this);
                showMenu(menu[retrieveType(entity)], entity, evt);
                return false;
            });
            $.each(menu, function () {
                $(this).children().each(function () {
                    if (this.sub) {
                        var item = $(this);
                        var subMenu = this.sub;
                        item.append(subMenu.hide())
                    }
                })
            })
        }
        var extendable = {
            show: function (entity, reference) {
                if (arguments.length > 1) {
                    hideMenu();
                    showMenu(this, entity, reference);
                    return;
                }
                if (activeMenu) {
                    var item = activeMenu.find("[action='" + entity + "']");
                    if (!item.length) {
                        item = activeMenu.find("." + entity)
                    }
                    item.show();
                }
            },
            hide: function (action) {
                if (!action) {
                    hideMenu();
                    return;
                }
                if (activeMenu) {
                    var item = activeMenu.find("[action='" + action + "']");
                    if (!item.length) {
                        item = activeMenu.find("." + action)
                    }
                    item.hide();
                }
            },
            enable: function (action) {
                if (!action) {
                    return;
                }
                if (activeMenu) {
                    var item = activeMenu.find("[action='" + action + "']");
                    if (!item.length) {
                        item = activeMenu.find("." + action)
                    }
                    item.removeClass("disabled");
                }
            },
            disable: function (action) {
                if (!action) {
                    return;
                }
                if (activeMenu) {
                    var item = activeMenu.find("[action='" + action + "']");
                    if (!item.length) {
                        item = activeMenu.find("." + action)
                    }
                    item.addClass("disabled");
                }
            }
        };
        var returnable = $.each(menu, function () {
            $.extend(this, extendable)
        });
        if (returnable.def) {
            return returnable.def
        }
        return returnable
    },
    metaTagEditor: function (panel) {
        var rowTemplate = '<tr><td class="name editable" maxlength="">#NAME#</td><td class="value editable" maxlength="">#VALUE#</td><td class="actions-column"><input type="hidden" name="tag_name" value="#NAME#">' +
            '<input type="hidden" name="tag_content" value="#VALUE#"><span class="tool-icon remove"></span></td></tr>';
        var metaTagSection = panel.find(".meta-tag-editor"), tagTable = metaTagSection.find("table"), lastRow = tagTable.find("tr.last-row");

        function attachRowEvent(content, panel) {
            bm.makeTableCellEditable(content.find("td.editable"), function (td, newVal, oldVal) {
                var parent = td.parent("tr");
                var flag = false;
                if (!newVal) {
                    errorHighlight(td.find("input"));
                    bm.notify($.i18n.prop("value.must.not.be.empty"), "error");
                    return false
                }
                if (td.is(".name")) {
                    parent.find("[name=tag_name]").val(newVal)
                } else {
                    parent.find("[name=tag_content]").val(newVal)
                }
            });
            content.find("td span.remove").on("click", function () {
                $(this).parents("tr").remove();
                panel.setDirty();
            })
        }

        function addTag(name, value, lastRow, panel) {
            var row = $(rowTemplate.replaceAll("#NAME#", name.htmlEncode()).replaceAll("#VALUE#", value.htmlEncode()));
            if (lastRow) {
                if (lastRow.find(".name").attr("maxlength")) {
                    row.find(".name").attr("maxlength", lastRow.find(".name").attr("maxlength"))
                }
                if (lastRow.find(".value").attr("maxlength")) {
                    row.find(".value").attr("maxlength", lastRow.find(".value").attr("maxlength"))
                }
            }
            attachRowEvent(row, panel);
            lastRow.before(row)
        }

        tagTable.find("tr:gt(0):not(.last-row)").each(function () {
            attachRowEvent($(this));
        });
        function errorHighlight(item) {
            item.addClass("error-highlight");
            setTimeout(function () {
                item.removeClass("error-highlight")
            }, 1000);
        }

        var addMapping = function () {
            var name = lastRow.find(".name").val(), value = lastRow.find(".value").val();
            if (!name) {
                errorHighlight(lastRow.find(".name"));
                return;
            }
            if (!value) {
                errorHighlight(lastRow.find(".value"));
                return;
            }
            addTag(name, value, lastRow, panel);
            lastRow.find("input").val("");
            return false
        };
        lastRow.find("input").bind("keyup.key_return", addMapping);
        lastRow.find(".add-row").on("click", addMapping);
        lastRow.find("input").on("keydown, keyup, keypress", function (e) {
            if (e.keyCode == 13) {
                return false
            }
        })
    },
    /**
     * The message key/text for a toast. An error or alert with no message gets a generic one: ~130 FEE error
     * handlers read resp.responseJSON.message, which a 413/500 page from the container does not carry, and
     * showed an empty red toast (BF2 #61, #116).
     */
    toastMessageOrFallback: function (message, type) {
        var blank = message == null || String(message).trim() === "";
        return (blank && (type === "error" || type === "alert")) ? "something.went.wrong" : message;
    },

    /**
     * The bm.ajax body for posting `formData`: url-encoded unless a file is actually attached. Tomcat caps a multipart
     * request at a number of parts (50 on stage), so a large form sent as FormData was rejected with a 413 before it
     * reached the app (BF2 #61, #116); a url-encoded body has no part cap. Returns {data, contentType}.
     */
    formPostBody: function (formData) {
        var params = new URLSearchParams(), hasFile = false;
        formData.forEach(function (value, key) {
            if (value instanceof File) {
                hasFile = hasFile || !!value.name;
            } else {
                params.append(key, value);
            }
        });
        return hasFile ? {data: formData, contentType: false}
                       : {data: params.toString(), contentType: "application/x-www-form-urlencoded; charset=UTF-8"};
    },

    notify: function (message, type) {
        if (typeof bm.__lvLicenseBlockActive === "function" && bm.__lvLicenseBlockActive(type)) { return; }
        if($("body.new-editor-body").length){
            this.feeNotify(message, type)
            return
        }
        var dom = $(".popup.notification");
        message = $.i18n.prop(bm.toastMessageOrFallback(message, type));
        if (dom.length) {
            dom.find(".message").html(message.trim());
            dom.find(".type").text($.i18n.prop(type) + "!");
            dom.removeClass("success error info warning alert").addClass(type);
            dom.obj().resetCloseTimer();
            return;
        }
        dom = $("<div class='notification fee-identical-sewc-elm'><span class='icon fee-identical-sewc-elm'></span><span class='type fee-identical-sewc-elm'></span></span><span class='message fee-identical-sewc-elm'></span><span class='close fee-identical-sewc-elm'></span></div>");
        dom.find(".message").html(message.trim());
        dom.find(".type").text($.i18n.prop(type) + "!");
        return dom.popup({
            auto_close: 3000,
            auto_active: false,
            auto_active_on_focus: false,
            modal: false,
            is_fixed: true,
            is_center: true,
            top: 20,
            is_always_up: true,
            clazz: type,
            not_enable_body_scroll: true,
            position: function () {
                var dom = this.getDom();
                dom.css({top: -dom.outerHeight(), left: bm.center(dom.outerWidth(), 0, true).left});
                dom.animate({top: 20}, {easing: 'easeOutBounce'});
            },
            close: function () {
                var dom = this.getDom();
                var _self = this;
                var _arguments = arguments;
                dom.fadeOut(function () {
                    POPUP.prototype.close.apply(_self, _arguments);
                })
            },
            events: {
                render: function () {
                    var content = this;
                    content.hover(function () {
                            content.addClass("hover");
                        },
                        function () {
                            content.removeClass("hover");
                        })
                }
            }
        });
    },

    feeNotify: function (message, type) {
        // A license limit/feature block is handled by the upgrade popup (utility.js) — never toast its raw
        // envelope, nor the localized "denied ... exceed limit" message that accompanies a block we just showed.
        try {
            if (typeof message === "string" && (message.indexOf("license_limit_exceeded") !== -1 || message.indexOf("license_feature_disabled") !== -1)) { return; }
        } catch (e) {}
        if (typeof bm.__lvLicenseBlockActive === "function" && bm.__lvLicenseBlockActive(type)) { return; }
        /* the open toast is the .fee-alert itself (POPUP adds "popup" to it); looking only for the legacy
           .popup.notification never found it, so a second call - bm.ajax's own toast of the response message, then the
           caller's - stacked a second toast over the first. One still open (not fading out) is updated in place. */
        var dom = $(".popup.fee-alert").not(".fee-alert--closing").last();
        var typeIconMapping = {error: "circle-exclamation", alert: "circle-exclamation", warning: "triangle-exclamation", info: "circle-exclamation", success: "circle-check"}
        message = $.i18n.prop(bm.toastMessageOrFallback(message, type));
        // Null-guard: a caller may hand us undefined (e.g. an error handler that reads resp.message off a jqXHR,
        // where there is no parsed body). Coerce so the message.trim() calls below never throw.
        if (message == null) { message = ""; }
        else { message = String(message); }
        if (dom.length && dom.obj()) {
            dom.find(".fee-alert__message").html(message.trim());
            dom.removeClass("fee-alert--success fee-alert--error fee-alert--info fee-alert--warning fee-alert--alert").addClass("fee-alert--"+type);
            dom.find(".fee-alert__type-icon").removeClass("fee-alert__type-icon--success fee-alert__type-icon--error fee-alert__type-icon--info fee-alert__type-icon--warning fee-alert__type-icon--alert").addClass("fee-alert__type-icon--"+type);
            dom.find(".fee-alert__type-icon use").attr("xlink:href", app.systemResourceUrl + "svg/fee-icon-sprite.svg#" + typeIconMapping[type]);
            dom.obj().resetCloseTimer();
            return;
        }
        dom = $("<div class=\"fee-alert fee-alert--"+type+"\">" +
            "   <div class=\"fee-alert__container\">" +
            "   <span class=\"fee-alert__type-icon fee-alert__type-icon--"+type+"\">" +
            "       <svg class=\"fee-icon\"><use xlink:href='"+ app.systemResourceUrl + "svg/fee-icon-sprite.svg#"+typeIconMapping[type]+"\'></use></svg>"+
            "   </span>"+
            "    <span class=\"fee-alert__message\"></span>\n" +
            "    <span class=\"fee-alert__close-icon\">\n" +
            "       <svg class=\"close fee-icon\"><use xlink:href='"+ app.systemResourceUrl + "svg/fee-icon-sprite.svg#x-mark\'></use></svg>"+
            "   </span>" +
            "</div>" +
            "</div>");
        dom.find(".fee-alert__message").html(message.trim());
        return dom.popup({
            auto_close: 3000,
            auto_active: false,
            auto_active_on_focus: false,
            modal: false,
            is_fixed: true,
            is_center: true,
            top: 20,
            is_always_up: true,
            not_enable_body_scroll: true,
            position: function () {
                var dom = this.getDom();
                dom.css({top: -dom.outerHeight(), left: bm.center(dom.outerWidth(), 0, true).left});
                dom.animate({top: 20}, {easing: 'easeOutBounce'});
            },
            close: function () {
                var dom = this.getDom();
                var _self = this;
                var _arguments = arguments;
                dom.addClass("fee-alert--closing");   // fading out: the next feeNotify builds a fresh toast
                dom.fadeOut(function () {
                    POPUP.prototype.close.apply(_self, _arguments);
                })
            },
            events: {
                render: function () {
                    var content = this;
                    content.hover(function () {
                            content.addClass("hover");
                        },
                        function () {
                            content.removeClass("hover");
                        })
                }
            }
        });
    },

    posRefChangeLtoR: function(tag) {
        var right =  tag.outerWidth();
        tag.css({
            left: "auto",
            right: right
        })
    },
    /**
     * @overload - 1
     * @param inputForm
     * @param config -> {url, data, title, onSuccess}
     */
    renderSitePopup: function (url, title, emphasized, data, config) {
        config = $.extend({}, {
            auto_close_on_success: true,
            disable_on_submit: true,
            disable_on_invalid: true,
            disable_button_text: undefined,
            modify_ui: true,
            width: 500,
            form_selector: ".site-popup-form",
            buttonLine: "button-line",
            scroll: true
        }, config);
        var events = (config.events || {});
        var _caller_content_loaded = events ? events.content_loaded : undefined;
        events.content_loaded = function (popup) {
            var form = this.find(config.form_selector);
            var newSubmit;
            if (typeof(config.buttonLine) == "string") {
                var buttonLine = form.find("." + config.buttonLine);
                newSubmit = buttonLine.clone();
                buttonLine.remove();
            } else {
                newSubmit = config.buttonLine
            }
            var button = newSubmit.find(".submit-button, button[type=submit]").addClass("site-popup-form-submit").on("click", function () {
                form.submit();
            });
            this.append(newSubmit);
            var _success = (config.ajax && config.ajax.success) || config.success;
            form.form({
                ajax: this.find(".site-popup-form").attr("no-ajax") == null,
                disable_on_submit: config.disable_on_submit,
                disable_on_invalid: config.disable_on_invalid,
                disable_button_text: config.disable_button_text,
                submitButton: button,
                preSubmit: function (ajaxSettings) {
                    $.extend(ajaxSettings, {
                        response: config.response,
                        error: config.error
                    }, config.ajax, {
                        success: function () {
                            if (config.auto_close_on_success) {
                                popup.close();
                            }
                            if (_success) {
                                _success.apply(this, arguments);
                            }
                        }
                    });
                    if (config.beforeSubmit) {
                        return config.beforeSubmit.call(popup.getDom(), form, ajaxSettings ? (ajaxSettings.data = ajaxSettings.data || {}) : null, popup);
                    }
                }
            });
            form.find("[default-focus]").focus();
            this.find(".cancel-button").click(function () {
                popup.close(1);
            });
            popup.on("content-change", function (ev, added, removed) {
                if (added) {
                    form.obj(ValidationPanel).attach(added.filter("[validation]").add(added.find("[validation]")));
                }
                if (removed) {
                    form.obj(ValidationPanel).detach(removed.filter("[validation]").add(removed.find("[validation]")));
                }
            });
            if (_caller_content_loaded) {
                _caller_content_loaded.apply(this, [popup, form]);
            }
        };
        delete config.events;
        return new POPUP($.extend({
            title: title + (emphasized ? " - <span class='emphasized'>" + bm.htmlEncode(emphasized) + "</span>" : ""),
            width: 430,
            ajax_url: url,
            ajax_settings: {
                data: data
            }
        }, config, {clazz: "site-popup" + (config.clazz ? " " + config.clazz : ""), events: events}))
    },
    selectFromAssetLibrary: function (title, selectButtonHandler, fileExtensions, config, isFile) {
        var fileUrl;
        var isSelected;
        config = $.extend({}, config, {
            _self: this,
            width: 500,
            events: {
                content_loaded: function (popup) {
                    var dom = this;
                    var targeteBody = this.find(".remote_folders").scrollbar({
                        vertical: {
                            offset: 2
                        }
                    });
                    var targetDirPreviewPanel = this.find(".asset-library-image-preview").scrollbar({
                        vertical: {
                            offset: 2
                        }
                    });

                    var backPath;
                    function loadAssetLibrary(repository) {
                        if (typeof repository == "undefined") {
                            repository = "pub"
                        }
                        WebDAVClient.doPropFind(repository, this, {
                            onPopulate: function (childList) {
                                targeteBody.find(".folder, .file").remove();
                                if (repository != "pub") {
                                    var $tr = $('<div class="folder"> <span class="tool-icon back" title="' + $.i18n.prop("back") + '"></span></div>');
                                    targeteBody.append($tr);
                                    $tr.click(function () {
                                        isSelected = false;
                                        backPath = backPath.substring(0, backPath.lastIndexOf("/"));
                                        loadAssetLibrary(backPath)
                                    });
                                }
                                $.each(childList.folders, function (key, value) {
                                    var $tr = $('<div class="folder"> <span class="tree-icon"></span> <span class="tree-title">' + value.name + '</span></div>');
                                    targeteBody.append($tr);
                                    var clicks = 0;
                                    $tr.click(function () {
                                        var timer = null;
                                        clicks++;
                                        if (clicks === 1) {
                                            timer = setTimeout(function () {
                                                clicks = 0;
                                                $tr.siblings(".selected").removeClass("selected");
                                                isSelected = false;
                                                if (isFile == false) {
                                                    isSelected = true;
                                                    $tr.addClass("selected").siblings(".selected").removeClass("selected");
                                                    fileUrl = bm.encodePath(app.baseUrl + "pub" + value.path.substring(value.path.indexOf("/")))
                                                }
                                            }, 200);
                                        } else {
                                            clicks = 0;
                                            clearTimeout(timer);
                                            backPath = value.path;
                                            loadAssetLibrary(value.path);
                                            targeteBody.next().find(".selectedValue").removeAttr("src").data("loaded", false);
                                        }
                                    });
                                });
                                $.each(childList.files, function (key, value) {
                                    var imageExt = ["bmp", "gif", "jpg", "png", "psd", "pspimage", "thm", "tif", "yuv", "jpeg", "webp"];
                                    var extension = value.clazz;
                                    fileExtensions = fileExtensions ? fileExtensions : imageExt;
                                    if (fileExtensions.contains(extension) && isFile != false) {
                                        var _tr = $('<div class="file ' + extension + '"> <span class="tree-icon"></span> <span class="tree-title">' + value.name + '</span></div>');
                                        targetDirPreviewPanel.append(_tr);
                                        _tr.click(function () {
                                            isSelected = false;
                                            fileUrl = bm.encodePath(app.systemPubUrl + "/" + value.path.substring(value.path.indexOf("/")));
                                            if (isFile === undefined) {
                                                var img = $("<img>", {
                                                    src: fileUrl
                                                });
                                                dom.find(".asset-library-image-preview").html(img);
                                                img.on("load", function () {
                                                    isSelected = true;
                                                    _tr.addClass("selected").siblings(".selected").removeClass("selected")
                                                })
                                            } else if (isFile) {
                                                targetDirPreviewPanel.find(".file.selected").removeClass("selected");
                                                _tr.addClass("selected");
                                                isSelected = true;
                                            }
                                        })
                                    }
                                })
                            }
                        })
                    }

                    loadAssetLibrary("pub");
                    this.find(".file-selector").form({
                        preSubmit: function () {
                            if (isSelected) {
                                selectButtonHandler(fileUrl);
                                popup.close();
                            } else {
                                if (isFile) {
                                    bm.notify($.i18n.prop("file.not.selected"), "error")
                                } else if (isFile === undefined) {
                                    bm.notify($.i18n.prop("image.not.selected"), "alert")
                                } else {
                                    bm.notify($.i18n.prop("folder.not.selected"), "error")
                                }
                            }
                            return false
                        }
                    })
                }
            }
        });
        bm.editPopup(app.baseUrl + "remoteRepository/selectFileFromAssetLibraryForWidget", title, "", {isFile: isFile === undefined ? isFile : true}, config)
    },
    selectionFloatingPanel: function (ref, url, data, config) {
        var instance = {
            isLoaded: false,
        };
        instance.reload = function () {
            var _self = this, element = _self.el, data = {searchText: _self.searchText};
            element.loader();
            config.beforeReload && config.beforeReload(data);
            bm.ajax({
                url: url,
                data: data,
                dataType: "html",
                response: function() {
                    element.loader(false);
                },
                success: function(resp) {
                    element.find(".body").replaceWith($(resp).find(".body"));
                    _self.attachEvents();
                }
            });
        };
        instance.attachEvents = function () {
            var _self = this, element = _self.el;
            element.find(".body").scrollbar({
                vertical: {
                    offset: 15
                }
            });
            element.updateUi();
            element.find(".select-item").on("click", function() {
                var $this = $(this);
                if(!$this.is(".selected")) {
                    config.onSelect($this.config("entity"));
                }
                _self.popup.close()
            })
        };
        var events = (config.events || {});
        var _caller_content_loaded = events ? events.content_loaded : undefined;
        events.content_loaded = function (popup) {
            var el = instance.el = popup.el, searchForm = el.find(".search-form");
            instance.popup = popup;
            el.find(".cancel-button").on("click", function() {
                popup.close();
            });
            searchForm.form({
                preSubmit: function() {
                    var searchText = searchForm.find(".search-text").val();
                    if(instance.searchText === searchText) {
                        return false
                    }
                    instance.searchText = searchText;
                    instance.reload();
                    return false
                }
            });
            instance.attachEvents();
            _caller_content_loaded && _caller_content_loaded.apply(this, arguments)
        };
        delete config.events;
        bm.floatingPanel(ref, url, data, $.extend({
            width: 400,
            height: null,
            events: events,
            position_collison: "none"
        }, config));
        return instance
    },
    table: function (tableWrapper, settings) {
        var _config = {
            url: '',
            appendUrl: null,
            type: "get"
        };
        var tabulator;
        var paginator = tableWrapper.find(".pagination") ? tableWrapper.find(".pagination").obj() : null;
        var paginatedTable = tableWrapper.find(settings.isNonTable ? ".table:first" : "table:first");
        var menu;

        function _sendReloadRequest() {
            _config.param = paginator ? {
                max: paginator.all ? -1 : paginator.itemsPerPage,
                offset: (paginator.currentPage - 1) * paginator.itemsPerPage
            } : {max: -1, offset: 0};
            if (_config.sortable && _config.sorted) {
                $.extend(_config.param, {
                    sort: _config.sortable[_config.sorted],
                    dir: _config.sortedDir == "down" ? "desc" : "asc"
                });
            }
            if (_config.beforeReloadRequest) {
                _config.beforeReloadRequest();
            }
            tableWrapper.loader();
            bm.ajax({
                url: _config.url + (_config.appendUrl || ""),
                type: _config.type,
                data: _config.param,
                dataType: 'html',
                success: function () {
                    onReloadSuccess.apply(this, arguments);
                    if (_config.afterLoad) {
                        _config.afterLoad();
                    }
                },
                response: function () {
                    tableWrapper.loader(false);
                }
            });
        }

        function initializeSortableColumns() {
            if (_config.sortable) {
                $.each(_config.sortable, function (ind) {
                    var columnHead = paginatedTable.find("th:nth-child(" + (+ind + 1) + ")").eq(0);
                    columnHead.addClass("sortable");
                });
                if (_config.sorted) {
                    paginatedTable.find("th:nth-child(" + (+_config.sorted + 1) + ")").eq(0).addClass("sort-" + _config.sortedDir);
                }
            }
        }

        function onReloadSuccess(resp) {
            resp = $(resp);
            paginatedTable.html(resp.find(settings.isNonTable ? ".table" : "table").html()).updateUi();
            var title = resp.filter(".header").find(".title");
            if(title.length == 0) {
                title = resp.find(".header").find(".title");
            }
            tableWrapper.find(".header .title").replaceWith(title);
            tableWrapper.trigger("tabulator-load-success", [resp]);
            var paginatorTag = resp.find("paginator");
            var total = +paginatorTag.attr("total");
            var max = +paginatorTag.attr("max");
            var offset = +paginatorTag.attr("offset");
            if (paginator) {
                paginator.update(total, max, Math.floor(offset / max) + 1);
            }
            initializeSortableColumns();
            initializeEditableColumns();
            initializeSelectableColumns()
        }

        if (settings.menu_entries) {
            menu = bm.menu(settings.menu_entries, paginatedTable, ".action-navigator", {
                click: function (action, navigator) {
                    tabulator.onActionClick(action, navigator.config("entity"), navigator);
                },
                open: function (navigator, pos_hash) {
                    if (tabulator.onMenuOpen) {
                        tabulator.onMenuOpen(navigator, menu)
                    }
                }
            }, "click", ["right+10 bottom+5", "right top"]);
        }
        paginatedTable.on("click", ".sortable", function (ev) {
            var targetCell = $(ev.target);
            var index = targetCell.index();
            _config.sorted = "" + index;
            _config.sortedDir = targetCell.is(".sort-up") ? "down" : "up";
            tabulator.reload();
        });
        tabulator = $.extend({
            paginator: paginator,
            reload: function () {
                if (paginator) {
                    paginator.onPageClick(paginator.getCurrentPage());
                } else {
                    _sendReloadRequest();
                }
            },
            menu: menu,
            sortAdd: function (position, index) {
                _config.sortable[position] = index;
            },
            sortRemove: function (position) {
                delete _config.sortable[position];
            }
        }, settings);
        $.extend(_config, settings);
        tableWrapper.find('select.per-page-count').change(function (ev, oldValue, newValue) {
            paginator.update(undefined, +newValue, 1);
            _sendReloadRequest();
        });
        if (paginator) {
            paginator.onPageClick = _sendReloadRequest;
        }
        function initializeEditableColumns() {
            var editableCell = paginatedTable.find("td.editable");
            if (editableCell.length) {
                bm.makeTableCellEditable(editableCell, tabulator.afterCellEdit);
            }
        }

        function initializeSelectableColumns() {
            var selectable = paginatedTable.find("td.selectable");
            if (selectable.length && tabulator.selectableCellSelect) {
                bm.makeTableCellSelectable(selectable, tabulator.selectableCellSelect, tabulator.afterCellSelect, tabulator.beforeCellSelect);
            }
        }

        initializeSortableColumns();
        initializeEditableColumns();
        initializeSelectableColumns();
        return tabulator;
    },
    tableCheckAll: function (table, onFull, onPartial, onNo) {
        var orgTable = table.filter(".content");
        orgTable.delegate("td.select-column :checkbox", "change", function () {
            var checkBoxes = table.find("td.select-column :checkbox");
            if (checkBoxes.length == checkBoxes.filter(":checked").length) {
                orgTable.find(".check-all").prop("checked", true);
                if (onFull && checkBoxes.filter(":checked").length > 1) {
                    onFull()
                }
            } else if (checkBoxes.filter(":checked").length > 1) {
                orgTable.find(".check-all").checkbox("state", "partial");
                if (onPartial) {
                    onPartial()
                }
            } else {
                orgTable.find(".check-all").prop("checked", false);
                if (onNo) {
                    onNo()
                }
            }
            if (orgTable.obj(Scrollbar)) {
                orgTable.tscrollbar("content", orgTable.find(".check-all").closest("th"));
            }
        });
        table.delegate(".check-all", "change", function () {
            var allCheckBoxes = orgTable.find(".select-column :checkbox");
            allCheckBoxes.prop("checked", this.checked);
            if (this.checked && allCheckBoxes.filter(":checked").length >2) {
                if (onFull) {
                    onFull()
                }
            } else {
                if (onNo) {
                    onNo()
                }
            }
            orgTable.tscrollbar("content", orgTable.find(".check-all").closest("th"));
        });
    },
    tableToggleRow: function (container, callback) {
        container.find(".toggle-cell").click(function () {
            var _this = $(this);
            var detailsRow = _this.parents("tr").next();
            if (_this.is(".collapsed")) {
                _this.removeClass("collapsed").addClass("expanded");
                detailsRow.show()
            } else {
                _this.removeClass("expanded").addClass("collapsed");
                detailsRow.hide()
            }
            if (callback) {
                callback(_this);
            }
        })

    },
    taskPopup: function (url, data, popConfig) {
        if (!app.taskPopupCaches) {
            app.taskPopupCaches = {};
        }
        var hash = data.token + "#" + data.name;
        if (app.taskPopupCaches[hash]) {
            app.taskPopupCaches[hash].setActive();
            return;
        }
        var repeater = function () {
            bm.ajax({
                url: data.detail_status_url,
                data: {token: data.token},
                success: function (resp) {
                    data.detail_viewer.update(viewer, resp);
                    if (resp.status == "running") {
                        setTimeout(repeater, 1000);
                    }
                }
            })
        };
        var viewer = new POPUP($.extend({
            title: $.i18n.prop("task.detail") + " - <span class='emphasized'>" + bm.htmlEncode(data.name) + "</span>",
            ajax_url: url,
            ajax_settings: {
                data: data
            },
            clazz: "task-popup",
            draggable: false,
            modal: false,
            events: {
                content_loaded: function () {
                    data.detail_viewer.init(viewer);
                    repeater();
                }
            }
        }, popConfig));
        viewer.on("close", function () {
            delete app.taskPopupCaches[hash];
        });
        return app.taskPopupCaches[hash] = viewer;
    },
    twoSideSelection: function (container, itemPerPageSelect, itemName, leftTableUrl, actions, fieldNames, config) {
        if (config === undefined){
            config = {}
        }
        var initOtherContentInitialized = false;
        var def_actions = {remove: true, view: true, edit: true, config: false, "column-sort": false};
        var perPageCount;
        actions = $.extend({}, def_actions, actions);
        var defaultMenuEntries = {
            view: {text: $.i18n.prop("view"), ui_class: "view", action: "view"},
            edit: {text: $.i18n.prop("edit"), ui_class: "edit", action: "edit"},
            config: {text: $.i18n.prop("configure"), ui_class: "config", action: "config"},
            remove: {text: $.i18n.prop("remove"), ui_class: "remove", action: "remove"}
        };
        var _config = config
        var funcBinds = {
            reload: function () {
                if (!leftLoading) {
                    leftPaginator.onPageClick(leftPaginator.getCurrentPage());
                }
            },
            setUrl: function (url, name, _actions, fields) {
                itemName = name;
                leftTableUrl = url;
                fieldNames = fields;
                actions = $.extend({}, def_actions, _actions, {"column-sort": actions["column-sort"]});
                if (!leftLoading) {
                    loadLeftPanelTable(1);
                }
                actionMenu = bm.createMenu(generateMenuEntries());

            },
            clearAllSelection: function () {
                clearAllSelection(false);
            },
            getAllSelectedByField: function (field) {
                var retArray = [];
                if (field) {
                    rightTable.find("input[name='" + field + "']").each(function (id, elm) {
                        retArray.push($(elm).val());
                    });
                }
                return retArray;
            },
            hasSelected: function (field, value) {
                var retVal = false;
                if (typeof value == "undefined") {
                    rightTable.find("tr:not(.empty) td.actions-column").each(function (idx, elm) {
                        if ($(elm).find("input:first").val() == field) {
                            retVal = true;
                        }
                    })

                } else {
                    rightTable.find("input[name='" + field + "']").each(function (idx, elm) {
                        if ($(elm).val() == value) {
                            retVal = true;
                        }
                    });
                }
                return retVal;
            },
            onViewClick: function () {
            },
            onEditClick: function (type, value, name, row) {
            },
            onDeleteClick: function (type, value, name, row) {
            },
            onConfigClick: function () {
            },
            onNewSelection: function () {

            },
            getPanelBody: function () {
            },
            triggerExternalInit: function () {
                funcBinds.initContent(leftPanel, function (name, value, row) {
                    if (typeof row == "undefined") {
                        addSelectedRow([
                            {name: name, value: value}
                        ]);
                    } else {
                        addSelectedRow([
                            {name: name, value: value, row: row}
                        ]);
                    }
                });
            },
            unselect: function (type, id) {
                var affectedInputs = itemName == type ? leftPanel.find("td.actions-column[" + type + "='" + id + "'] input:checkbox") : [];
                if (!affectedInputs.length) {
                    affectedInputs = rightTable.find("tr:has(td.actions-column[item='" + id + "'][type='" + type + "'])");
                }
                affectedInputs.filter("input:checkbox").prop("checked", false);
                uncheckInputs(affectedInputs);
            },
            getSavedData: function (id, type, dataName) {
                if (typeof id == "string") {
                    id = rightTable.find("td.actions-column[item='" + id + "'][type='" + type + "']");
                }
                return id.data(dataName);
            },
            saveData: function (id, type, dataName, value) {
                if (typeof id == "string") {
                    id = rightTable.find("td.actions-column[item='" + id + "'][type='" + type + "']");
                }
                id.data(dataName, value);
            },
            getAllSelectedData: function () {
                var fromdom = rightTable.serializeObject();
                var selected = rightTable.find("td.actions-column[item]");
                selected.each(function () {
                    var _data = $(this).data();
                    if (_data) {
                        fromdom = bm.serializeMix(fromdom, _data)
                    }
                });
                return fromdom;
            },
            isSelected: function (name, value) {
                var selected = rightTable.find("input[name='" + name + "'][value='" + value + "']");
                return selected.length
            },
            resetRightPanel: function (resp, rightPanelSelectedTd, callback) {
                var respTds = resp.find("td.actions-column");
                for (var i= 0; i < rightPanelSelectedTd.length; i++) {
                    var td = $(rightPanelSelectedTd[i]);
                    var respTd = respTds.find("input[value=" + td.attr("item") + "]").parent();
                    if (respTd.length) {
                        td.prev("td").text(respTd.prev("td").text().trim());
                        td.prev("td").not(".order.editable").text(respTd.prev("td").text().trim());
                    } else {
                        td.parent().remove();
                    }
                }
                if (callback) {
                    callback();
                }
            }
        };

        function onMenuActionClick(action, navigator) {
            var cell = navigator.closest("td");
            var values = getCellData(cell);
            var type = cell.attr("type");
            switch (action) {
                case "remove":
                    var row = cell.closest("tr");
                    funcBinds.onDeleteClick(type, values, cell.prev().html().trim(), row);
                    var inputsToUncheck = $();
                    if (leftTable && itemName == type) {
                        var value = cell.attr("item");
                        inputsToUncheck = inputsToUncheck.add(leftTable.find("td.actions-column[" + type + "='" + value + "'] input:checkbox"));
                        inputsToUncheck.prop("checked", false);
                        leftTable.trigger("change")
                    }
                    removeSelections(inputsToUncheck, row);
                    break;
                case "view":
                    funcBinds.onViewClick(type, values, cell.prev().html().trim(), cell);
                    break;
                case "edit":
                    funcBinds.onEditClick(type, values, cell.prev().html().trim(), cell.closest("tr"));
                    break;
                case "config":
                    funcBinds.onConfigClick(type, values, cell.prev().html().trim(), cell);
                    break;
            }
        }

        function generateMenuEntries() {
            var x = [];
            $.each(defaultMenuEntries, function (key, val) {
                if (actions[key]) {
                    x.push(val);
                }
            });
            return x;
        }

        function hideMenu(navigator) {
            navigator.removeClass("expanded up-side").addClass("collapsed");
            actionMenu.off("blur").removeClass("up-side").remove();
            var hiddenClasses = navigator.attr("entry-hidden");
            actionMenu.find(hiddenClasses).removeClass("hidden");
        }

        function fillRightGaps(fillUpCount, itemAddRemovePreview) {
            var rows = $();
            var rightPanelToPreview = rightTable;
            if(itemAddRemovePreview && itemAddRemovePreview.length){
                rightPanelToPreview = itemAddRemovePreview.find("tbody")
            }
            for (var g = 0; g < fillUpCount; g++) {
                var row = diceRow.clone();
                rightPanelToPreview.append(row);
                rows = rows.add(row);
            }
            return rows;
        }

        function fillRequiredGaps() {
            var rightRowCount = rightTable.find("tr td[item]").length;
            var column = leftTable.find("tr td").length / 2;
            var leftRowCount = column > 1 ? column : 1;
            var fillUpCount = rightRowCount ? ((leftRowCount - rightRowCount) < 0 ? 0 : (leftRowCount - rightRowCount)) : leftRowCount;
            if (rightRowCount != 0 && fillUpCount == perPageCount) {
                return;
            }
            var alreadyFilledCount = perPageCount < 0 ? 0 : rightTable.find("tr.empty").length;
            if (fillUpCount < alreadyFilledCount) {
                rightTable.find("tr.empty").filter(":lt(" + (alreadyFilledCount - fillUpCount) + ")").remove();
            } else {
                fillRightGaps(fillUpCount - alreadyFilledCount);
            }
            rightPaginator.onPageClick(rightPaginator.getCurrentPage())
        }

        function getCellData(cell) {
            var obj = {};
            if (cell.find("input[name]").length > 0) {
                cell.find("input[name]").each(function () {
                    obj[$(this).attr("name")] = $(this).val();
                });
            } else {
                fieldNames.everyCustomFunc(function (i, fn) {
                    if (cell.attr(fn)) {
                        obj[fn] = cell.attr(fn)
                    }
                });
            }
            return obj;
        }

        function clearCurrentPageSelections() {
            clearAllSelection(true);
            if (typeof funcBinds.onRemoveAll == "function") {
                funcBinds.onRemoveAll.call(this)
            }
        }

        function clearAllSelection(viewedOnly) {
            var rightTableToPreview = $(".double-table-to-selected-removed-preview").length ?  $(".double-table-to-selected-removed-preview") :  rightTable;
            var cellsToClear = rightTableToPreview.find("td[item].actions-column" + (viewedOnly ? ":visible" : ""));
            var inputsToUncheck = $();
            if (leftTable.length) {
                cellsToClear.each(function () {
                    var value = $(this).attr("item");
                    inputsToUncheck = inputsToUncheck.add(leftPanel.find("td.actions-column[" + itemName + "='" + value + "'] input:checkbox")).prop("checked", false);
                });
                leftTable.trigger("change")
            }
            removeSelections(inputsToUncheck, cellsToClear.closest("tr"))
        }

        function removeSelections(checks, selectedRows) {
            checks.closest("tr").removeClass("selected");
            if (checks.length) {
                updateHeaderCheckStatus();
            }
            if (selectedRows.length) {
                removeSelectedRows(selectedRows)
            }
        }

        function uncheckInputs(checksToUncheck) {
            var selectedRows = $();
            var rightPanelToPreview = $(".item-add-remove-preview-panel").length ? $(".item-add-remove-preview-panel") : rightTable
            checksToUncheck.each(function () {
                var input = $(this);
                var value = input.parent().attr(itemName);
                selectedRows = selectedRows.add(rightPanelToPreview.find("td.actions-column[item='" + value + "'][type='" + itemName + "']").closest("tr"));
            });
            removeSelections(checksToUncheck, selectedRows)
        }

        function removeSelectedRows(selectedRows) {
            var targerTable = selectedRows.closest("table");
            selectedRows.remove();
            rightPaginator.setTotal(rightPaginator.getTotal() - selectedRows.length);
            rightPaginator.onPageClick(rightPaginator.getCurrentPage());

            var targetItem = selectedRows.attr("class");
            var totalSelected = targerTable.find("tr."+targetItem).length;
            var counterPanel = targerTable.parents(".columns.last-column").find(".selected-"+targetItem+"-count");
            if(counterPanel.length){
                counterPanel.text("("+totalSelected+")")
            }

            fillRequiredGaps()
        }

        function rightPanelPageReload(page) {
            var perpage = rightPaginator.all ? (rightPaginator.getTotal() > 10 ? rightPaginator.getTotal() : 10) : rightPaginator.getItemsPerPage();
            var offsetIndex = (page - 1) * perpage;
            if (offsetIndex < 1) {
                offsetIndex = 0;
            }
            var rightTableTr = rightTable.find("tr:not(:first)");
            rightTableTr.hide();
            for (var i = 0; i < rightPaginator.getTotal(); i++) {
                if(((i >= offsetIndex) && (i < (perpage * page)))) {
                    if (rightTableTr[i]) {
                        var jqObjRow = rightTableTr[i].jqObject;
                        if (!jqObjRow.hasClass("empty")) {
                            jqObjRow.show()
                        }
                    }
                }
            }
        }

        function addSelectedRow(entries) {
            rightPaginator.setTotal(rightPaginator.getTotal() + entries.length);
            var itemAddRemovePreview = rightPanel.find(".item-add-remove-preview-panel");
            var emptyRows;
            if(itemAddRemovePreview.length){
                emptyRows = itemAddRemovePreview.find(".empty");
            } else {
                emptyRows = rightTable.find(".empty");
            }
            if (emptyRows.length < entries.length) {
                fillRightGaps(entries.length, itemAddRemovePreview);
                if (rightPaginator.getPageCount() == rightPaginator.getCurrentPage() + 1) {
                    rightPaginator.setCurrentPage(rightPaginator.getCurrentPage() + 1, true);
                }
            }
            $.each(entries, function () {
                var emptyRow;
                if (this.row) {
                    emptyRow = this.row;
                } else if(itemAddRemovePreview.length){
                    emptyRow = itemAddRemovePreview.find(".empty:first").removeClass("empty");
                } else{
                    emptyRow = rightTable.find(".empty:first").removeClass("empty");
                }
                var emptyColums = emptyRow.find("td").not(":last");
                for (var i = 0; i < this.name.length; i++) {
                    var td = emptyColums[i];
                    if ($(td).find('span').length > 0) {
                        $(td).prepend(this.name[i] + ' ');
                        $(td).find('span').addClass(itemName);
                        $(td).addClass(itemName+'-column');
                        $(td).attr('id', this.value[i]);
                        $(td).attr('name', this.name[i]);

                        bm.attacheCustomEvents(rightTable.closest(".fee-select-customer-popup"))

                    } else {
                        // td.text(this.name[i])
                        $(emptyColums[i]).text(this.name[i]);
                    }
                }
                emptyRow.attr("type", itemName).find("td.actions-column").attr("item", this.value).attr("type", itemName);
                emptyRow.addClass(itemName);
                var _self = this;
                emptyRow.find("input[type='hidden']").each(function (i, elm) {
                    $(elm).attr("name", fieldNames[i]).val(_self.value[i]);
                });
                if(emptyRow.find(".editable").length){
                    bm.makeTableCellEditable(emptyRow.find(".editable"), app.editCategory.productCategory_editable);
                }
                funcBinds.onNewSelection(emptyRow)
            });
            rightTable.trigger("row-update");

            var totalSelected = rightPanel.find("tr."+itemName).length;
            var counterPanel = rightPanel.find(".selected-"+itemName+"-count");
            if(counterPanel.length){
                counterPanel.text("("+totalSelected+")");
            }
            rightPaginator.onPageClick(rightPaginator.getCurrentPage());
        }

        function checkInputs(inputs) {
            inputs.closest("tr").addClass("selected");
            var entries = [];
            var rightTableColumns = $(rightTable.find("tr")[0]).find("th").not(":last").not(".ignore-count");
            inputs.each(function () {
                var input = $(this);
                var value = [];
                input.siblings("input").each(function () {
                    value.push($(this).val())
                });
                var row = input.closest("tr");
                var values = [];
                var leftTableColums = row.find("td").not(":last");
                if (rightTableColumns.length == leftTableColums.length) {
                    for (var i = 0; i < rightTableColumns.length; i++) {
                        values.push($(leftTableColums[i]).text().trim());
                    }
                } else if (rightTableColumns.length < leftTableColums.length) {
                    var i = 0;
                    var tempText = [];
                    while (i < rightTableColumns.length - 1) {
                        values.push($(leftTableColums[i]).text().trim());
                        i++;
                    }
                    while (i < leftTableColums.length) {
                        if ($(leftTableColums[i]).text()) {
                            tempText.push($(leftTableColums[i]).text().trim());
                        }
                        i++;
                    }
                    values.push(tempText.join('-'));
                } else {
                    var l = 0;
                    var r = 0;
                    while (r < rightTableColumns.length) {
                        values.push($(leftTableColums[l]).text().trim());
                        l++;
                        r++;
                        if (l == leftTableColums.length) {
                            l = 0;
                        }
                    }
                }
                entries.push({name: values, value: value});
            });
            addSelectedRow(entries);
            updateHeaderCheckStatus();
        }

        function updateHeaderCheckStatus() {
            var checkBoxes = leftTable.find("td.actions-column :checkbox");
            if (checkBoxes.filter(":checked").length == 0) {
                leftTable.find(".check-all").prop("checked", false)
            } else if (checkBoxes.length == checkBoxes.filter(":checked").length) {
                leftTable.find(".check-all").prop("checked", true)
            } else {
                leftTable.find(".check-all").checkbox("state", "partial")
            }
            if (leftTable.find(".check-all").closest("th").length) {
                leftTable.tscrollbar("content", leftTable.find(".check-all").closest("th"))
            }
            try {
                var form = leftTable.parents("form")
                var counterPanel = form.find(".selected-items-count-wrapper")
                if (counterPanel) {
                    setTimeout(function () {
                        if (form.find("input:hidden[name]").length == 1) {
                            counterPanel.text(form.find("input:hidden[name]").length + " " + counterPanel.jqObject.attr(("item-type")) + " selected");
                        } else {
                            counterPanel.text(form.find("input:hidden[name]").length + " " + counterPanel.jqObject.attr("item") + " selected");
                        }
                    }, 300);
                }
            } catch (e) {
            }
        }

        // Bidirectional sync of left-panel checkbox state to the right panel
        // (the modal-session source of truth). Accepts an optional `scope` so it can be
        // called on a DETACHED table fragment BEFORE it's inserted into the DOM — this
        // is what eliminates the visible flicker on page change. Without pre-sync the
        // user sees stale server-rendered checks for the duration of the right-table
        // reload AJAX gap.
        function syncRowsToRightPanel(scope) {
            var rightPanelToPreview = $(".item-add-remove-preview-panel").length ? $(".item-add-remove-preview-panel") : rightTable;
            scope.find("td.actions-column").each(function () {
                var value = $(this).attr(itemName);
                var rightSideRow = rightPanelToPreview.find("td[type='" + itemName + "'][item='" + value + "']");
                var tr = $(this).closest("tr");
                if (rightSideRow.length) {
                    tr.addClass("selected");
                    tr.find("input:checkbox").prop("checked", true);
                } else {
                    tr.removeClass("selected");
                    tr.find("input:checkbox").prop("checked", false);
                }
            });
        }

        function checkSelecteds() {
            var allCells = leftPanel.find("td.actions-column");
            syncRowsToRightPanel(leftPanel);
            var cBoxCount = allCells.find("input:checkbox").length,
                selectedCBoxCount = allCells.find("input:checkbox:checked").length,
                checkAll = leftTable.find(".check-all:first").filter(":hidden");
            if (cBoxCount == selectedCBoxCount && selectedCBoxCount != 0) {
                checkAll.prop("checked", true);
            } else if (selectedCBoxCount > 0) {
                checkAll.checkbox("state", "partial");
            } else {
                checkAll.prop("checked", false);
            }
            updateHeaderCheckStatus();
        }

        function reloadRightTable(callback) {
            var rightPanelSelectedTd = rightPanel.find("td.actions-column[type='" + itemName + "']");
            var ids = [];
            rightPanelSelectedTd.each(function () {
                ids.push($(this).attr("item"));
            });
            if (ids.length) {
                rightPanel.loader();
                bm.ajax({
                    url: leftTableUrl,
                    data: {ids: ids, max: ids.length},
                    dataType: "html",
                    response: function () {
                        rightPanel.loader(false);
                    },
                    success: function (resp) {
                        if(_config.resetRightPanel == false) {
                            callback();
                        } else {
                            funcBinds.resetRightPanel($(resp), rightPanelSelectedTd, callback)
                        }
                    },
                    error: function () {
                        if (callback) {
                            callback();
                        }
                    }
                })
            }
        }

        function loadLeftPanelTable(page) {
            leftPanel.loader();
            leftLoading = true;
            var param = {
                max: perPageCount,
                offset: perPageCount * (page - 1),
                fieldName: itemName
            };
            if (funcBinds.beforeLoadTableContent) {
                funcBinds.beforeLoadTableContent(param);
            }
            if (leftTableUrl) {
                bm.ajax({
                    url: leftTableUrl,
                    data: param,
                    dataType: 'html',
                    response: function () {
                        leftPanel.loader(false)
                    },
                    success: function (resp) {
                        if (initOtherContentInitialized) {
                            initOtherContentInitialized = false;
                            leftPanel.html(resp);
                            leftPanel.updateUi();
                            leftPaginator = initializeLeftPagination()
                        } else {
                            var table = $(resp).find("table");
                            // HWC-577: pre-sync checkbox state on the detached table before it
                            // enters the DOM. The post-AJAX checkSelecteds() also runs as a safety
                            // net, but doing it here removes the flicker the user would otherwise
                            // see during the reloadRightTable AJAX gap.
                            syncRowsToRightPanel(table);
                            leftTable.tscrollbar("destroy");
                            leftPanel.find("table").replaceWith(table);
                            table.updateUi();
                        }
                        var paginatorTag = $(resp).find("paginator");
                        var total = +paginatorTag.attr("total");
                        var max = +paginatorTag.attr("max");
                        var offset = +paginatorTag.attr("offset");
                        leftPaginator.update(total, max, Math.floor(offset / max) + 1);
                        leftTable = leftPanel.find("table").tscrollbar({
                            vertical: {
                                height: 442
                            }
                        });
                        reloadRightTable(function () {
                            checkSelecteds();
                            fillRequiredGaps();
                        });
                    },
                    complete: function () {
                        leftPanel.removeClass("updating");
                        leftPanel.sortableTreeList({
                            change: function(info) {
                                // Clear existing custom-ordering container
                                $("#assign-products-section .custom-ordering-data").remove();

                                // Collect all product IDs with their current order
                                var orderingData = [];
                                $("table.content.selected-items tr.selected[data-product-id]").each(function(index) {
                                    var pid = $(this).attr("data-product-id");
                                    orderingData.push(pid + ":" + index);
                                });

                                // Create hidden container with all ordering data
                                if (orderingData.length > 0) {
                                    $("#assign-products-section").append("<div class='custom-ordering-data' style='display:none;'>" + orderingData.join(",") + "</div>");
                                }
                                $('#category-product-done-btn').removeAttr('disabled');
                            },
                            containment: {left: 0, right: 0, top: 0, bottom: 0}});
                        leftPanel.updateUi()
                        leftLoading = false;
                    }
                });
            } else {
                function initOtherContent(html) {
                    leftPanel.html(html);
                    funcBinds.initContent(leftPanel, function (name, value) {
                        addSelectedRow([
                            {name: name, value: value}
                        ]);
                    });
                    leftPanel.loader(false)
                    leftLoading = false;
                    leftTable = $("");
                }

                initOtherContentInitialized = true;
                var body = funcBinds.getPanelBody(itemName, param);
                if (typeof body == "string") {
                    initOtherContent(body);
                } else {
                    body.then = initOtherContent
                }
            }
        }

        function initializeLeftPanel() {
            checkSelecteds();
            leftPanel.on("click", ".tool-icon.view", function (ev) {
                if ($(ev.target).hasClass("disabled")) {
                    return;
                }
                var cell = $(ev.target).parent();
                var id = cell.attr(itemName);
                funcBinds.onViewClick(itemName, id, cell.prev().html().trim(), cell);
            }).on("click", ".tool-icon.edit", function (ev) {
                if ($(ev.target).hasClass("disabled")) {
                    return;
                }
                var cell = $(ev.target).parent();
                var id = cell.attr(itemName);
                funcBinds.onEditClick(itemName, id, cell.prev().html().trim(), cell.closest("tr"));
            });

            var leftPaginator = initializeLeftPagination();

            return leftPaginator
        }

        function initializeRightPanel() {
            var allCells = rightPanel.find("td.actions-column");
            allCells.each(function () {
                var td = $(this);
                var tr = td.closest("tr");
                tr.addClass(td.attr("type"));
            });
        }

        function initializeLeftPagination() {
            var leftPaginator = leftPanel.find(".pagination").obj();
            if (leftPaginator) {
                leftPaginator.onPageClick = loadLeftPanelTable
            }

            container.find(".per-page-count").change(function (ev, old, newValue) {
                newValue = +newValue;
                leftPaginator.update(undefined, newValue, 1);
                rightPaginator.update(undefined, newValue, 1);
                perPageCount = newValue;
                rightPaginator.onPageClick(rightPaginator.getCurrentPage());
                funcBinds.reload();
            });
            return leftPaginator
        }

        var actionMenu = bm.createMenu(generateMenuEntries());
        if (typeof itemPerPageSelect == "number") {
            perPageCount = itemPerPageSelect;
        } else {
            if (!itemPerPageSelect) {
                itemPerPageSelect = container.find(".pagination-perpage-selector");
            } else if (!itemPerPageSelect.is("select")) {
                itemPerPageSelect = itemPerPageSelect.find("select");
            }
            itemPerPageSelect.change(function () {
                perPageCount = +this.value;
                loadLeftPanelTable(1);
                rightPaginator.setItemsPerPage(perPageCount);
                fillRequiredGaps();
                rightPaginator.onPageClick(rightPaginator.getCurrentPage());
            });
            perPageCount = +itemPerPageSelect.val();
        }
        if (!itemPerPageSelect || !itemPerPageSelect.length) {
            perPageCount = 10;
        }
        var rightPanel = container.find(".last-column .column-content");
        var leftPanel = container.find(".first-column .column-content");
        var diceRow = rightPanel.find(".action-column-dice-content table tr").addClass("empty");
        var rightTable = rightPanel.find("table:first");
        var leftTable = leftPanel.find("table:first");
        if (actions["column-sort"]) {
            rightTable.find("th:eq(0)").sortablecolumn({});
            rightTable.bind("sort", function () {
                rightPaginator.setCurrentPage(rightPaginator.getCurrentPage(), true);
                rightTable.tscrollbar("content", rightTable.find("th:eq(0)"))
            });
        }
        var rightPaginator = rightPanel.find(".pagination").obj();
        rightPaginator.onPageClick = rightPanelPageReload;
        fillRequiredGaps();
        var rightTableToPreview = $(".double-table-to-selected-removed-preview").length ?  $(".double-table-to-selected-removed-preview") :  rightTable;
        rightTableToPreview .on("click", ".remove-item", function () {
            var cell = $(this).closest("td");
            var values = getCellData(cell);
            var type = cell.attr("type");
            var row = cell.closest("tr");
            funcBinds.onDeleteClick(type, values, cell.prev().html().trim(), row);
            var inputsToUncheck = $();
            if (leftTable && itemName == type) {
                var value = cell.attr("item");
                inputsToUncheck = inputsToUncheck.add(leftTable.find("td.actions-column[" + type + "='" + value + "'] input:checkbox"));
                inputsToUncheck.prop("checked", false)
            }
            removeSelections(inputsToUncheck, row)
        });
        container.on("click", ".action-navigator", function () {
            var navigator = $(this);
            var hiddenClasses = navigator.attr("entry-hidden");
            actionMenu.find(hiddenClasses).addClass("hidden");
            if (navigator.is(".collapsed")) {
                if (!navigator.is("[tabindex]")) {
                    navigator.attr("tabindex", "0")
                }
                navigator.removeClass("collapsed").addClass("expanded");
                navigator.after(actionMenu);
                var height = navigator.outerHeight();
                var menuHeight = actionMenu.outerHeight();
                var requiredBottom = navigator.offset().top - $(window).scrollTop() + height + menuHeight;
                var actualBottom = $(window).height();
                if (actualBottom < requiredBottom) {
                    actionMenu.position({
                        my: "right bottom",
                        at: "right top+1",
                        of: navigator
                    }).addClass("up-side");
                    navigator.addClass("up-side")
                } else {
                    actionMenu.position({
                        my: "right top",
                        at: "right bottom-1",
                        of: navigator
                    })
                }
                navigator.focus().on("blur", function () {
                    hideMenu(navigator)
                });
            } else {
                hideMenu(navigator)
            }
        });
        container.on("mousedown", ".menu-item", function (ev) {
            var item = $(this);
            if (item.is(".disabled")) {
                return;
            }
            var navigator = item.closest(".floating-menu").siblings(".action-navigator");
            onMenuActionClick(item.attr("action"), navigator);
        });

        var rightTableToPreview = $(".double-table-to-selected-removed-preview").length ?  $(".double-table-to-selected-removed-preview") :  rightTable;
        rightTableToPreview.find(".remove-all").on("click", clearCurrentPageSelections);
        rightTable.tscrollbar({
            vertical: {
                height: 443
            }
        });
        rightTable.on("click", "td.actions-column .move-up", function (ev) {
            var thisRow = $(ev.target).closest("tr");
            var prevRow = thisRow.prev();
            if (prevRow.length && prevRow.has("th").length == 0) {
                thisRow.swap(prevRow);
                if (prevRow.is(":hidden")) {
                    thisRow.hide();
                    prevRow.show();
                }
                rightTable.find("th:eq(0)").sortablecolumn("resetSortState");
                rightTable.tscrollbar("content", rightTable.find("th:eq(0)"))
            }
            rightTable.trigger("change")
        }).on("click", "td.actions-column .move-down", function (ev) {
            var thisRow = $(ev.target).closest("tr");
            var nextRow = thisRow.next();
            if (nextRow.length && !nextRow.is(".empty")) {
                thisRow.swap(nextRow);
                if (nextRow.is(":hidden")) {
                    thisRow.hide();
                    nextRow.show();
                }
                rightTable.find("th:eq(0)").sortablecolumn("resetSortState");
                rightTable.tscrollbar("content", rightTable.find("th:eq(0)"))
            }
            rightTable.trigger("change")
        });
        rightPaginator.setCurrentPage(1, true);
        var leftPanel = container.find(".first-column .column-content");
        var leftLoading = false;
        leftPanel.on("change", "td.actions-column input:checkbox", function (ev) {
            if ($(ev.target).prop("checked")) {
                checkInputs($(ev.target));
            } else {
                uncheckInputs($(ev.target));
            }
        });
        var leftTable = leftPanel.find("table").tscrollbar({
            vertical: {
                height: 443
            }
        });
        leftPanel.on("change", ".check-all", function (ev) {
            if ($(ev.target).prop("checked")) {
                var inputsToCheck = leftPanel.find("td:visible input:checkbox:not(:checked)")
                if (inputsToCheck.length) {
                    inputsToCheck.each(function () {
                        $(this).prop("checked", true)
                    });
                    checkInputs(inputsToCheck);
                } else {
                    updateHeaderCheckStatus()
                }
            } else {
                var checkedBoxes = leftPanel.find("td input:checkbox:checked");
                if (checkedBoxes.length) {
                    checkedBoxes.each(function () {
                        $(this).prop("checked", false)
                    });
                    uncheckInputs(checkedBoxes);
                }
            }
        });
        var leftPaginator = leftTableUrl ? initializeLeftPanel() : null;
        initializeRightPanel();
        return funcBinds;
    },
    unique: function (config) {
        var _config = {
            url: '',
            elm: undefined,
            editMode: false
        };
        var lockId = bm.getUUID();
        config = $.extend({lockId: lockId}, _config, config);
        var form = config.elm.closest("form");

        function manageTrashRow(row, list) {
            if (list.length == 1) {
                $(list[0]).closest(".form-row").after(row);
                var deleteBox = row.find(".trash-duplicate-delete");
                if (deleteBox.is(":checked")) {
                    deleteBox.trigger("change")
                }
                deleteBox.attr("name", "deleteTrashItem." + list[0].name);
                row.show();
            } else {
                row.hide();
            }
        }

        function clearErrorLock(form, el) {
            form.form("unlock", lockId);
            if (el.is(".trash-conflict-element")) {
                el.removeClass("trash-conflict-element");
                var trashRow = form.find(".trash-row");
                var trashList = form.data("trash-conflicts-list");
                trashList.remove(el[0]);
                manageTrashRow(trashRow, trashList);
            }
        }

        var composite_name = config.elm.attr("composite-unique");
        var composite_field;
        var elm = config.elm;
        if (composite_name) {
            composite_field = form.find("[name='" + composite_name + "']")
        }
        var last_time = 0;

        function afterUniqueFieldChange() {
            var now_time = new Date().getTime();
            if (now_time - last_time <= 20) {
                return
            }
            last_time = now_time;
            var el = config.elm;
            var params = {};
            var form = config.form || el.closest("form");
            if (config.editMode) {
                params.id = form.find("input[name=id]").val();
            }
            params.field = el.attr("unique-field") || el.attr("name");
            params.value = el.val().trim();
            params.customName = el.attr("unique-field-name");
            params.customFieldType = el.attr("unique-field-type");
            params.customDomainName = el.attr("unique-domain-name");
            if (composite_name) {
                params.compositeField = composite_name;
                params.compositeValue = composite_field.val().trim();
            }
            if (!params.value) {
                return;
            }
            if (this != el[0]) {
                el[0].validation_obj.clear()
            }
            bm.ajax({
                url: config.url,
                data: params,
                show_response_status: false,
                success: function () {
                    config.elm.trigger("unique");
                    clearErrorLock(form, el)
                },
                error: function (xhr, status, data) {
                    el[0].validation_obj.showError({msg_template: data.message});
                    form.form("lock", lockId);
                    if (data.errorFlag == "inTrash") {
                        el.data("trash-params", params);
                        if (!el.is(".trash-conflict-element")) {
                            var trashRow = form.find(".trash-row");
                            var trashList = form.data("trash-conflicts-list");
                            if (!trashList) {
                                form.data("trash-conflicts-list", trashList = [el[0]]);
                            } else {
                                trashList.push(el[0])
                            }
                            manageTrashRow(trashRow, trashList);
                            el.addClass("trash-conflict-element")
                        }
                    } else if (el.is(".trash-conflict-element")) {
                        el.removeClass("trash-conflict-element");
                        var trashRow = form.find(".trash-row");
                        var trashList = form.data("trash-conflicts-list");
                        trashList.remove(el[0]);
                        manageTrashRow(trashRow, trashList);
                    }
                }
            });
        }

        elm.on("change blur", afterUniqueFieldChange);
        if (composite_field) {
            composite_field.on("change", afterUniqueFieldChange)
        }
        form.find(".trash-duplicate-restore").off("click").click(function () {
            var trashList = form.data("trash-conflicts-list");
            var params = $(trashList[0]).data("trash-params");
            var _config = trashList[0].unique_config;
            bm.ajax({
                url: _config.restoreUrl,
                data: params,
                success: function (resp) {
                    form.trigger("trash-restore", [resp.type, resp.id]);
                    app.global_event.trigger("trash-restore", [resp.type, resp.id]);
                    app.global_event.trigger(resp.type + "-restore", [resp.id]);
                    var popup = form.closest('.popup').obj(POPUP);
                    if (popup) {
                        popup.close()
                    }
                }
            })
        });
        form.find(".trash-duplicate-delete").off("change").on("change", function () {
            var trashList = form.data("trash-conflicts-list");
            var _config = trashList[0].unique_config;
            if ($(this).prop("checked")) {
                form.form("unlock", _config.lockId).on("ajax-submit-success", function () {
                    app.global_event.trigger("trash-delete")
                });
            } else {
                form.form("lock", _config.lockId).off("ajax-submit-success");
            }
        });
        var obj = ValidationField.createDetachedField(elm);
        config.elm.on("focus", function () {
            clearErrorLock(form, config.elm);
            obj.clear();
        });
        config.elm[0].validation_obj = obj;
        config.elm[0].unique_config = config
    },
    unmask: function (tag) {
        tag.unmask();
    },
    viewPopup: function (url, data, popConfig) {
        if (!app.viewCaches) {
            app.viewCaches = {};
        }
        var cache_key = url + "#" + bm.hash(data);
        var viewer = app.viewCaches[cache_key];
        if (viewer) {
            viewer.setActive();
            return viewer;
        }
        viewer = new POPUP($.extend({
            ajax_url: url,
            ajax_settings: {
                data: data
            },
            show_title: false,
            clazz: "view-popup",
            draggable: true,
            drag_handle: "*",
            drag_cancel: ":input, .view-content-block",
            modal: false,
            width: 500
        }, popConfig));
        viewer.on("close", function () {
            delete app.viewCaches[cache_key];
        });
        return app.viewCaches[cache_key] = viewer;
    },
    waitPopup: function () {
        return new POPUP({
            show_close: false,
            width: 620,
            height: 400,
            el: $('<div><div class="bg-white div-mask" style="position: absolute; top: 0; bottom: 0; left: 0; right: 0"><div class="loader2"></div><div class="wait-message">' + $.i18n.prop('this.may.take.some.time') + '</div></div></div>')
        });
    },
    countryChange: function (container, config) {
        container.find("#countryId").on('change', function () {
            var name = this.name;
            var type;
            if (name.indexOf(".")) {
                type = name.split(".")[0]
            }
            var prefixed = $(this).attr("name").endsWith("default_country");
            var id = $(this).val();
            var data = $.extend({}, {
                id: id,
                inputClass: "large",
                stateLabel: prefixed ? "default.state" : "state",
                stateName: (type ? type + "." : "") + (prefixed ? "default_state" : "state"),
                noSelection: null
            }, config);
            bm.ajax({
                url: app.baseUrl + "app/loadStateForCountry",
                dataType: 'html',
                data: data,
                success: function (data) {
                    container.find(".form-row.state-selector-row").remove();
                    container.find(".form-row.country-selector-row").after(data);
                    container.find(".form-row.state-selector-row").updateUi();
                    container.trigger("state-load");
                }
            })
        });
    },
    countryChangeSelection: function (countrySelect, isMultiple, params) {
        var countryRow = countrySelect.closest(".form-row");
        var stateSelectionRow = countryRow.next('.state-selector-row');
        var postCodeRow = countryRow.siblings('.post-code');
        if (stateSelectionRow) {
            bindStateChange(stateSelectionRow);
        }
        var country = countrySelect.val();
        if (!country || country.length > 1) {
            postCodeRow.hide();
        }
        countrySelect.change(function () {
            var value = $(this).val();
            stateSelectionRow.remove();
            if ((value && value.length == 1) || !isMultiple) {
                $.extend(params, {id: isMultiple ? value[0] : value});
                bm.ajax({
                    url: app.baseUrl + "app/loadStateForCountry",
                    dataType: 'html',
                    data: params,
                    success: function (data) {
                        stateSelectionRow = $(data).insertAfter(countryRow);
                        if (stateSelectionRow) {
                            bindStateChange(stateSelectionRow);
                            stateSelectionRow.updateUi();
                        }
                        countryRow.parents("form").trigger("state-load")
                    }
                });
                postCodeRow.show();
            } else if (isMultiple) {
                postCodeRow.hide();
            }
        });
        function bindStateChange(stateSelectionRow) {
            stateSelectionRow.find("select[name=zone\\.state\\.id]").change(function () {
                var value = $(this).val();
                if (value && value.length > 1) {
                    postCodeRow.hide();
                } else if (postCodeRow) {
                    postCodeRow.show();
                }
            }).trigger("change");
        }
    },
    tableToggleRow: function (container, callback) {
        container.find(".toggle-cell").click(function () {
            var _this = $(this);
            var detailsRow = _this.parents("tr").next();
            if (_this.is(".collapsed")) {
                _this.removeClass("collapsed").addClass("expanded");
                detailsRow.show()
            } else {
                _this.removeClass("expanded").addClass("collapsed");
                detailsRow.hide()
            }
            if (callback) {
                callback(_this);
            }
        })

    },
    selectFromAssetLibrary: function (title, selectButtonHandler, fileExtensions, config, isFile, forFileSelection) {
        var fileUrl;
        var isSelected;
        config = $.extend({}, config, {
            _self: this,
            width: 800,
            clazz: "asset-library-select",
            events: {
                content_loaded: function (popup) {
                    var dom = this;
                    var targeteBody = this.find(".remote_folders").scrollbar({
                        vertical: {
                            offset: 2
                        }
                    });
                    var targetDirPreviewPanel = this.find(".asset-library-image-preview").scrollbar({
                        vertical: {
                            offset: 2
                        }
                    });
                    var backPath;
                    var selectedParent;
                    function loadAssetLibrary(repository, parentNodeContainer) {
                        if (typeof repository == "undefined") {
                            repository = "pub"
                        }
                        WebDAVClient.doPropFind(repository, this, {
                            onPopulate: function (childList) {
                                var lastFolderIndex = childList.folders.length - 1;
                                $.each(childList.folders, function (key, value) {
                                    var nodeContainer = "";
                                    var lastSib = "";
                                    if(lastFolderIndex == key){
                                        lastSib = "tree-lastsib"
                                    }
                                    if(parentNodeContainer){
                                        nodeContainer = $("<div class='tree-container'><div class='tree-node-container " + lastSib + "'></div></div>");
                                    }else {
                                        nodeContainer = $("<div class='tree-node-container " + lastSib + "'></div>");
                                    }
                                    var hasChildParentClass = "";
                                    var treeConnector = "";
                                    var treeExpander = "";
                                    if(value.hasChildFolder){
                                        hasChildParentClass = "tree-has-children tree-lazy tree-exp-e tree-ico-e";
                                        treeExpander = "<span class=\"tree-expander\"></span>" ;
                                    }else {
                                        treeExpander = "<span class='tree-connector'></span>";
                                    }

                                    var $tr = $('<div class="tree-node folder '+ hasChildParentClass +'">'+ treeExpander + treeConnector +'<span class="tree-icon"></span><span class="tree-title" title="' + value.name + '">' + value.name + '</span></div>');
                                    nodeContainer.append($tr);
                                    if(parentNodeContainer){
                                        nodeContainer.find(".tree-node-container").append($tr);
                                    }else {
                                        nodeContainer.append($tr);
                                    }
                                    if(parentNodeContainer){
                                        parentNodeContainer.append(nodeContainer);
                                    } else {
                                        targeteBody.append(nodeContainer);
                                    }
                                    $tr.find(".tree-expander").click(function () {
                                        var node = this.jqObject.closest(".tree-node");
                                        if(node.hasClass("tree-expanded")){
                                            node.closest(".tree-container").find(".tree-container").remove();
                                            node.removeClass("tree-expanded");
                                        }else {
                                            loadAssetLibrary(value.path, nodeContainer);
                                            node.addClass("tree-expanded");
                                        }
                                    });
                                    $tr.click(function () {
                                        loadAssetDirFiles(value.path, this.jqObject)
                                    });
                                });
                                loadAssetDirFiles(repository, this.jqObject, true);
                                dom.find(".public-folder-root").on("click", function () {
                                    loadAssetDirFiles(repository, this.jqObject);
                                })
                            }
                        })
                    }

                    function loadAssetDirFiles(repository, dir, isInitial) {
                        if (!isInitial) {
                            if (!isFile) {
                                dom.find(".remote_folders").find(".selected").removeClass("selected");
                            } else {
                                dom.find(".columns.first-column.tree-panel").find(".selected").removeClass("selected");
                            }
                        }
                        dir.addClass("selected");
                        if (typeof repository == "undefined") {
                            repository = "pub"
                        }
                        if (!isFile && !forFileSelection) {
                            isSelected = true;
                            fileUrl = repository.substring(repository.indexOf("/"))
                        }
                        WebDAVClient.doPropFind(repository, this, {
                            onPopulate: function (childList) {
                                targetDirPreviewPanel.html("");
                                $.each(childList.files, function (key, value) {
                                    var imageExt = ["bmp", "gif", "jpg", "png", "psd", "pspimage", "thm", "tif", "yuv", "jpeg"];
                                    var extension = value.clazz;
                                    fileExtensions = fileExtensions ? fileExtensions : imageExt;
                                    if (fileExtensions.contains(extension) && isFile != false) {
                                        fileUrl = bm.encodePath(app.systemPubUrl + "/" + value.path.substring(value.path.indexOf("/")+1));
                                        var $tr = $('<div  title="' + value.name + '"class="file grid-item  ' + extension + '"> <img class="tree-image" src="'+ fileUrl +'"><div class="title tree-title">' + value.name + '</div></div>');
                                        targetDirPreviewPanel.append($tr);
                                        $tr.click(function () {
                                            isSelected = true;
                                            $tr.addClass("selected").siblings(".selected").removeClass("selected");
                                            fileUrl = bm.encodePath(app.systemPubUrl + "/" + value.path.substring(value.path.indexOf("/")))
                                        })
                                    }
                                })
                            }
                        })
                    }
                    loadAssetLibrary("pub");
                    this.find(".file-selector").form({
                        preSubmit: function () {
                            if (isSelected) {
                                selectButtonHandler(fileUrl);
                                popup.close();
                            } else {
                                if (isFile) {
                                    bm.notify($.i18n.prop("file.not.selected"), "error")
                                } else if (isFile === undefined) {
                                    bm.notify($.i18n.prop("image.not.selected"), "alert")
                                } else {
                                    bm.notify($.i18n.prop("folder.not.selected"), "error")
                                }
                            }
                            return false
                        }
                    })
                }
            }
        });
        bm.editPopup(app.baseUrl + "remoteRepository/selectFileFromAssetLibraryForWidget", title, "", {isFile: isFile === undefined ? isFile : true}, config)
    },
    makeTableCellEditable: function (tds, callback) {
        function editingTd() {
            var icon = $(this);
            var td = icon.parent();
            var tr = td.parent();
            td.addClass("editing");
            var tdVal = td.find(".value");
            var oldVal = tdVal.chide().text().trim();
            var validation = td.attr("validation");
            var maxlength = td.attr("maxlength");
            td.append("<input type='text' class='td-full-width' maxlength='" + (maxlength ? maxlength : "") + "' validation='" + (validation ? validation : "") + "'>");
            var restrict = td.attr("restrict");
            var editField = td.find("input[type='text']");
            editField.val(oldVal);
            if (restrict) {
                editField[restrict]();
            }
            var input = editField.get(0);

            var hiddenField = td.find("input[type='hidden']");

            input.selectionStart = input.selectionEnd = input.value.length;
            input.focus();
            td.trigger("cell-edit");
            tr.siblings("tr.data-row").addBack().each(function () {
                $(this).trigger("heightChange");
            });
            function updateTd($this) {
                var editFieldVal = $this.val();
                tdVal.text(editFieldVal);
                if (editFieldVal != oldVal) {
                    hiddenField.val(editFieldVal);
                    if (callback && callback(td, editFieldVal, oldVal) === false) {
                        input.focus();
                        return;
                    }
                }
                editField.remove();
                td.removeClass("editing");
                tdVal.cshow();
                tr.siblings("tr.data-row").addBack().each(function () {
                    $(this).trigger("heightChange");
                })
            }

            editField.on("focusout", function () {
                updateTd($(this));
            }).on("keypress", function (e) {
                if (e.keyCode == 13) {
                    e.preventDefault();
                    updateTd($(this));
                }
            });
        }

        tds.each(function () {
            var td = $(this);
            if (!td.find(".value").length) {
                var html = td.html();
                td.html('<span class="value"></span>');
                td.find(".value").html(html)
            }
            var clazz = "edit";
            if (td.is(".custom-edit")) {
                clazz = "change-all";
                td.append('<span class="fake-link ' + clazz + '">' + $.i18n.prop("change.all") + '</span>');
            } else {
                td.append('<span class="tool-icon ' + clazz + '"></span>');
            }
            var editBtn = td.find("." + clazz);
            editBtn.on("click", editingTd);
        });
    },
    makeTableCellSelectable: function (tds, select, callback, before) {
        function editingTd() {
            var icon = $(this);
            var td = icon.parent();
            td.addClass("editing");
            var tdVal = td.find(".value");
            var tdText = td.find(".text");
            var oldVal = tdVal.chide().text().trim();
            var _select = $.isFunction(select) ? select(td) : select.clone().show();
            _select.addClass('td-full-width');
            if (td.is(".hidden-overflow-selectable")) {
                var div = $("<div class='selectable-td-proxy'></div>").appendTo(document.body);
                div.append(_select);
                div.position({
                    my: "left top",
                    at: "left top",
                    of: td,
                    collision: "none"
                });
                div.width(td.outerWidth(), true);
                div.height(td.outerHeight(), true)
            } else {
                td.append(_select);
            }
            _select.val(oldVal);
            _select.chosen();
            _select.on("chosen:hiding_dropdown", function () {
                var editFieldVal = $(this).val();
                _select.chosen("remove");
                if (oldVal != editFieldVal && editFieldVal != undefined) {
                    tdVal.text(editFieldVal);
                    var selectedText = $(this).find("option:selected").text();
                    tdText.text(selectedText);
                    if (callback) {
                        callback(td, editFieldVal, selectedText, oldVal);
                    }
                }
                td.removeClass("editing");
                if (td.is(".hidden-overflow-selectable")) {
                    $(".selectable-td-proxy").remove()
                }
                tdVal.cshow();
            });
            _select.chosen("dropshow");
            return false;
        }

        tds.each(function () {
            var td = $(this);
            if (!td.find(".value").length) {
                var html = td.html();
                td.html('<span class="value"></span><span class="text"></span>');
                td.find(".value").html(html);
                td.find(".text").html(html)
            }
            var clazz = "edit";
            if (td.is(".custom-select")) {
                clazz = "change-all";
                td.prepend('<span class="fake-link ' + clazz + '">' + $.i18n.prop("change.all") + '</span>');
            } else {
                td.append('<span class="tool-icon ' + clazz + '"></span>');
            }
            var editBtn = td.find("." + clazz);
            editBtn.on("click", function () {
                if (before && before(td) === false) {
                    return;
                }
                editingTd.call(this)
            });
        });
    },
    autoToggle: function (box) {
        var namespace = bm.getUUID();

        function filterRadios(next_target) {
            var radios = next_target.filter(":radio");
            next_target = next_target.not(radios);
            var processed = [];
            radios.each(function () {
                var $this = $(this), name = $this.attr("name");
                if (processed.contains(name)) {
                    return;
                }
                processed.push(name);
                var win = radios.filter("[name='" + name + "']:checked");
                if (!win.length) {
                    win = box.find("[name='" + name + "']:checked")
                }
                if (!win.length) {
                    win = $this
                }
                next_target = next_target.add(win)
            });
            return next_target
        }

        function chainToggle(target, show, mainTargetSelector) {
            var next_target = target.find("[toggle-target]");
            if (target.is("[toggle-target]")) {
                next_target = next_target.add(target)
            }
            next_target = filterRadios(next_target);
            next_target.each(function () {
                var _target = $(this);
                var evName = _target.is("select, :checkbox, :radio") ? "change" : "click";
                if (show) {
                    _target.triggerHandler(evName + "." + namespace, [false, mainTargetSelector])
                } else {
                    _target.triggerHandler(evName + "." + namespace, [true, mainTargetSelector])
                }
            })
        }

        function handleToggle(target, checked, animation, mainTargetSelector) {
            target.each(function () {
                var _target = $(this);
                if (mainTargetSelector && _target.is(mainTargetSelector)) {
                    return;
                }
                var reverse = _target.is("[do-reverse-toggle]");
                var _checked = checked;
                if (reverse) {
                    _checked = !checked
                }
                var is_hide = _target.css("display") == "none";
                if (_checked && is_hide) {
                    var done = function () {
                        chainToggle(_target, true, mainTargetSelector);
                    };
                    if (animation) {
                        _target.show(animation, done);
                    } else {
                        _target.show();
                        done()
                    }
                } else if (!_checked && !is_hide) {
                    var done = function () {
                        var validatable = _target.find('[validation]:not([validate-on="call-only"])');
                        if (_target.is("[validation]")) {
                            validatable = validatable.add(_target)
                        }
                        validatable.trigger('[validation]:not([validate-on="call-only"])');
                        chainToggle(_target, false, mainTargetSelector);
                        _target.find("input").valid();
                    };
                    if (animation) {
                        _target.hide(animation, done);
                    } else {
                        _target.hide();
                        done()
                    }
                } else {
                    chainToggle(_target, _checked, mainTargetSelector);
                }
            })
        }

        function isATargetOrInChain(toggler) {
            var yes = false;
            var targets = box.find("[toggle-target]");
            targets.each(function () {
                var target = $(this).attr("toggle-target");
                if ($(this).is("select")) {
                    var options = $(this).find("option");
                    options.each(function () {
                        var targetSelector = "." + target + "-" + $(this).val();
                        if (toggler.closest(targetSelector, box[0]).length) {
                            yes = true;
                            return false;
                        }
                    })
                } else {
                    yes = toggler.closest("." + target, box[0]).length
                }
                if (yes) {
                    return false
                }
            });
            return yes;
        }

        var getAllChainedTargets = function (toggler) {
            var allTogglers = toggler;
            toggler.each(function () {
                var _toggler = $(this);
                var nextTarget;
                if (_toggler.is("select")) {
                    var type = _toggler.val().replaceAll("\\.", "_");
                    nextTarget = box.find("." + _toggler.attr("toggle-target") + "-" + type);
                } else {
                    nextTarget = box.find("." + _toggler.attr("toggle-target"))
                }
                if (nextTarget.length) {
                    var nextTogglers = nextTarget.find("[toggle-target]");
                    nextTogglers = nextTogglers.add(nextTarget.filter("[toggle-target]"));
                    if (nextTogglers.length) {
                        allTogglers = allTogglers.add(getAllChainedTargets(nextTogglers))
                    }
                }
            });
            return allTogglers
        };
        var allTargets = box.find("[toggle-target]:not('.stop-toggle')").each(function () {
            var toggler = $(this);
            var animation = toggler.attr("toggle-anim") ? toggler.attr("toggle-anim") : "blind";
            if (animation == "none") {
                animation = null;
            }
            var evName;
            if (toggler.is("select")) {
                evName = "change";
                toggler.on(evName + "." + namespace, function (e, forceOff, excludeTargets) {
                    if (typeof forceOff != "boolean") {
                        forceOff = false;
                        excludeTargets = null
                    }
                    var type = toggler.val() ? toggler.val().replaceAll("\\.", "_") : "";
                    var target = "." + toggler.attr("toggle-target") + "-" + type;
                    var toHideTargets = $();
                    toggler.find("option").each(function (i, opt) {
                        var option_type = $(opt).val().replaceAll("\\.", "_");
                        if (option_type != type) {
                            var selector = toggler.attr("toggle-target") + "-" + option_type;
                            var hideTarget = box.find("." + selector);
                            toHideTargets = toHideTargets.add(hideTarget.not(target))
                        }
                    });
                    target = box.find(target);
                    var subExcludeTargets = excludeTargets ? excludeTargets.add(getAllChainedTargets(target)) : getAllChainedTargets(target);
                    handleToggle(toHideTargets, false, animation, subExcludeTargets);
                    handleToggle(target, forceOff ? false : true, animation, excludeTargets)
                });
            } else if (toggler.is(":checkbox, :radio")) {
                evName = "change";
                var targetText = "." + toggler.attr("toggle-target");
                var target = box.find(targetText);

                function changeHandler(e, forceOff, excludeTargets, isMain) {
                    if (typeof forceOff != "boolean") {
                        forceOff = false;
                        excludeTargets = null
                    }
                    if (!forceOff) {
                        var otherRadios = box.find("[name='" + toggler.attr("name") + "']").not(toggler).filter("[toggle-target]:not([independent])");
                        var toHideTargets = $();
                        otherRadios.each(function (i, opt) {
                            var hideTarget = box.find("." + $(opt).attr("toggle-target"));
                            toHideTargets = toHideTargets.add(hideTarget.not(target))
                        });
                        handleToggle(toHideTargets, false, animation, isMain ? (excludeTargets ? excludeTargets.add(getAllChainedTargets(target)) : getAllChainedTargets(target)) : excludeTargets)
                    }
                    var checked = toggler.prop("checked");
                    toggler.state = checked;
                    if (toggler.is(".toggle-reverse")) {
                        checked = !checked
                    }
                    handleToggle(target, forceOff ? false : checked, animation, excludeTargets, isMain);
                }

                toggler.on(evName + "." + namespace, function (a, b, c) {
                    changeHandler(a, b, c, true)
                });
                if (toggler.is(":radio")) {
                    var otherRadios = box.find("[name='" + toggler.attr("name") + "']:radio").not("[toggle-target]");
                    otherRadios.on(evName + "." + namespace, function (e, xx, excludeTarget) {
                        if (typeof xx != "boolean") {
                            excludeTarget = null
                        }
                        if (toggler.state || toggler.state === undefined) {
                            changeHandler(e, true, excludeTarget)
                        }
                    })
                }
            } else {
                evName = "click";
                var target = box.find("." + toggler.attr("toggle-target"));
                toggler.on(evName + "." + namespace, function (e, forceOff, excludeTargets) {
                    var checked = toggler.attr("row-expanded") == "true";
                    if (typeof forceOff == "undefined") {
                        checked = !checked;
                        toggler.attr("row-expanded", "" + checked)
                    }
                    handleToggle(target, forceOff ? false : checked, animation, excludeTargets)
                })
            }
        });
        filterRadios(allTargets).each(function () {
            var toggler = $(this);
            var evName = toggler.is("select, :checkbox, :radio") ? "change" : "click";
            if (!isATargetOrInChain(toggler)) {
                toggler.triggerHandler(evName + "." + namespace, [false]);
            }
        });
        return box
    },
    cBaseDoc: function (nodes) {
        var slideDom = $("<div id='documentation-slide' style='display: none'><div class='icon-block'><span class='tool-icon close-icon' title='" + $.i18n.prop("close") + "'></span></div><iframe src='about:blank'></iframe></div>");
        var body = $(document.body);
        nodes.each(function () {
            var node = $(this);
            if (!node.attr("attached")) {
                node.click(function () {
                    var docUrl = node.attr("target-url");
                    if (slideDom.is(":hidden")) {
                        body.prepend(slideDom);
                        slideDom.css({height: window.innerHeight});
                        slideDom.find(".tool-icon.close-icon").click(function () {
                            slideDom.toggle("slide", {direction: 'right'}, function () {
                                body.find("#documentation-slide").remove();
                            });
                        });
                        slideDom.toggle("slide", {direction: 'right'});
                        slideDom.find("iframe").attr("src", docUrl);
                    } else {
                        slideDom.find("iframe").attr("src", docUrl);
                    }
                });
                node.attr("attached", true);
            }
        });
    },
    floatingPanel: function (ref, url, data, conf) {
        conf = conf ? conf : {};
        conf.clazz = "floating-panel-popup" + (conf.clazz ? " " + conf.clazz : "")
        var defaultUiPosition = {
            my: "right top",
            at: "right+10 bottom+0",
            of: ref,
            collision: conf.position_collison
        };

        if(ref.is(".bulk-action")){
            defaultUiPosition = {
                my: "right top",
                at: "right+84 bottom+10",
                of: ref,
                collision: conf.position_collison
            }
        }

        var popup = new POPUP($.extend({
            ajax_url: url,
            ajax_settings: {
                data: data
            },
            show_title: false,
            masking: false,
            show_close: false,
            close_on_blur: true,
            modal: false,
            is_center: true,
            width: 350,
            ui_position:  conf.ui_position  ? conf.ui_position: defaultUiPosition
        }, conf));
        return popup
    },

    selectionFloatingPanel: function (ref, url, data, config) {
        var instance = {
            isLoaded: false,
        };
        instance.reload = function () {
            var _self = this, element = _self.el, data = {searchText: _self.searchText};
            element.loader();
            config.beforeReload && config.beforeReload(data);
            bm.ajax({
                url: url,
                data: data,
                dataType: "html",
                response: function() {
                    element.loader(false);
                },
                success: function(resp) {
                    element.find(".body").replaceWith($(resp).find(".body"));
                    _self.attachEvents();
                }
            });
        };
        instance.attachEvents = function () {
            var _self = this, element = _self.el;
            element.find(".body").scrollbar({
                vertical: {
                    offset: 15
                }
            });
            element.updateUi();
            element.find(".select-item").on("click", function() {
                var $this = $(this);
                if(!$this.is(".selected")) {
                    var shipToDiffAddress = $("input[name=is_different_shipping]").nat;
                    $.extend($this.config("entity"), {is_different_shipping: shipToDiffAddress ? shipToDiffAddress.checked : null});
                    config.onSelect($this.config("entity"));
                }
                _self.popup.close()
            });
            element.find(".assign-item").on("click", function() {
                var selectedId = element.find(".item-to-assign:checked").val();
                config.onSelect(selectedId);
                _self.popup.close()
            })
        };
        var events = (config.events || {});
        var _caller_content_loaded = events ? events.content_loaded : undefined;
        events.content_loaded = function (popup) {
            var el = instance.el = popup.el, searchForm = el.find(".search-form");
            instance.popup = popup;
            el.find(".cancel-button").on("click", function() {
                popup.close();
            });
            searchForm.form({
                preSubmit: function() {
                    var searchText = searchForm.find(".search-text").val();
                    if(instance.searchText === searchText) {
                        return false
                    }
                    instance.searchText = searchText;
                    instance.reload();
                    return false
                }
            });
            instance.attachEvents();
            _caller_content_loaded && _caller_content_loaded.apply(this, arguments)
        };
        delete config.events;
        bm.floatingPanel(ref, url, data, $.extend({
            width: 400,
            height: null,
            events: events,
            position_collison: "none"
        }, config));
        return instance
    },
    metaTagEditor: function (panel) {
        var rowTemplate = '<tr><td class="name editable" maxlength="">#NAME#</td><td class="value editable" maxlength="">#VALUE#</td><td class="actions-column"><input type="hidden" name="tag_name" value="#NAME#">' +
            '<input type="hidden" name="tag_content" value="#VALUE#"><span class="tool-icon remove"></span></td></tr>';
        var metaTagSection = panel.find(".meta-tag-editor"), tagTable = metaTagSection.find("table"), lastRow = tagTable.find("tr.last-row");

        function attachRowEvent(content, panel) {
            bm.makeTableCellEditable(content.find("td.editable"), function (td, newVal, oldVal) {
                var parent = td.parent("tr");
                var flag = false;
                if (!newVal) {
                    errorHighlight(td.find("input"));
                    bm.notify($.i18n.prop("value.must.not.be.empty"), "error");
                    return false
                }
                if (td.is(".name")) {
                    parent.find("[name=tag_name]").val(newVal)
                } else {
                    parent.find("[name=tag_content]").val(newVal)
                }
            });
            content.find("td span.remove").on("click", function () {
                $(this).parents("tr").remove();
                panel.setDirty();
            })
        }

        function addTag(name, value, lastRow, panel) {
            var row = $(rowTemplate.replaceAll("#NAME#", name.htmlEncode()).replaceAll("#VALUE#", value.htmlEncode()));
            if (lastRow) {
                if (lastRow.find(".name").attr("maxlength")) {
                    row.find(".name").attr("maxlength", lastRow.find(".name").attr("maxlength"))
                }
                if (lastRow.find(".value").attr("maxlength")) {
                    row.find(".value").attr("maxlength", lastRow.find(".value").attr("maxlength"))
                }
            }
            attachRowEvent(row, panel);
            lastRow.before(row)
        }

        tagTable.find("tr:gt(0):not(.last-row)").each(function () {
            attachRowEvent($(this), panel);
        });
        function errorHighlight(item) {
            item.addClass("error-highlight");
            setTimeout(function () {
                item.removeClass("error-highlight")
            }, 1000);
        }

        var addMapping = function () {
            var name = lastRow.find(".name").val().trim(), value = lastRow.find(".value").val().trim();
            if (!name) {
                errorHighlight(lastRow.find(".name"));
                bm.notify($.i18n.prop("field.required"), "alert");
                return;
            }
            if (!value) {
                errorHighlight(lastRow.find(".value"));
                bm.notify($.i18n.prop("field.required"), "alert");
                return;
            }
            addTag(name, value, lastRow, panel);
            lastRow.find("input").val("");
            return false
        };
        lastRow.find("input").bind("keyup.key_return", addMapping);
        lastRow.find(".add-row").on("click", addMapping);
        lastRow.find("input").on("keydown, keyup, keypress", function (e) {
            if (e.keyCode == 13) {
                return false
            }
        })
    },
    initCityValidator: function (postcodes, countryFiledName, stateFiledName, form, cityFieldName) {
        countryFiledName = countryFiledName ? countryFiledName : "country.id";
        stateFiledName = stateFiledName ? stateFiledName : "state.id";
        cityFieldName = cityFieldName ? cityFieldName : "city";
        if (postcodes.length) {
            postcodes.each(function () {
                var postCode = $(this);
                form = form ? form : postCode.closest("form");
                var state = form.find('[name="' + stateFiledName + '"]');
                var country = form.find('[name="' + countryFiledName + '"]');
                var container = form.find('.city-selector-row');
                if(country.val() == undefined){
                    country = form.find('.selected-country-value');
                }

                function checker(excludeCountry) {
                    var data = {state: state.val(), postCode: postCode.val(), cityFieldName: cityFieldName};
                    if (excludeCountry != true) {
                        data.country = country.val()
                    }
                    var validation = container.find(":input").attr("validation");
                    if (validation) {
                        data.validation = validation;
                    }
                    // Carry the configured city placeholder across the reload so a state/postcode change
                    // keeps the admin-set hint instead of reverting to the default prompt.
                    var cityPlaceholder = container.find(":input").attr("placeholder");
                    if (cityPlaceholder) {
                        data.placeholder = cityPlaceholder;
                    }
                    // Address autocomplete stashes its suggested suburb here, because a <select> cannot hold
                    // it until these options have been reloaded. Post it up so the server re-selects it -
                    // otherwise the re-rendered dropdown falls back to the first suburb for the postcode.
                    // Only the stash is honoured: reading the live field instead would also make a suburb
                    // survive a country change, which is what clears it today.
                    var preferredCity = container.data("preferred-city");
                    if (preferredCity) {
                        data.city = preferredCity;
                    }
                    bm.ajax({
                        url: app.baseUrl + 'app/loadCitiesByCountryOrState',
                        data: data,
                        dataType: 'html',
                        success: function (resp) {
                            container.removeData("preferred-city");
                            resp = $(resp);
                            if (app.is_front_end) {
                                container.find(":input").remove();
                            } else {
                                container.children().not("label").remove();
                            }
                            container.append(resp);
                            if (!app.is_front_end && resp.attr("et-category") == "dropdown") {
                                resp.chosen();
                            }
                            var validator = resp.closest("form").obj(ValidationPanel);
                            if (validator) {
                                validator.attach(resp.filter("[validation]"), validator);
                            }
                            var stateId = resp.find("option:selected").attr("state");
                            if (stateId) {
                                state.val(stateId);
                                if (!app.is_front_end) state.trigger("chosen:updated")
                            }
                        }
                    });
                }

                if (container.length) {
                    state.change(function () {
                        checker(true)
                    });
                    form.on("state-load", function () {
                        state = form.find('[name="' + stateFiledName + '"]');
                        checker();
                        if (state.length) {
                            state.change(checker)
                        }
                    });
                    postCode.ichange(checker);
                }
            })
        }
    },
    initCountryChangeHandler: function (select, stateName) {
        select.change(function () {
            var _self = $(this);
            var form = _self.closest("form");
            var id = $(this).val();
            $.ajax({
                url: app.baseUrl + "app/loadStateForCountry",
                dataType: 'html',
                data: {id: id, stateName: stateName},
                success: function (data) {
                    form.find(".form-row.state-selector-row").remove();
                    select.parents(".form-row").after(data);
                    form.find(".state-selector-row").updateUi();
                    form.trigger("state-load")
                }
            })
        });
    },
    customTooltip: function (url, count, pos, atBottom, atRight, callback) {
        config = {
            auto_close_on_success: true,
            disable_on_submit: true,
            disable_on_invalid: true,
            disable_button_text: undefined,
            modify_ui: true,
            on_load_loader: false
        };
        if (!pos[count - 1].length) {
            count = count + 1;
            atBottom = "7";
            atRight = "-7"
        }
        var events = (config.events || {});
        $(pos[count - 1]).addClass("active");
        events.content_loaded = function (popup) {
            var _self = this;
            _self.updateUi();
            if (count > 2) {
                atBottom = "7";
                atRight = "-7";
                var btn = $("<button type='button' class='submit-button-pre'></button>");
                btn.text($.i18n.prop("prev"));
                _self.find(".pop-bottom").append(btn)
            }
            if (count == 8) {
                _self.find(".submit-button-next").remove();
                var btn = $("<button type='button' class='submit-button-done'></button>");
                btn.text($.i18n.prop("done"));
                _self.find(".pop-bottom").prepend(btn);
                var div = $("<div class='show-next-wrapper'>" + "<input type='checkbox' name='remember' class='single'>" + "<span class='show-next'> Show on next login</span>" + "</div>");
                _self.find(".pop-bottom").append(div)
            }
            var check = true;
            _self.find(".single").on("change", function () {
                check = this.checked ? false : true
            });
            _self.find(".submit-button-done, .submit-button-skip").click(function () {
                bm.ajax({
                    url: app.baseUrl + "user/saveIsMatured",
                    data: {check: check},
                    success: function (resp) {
                        if (callback && callback.getStart) {
                            callback.getStart();
                        }
                    }
                });
                popup.close(1);
                $(pos[count - 1]).removeClass("active")
            });
            _self.find(".submit-button-next").click(function () {
                count++;
                popup.close(1);
                $(pos[count - 2]).removeClass("active");
                atBottom = "7";
                atRight = "-7";
                atRight = (count == 3) ? "+15" : "-7";
                if (count < pos.length + 1) {
                    bm.customTooltip(app.baseUrl + "dashboard/loadOnScreenHelp", count, pos, atBottom, atRight, callback);
                }
            });
            _self.find(".submit-button-pre").click(function () {
                popup.close(1);
                if (count > 1) {
                    $(pos[count - 1]).removeClass("active");
                    count--;
                    switch (count) {
                        case 1:
                            atBottom = "100";
                            atRight = "-100";
                            break;
                        case 3:
                            atBottom = "7";
                            atRight = "+15";
                            break;
                        default :
                            atBottom = "7";
                            atRight = "-7"
                    }
                }
                bm.customTooltip(app.baseUrl + "dashboard/loadOnScreenHelp", count, pos, atBottom, atRight, callback)
            });
            _self.find(".tool-tip-close").click(function () {
                $(pos[count - 1]).removeClass("active");
                popup.close(1);
                if (callback && callback.getStart) {
                    callback.getStart(1);
                }
            });
            _self.addClass("loaded")
        };
        delete config.events;
        return new POPUP($.extend({
            template: '<div></div>',
            show_title: false,
            width: 380,
            height: 150,
            ajax_url: url,
            ajax_settings: {
                data: {count: count, wizard: pos[0].length ? true : null}
            },
            ui_position: {
                my: "right top+10",
                at: "right" + atRight + " bottom+" + atBottom,
                of: pos[count - 1]
            },
            draggable: false
        }, config, {clazz: "tool-tip-popup", events: events}))
    },
    highlight: function (item, time, blink) {
        item.addClass("highlight-row" + (blink ? " blink" : ""));
        setTimeout(function () {
            item.removeClass("highlight-row" + (blink ? " blink" : ""));
        }, time ? time : 3000);
    },
    trigger: function (dom, base, name, args) {
        if (arguments.length == 5) {
            return bm.trigger.call(dom, base, name, args, arguments[4])
        }
        var returnValue;
        if (!$.isArray(args)) {
            args = [args]
        }
        if ($.isFunction(this["on" + name.capitalize()])) {
            returnValue = this["on" + name.capitalize()].apply(this, args)
        }
        if (returnValue === false) {
            return false
        }
        if (this.options && $.isFunction(this.options[name])) {
            returnValue = this.options[name].apply(this, args)
        }
        if (returnValue === false) {
            return false
        }
        return dom.trigger(base + ":" + name, args)
    },
    clearTextSelection: function (_document) {
        if (!_document) {
            _document = document
        }
        var selection = null;
        var _window = _document.defaultView;
        if (_window.getSelection) {
            selection = _window.getSelection();
        } else if (_document.selection) {
            selection = _document.selection;
        }
        if (selection) {
            if (selection.empty) {
                selection.empty();
            }
            if (selection.removeAllRanges) {
                selection.removeAllRanges();
            }
        }
    },
    disableTextSelection: function (_document) {
        if (!_document) {
            _document = document
        }
        if (browser.ff) {
            bm.clearTextSelection(_document);
            _document.body.style["MozUserSelect"] = "none"
        } else {
            _document.onselectstart = function () {
                return false;
            }
        }
    },
    enableTextSelection: function (_document) {
        if (!_document) {
            _document = document
        }
        if (browser.ff) {
            _document.body.style["MozUserSelect"] = ""
        } else {
            _document.onselectstart = null;
        }
    },
    getTopScroller: function (_document) {
        return $(/webkit/i.test(navigator.userAgent) || _document.compatMode == 'BackCompat' ? _document.body : _document.documentElement)
    },
    errorHighLight: function (item, time) {
        item.addClass("error-highlight");
        setTimeout(function () {
            item.removeClass("error-highlight");
        }, time ? time : 1000);
    },
    attachModernUiPanel: function () { // TODO: Should be removed
        var _self = this;
        var leftPanel = _self.body.find(".modern-list-left-panel");
        if (leftPanel.length) {
            var leftPanelConfig = $.extend({
                thumbPanel: $(),
                url: "",
                thumb_menu_entries: [],
                thumbMenuClick: function (config) {
                },
                leftNavigationClick: function (type) {
                }
            }, _self.leftPanelConfig || {});

            leftPanel.find(".left-panel-btn button").click(function () {
                var newItem = leftPanel.find(".item-thumb.new-item");
                var selected = leftPanel.find(".body .selected").attr("item-id");
                if (newItem.length) {
                    newItem.find(".item-title").focus();
                    return;
                }
                var newDom = leftPanelConfig.thumbPanel.clone();
                _self.body.find(".left-panel .item-wrapper").prepend(newDom);
                var field = ValidationField.createDetachedField(newDom.find("input"), {
                    error_position: "after"
                });
                var applyClicked = false;
                newDom.find(".item-title").focus().on("keyup.key_return", function () {
                    updateName();
                }).on("blur", function () {
                    if (!applyClicked) {
                        _self.reload(selected, true);
                    }
                    applyClicked = false;
                });

                newDom.find(".tool-icon.apply").mousedown(function () {
                    applyClicked = true
                }).click(function () {
                    updateName();
                });

                function updateName() {
                    if (field.validate()) {
                        var name = field.elm.val();
                        bm.ajax({
                            show_response_status: false,
                            url: leftPanelConfig.url,
                            data: {name: name},
                            success: function (resp) {
                                _self.reload(resp.id, true, function (id) {
                                    leftPanel.find(".item-thumb[item-id=" + id + "]").trigger("click");
                                });
                            },
                            error: function (a, b, resp) {
                                field.elm.focus();
                                field.showError({
                                    msg_template: resp.message,
                                    msg_params: [],
                                    rule: undefined
                                })
                            }
                        })
                    } else {
                        field.elm.focus()
                    }
                }
            });
            bm.menu(leftPanelConfig.thumb_menu_entries, _self.body.find(".left-panel .float-menu-navigator"), null, {
                hide: function (entity) {
                    entity.parent().removeClass("float-menu-opened");
                },
                click: function (action, navigator) {
                    var config = navigator.closest(".item-thumb").config("item");
                    leftPanelConfig.thumbMenuClick.call(_self, action, config);
                }
            }, "click", ["center bottom", "right+22 top+7"]);

            _self.body.find(".item-thumb").on("click", function (e) {
                var $this = $(this);
                if ($(e.target).is(".float-menu-navigator")) { //prevent firing for childs
                    return;
                }
                _self.body.find(".item-thumb.selected").removeClass("selected");
                $this.addClass("selected");
                var selected = $this.attr("item-id");
                _self.reload(selected);
            });
            leftPanel.find(".one-line-scroll-content").scrollbar({
                show_vertical: false,
                show_horizontal: true,
                use_bar: false,
                visible_on: "auto",
                horizontal: {
                    handle: {
                        left: leftPanel.find(".left-scroller"),
                        right: leftPanel.find(".right-scroller")
                    },
                    step: "auto"
                }
            });
            leftPanel.find(".navigation-button").on("click", function () {
                var $this = $(this);
                leftPanelConfig.leftNavigationClick.call(_self, $this.attr("item-type"))
            });
            //Modern List Left Panel End
        }
    },
    instantSearch: function (searchContext, searchForm, nodeSelector, textSelector, callback) {
        var searchBox = searchForm.find(".search-text");

        function filter() {
            var searchText = searchBox.val();
            if (searchText) {
                searchContext.addClass("search-active")
            } else {
                searchContext.removeClass("search-active")
            }
            searchContext.find(nodeSelector).each(function () {
                var $this = $(this), name = $this.find(textSelector).text().trim();
                if (name.match(new RegExp(searchText, "i"))) {
                    $this.show()
                } else {
                    $this.hide()
                }
            });
        }

        searchBox.ichange(800, function () {
            filter()
        });
        searchForm.form({
            preSubmit: function () {
                filter();
                return false
            }
        })
    },
    floatingPopup: function (_content, _config) {
        _content.find(".popup-body").hide();
        var _popup = undefined;
        var _toggle = !!(_config && _config.toggle);
        var _dropper = _content.find(".floating-action-dropper");
        // When toggling is enabled, the popup's close_on_blur hides it on any document mousedown —
        // including a mousedown on this trigger — before the click handler runs. Record the open-state
        // on the trigger's own mousedown (which fires before the document-level handler) so the click
        // can close an open menu instead of re-showing it (the open -> close -> reopen flicker).
        if(_toggle) {
            _dropper.on("mousedown", function () {
                var navigator = this.jqObject;
                var popup = navigator.data("popup");
                // Also check real visibility: menu items hide the panel with a raw jQuery .hide(), which leaves
                // is_hidden false — trusting it alone made the next click "close" an already-hidden menu.
                navigator.data("popup-was-open", !!(popup && !popup.is_hidden && popup.el.is(":visible")));
            });
        }
        _dropper.click(function () {
            var config = $.extend({}, _config)
            var navigator = this.jqObject;
            var customClazz = navigator.attr("custom-clazz")
            if(customClazz){
                config.clazz = customClazz
            }
            var popup = navigator.data("popup")
            if(popup) {
                if(_toggle && navigator.data("popup-was-open")) {
                    popup.hide();
                } else {
                    popup.show();
                }
                return;
            }
            var body = navigator.next(".popup-body");
            config = $.extend({
                content: body,
                position_collison: "none",
                events: {
                    content_loaded: function (popup) {
                        body.show();
                        popup.position();
                    }
                }
            }, config);
            _popup = popup = bm.floatingPanel(navigator, null, {}, config);
            popup.close = popup.hide;
            navigator.data("popup", popup)
        });
        _content.find(".close-popup").click(function () {
            if(_popup) {
                _popup.close();
            }
        });
        return _content
    },

    renderSitePopup: function (url, title, emphasized, data, config) {
        config = $.extend({}, {
            auto_close_on_success: true,
            disable_on_submit: true,
            disable_on_invalid: true,
            disable_button_text: undefined,
            modify_ui: true,
            width: 500,
            form_selector: ".site-popup-form",
            buttonLine: "button-line",
            scroll: true
        }, config);
        var events = (config.events || {});
        var _caller_content_loaded = events ? events.content_loaded : undefined;
        events.content_loaded = function (popup) {
            var form = this.find(config.form_selector);
            var newSubmit;
            if (typeof(config.buttonLine) == "string") {
                var buttonLine = form.find("." + config.buttonLine);
                newSubmit = buttonLine.clone();
                buttonLine.remove();
            } else {
                newSubmit = config.buttonLine
            }
            var button = newSubmit.find(".submit-button, button[type=submit]").addClass("site-popup-form-submit").on("click", function () {
                form.submit();
            });
            this.append(newSubmit);
            var _success = (config.ajax && config.ajax.success) || config.success;
            form.form({
                ajax: this.find(".site-popup-form").attr("no-ajax") == null,
                disable_on_submit: config.disable_on_submit,
                disable_on_invalid: config.disable_on_invalid,
                disable_button_text: config.disable_button_text,
                submitButton: button,
                preSubmit: function (ajaxSettings) {
                    $.extend(ajaxSettings, {
                        response: config.response,
                        error: config.error
                    }, config.ajax, {
                        success: function () {
                            if (config.auto_close_on_success) {
                                popup.close();
                            }
                            if (_success) {
                                _success.apply(this, arguments);
                            }
                        }
                    });
                    if (config.beforeSubmit) {
                        return config.beforeSubmit.call(popup.getDom(), form, ajaxSettings ? (ajaxSettings.data = ajaxSettings.data || {}) : null, popup);
                    }
                }
            });
            form.find("[default-focus]").focus();
            this.find(".cancel-button").click(function () {
                popup.close(1);
            });
            popup.on("content-change", function (ev, added, removed) {
                if (added) {
                    form.obj(ValidationPanel).attach(added.filter("[validation]").add(added.find("[validation]")));
                }
                if (removed) {
                    form.obj(ValidationPanel).detach(removed.filter("[validation]").add(removed.find("[validation]")));
                }
            });
            if (_caller_content_loaded) {
                _caller_content_loaded.apply(this, [popup, form]);
            }
        };
        delete config.events;
        return new POPUP($.extend({
            title: title + (emphasized ? " - <span class='emphasized'>" + bm.htmlEncode(emphasized) + "</span>" : ""),
            width: 430,
            ajax_url: url,
            ajax_settings: {
                data: data
            }
        }, config, {clazz: "site-popup" + (config.clazz ? " " + config.clazz : ""), events: events}))
    },
});

$.extend(app, {
    isPermitted: function (key, params) {
        if (app.permissions === undefined) {
            return true;
        }
        var admin = app.admin_id;
        var permission = app.permissions[key] ? app.permissions[key] : {};
        var allowed = permission.general == true;
        var policyEntityParam = params ? params.id : undefined;
        policyEntityParam = policyEntityParam ? (policyEntityParam instanceof Array ? policyEntityParam : [policyEntityParam]) : [];
        if (policyEntityParam.length && (permission.general == null || allowed)) {
            if (permission.allowed_entity) {
                var allowed_set = permission.allowed_entity.intersect(policyEntityParam);
                if (Object.keys(permission.allowed_entity).length && allowed_set.length == policyEntityParam.length) {
                    allowed = true;
                }
            }
            if (permission.denied_entity) {
                var denied_set = permission.denied_entity.intersect(policyEntityParam);
                if (Object.keys(permission.denied_entity).length && denied_set.length != 0) {
                    allowed = false;
                }
            }
        }

        return allowed;
    },
    checkPermission: function (menu, menuItems, config) {
        if (app.permissions === undefined) {
            return;
        }
        if (menu) {
            $.each(menuItems, function (i, v) {
                var cfg = v.isEntity ? config : {};
                if (app.isPermitted(v.key, cfg)) {
                    if (menu.enable) {
                        menu.enable(v['class']);
                    } else {
                        menu.find("." + v['class']).removeClass("disabled");
                    }
                } else {
                    if (menu.disable) {
                        menu.disable(v['class']);
                    } else {
                        menu.find("." + v['class']).addClass("disabled");
                    }
                }
            });
        }
    },
    updatePermissions: function () {
        bm.ajax({
            url: app.baseUrl + "adminBase/updatePermissions",
            data: {},
            success: function (resp) {
                if (app.permissions !== undefined) {
                    app.permissions = resp.permissions;
                }
            }
        })
    }
});

function getCountryCode(countryName) {
    const countryCodes = {
        "Afghanistan": "AF",
        "Albania": "AL",
        "Algeria": "DZ",
        "American Samoa": "AS",
        "Andorra": "AD",
        "Angola": "AO",
        "Anguilla": "AI",
        "Antarctica": "AQ",
        "Antigua & Barbuda": "AG",
        "Argentina": "AR",
        "Armenia": "AM",
        "Australia": "AU",
        "Aruba": "AW",
        "Austria": "AT",
        "Azerbaijan": "AZ",
        "The Bahamas": "BS",
        "Bahrain": "BH",
        "Bangladesh": "BD",
        "Barbados": "BB",
        "Belarus": "BY",
        "Belgium": "BE",
        "Belize": "BZ",
        "Benin": "BJ",
        "Bermuda": "BM",
        "Bhutan": "BT",
        "Bolivia": "BO",
        "Bosnia and Herzegovina": "BA",
        "Botswana": "BW",
        "Bouvet Island": "BV",
        "Brazil": "BR",
        "British Indian Ocean T.": "IO",
        "Brunei Darussalam": "BN",
        "Bulgaria": "BG",
        "Burkina Faso": "BF",
        "Burundi": "BI",
        "Cambodia": "KH",
        "Cameroon": "CM",
        "Canada": "CA",
        "Cape Verde": "CV",
        "Cayman Islands": "KY",
        "Central African Republic": "CF",
        "Chad": "TD",
        "Chile": "CL",
        "China": "CN",
        "Christmas Island": "CX",
        "Cocos (Keeling) Islands": "CC",
        "Colombia": "CO",
        "Comoros": "KM",
        "Congo": "CG",
        "Democratic Republic of the Congo": "CD",
        "Cook Islands": "CK",
        "Costa Rica": "CR",
        "Cote D'Ivoire": "CI",
        "Croatia": "HR",
        "Cuba": "CU",
        "Cyprus": "CY",
        "Czech Republic": "CZ",
        "Denmark": "DK",
        "Djibouti": "DJ",
        "Dominica": "DM",
        "Dominican Republic": "DO",
        "East Timor (Timor-Leste)": "TP",
        "Ecuador": "EC",
        "Egypt": "EG",
        "El Salvador": "SV",
        "Equatorial Guinea": "GQ",
        "Eritrea": "ER",
        "Estonia": "EE",
        "Ethiopia": "ET",
        "European Union": "EU",
        "Falkland Islands (Malvinas)": "FK",
        "Faroe Islands": "FO",
        "Fiji": "FJ",
        "Finland": "FI",
        "France": "FR",
        "French Guiana": "GF",
        "French Polynesia": "PF",
        "French Southern Terr.": "TF",
        "Gabon": "GA",
        "The Gambia": "GM",
        "Georgia": "GE",
        "Germany": "DE",
        "Ghana": "GH",
        "Gibraltar": "GI",
        "Greece": "GR",
        "Greenland": "GL",
        "Grenada": "GD",
        "Guadeloupe": "GP",
        "Guam": "GU",
        "Guatemala": "GT",
        "Guernsey and Alderney": "GG",
        "Guinea": "GN",
        "Guinea-Bissau": "GW",
        "Guyana": "GY",
        "Haiti": "HT",
        "Heard & McDonald Is.(AU)": "HM",
        "Holy See (Vatican)": "VA",
        "Honduras": "HN",
        "Hong Kong, (China)": "HK",
        "Hungary": "HU",
        "Iceland": "IS",
        "India": "IN",
        "Indonesia": "ID",
        "Islamic Republic of Iran": "IR",
        "Iraq": "IQ",
        "Ireland": "IE",
        "Israel": "IL",
        "Italy": "IT",
        "Jamaica": "JM",
        "Japan": "JP",
        "Jersey": "JE",
        "Jordan": "JO",
        "Kazakhstan": "KZ",
        "Kenya": "KE",
        "Kiribati": "KI",
        "North Korea": "KP",
        "South Korea": "KR",
        "Kosovo": "KV",
        "Kuwait": "KW",
        "Kyrgyzstan": "KG",
        "Lao People's Democ. Rep.": "LA",
        "Latvia": "LV",
        "Lebanon": "LB",
        "Lesotho": "LS",
        "Liberia": "LR",
        "Libyan Arab Jamahiriya": "LY",
        "Liechtenstein": "LI",
        "Lithuania": "LT",
        "Luxembourg": "LU",
        "Macao, (China)": "MO",
        "Macedonia, TFYR": "MK",
        "Madagascar": "MG",
        "Malawi": "MW",
        "Malaysia": "MY",
        "Maldives": "MV",
        "Mali": "ML",
        "Malta": "MT",
        "Man, Isle of": "IM",
        "Marshall Islands": "MH",
        "Martinique (FR)": "MQ",
        "Mauritania": "MR",
        "Mauritius": "MU",
        "Mayotte (FR)": "YT",
        "Mexico": "MX",
        "Micronesia, Fed. States of": "FM",
        "Republic of Moldova": "MD",
        "Monaco": "MC",
        "Mongolia": "MN",
        "Montenegro": "CS",
        "Montserrat": "MS",
        "Morocco": "MA",
        "Mozambique": "MZ",
        "Myanmar (ex-Burma)": "MM",
        "Namibia": "NA",
        "Nauru": "NR",
        "Nepal": "NP",
        "Netherlands": "NL",
        "Netherlands Antilles": "AN",
        "New Caledonia": "NC",
        "New Zealand": "NZ",
        "Nicaragua": "NI",
        "Niger": "NE",
        "Nigeria": "NG",
        "Niue": "NU",
        "Norfolk Island": "NF",
        "Northern Mariana Islands": "MP",
        "Norway": "NO",
        "Oman": "OM",
        "Pakistan": "PK",
        "Palau": "PW",
        "Palestinian Territory": "PS",
        "Panama": "PA",
        "Papua New Guinea": "PG",
        "Paraguay": "PY",
        "Peru": "PE",
        "Philippines": "PH",
        "Pitcairn Island": "PN",
        "Poland": "PL",
        "Portugal": "PT",
        "Puerto Rico": "PR",
        "Qatar": "QA",
        "Reunion (FR)": "RE",
        "Romania": "RO",
        "Russia (Russian Fed.)": "RU",
        "Rwanda": "RW",
        "Saint Barthelemy (FR)": "BL",
        "Saint Helena (UK)": "SH",
        "Saint Kitts and Nevis": "KN",
        "Saint Lucia": "LC",
        "Saint Martin (FR)": "MF",
        "S Pierre & Miquelon(FR)": "PM",
        "S Vincent & Grenadines": "VC",
        "Samoa": "WS",
        "San Marino": "SM",
        "Sao Tome and Principe": "ST",
        "Saudi Arabia": "SA",
        "Senegal": "SN",
        "Serbia": "RS",
        "Seychelles": "SC",
        "Sierra Leone": "SL",
        "Singapore": "SG",
        "Slovakia": "SK",
        "Slovenia": "SI",
        "Solomon Islands": "SB",
        "Somalia": "SO",
        "South Africa": "ZA",
        "S.George & S.Sandwich": "GS",
        "South Sudan": "SS",
        "Spain": "ES",
        "Sri Lanka": "LK",
        "Sudan": "SD",
        "Suriname": "SR",
        "Svalbard & Jan Mayen Is.": "SJ",
        "Swaziland": "SZ",
        "Sweden": "SE",
        "Switzerland": "CH",
        "Syrian Arab Republic": "SY",
        "Taiwan": "TW",
        "Tajikistan": "TJ",
        "The United Republic of Tanzania": "TZ",
        "Thailand": "TH",
        "Timor-Leste (East Timor)": "TL",
        "Togo": "TG",
        "Tokelau": "TK",
        "Tonga": "TO",
        "Trinidad & Tobago": "TT",
        "Tunisia": "TN",
        "Turkey": "TR",
        "Turkmenistan": "TM",
        "Turks & Caicos Islands": "TC",
        "Tuvalu": "TV",
        "Uganda": "UG",
        "Ukraine": "UA",
        "United Arab Emirates": "AE",
        "United Kingdom": "GB",
        "United States of America": "US",
        "Uruguay": "UY",
        "Uzbekistan": "UZ",
        "Vanuatu": "VU",
        "Venezuela": "VE",
        "Vietnam": "VN",
        "Western Sahara": "EH",
        "Yemen": "YE",
        "Zambia": "ZM",
        "Zimbabwe": "ZW"
    };

    return countryCodes[countryName];
}/**
 * Modern Permission Popup Handler
 * This file provides a modern UI wrapper around the existing permission system
 * without modifying the core permission logic
 */


; //region FUNCTION
$.extend(Function.prototype, {
    /**
     * this() then extend()
     * @param extend
     * @returns {Function}
     */
    blend: function (extend) {
        if (!extend) {
            return this
        }
        var _this = this
        return function () {
            if (extend.isString) {
                extend = bm.prop(window, extend)
            }
            var ret = _this.apply(this, arguments)
            return extend.apply(this, arguments) || ret
        }
    },
    /**
     * usable for multiple inheritance. if order and virtual not defined then will work as blend
     * @param extend
     * @returns {Function}
     */
    mixin: function (extend) {
        if (!extend) {
            return this
        }
        if (extend.override || this.virtual) {
            return extend
        } else if (this.override || extend.virtual) {
            return this
        } else {
            var torder = this.order || 0
            var eorder = extend.order || 0
            return torder <= eorder ? this.blend(extend) : extend.blend(this)
        }
    },
    /**
     * inherits provided super classes. argument can have multiple functions. only first function will be attached with the callee as _super
     * @param superFunction
     * @returns a new prototype with combining all properties from callee and arguments
     */
    inherit: function (superFunction) {
        var mixins = []
        if (arguments.length > 1) {
            mixins = Array.prototype.slice.call(arguments, 1)
        }
        var middleMan = function () {
        }
        middleMan.prototype = superFunction.prototype
        var oldProto = this.prototype
        var newProto = this.prototype = new middleMan()
        $.extend(newProto, bm.filterOwnProperties(oldProto))
        if (mixins.length) {
            var extendProto = newProto
            middleMan = function () {
            }
            middleMan.prototype = newProto
            newProto = this.prototype = new middleMan()
            var overrideList
            mixins.everyCustomFunc(function (key, value) {
                $.each(value.prototype || ($.isPlainObject(value) ? value : {}), function (k) {
                    extendProto[k] = extendProto[k] ? extendProto[k].mixin(this) : this
                })
                overrideList = undefined
                return true
            })
            this._super = middleMan.prototype
            this._super.constructor = function () {
                superFunction.apply(this, arguments)
                var _this = this
                var _arg = arguments
                mixins.everyCustomFunc(function (key, value) {
                    if (typeof value == "function") {
                        value.apply(_this, _arg)
                    }
                })
            }
        } else {
            this._super = superFunction.prototype
            this._super.constructor = superFunction
        }
        newProto.constructor = this
        return newProto
    },
    /**
     * returns a new function where first the caller is called and then argument
     * @param extend
     * @returns {Function}
     */
    intercept: function (extend) {
        if (!extend) {
            return this
        }
        var _this = this
        return function () {
            if (extend.isString) {
                extend = bm.prop(window, extend)
            }
            var ret = extend.apply(this, arguments)
            return _this.apply(this, arguments) || ret
        }
    },
    later: (function () {
        var timer = 0
        return function (ms) {
            var data
            if(arguments.length > 1) {
                data = Array.prototype.splice.call(arguments, 1)
            }
            clearTimeout(timer)
            timer = setTimeout(data ? function() {this.apply(null, data)}.bind(this) : this, ms)
        }
    })(),
    on: function (ev) {
        app.event.on(ev, this)
    }
})
//endregion

//region ARRAY
Array.prototype.contains = function (item) {
    return this.indexOf(item) > -1
}

$.extend(Array.prototype, {
    all: function () {
        for (h in this) {
            if (!this[h]) {
                return false
            }
        }
        return true
    },
    any: function (filter) {
        var l = this.length
        if (!filter) {
            for (var h = 0; h < l; h++) {
                if (this[h]) {
                    return true
                }
            }
        } else if (filter instanceof Function) {
            for (var h = 0; h < l; h++) {
                if (filter(this[h])) {
                    return true
                }
            }
        } else {
            function doTheTrick() {
                return eval(filter)
            }

            for (var h = 0; h < l; h++) {
                if (doTheTrick.call(this[h])) {
                    return true
                }
            }
        }
        return false
    },
    /**
     * returns new collection using the value for given property of each entity/return value of calling function
     * @param prop {String | Function}
     * @returns {Array}
     */
    collect: function (prop) {
        var ret = []
        if ($.isFunction(prop)) {
            $.each(this, function () {
                ret.push(prop.call(this))
            })
        } else {
            $.each(this, function () {
                ret.push(this[prop])
            })
        }
        return ret
    },
    clone: function () {
        return this.slice(0)
    },
    count: function (condition) {
        var found = 0
        if ($.isFunction(condition)) {
            this.everyCustomFunc(function (k, p) {
                (function () {
                    if (condition.apply(p) === true) {
                        found++
                    }
                }).apply(p, Array.prototype.splice.call(arguments, 1))
            })
        } else {
            this.everyCustomFunc(function (k, p) {
                (function () {
                    if (eval(condition) === true) {
                        found++
                    }
                }).apply(p, Array.prototype.splice.call(arguments, 1))
            })
        }
        return found
    },
    distinct: function () {
        var res = []
        for (var i = 0; i < this.length; i++) {
            var itm = this[i]
            if ($.inArray(itm, res) === -1) {
                res.push(itm)
            }
        }
        return res
    },
    everyCustomFunc: function (callback) {
        var array = this
        //native every does not call the function for unassigned index
        $.each(this, function (k, v) {
            var ret = callback.call(v, k, v, array)
            return ret !== false
        })
    },
    /**
     * reverses of string exSplit process
     * @returns {String}
     */
    exJoin: function (joinChar) {
        joinChar = joinChar || ','
        var result = ""
        this.everyCustomFunc(function (i, value) {
            result += (i > 0 ? joinChar : '') + (value.indexOf(joinChar) > -1 || value.charAt(0) == "(" ? "(" + value + ")" : value)
        })
        return result
    },
    native_filter: Array.prototype.filter,
    filter: function (filter) {
        // Function predicates go to the native method, which also serves array-likes (NodeList,
        // TextTrackList) borrowed via Array.prototype.filter.call - they have no native_filter of their own.
        if ($.isFunction(filter)) {
            return Array.prototype.native_filter.apply(this, arguments)
        }
        var found = []
        if(this.every){
            this.everyCustomFunc(function () {
                if (eval(filter) === true) {
                    found.push(this)
                }
            })
        }
        return found
    },
    native_find: Array.prototype.find,
    /**
     * return found object
     * @param condition [String | Function]
     * @returns {object} entry that is matched
     */
    find: function (condition) {
        var found = undefined
        if ($.isFunction(condition)) {
            return Array.prototype.native_find.apply(this, arguments)
        }
        this.everyCustomFunc(function (i, value) {
            if (eval(condition) === true) {
                found = this
                return false
            }
        })
        return found
    },
    native_indexOf: Array.prototype.indexOf,
    /*indexOf: function(condition) {
        if($.isFunction(condition)) {
            let index = -1
            this.everyCustomFunc((i, value) => {
                if (condition.apply(value, [i, this]) === true) {
                    index = i
                    return false
                }
            })
            return index
        }
        return this.native_indexOf.apply(this, arguments)
    },*/
    intersect: function (array) {
        if (!array) {
            return this
        }
        var result = []
        var distinctArray = this.distinct()
        for (var i = 0; i < distinctArray.length; i++) {
            var item = distinctArray[i]
            var shouldAddToResult = true
            for (var j = 0; j < arguments.length; j++) {
                var array2 = arguments[j]
                if (array2.length == 0) return []
                if ($.inArray(item, array2) === -1) {
                    shouldAddToResult = false
                    break
                }
            }
            if (shouldAddToResult) {
                result.push(item)
            }
        }
        return result
    },
    /**
     * returns first matched entry
     * @param condition
     * @returns {*} matched entry
     */
    iterate: function (iterator) {
        var c_ind = 0
        var obj = this
        var iter_caller = function () {
            if (c_ind == obj.length) {
                return
            }
            iterator.call(obj[c_ind], {
                next: function () {
                    c_ind++
                    setTimeout(iter_caller, 1)
                }
            }, c_ind)
        }
        iter_caller()
    },
    last: function () {
        return this[this.length - 1]
    },
    minus: function (toRemove) {
        return this.filter(function (i) {
            return toRemove.indexOf(i) < 0
        })
    },
    pushAll: function (pushArray) {
        this.push.apply(this, pushArray)
    },
    remove: function (entry) {
        var index = this.indexOf(entry)
        if (index > -1) {
            this.splice(index, 1)
        }
    },
    removeAll: function (filter) {
        var _self = this
        this.filter(filter).everyCustomFunc(function (key, value) {
            _self.remove(value)
            return true
        })
        return this
    },
    /**
     * performs a reverse each
     * @param loopHandler {Function (index, reversedIndex, element) - context element}
     * @param thisArg [object (optional)] if provided - it will be passed as this on callback invocation
     */
    revery: function (loopHandler, thisArg) {
        var total = this.length - 1
        for (var t = total; t >= 0; t--) {
            if(loopHandler.call(thisArg || this[t], this[t], total - t, t, this) === false) {
                break
            }
        }
    },
    sum: function (iterator) {
        var count = this.length
        var result = 0
        if (iterator.isString) {
            iterator = new Function("return " + iterator)
        }
        for (var g = 0; g < count; g++) {
            result += iterator.call(this[g], g)
        }
        return result
    }
})

for (var k in Array.prototype) {
    if (!$.prototype[k]) {
        $.prototype[k] = Array.prototype[k]
    }
}
//endregion

//region STRING
var string_org_index_of = String.prototype.indexOf
var string_org_last_index_of = String.prototype.lastIndexOf
$.extend(String.prototype, {
    array: function () {
        if (this == "[]") {
            return []
        }
        return JSON.parse(this)
    },
    bool: function () {
        return !/^\s*(false|no|off|0|inactive|negative|-(\d*\.)?\d+)\s*$/i.test(this)
    },
    byteCount: function () {
        return this.length;
    },
    camelCase: function (initial) {
        var writer = new StringWriter()
        var reader = this.reader()
        var data
        if (initial === undefined) {
            initial = true
        }
        var nextUpper = initial
        while ((data = reader.read()) != -1) {
            if ((data > '`' && data < '{') || (data > '@' && data < '[') || (data > '/' && data < ':')) {
                if (nextUpper) {
                    writer.plus(data.toUpperCase())
                    nextUpper = false
                } else {
                    writer.plus(data)
                }
            } else {
                nextUpper = true
            }
        }
        return writer.toString()
    },
    capitalize: function () {
        return this.length == 0 ? "" : this[0].toUpperCase() + this.substring(1)
    },
    contains: function (match) {
        return this.indexOf(match) > -1
    },
    dotCase: function () {
        var writer = new StringWriter()
        var reader = this.reader()
        var data
        while ((data = reader.read()) != -1) {
            if (data > '@' && data < '[') {
                writer.plus(".")
                writer.plus(data.toLowerCase())
            } else {
                writer.plus(data)
            }
        }
        return writer.toString()
    },
    equals: function (c, matchCase) {
        if (arguments.length == 1) {
            matchCase = true
        }
        var a = matchCase ? this + "" : this.toLowerCase()
        var b = matchCase ? c + "" : c.toLowerCase()
        return a == b
    },
    /**
     * if seperator charactor is expected in a value then that value must be enclosed within ( and ). e.g. for 1 and 2,3 and 4 - 1,(2,3),4
     */
    exSplit: function (seperatorChar) {
        seperatorChar = seperatorChar || ','
        var params = []
        var resultIndex = 0
        var skipUntil = false
        var bufferCount = 0
        params[0] = ""
        for (var i = 0; i < this.length; i++) {
            var char = this.charAt(i)
            if (!skipUntil && char == seperatorChar) {
                params[++resultIndex] = ""
                bufferCount = 0
            } else {
                if (char == '(' && !bufferCount) {
                    skipUntil = true
                } else {
                    if (char == ')' && skipUntil && (i + 1 == this.length || this.charAt(i + 1) == seperatorChar)) {
                        skipUntil = false
                    } else {
                        bufferCount++
                        params[resultIndex] += char
                    }
                }
            }
        }
        return params
    },
    hash: function () {
        var hash = 0
        if (this.length == 0) return hash
        var i
        for (i = 0; i < this.length; i++) {
            var ch = this.charCodeAt(i)
            hash = ((hash << 5) - hash) + ch
            hash = hash & hash
        }
        return hash
    },
    htmlEncode: function () {
        return this.replace(/&/g, '&amp')
            .replace(/</g, '&lt')
            .replace(/>/g, '&gt')
            .replace(/"/g, '&quot')
            .replace(/'/g, '&#39')
            .replace(/\r\n/g, '<br>')
            .replace(/\n/g, '<br>')
            .replace(/  /g, ' &nbsp')
    },
    indexOf: function (regex, i) {
        if (regex instanceof RegExp) {
            return this.substr(i || 0).search(regex) + (i || 0)
        }
        return string_org_index_of.apply(this, arguments)
    },
    int: function (value) {
        if (/^\s*\d+(.\d*)?\s*$/.test(value)) {
            return +value
        }
        return parseInt(value) || 0
    },
    lastIndexOf: function (regex, i) {
        if (regex instanceof RegExp) {
            i = (i || (this.length - 1)) - (this.length - 1)
            var _this = this.reverse()
            var fIndex = _this.indexOf(regex, i)
            if (fIndex == -1) {
                return -1
            }
            return fIndex + this.length - 1
        }
        return string_org_last_index_of.apply(this, arguments)
    },
    minusCase: function () {
        var writer = new StringWriter()
        var reader = this.reader()
        var data
        while ((data = reader.read()) != -1) {
            if (data > '@' && data < '[') {
                writer.plus("-")
                writer.plus(data.toLowerCase())
            } else {
                writer.plus(data)
            }
        }
        return writer.toString()
    },
    reader: function (shouldThroughError) {
        var index = 0
        var _self = this
        return {
            read: function () {
                var c = _self.charAt(index++)
                if (!c) {
                    if (shouldThroughError) {
                        throw "EOF"
                    }
                    return -1
                }
                return c
            }
        }
    },
    replaceAll: function (search, replace, isRegex) {
        if (isRegex) {
            var reg = new RegExp(search, "g")
            return this.replace(reg, replace)
        } else {
            return this.split(search).join(replace)
        }
    },
    reverse: function () {
        return this.split('').reverse().join('')
    },
    sanitize: function () {
        return this.trim().toLowerCase().replace(/\s/g, "-").replace(/[^a-z0-9-\._]+/g, "-")
    },
    textify: function () {
        return this.replace(/<[^>]*>/g, "")
    },
    toNumber: function() {
        return parseFloat(this)
    },
    upto: function (char) {
        return this.substring(0, this.indexOf(char))
    },
    pxToVal: function () {
        var out = this.split("px")[0];
        out = parseFloat(out);
        return (out ? out : 0);
    }
})
//endregion

//region JQUERY
var $_height = $.prototype.height
var $_width = $.prototype.width
var $_text = $.prototype.text
var $_show = $.prototype.show
var $_hide = $.prototype.hide
$.extend($.prototype, {
    acss: function (prop) {
        try {
            return this.chide()[0].ownerDocument.defaultView.getComputedStyle(this[0])[prop]
        } finally {
            this.cshow()
        }
    },
    bottomRib: function (margin, border, padding) {
        return this.dirRib("bottom", margin, border, padding)
    },
    /**
     * stores current display information and then hide. requires for cshow
     */
    chide: function () {
        return this.each(function () {
            var display = this.style ? this.style.display : undefined
            $(this).data("display-cache", display).css({display: "none"})
        })
    },
    clearCache: function (onClear) {
        if (!this.is("img")) {
            throw $.error("This function is only applicable for img tag")
        }
        var url = this.attr("src")
        var _self = this
        var iframe = $("<iframe style='position: absolute left: -20000px top: -20000px'></iframe>")
        iframe.appendTo(document.body)
        iframe.one("load", function () {
            iframe.one("load", function () {
                iframe.remove()
                _self.attr("src", url)
                if (onClear) {
                    onClear()
                }
            })[0].contentWindow.location.reload()
        }).attr("src", url).bind("error", function () {
            iframe.remove()
        })
    },
    _closestCache: $.prototype.closest,
    closest: function (filter) {
        // jQuery 3.5+ removed $.isFunction — use a native check (this .closest override runs in the editor
        // iframe where the closure `$` may be a partial/non-jQuery object lacking isFunction).
        if (typeof filter === "function") {
            var elm = this
            do {
                var ret = filter.call(elm[0])
                if (ret) {
                    return elm
                }
            } while ((elm = elm.parent()).length != 0)
            return null
        } else {
            return this._closestCache.apply(this, arguments)
        }
    },
    collect: function (prop) {
        return Array.prototype.collect.call(this, prop)
    },
    config: function (type, updates) {
        if(!this.length) {
            return
        }
        var cacheKey = "attr-parsed-cache#" + type
        var map = this.tag(cacheKey)
        if (!map) {
            map = {}
            this.tag(cacheKey, map)
            var cutLength = type.length + 1
            $.each(this.nat.attributes, function () {
                if (this.name.startsWith(type + "-")) {
                    map[this.name.substring(cutLength).toLowerCase()] = bm.autoType(this.value)
                }
            })
        }
        if (updates) {
            if (typeof updates == "string") {
                return map[updates.toLowerCase()]
            } else {
                var obj = this
                $.each(updates, function (k, v) {
                    k = k.toLowerCase()
                    map[k] = v
                    obj.attr(type + "-" + k, v)
                })
                return this
            }
        }
        return map
    },
    copyDeepEvents: function (to, keepContext) {
        this.copyEvents(to, keepContext)
        function repeat(from, to) {
            var toChildren = to.children()
            var thisChildren = from.children()
            if (toChildren.length == thisChildren.length) {
                thisChildren.each(function (ind) {
                    $(this).copyEvents(toChildren.eq(ind), keepContext)
                    repeat($(this), toChildren.eq(ind))
                })
            }
        }

        repeat(this, to)
    },
    copyEvents: function (to, keepContext) {
        var node = this
        var expando = this[0][$_priv_data.expando]
        if (expando) {
            var events = expando.events
            if (events) {
                $.each(events, function (key, ev) {
                    $.each(ev, function () {
                        var _event = this
                        var evKey = key
                        if (this.namespace) {
                            evKey = key + "." + this.namespace
                        }
                        var handler = keepContext ? function () {
                            if (_event.selector) {
                                _event.handler.apply(node.find(_event.selector), arguments)
                            } else {
                                _event.handler.apply(node, arguments)
                            }
                        } : this.handler
                        if (this.selector) {
                            to.on(evKey, this.selector, handler)
                        } else {
                            to.on(evKey, handler)
                        }
                    })
                })
            }
        }
    },
    /**
     * restores previous display information that stored by chide
     */
    cshow: function () {
        return this.each(function () {
            var display = $(this).data("display-cache")
            this.style.display = display
            $(this).removeData("display-cache")
        })
    },
    cssCodeEditor: function () {
        var $this = this
        return CodeMirror.fromTextArea($this[0], {
            lineNumbers: true,
            extraKeys: {"Ctrl-Space": "autocomplete"},
            mode: "css",
            theme: "default",
            highlightSelectionMatches: {showToken: /\w/},
            showCursorWhenSelecting: true,
            matchBrackets: true,
            autoCloseBrackets: true,
            gutters: ["CodeMirror-lint-markers"],
        })
    },
    /**
     * makes a input only positive decimal values supported
     */
    decimal: function () {
        return this.each(function () {
            var input = $(this)
            input.bind("keydown.restrict", function (e) {
                var key = e.keyCode
                if (e.shiftKey) {
                    return browser.key.isArrows(key)
                }
                if (key == browser.key.POINT || key == browser.key.NUM_POINT) {
                    return input.val().indexOf(".") == -1
                }
                return key == browser.key.BACKSPACE || key == browser.key.TAB || key == browser.key.DELETE || browser.key.isArrows(key) || browser.key.isDigit(key) || (e.ctrlKey && (browser.key.is('a', key) || browser.key.is('A', key) || browser.key.is('c', key) || browser.key.is('v', key) || browser.key.is('x', key) || browser.key.is('C', key) || browser.key.is('V', key) || browser.key.is('X', key)))
            }).on("paste", function () {
                var _self = this
                var oldValue = this.value
                setTimeout(function () {
                    // HWC-2994: isNaN("-50") returns false so negative pastes slipped through;
                    // mirror the numeric restrict guard by also rejecting values below zero.
                    if (isNaN(_self.value) || parseFloat(_self.value) < 0) {
                        _self.value = oldValue
                    }
                }, 0)
            })
        })
    },
    dirRib: function (dir, margin, border, padding) {
        var doList = []
        if (padding === undefined) {
            padding = true
        }
        if (border === undefined) {
            border = true
        }
        if (margin === undefined) {
            margin = true
        }
        if (padding) {
            doList.push("padding")
        }
        if (border) {
            doList.push("border")
        }
        if (margin) {
            doList.push("margin")
        }
        var num = function (value) {
            try {
                var intValue = parseInt(value, 10)
                if(isNaN(intValue)) {
                    return 0
                }
                return intValue
            } catch (t) {
                return 0
            }
        }
        var _this = this
        return doList.sum(function () {
            return num(_this.css(this + '-' + dir + (this == 'border' ? '-width' : '')))
        })
    },
    fill: function (settings) {
        return bm.ajax($.extend(settings, {fill: this}))
    },
    /**
     * blinks selected tags
     * @param {} flag
     * @returns {}
     */
    /**
     * removes input restrictions from a input element
     */
    free: function () {
        return this.each(function () {
            var input = $(this)
            if (!input.is("input")) {
                return
            }
            input.unbind("keydown.restrict")
        })
    },
    /**
     * extends jquery height function to set height considering element padding, margin
     */
    height: function (val/*Number(optional)*/, isOuter/*Boolean(optional)*/, includesMargin/*Boolean(optional)*/) {
        if (arguments.length < 2 || !(isOuter || includesMargin)) {
            return $_height.apply(this, arguments)
        } else {
            var reduceHeight = this.outerHeight(includesMargin || false) - this.height()
            return $_height.call(this, val - reduceHeight)
        }
    },
    hide: function () {
        $(this).find("*").each(function () {
            $(this).triggerHandler("hide")
        })
        return $_hide.apply(this, arguments)
    },
    htmlCodeEditor: function () {
        var $this = this, editor, mixedMode = {
            name: "htmlmixed",
            scriptTypes: [{
                matches: /\/x-handlebars-template|\/x-mustache/i,
                mode: null
            },
                {
                    matches: /(text|application)\/(x-)?vb(a|script)/i,
                    mode: "vbscript"
                }]
        }
        return CodeMirror.fromTextArea($this[0], {
            lineNumbers: true,
            extraKeys: {"Ctrl-Space": "autocomplete"},
            mode: mixedMode,
            theme: "eclipse"
        })

    },
    ichange: function (pauseDuration, handler) {
        return this.on("ichange", pauseDuration, handler)
    },
    //works only for single namespace
    isParentOf: function (child) {
        return this.find(child).length > 0
    },
    leftRib: function (margin, border, padding) {
        return this.dirRib("left", margin, border, padding)
    },
    /**
     * @param show [boolean ! string] if string then it will be added in the div as a class otherwise if it is false then it will hide the mask
     */
    loader: function (show) {
        if(this.nat && this.nat.mask_loadtimer) {
            clearTimeout(this.nat.mask_loadtimer)
        }
        if (show === false) {
            bm.unmask(this)
        } else {
            bm.unmask(this)
            var template = '<div class="wc-loader-overlay"><span class="wc-loader wc-loader--center"></span></div>'.jqObject
            if(typeof show == "string") {
                template.addClass(show)
            }
            if(this.nat){
                bm.mask(this, template)
            }
        }
        return this
    },


    loaderSpecial: function (show) {
        if(this.nat && this.nat.mask_loadtimer) {
            clearTimeout(this.nat.mask_loadtimer)
        }
        if (show === false) {
            bm.unmaskSpecialLoader(this)
        } else {
            var template = '<div><div class="configure-border-1">  \n' +
                '    <div class="configure-core"></div>\n' +
                '  </div>  \n' +
                '  <div class="configure-border-2">\n' +
                '    <div class="configure-core"></div>\n' +
                '  </div></div>'.jqObject
            if(typeof show == "string") {
                template.addClass(show)
            }
            if(this.nat){
                this.nat.mask_loadtimer = setTimeout(function() {
                    bm.specialLoaderWrap(this, template)
                }.bind(this), 0)
            }
        }
        return this
    },

    checkoutDeliveryTypeLoader: function (show) {
        if(this.nat && this.nat.mask_loadtimer) {
            clearTimeout(this.nat.mask_loadtimer)
        }
        if (show === false) {
            bm.unmaskCheckoutDeliveryTypeLoader(this)
        } else {
            var template = '<div class="checkout-page-placeholder-wrapper">\n' +
                '            <div class="advance-checkout-placeholder" style="display: flex">\n' +
                '                <div class="advance-checkout-order-details-dom-placeholder advance-checkout-steps-left-dom-placeholder">\n' +
                '                    <div class="advance-checkout-steps-left-dom-placeholder__title"></div>\n' +
                '                    <div class="advance-checkout-steps-left-dom-placeholder__sub-title"></div>\n' +

                '                    <div class="advance-checkout-steps-left-dom-placeholder__title address"></div>\n' +
                '                    <div class="advance-checkout-steps-left-dom-placeholder__from-row double-input-row">\n' +
                '                        <div class="advance-checkout-steps-left-dom-placeholder__inputbox"></div>\n' +
                '                        <div class="advance-checkout-steps-left-dom-placeholder__inputbox"></div>\n' +
                '                    </div>\n' +
                '                    <div class="advance-checkout-steps-left-dom-placeholder__from-row double-input-row">\n' +
                '                        <div class="advance-checkout-steps-left-dom-placeholder__inputbox"></div>\n' +
                '                        <div class="advance-checkout-steps-left-dom-placeholder__inputbox"></div>\n' +
                '                    </div>\n' +
                '                    <div class="advance-checkout-steps-left-dom-placeholder__from-row double-input-row">\n' +
                '                        <div class="advance-checkout-steps-left-dom-placeholder__inputbox"></div>\n' +
                '                        <div class="advance-checkout-steps-left-dom-placeholder__inputbox"></div>\n' +
                '                    </div>\n' +
                '                    <div class="advance-checkout-steps-left-dom-placeholder__from-row double-input-row">\n' +
                '                        <div class="advance-checkout-steps-left-dom-placeholder__inputbox"></div>\n' +
                '                        <div class="advance-checkout-steps-left-dom-placeholder__inputbox"></div>\n' +
                '                    </div>\n' +
                '                    <div class="advance-checkout-steps-left-dom-placeholder__from-row textarea-row">\n' +
                '                        <div class="advance-checkout-steps-left-dom-placeholder__textarea"></div>\n' +
                '                    </div>\n' +
                '                </div>\n' +
                '            </div>\n' +
                '        </div>'.jqObject
            if(typeof show == "string") {
                template.addClass(show)
            }
            if(this.nat){
                this.nat.mask_loadtimer = setTimeout(function() {
                    bm.checkoutDeliveryTypeLoaderWrap(this, template)
                }.bind(this), 0)
            }
        }
        return this
    },

    differentShippingLoader: function (show) {
        if(this.nat && this.nat.mask_loadtimer) {
            clearTimeout(this.nat.mask_loadtimer)
        }
        if (show === false) {
            this.find(".checkout-page-placeholder-wrapper").detach()
        } else {
            var template = '<div class="checkout-page-placeholder-wrapper">\n' +
                '            <div class="advance-checkout-placeholder" style="display: flex">\n' +
                '                <div class="advance-checkout-order-details-dom-placeholder advance-checkout-steps-left-dom-placeholder">\n' +
                '                    <div class="advance-checkout-steps-left-dom-placeholder__from-row double-input-row">\n' +
                '                        <div class="advance-checkout-steps-left-dom-placeholder__inputbox"></div>\n' +
                '                        <div class="advance-checkout-steps-left-dom-placeholder__inputbox"></div>\n' +
                '                    </div>\n' +
                '                    <div class="advance-checkout-steps-left-dom-placeholder__from-row double-input-row">\n' +
                '                        <div class="advance-checkout-steps-left-dom-placeholder__inputbox"></div>\n' +
                '                        <div class="advance-checkout-steps-left-dom-placeholder__inputbox"></div>\n' +
                '                    </div>\n' +
                '                    <div class="advance-checkout-steps-left-dom-placeholder__from-row double-input-row">\n' +
                '                        <div class="advance-checkout-steps-left-dom-placeholder__inputbox"></div>\n' +
                '                        <div class="advance-checkout-steps-left-dom-placeholder__inputbox"></div>\n' +
                '                    </div>\n' +
                '                    <div class="advance-checkout-steps-left-dom-placeholder__from-row double-input-row">\n' +
                '                        <div class="advance-checkout-steps-left-dom-placeholder__inputbox"></div>\n' +
                '                        <div class="advance-checkout-steps-left-dom-placeholder__inputbox"></div>\n' +
                '                    </div>\n' +
                '                    <div class="advance-checkout-steps-left-dom-placeholder__from-row double-input-row">\n' +
                '                        <div class="advance-checkout-steps-left-dom-placeholder__inputbox"></div>\n' +
                '                        <div class="advance-checkout-steps-left-dom-placeholder__inputbox"></div>\n' +
                '                    </div>\n' +
                '                    <div class="advance-checkout-steps-left-dom-placeholder__from-row double-input-row">\n' +
                '                        <div class="advance-checkout-steps-left-dom-placeholder__inputbox"></div>\n' +
                '                        <div class="advance-checkout-steps-left-dom-placeholder__inputbox"></div>\n' +
                '                    </div>\n' +
                '                </div>\n' +
                '            </div>\n' +
                '        </div>'.jqObject
            if(typeof show == "string") {
                template.addClass(show)
            }
            if(this.nat){
                this.nat.mask_loadtimer = setTimeout(function() {
                    bm.checkoutDeliveryTypeLoaderWrap(this, template)
                }.bind(this), 0)
            }
        }
        return this
    },

    sameShippingLoader: function (show) {
        if(this.nat && this.nat.mask_loadtimer) {
            clearTimeout(this.nat.mask_loadtimer)
        }
        if (show === false) {
            this.find(".checkout-page-placeholder-wrapper").detach()
        } else {
            var template = '<div class="checkout-page-placeholder-wrapper" style="margin-top:10px">\n' +
                '            <div class="advance-checkout-placeholder" style="display: flex">\n' +
                '                <div class="advance-checkout-order-details-dom-placeholder advance-checkout-steps-left-dom-placeholder">\n' +
                '                    <div class="advance-checkout-steps-left-dom-placeholder__sub-title"></div>\n' +
                '                  </div>\n' +
                '                </div>\n' +
                '            </div>\n' +
                '        </div>'.jqObject
            if(typeof show == "string") {
                template.addClass(show)
            }
            if(this.nat){
                this.nat.mask_loadtimer = setTimeout(function() {
                    bm.checkoutDeliveryTypeLoaderWrap(this, template)
                }.bind(this), 0)
            }
        }
        return this
    },

    loaderGeneral: function (show) {
        if(this.nat && this.nat.mask_loadtimer) {
            clearTimeout(this.nat.mask_loadtimer)
        }
        if (show === false) {
            bm.unmaskGeneralLoader(this)
        } else {
            var template = '<div><div class="configure-border-1">  \n' +
                '    <div class="configure-core"></div>\n' +
                '  </div>  \n' +
                '  <div class="configure-border-2">\n' +
                '    <div class="configure-core"></div>\n' +
                '  </div></div>'.jqObject
            if(typeof show == "string") {
                template.addClass(show)
            }
            if(this.nat){
                this.nat.mask_loadtimer = setTimeout(function() {
                    bm.generalLoaderWrap(this, template)
                }.bind(this), 0)
            }
        }
        return this
    },
    specialLoaderUnwrap: function () {
        this.removeClass("updating")
        this.find(".wc-spinner-loader-box").detach()
    },
    generalLoaderUnwrap: function () {
        this.removeClass("updating")
        this.find(".wc-general-spinner-loader-box").detach()
    },
    mask: function (maskHtml) {
        maskHtml = maskHtml ? maskHtml : "<div></div>"
        bm.mask(this, maskHtml)
    },
    /**
     * makes a input only positive numeric values supported
     */
    numeric: function () {
        return this.each(function () {
            $(this).bind("keydown.restrict", function (e) {
                var key = e.keyCode
                if (e.shiftKey) {
                    return browser.key.isArrows(key)
                }
                return key == browser.key.BACKSPACE || key == browser.key.TAB || key == browser.key.DELETE || browser.key.isArrows(key) || browser.key.isDigit(key) || (e.ctrlKey && (browser.key.is('a', key) || browser.key.is('A', key) || browser.key.is('c', key) || browser.key.is('v', key) || browser.key.is('x', key) || browser.key.is('C', key) || browser.key.is('V', key) || browser.key.is('X', key)))
            }).on("paste", function () {
                var _self = this
                var oldValue = this.value
                setTimeout(function () {
                    var newValue = _self.value
                    if (isNaN(newValue) || newValue.contains(".") || newValue < 0) {
                        _self.value = oldValue
                    }
                }, 0)
            })
        })
    },

    /**
     * @deprecated use <plugin-name>('inst')
     * @param type
     * @returns {*}
     */
    obj: function (type) {
        var data = this.data()
        if (!data) {
            return null
        }
        if (typeof type == "string") {
            return data[type]
        }
        if (!$.isFunction(type)) {
            type = null
        }
        var obj = null
        $.each(data, function (key) {
            if (type) {
                if (this instanceof type) {
                    obj = this
                    return false
                }
                return true
            }
            if (key.endsWith("Inst")) {
                obj = this
                return false
            }
            if (key.startsWith("wcui")) {
                obj = this
                return false
            }
        })
        return obj
    },
    outer: function () {
        return this[0].outerHTML
    },
    //analogous to prop function - analogy created to be used for custom properties
    pairuncheck: function () {
        this.after(function () {
            var check = $(this)
            if (check.data("pairuncheck-init")) return
            check.data("pairuncheck-init", true)
            var input = $("<input style='display: none' class='single pairuncheck-hidden' type='checkbox' name='" + check.attr("name") + "' value='" + check.attr("uncheck-value") + "'>")
            check.bind("change.form", function () {
                if (!this.checked) {
                    input[0].checked = true
                } else {
                    input[0].checked = false
                }
            })
            check.triggerHandler("change.form")
            return input
        })
    },
    /**
     * @param offset [boolean | {left: [number], top: [number]}] if boolean then it will be considered as includeMargin
     * @param includeMargin
     * @returns {*}
     */
    rect: function (offset, includeMargin) {
        var rect = $.extend({}, this.nat.getBoundingClientRect())
        var _document = this[0].ownerDocument
        var scroller = $(/webkit/i.test(navigator.userAgent) || _document.compatMode == 'BackCompat' ? _document.body : _document.documentElement)
        var s_top = scroller.scrollTop()
        var s_left = scroller.scrollLeft()
        rect.top += s_top
        rect.left += s_left
        rect.bottom += s_top
        rect.right += s_left
        if (arguments.length == 0) {
            return rect
        }
        if (offset instanceof Boolean || typeof offset == "boolean") {
            includeMargin = offset
            offset = undefined
        }
        if (offset instanceof $) {
            var _offset = offset.offset()
            _offset.left *= -1
            _offset.left -= offset.leftRib(false, true, false)
            _offset.top *= -1
            _offset.top -= offset.topRib(false, true, false)
            offset = _offset
        }
        if (offset) {
            rect.left += offset.left
            rect.top += offset.top
            rect.right += offset.left
            rect.bottom += offset.top
        }
        if (includeMargin) {
            var marginL = parseInt(this.css("margin-left"))
            var marginR = parseInt(this.css("margin-right"))
            var marginT = parseInt(this.css("margin-top"))
            var marginB = parseInt(this.css("margin-bottom"))
            rect.left -= marginL
            rect.top -= marginT
            rect.right += marginR
            rect.bottom += marginB
            rect.width += marginL + marginR
            rect.height += marginT + marginB
        }
        return rect
    },
    reset: function () {
        this.each(function () {
            var input = $(this)
            if(!input.is(":input")) {
                if(input.nat.reset) {
                    input.nat.reset()
                }
                return
            }
            var next = this.nextSibling
            var parent = input.parent()
            var form = $("<form></form>")
            form.append(input)
            form[0].reset()
            if (next) {
                $(next).before(input)
            } else {
                parent.append(input)
            }
        })
    },
    rightRib: function (margin, border, padding) {
        return this.dirRib("right", margin, border, padding)
    },
    scrollHere: function (scroller) {
        if (!scroller) {
            scroller = this.closest(".scrollable")
            if(!scroller.length) {
                var _document = this[0].ownerDocument
                scroller = bm.getTopScroller(_document)
            }
        } else if (scroller.nat instanceof Document) {
            scroller = bm.getTopScroller(scroller.nat)
        }
        if (this.is(":hidden")) {
            return
        }
        var height = scroller.height()
        var width = scroller.width()
        var scroller_offset = scroller.offset()
        var target_offset = this.offset()

        var bottom_dist = target_offset.top - scroller_offset.top - height
        if (bottom_dist > 0) {
            scroller.animate({scrollTop: "+=" + (bottom_dist + Math.min(height / 3, 150)) + "px"}, 800)
        } else {
            var top_dist = scroller_offset.top - target_offset.top
            if (top_dist > 0) {
                scroller.animate({scrollTop: "-=" + (top_dist + Math.min(height / 3, 150)) + "px"}, 800)
            }
        }

        var right_dist = target_offset.left - scroller_offset.left - width
        if (right_dist > 0) {
            scroller.animate({scrollLeft: "+=" + (right_dist + Math.min(width / 3, 150)) + "px"}, 800)
        } else {
            var left_dist = scroller_offset.left - target_offset.left
            if (left_dist > 0) {
                scroller.animate({scrollLeft: "-=" + (left_dist + Math.min(width / 3, 150)) + "px"}, 800)
            }
        }
        return this
    },
    /**
     * takes data from an form and generates an json object using those data
     * */
    serializeObject: function () {
        var o = {}
        var a = (this.is("form") ? this : this.find(":input")).serializeArray()
        $.each(a, function () {
            if (o[this.name] !== undefined) {
                if (!$.isArray(o[this.name])) {
                    o[this.name] = [o[this.name]]
                }
                o[this.name].push(this.value || '')
            } else {
                o[this.name] = this.value || ''
            }
        })
        return o
    },
    show: function () {
        var showHandler
        var afterShow = function () {
            $(this).find("*").each(function () {
                $(this).triggerHandler("show")
            })
            if (showHandler) {
                showHandler.apply(this, arguments)
            }
        }
        if (arguments.length == 1) {
            if ($.isPlainObject(arguments[0])) {
                showHandler = arguments[0].complete
                arguments[0].complete = afterShow
            }
        }
        var argumentPos = -1
        $.each(arguments, function (i) {
            if (typeof this == "function") {
                showHandler = this
                argumentPos = i
            }
        })
        if (argumentPos > -1) {
            arguments[argumentPos] = afterShow
        }
        $_show.apply(this, arguments)
        if (!showHandler) {
            afterShow.call(this[0])
        }
        return this
    },
    /**
     * makes a input only signed numeric values supported
     */
    sortablecolumn: function (config) {
        var defaults = {
            empty: "always-below"
        }

        var functions = {
            resetSortState: function () {
                return this.removeAttr("sort-dir").removeClass("sort-down").removeClass("sort-up")
            }
        }

        if (typeof config == "string") {
            return functions[config].call(this)
        }

        $.extend(config, defaults)

        function sortIt(th, dir) {
            var index = th.index()
            var table = th.closest("table")
            var rows = table.find("tr").not(":first")
            rows.sort(function (a, b) {
                var keyA = $('td:eq(' + index + ')', a).text().trim().toUpperCase()
                var keyB = $('td:eq(' + index + ')', b).text().trim().toUpperCase()
                if (keyA == keyB) {
                    return 0
                }
                if (keyA == "") {
                    if (config.empty == "always-below") {
                        return 1
                    } else if (config.empty == "always-above") {
                        return -1
                    }
                }
                if (keyB == "") {
                    if (config.empty == "always-below") {
                        return -1
                    } else if (config.empty == "always-above") {
                        return 1
                    }
                }
                if ((dir == "up" && keyA > keyB) || (dir == "down" && keyA < keyB)) {
                    return 1
                }
                return -1
            })
            table.append(rows.remove())
        }

        var th = $(this)
        th.addClass("sortable").click(function () {
            var _self = $(this)
            var dir = _self.attr("sort-dir") || "down"
            if (dir == "down") {
                _self.attr("sort-dir", dir = "up")
                _self.addClass("sort-up").removeClass("sort-down")
            } else {
                _self.attr("sort-dir", dir = "down")
                _self.addClass("sort-down").removeClass("sort-up")
            }
            sortIt(_self, dir)
            _self.closest("table").trigger("sort")
            _self.closest("table").trigger("change")
        })
        var table = th.closest("table")
        table.bind("row-update", function () {
            var _self = $(this).find("th.sortable")
            _self.each(function () {
                var th = $(this)
                var dir = th.attr("sort-dir")
                if (dir) {
                    sortIt(th, dir)
                }
            })
            _self.trigger("sort")
            table.trigger("change")
        })
        return this
    },
    //analogous to prop function - analogy created to be used for custom properties
    store: function (name, value) {
        if (arguments.length == 2) {
            this.each(function () {
                this[name] = value
            })
            return this
        }
        return this.length ? this[0][name] : null
    },
    swap: function (to) {
        var aParent = this.parent()
        var aIndex = this.index()
        var bParent = to.parent()
        var bIndex = to.index()
        if (aParent[0] == bParent[0]) {
            if (aIndex < bIndex) {
                this.before(to)
                var eAtPos = bParent.find(">*:eq(" + bIndex + ")")
                if (eAtPos[0] == this[0]) {
                    return
                }
                if (eAtPos.length) {
                    eAtPos.after(this)
                } else {
                    bParent.append(this)
                }
            } else {
                this.after(to)
                var eAtPos = bParent.find(">*:eq(" + bIndex + ")")
                if (eAtPos[0] == this[0]) {
                    return
                }
                if (eAtPos.length) {
                    eAtPos.before(this)
                } else {
                    bParent.append(this)
                }
            }
        } else {
            this.before(to)
            var eAtPos = bParent.find(">*:eq(" + bIndex + ")")
            if (eAtPos.length) {
                eAtPos.before(this)
            } else {
                bParent.append(this)
            }
        }
    },
    /**
     * only name - retrieves save data
     * value is undefined - removes data
     * no arguments usage - tag().remove(name) [remove/get/set]
     * @param name
     * @param value
     * @returns {*}
     */
    tag: function (name, value) {
        var _this = this.nat
        if (name && !_this) {
            return null
        }
        var funcs = {
            remove: function (name) {
                if (_this[bm.expando]) {
                    var prev = _this[bm.expando][name]
                    delete _this[bm.expando][name]
                    return prev
                }
            },
            get: function (name) {
                return _this[bm.expando] && _this[bm.expando][name]
            },
            set: function (name) {
                if (!_this[bm.expando]) {
                    _this[bm.expando] = {}
                }
                var prev = _this[bm.expando][name]
                _this[bm.expando][name] = value
                return prev
            },
            iterate: function (func) {
                var all = _this[bm.expando]
                if (!all) {
                    return
                }
                $.each(all, func)
            }
        }
        if (!name) {
            return funcs
        }
        if (arguments.length == 1) {
            return funcs.get(name)
        }
        if (value === undefined) {
            return funcs.remove(name)
        }
        return funcs.set(name)
    },
    /**
     * extends jquery text function. It makes a space preceeded by space as &nbsp
     */
    text: function (text) {
        if (typeof text == "string" && (text.indexOf("\n") != -1 || text.indexOf("  ") != -1)) {
            text = text.htmlEncode()
            return this.each(function () {
                this.innerHTML = text
            })
        }
        return $_text.apply(this, arguments)
    },
    tip: function (config) {
        if (!config) {
            config = {}
        }
        this.mouseenter(function (ev) {
            $.global_tip_mouseevent_reference = ev
            var item = $(this)
            var _config = $.extend({}, config)
            _config.text = _config.text || item.attr("tip-text") || item.attr("title")
            item.removeAttr("title")
            item.trigger("tip-show", [_config])
            $.global_tip_timer_reference = setTimeout(function () {
                if ($.global_tip_inst_reference) {
                    $.global_tip_inst_reference.close()
                }
                $.global_tip_timer_reference = null
                $.global_tip_inst_reference = new POPUP({
                    content: _config.text,
                    template: "<div><div class='content'></div></div>",
                    clazz: "tip-popup",
                    modal: false,
                    is_always_up: true,
                    auto_active: false,
                    auto_active_on_focus: false,
                    ui_position: {
                        my: "left bottom",
                        at: "right top",
                        of: $.global_tip_mouseevent_reference
                    }
                })
                if (typeof config.render === 'function') {
                    config.render($.global_tip_inst_reference.content)
                }
            }, _config.delay || 350)
        }).mouseleave(function (ev) {
            var pop = $.global_tip_inst_reference
            if (pop && config.sustain_on_hover) {
                var popdom = pop.getDom()
                var offset = popdom.offset()
                offset.right = offset.left + popdom.outerWidth()
                offset.bottom = offset.top + popdom.outerHeight()
                if (ev.pageX > offset.left && ev.pageX < offset.right && ev.pageY > offset.top && ev.pageY < offset.bottom) {
                    pop.getDom().mouseleave(function () {
                        pop.close()
                        $.global_tip_inst_reference = null
                    })
                    return
                }
            }
            if ($.global_tip_timer_reference) {
                clearTimeout($.global_tip_timer_reference)
                $.global_tip_timer_reference = null
            }
            if (pop) {
                pop.close()
                $.global_tip_inst_reference = null
            }
        }).mousemove(function (ev) {
            $.global_tip_mouseevent_reference = ev
        })
        return this
    },
    _toggleClassCache: $.prototype.toggleClass,
    /**
     * overrides jquery default implementation. if a exists makes it b and vice versa
     * @param {} a
     * @param {} b
     * @returns {}
     */
    toggleClass: function (a, b) {
        if (arguments.length == 2 && b.isString) {
            if (this.hasClass(a)) {
                this.removeClass(a).addClass(b)
            } else {
                this.removeClass(b).addClass(a)
            }
            return this
        }
        return this._toggleClassCache(a, b)
    },
    topRib: function (margin, border, padding) {
        return this.dirRib("top", margin, border, padding)
    },
    // Storefront-needed: the wcui checkbox/radio click handlers (custom-ui.js) fire
    // change through this on every site page, so it cannot live in prototype-editor.js.
    triggerWithPropagation: function () {
        var eventName = arguments[0]
        var params = arguments[1]
        this.each(function () {
            var event = $.Event(eventName)
            event.target = this
            var parents = $(this).parents().addBack()
            var length = parents.length
            for (var k = length - 1; k >= 0; k--) {
                if (parents.eq(k).triggerHandler(event, params) === false) {
                    return false
                }
            }
        })
    },
    unmask: function () {
        this.removeClass("updating")
        this.find(".div-mask").detach()
    },
    /**
     * reverse of wrapInner
     * @returns {}
     */
    unwrapInner: function () {
        var wrapper = this.children().first()
        var contents = wrapper.contents()
        this.prepend(contents)
        wrapper.remove()
        return this
    },
    /**
     * extends jquery width function to set width considering element padding, margin
     */
    width: function (val/*Number(optional)*/, isOuter/*Boolean(optional)*/, includesMargin/*Boolean(optional)*/) {
        if (arguments.length < 2 || !(isOuter || includesMargin)) {
            return $_width.apply(this, arguments)
        } else {
            var reduceWidth = this.outerWidth(includesMargin || false) - this.width()
            return $_width.call(this, val - reduceWidth)
        }
    },

    /**
     * removes inline display property
     */
    xshow: function () {
        return this.each(function () {
            this.style.display = ''
        })
    }
})
Object.defineProperty($.prototype, "nat", {
    get: function () {
        return this.length ? this[0] : null
    }
})
//endregion

//region JQUERY EVENTS
bm.domnode_parent_remove_handler = []
bm.domnode_self_remove_handler = []
$(document).on("DOMNodeRemoved", function (ev) {
    var elm = ev.target
    var hash = elm.remove_key_hash || (elm.remove_key_hash = bm.getUUID())
    if (bm.domnode_self_remove_handler[hash]) {
        var _events = bm.domnode_self_remove_handler[hash]
        delete bm.domnode_self_remove_handler[hash]
        _events.everyCustomFunc(function (key, handle) {
            elm == handle.element && handle.handler.call(elm, ev)
            return true
        })
    }
    bm.domnode_parent_remove_handler.everyCustomFunc(function (key, value) {
        if ($(elm).find(value.element).length) {
            if (value.selector) {
                var _self = value
                $(value.element).find(value.selector).each(function () {
                    _self.handler.call(this, ev)
                })
            } else {
                value.handler.call(value.element, ev)
            }
        }
        return true
    })
})

bm.jquery_data_clean_handler = []
var original_clean = $.cleanData
$.cleanData = function (elements, acceptData) {
    if (!(elements instanceof Array)) {
        elements = $.makeArray(elements)
    }
    elements.everyCustomFunc(function (k, elm) {
        elm.cleaning_data = true
        return true
    })
    bm.jquery_data_clean_handler.everyCustomFunc(function (key, value) {
        if (elements.contains(value.element)) {
            if (value.selector) {
                var _self = value
                $(value.element).find(value.selector).each(function () {
                    _self.handler.call(this, $.Event("jqclean"))
                })
            } else {
                value.handler.call(value.element, $.Event("jqclean"))
            }
        }
    })
    original_clean.apply(this, arguments, acceptData)
    elements.everyCustomFunc(function (key, elm) {
        delete elm.cleaning_data
        return true
    })
}

$.extend($.event.special, {
    //if multiple handler is bound then duration for successive handlers will be ignored
    ichange: {
        add: function (obj) {
            var selectors = obj.selector ? obj.selector.split(",") : ["no-selector"]
            var pauseDuration = obj.data || 400
            var _self = $(this)
            var namespaces = obj.namespace ? obj.namespace.split(".") : ["no-namespace"]
            var focused

            $.each(selectors, function (index, selector) {
                selector = selector.trim()
                var timer
                var initialValue

                var boundCollection = _self.data("ichange-bound")
                if (!boundCollection) {
                    boundCollection = {}
                    boundCollection[selector] = namespaces
                    _self.data("ichange-bound", boundCollection)
                } else if (boundCollection[selector] != null) {
                    $.each(namespaces, function () {
                        boundCollection[selector].push(this)
                    })
                    return
                }

                if (selector == "no-selector") {
                    selector = null
                }

                function checkForChange() {
                    var input = selector ? _self.find(selector) : _self
                    var currentValue = input.val()
                    if (currentValue != initialValue) {
                        var prevValue = initialValue
                        initialValue = currentValue
                        setTimeout(function () {
                            if (selector) {
                                _self.triggerHandler({type: "ichange", target: input[0]}, [currentValue, prevValue])
                            } else {
                                _self.triggerHandler("ichange", [currentValue, prevValue])
                            }
                        }, 5)
                    }
                }

                function startTimer() {
                    if (timer) {
                        clearInterval(timer)
                    }
                    timer = setInterval(checkForChange, pauseDuration)
                }

                var focusHandler = function () {
                    initialValue = this.value
                    focused = this
                    startTimer()
                }
                var blurHandler = function () {
                    if (timer) {
                        clearInterval(timer)
                    }
                    checkForChange()
                }
                var changeHandler = function (e, v1, v2) {
                    if (this == focused) {
                        return
                    }
                    if (selector) {
                        _self.triggerHandler({type: "ichange", target: this}, [this.value, v2])
                    } else {
                        _self.triggerHandler("ichange", [this.value, v2])
                    }
                }

                if (selector) {
                    _self.on("focus.ichange-event", selector, focusHandler)
                    _self.on("blur.ichange-event", selector, blurHandler)
                    _self.on("keydown.ichange-event", selector, startTimer)
                    _self.on("change.ichange-event", selector, changeHandler)
                } else {
                    _self.on("focus.ichange-event", focusHandler)
                    _self.on("blur.ichange-event", blurHandler)
                    _self.on("keydown.ichange-event", startTimer)
                    _self.on("change.ichange-event", changeHandler)
                    _self.each(function () {
                        this.isilent = function (value) {
                            if (this == focused) {
                                initialValue = value
                            }
                            this.value = value
                            return $(this)
                        }
                    })
                }
            })
        },
        remove: function (obj) {
            var selectors = obj.selector ? obj.selector.split(",") : ["no-selector"]
            var _self = $(this)
            var modifiedSelectors = ""
            $.each(selectors, function (index, selector) {
                selector = selector.trim()
                var boundCollection = _self.data("ichange-bound")
                if (!boundCollection) {
                    return
                } else if (boundCollection[selector] && obj.namespace) {
                    var namespaces = obj.namespace.split(".")
                    var addedNamespaces = boundCollection[selector]
                    $.each(namespaces, function (index, namespace) {
                        var indices = []
                        $.each(addedNamespaces, function (_index) {
                            if (namespace == this) {
                                indices.push(_index)
                            }
                        })
                        $.each(indices, function (n) {
                            boundCollection[selector].splice(this - n, 1)
                        })
                    })
                    if (boundCollection[selector].length == 0) {
                        modifiedSelectors += " " + selector
                        delete boundCollection[selector]
                    }
                    return
                } else {
                    modifiedSelectors += " " + selector
                }
            })
            if (modifiedSelectors == "") {
                return
            } else if (modifiedSelectors != "no-selector") {
                _self.off("focus.ichange-event", modifiedSelectors)
                _self.off("blur.ichange-event", modifiedSelectors)
                _self.off("keydown.ichange-event", modifiedSelectors)
            } else {
                _self.off("focus.ichange-event")
                _self.off("blur.ichange-event")
                _self.off("keydown.ichange-event")
            }
        }
    },
    remove: {
        add: function (obj) {
            var hash = {
                element: this,
                namespace: obj.namespace,
                handler: obj.handler
            }
            if (!obj.selector) {
                var hashKey = this.remove_key_hash || (this.remove_key_hash = bm.getUUID())
                if (!bm.domnode_self_remove_handler[hashKey]) {
                    bm.domnode_self_remove_handler[hashKey] = []
                }
                bm.domnode_self_remove_handler[hashKey].push(hash)
            }
            bm.domnode_parent_remove_handler.push(hash)
        },
        remove: function (obj) {
            var _self = this
            if (!obj.selector && !this.cleaning_data) {
                var hash = this.remove_key_hash || (this.remove_key_hash = bm.getUUID())
                if (bm.domnode_self_remove_handler[hash]) {
                    bm.domnode_self_remove_handler[hash].removeAll(function (handle) {
                        return _self == handle.element && (!obj.namespace || obj.namespace == handle.namespace) && (!obj.handler || obj.handler == handle.handler)
                    })
                    if (!bm.domnode_self_remove_handler[hash].length) {
                        delete bm.domnode_self_remove_handler[hash]
                    }
                }
            }
            bm.domnode_parent_remove_handler.removeAll(function (handle) {
                return _self == handle.element && (!obj.namespace || obj.namespace == handle.namespace) && (!obj.selector || obj.selector == handle.selector) && (!obj.handler || obj.handler == handle.handler)
            })
        }
    },
    jqclean: {
        add: function (obj) {
            bm.jquery_data_clean_handler.push({
                element: this,
                namespace: obj.namespace,
                selector: obj.selector,
                handler: obj.handler
            })
        },
        remove: function (obj) {
            var _self = this
            bm.jquery_data_clean_handler.removeAll(function (handle) {
                return _self == handle.element && (!obj.namespace || obj.namespace == handle.namespace) && (!obj.selector || obj.selector == handle.selector) && (!obj.handler || obj.handler == handle.handler)
            })
        }
    }
})
//endregion

//region NUMBER
var _to_fixed = Number.prototype.toFixed
$.extend(Number.prototype, {
    /**
     * removes trailing 0s from fixed values if true is passed as trimmed
     */
    toFixed: function (count, trimmed) {
        var fixed = _to_fixed.call(this, count)
        if (trimmed) {
            return fixed.replace(/\.?0+$/, '')
        }
        return fixed
    },
    /**
     * considers value as byte and returns its representation in KB/MB/GB whichever convenient
     */
    toByteNotation: function () {
        if (this < 1024) {
            return this.toFixed(3, true) + " B"
        }
        var kilo = this / 1024
        if (kilo < 1024) {
            return kilo.toFixed(2, true) + " KB"
        }
        var mega = kilo / 1024
        if (mega < 1024) {
            return mega.toFixed(2, true) + " MB"
        }
        var giga = mega / 1024
        if (giga < 1024) {
            return giga.toFixed(2, true) + " GB"
        }
        var tera = giga / 1024
        return tera.toFixed(2, true) + " TB"
    },
    loop: function (func, startFrom) {
        if (startFrom == null) {
            startFrom = 0
        }
        var endTo = this + startFrom
        for (var g = startFrom; g < endTo; g++) {
            func(g)
        }
    },
    rloop: function (func, startFrom) {
        if (startFrom == null) {
            startFrom = this
        }
        var endTo = this - startFrom
        for (var g = startFrom; g > endTo; g--) {
            var breakIt = func(g)
            if (breakIt === false) {
                break
            }
        }
    }
})
//endregion

//region STRINGWRITER
function StringWriter() {
    this.buffer = []
}

StringWriter.prototype.plus = function (j) {
    this.buffer.push(j)
    return this
}

StringWriter.prototype.toString = function () {
    return this.buffer.join("")
}
//endregion

//region DATE
/**
 * Formatting and parsing for the date patterns the date picker and form validation use, e.g. "yyyy-MM-dd",
 * "yyyy-MM-dd HH:mm:ss" and "hh:mm tt". This is the Datejs pattern syntax those were written against;
 * Datejs itself was removed. Tokens: yyyy yy MMMM MMM MM M dddd ddd dd d HH H hh h mm m ss s tt t.
 * Any other character is matched literally. Dates are read and written in local time.
 */
;(function () {
    var PATTERN_TOKENS = ["yyyy", "yy", "MMMM", "MMM", "MM", "M", "dddd", "ddd", "dd", "d", "HH", "H", "hh", "h",
        "mm", "m", "ss", "s", "tt", "t"]
    var MONTH_NAMES = ["January", "February", "March", "April", "May", "June", "July", "August", "September",
        "October", "November", "December"]
    var DAY_NAMES = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
    // [fewest, most] digits each numeric token accepts when parsing
    var DIGIT_COUNTS = {yyyy: [4, 4], yy: [2, 2], MM: [2, 2], M: [1, 2], dd: [2, 2], d: [1, 2], HH: [2, 2], H: [1, 2],
        hh: [2, 2], h: [1, 2], mm: [2, 2], m: [1, 2], ss: [2, 2], s: [1, 2]}
    // A two-digit year at or below this is 20yy, above it 19yy, as Datejs's en-US culture did.
    var TWO_DIGIT_YEAR_PIVOT = 29

    function splitPattern(pattern) {
        var parts = []
        var index = 0
        while (index < pattern.length) {
            var token = null
            for (var t = 0; t < PATTERN_TOKENS.length; t++) {
                if (pattern.substr(index, PATTERN_TOKENS[t].length) === PATTERN_TOKENS[t]) {
                    token = PATTERN_TOKENS[t]
                    break
                }
            }
            parts.push(token ? {token: token} : {literal: pattern.charAt(index)})
            index += token ? token.length : 1
        }
        return parts
    }

    function padTwo(number) {
        return number < 10 ? "0" + number : String(number)
    }

    function formatDate(date, pattern) {
        var month = date.getMonth()
        var weekday = date.getDay()
        var hours = date.getHours()
        var twelveHour = hours % 12 || 12
        var values = {
            yyyy: String(date.getFullYear()), yy: padTwo(date.getFullYear() % 100),
            MMMM: MONTH_NAMES[month], MMM: MONTH_NAMES[month].substr(0, 3), MM: padTwo(month + 1), M: String(month + 1),
            dddd: DAY_NAMES[weekday], ddd: DAY_NAMES[weekday].substr(0, 3),
            dd: padTwo(date.getDate()), d: String(date.getDate()),
            HH: padTwo(hours), H: String(hours), hh: padTwo(twelveHour), h: String(twelveHour),
            mm: padTwo(date.getMinutes()), m: String(date.getMinutes()),
            ss: padTwo(date.getSeconds()), s: String(date.getSeconds()),
            tt: hours < 12 ? "AM" : "PM", t: hours < 12 ? "A" : "P"
        }
        var parts = splitPattern(pattern)
        var formatted = ""
        for (var i = 0; i < parts.length; i++) {
            formatted += parts[i].token ? values[parts[i].token] : parts[i].literal
        }
        return formatted
    }

    function readDigits(text, position, counts) {
        var end = position
        while (end < text.length && end - position < counts[1] && text.charAt(end) >= "0" && text.charAt(end) <= "9") {
            end++
        }
        return end - position >= counts[0] ? {value: parseInt(text.substring(position, end), 10), next: end} : null
    }

    function readName(text, position, names, length) {
        for (var i = 0; i < names.length; i++) {
            var name = length ? names[i].substr(0, length) : names[i]
            if (text.substr(position, name.length).toLowerCase() === name.toLowerCase()) {
                return {value: i, next: position + name.length}
            }
        }
        return null
    }

    function readMeridiem(text, position, length) {
        var found = readName(text, position, length === 2 ? ["AM", "PM"] : ["A", "P"])
        return found ? {value: found.value === 1, next: found.next} : null
    }

    /**
     * Reads `text` strictly against `pattern`. Returns a local Date, or null when the text does not match the
     * pattern or names a date that does not exist (e.g. 2026-02-30). Missing date parts default to today and
     * missing time parts to 0.
     */
    function parseDate(text, pattern) {
        if (typeof text !== "string" || typeof pattern !== "string") {
            return null
        }
        var today = new Date()
        var fields = {year: today.getFullYear(), month: today.getMonth(), day: today.getDate(), hour: 0, minute: 0, second: 0}
        var isPm = null
        var position = 0
        var parts = splitPattern(pattern)
        for (var i = 0; i < parts.length; i++) {
            var part = parts[i]
            if (part.literal !== undefined) {
                if (text.charAt(position) !== part.literal) {
                    return null
                }
                position++
                continue
            }
            var token = part.token
            var read
            if (token === "MMMM" || token === "MMM") {
                read = readName(text, position, MONTH_NAMES, token === "MMM" ? 3 : 0)
            }
            else if (token === "dddd" || token === "ddd") {
                read = readName(text, position, DAY_NAMES, token === "ddd" ? 3 : 0)
            }
            else if (token === "tt" || token === "t") {
                read = readMeridiem(text, position, token.length)
            }
            else {
                read = readDigits(text, position, DIGIT_COUNTS[token])
            }
            if (!read) {
                return null
            }
            position = read.next
            switch (token.charAt(0)) {
                case "y":
                    fields.year = token === "yy" ? read.value + (read.value <= TWO_DIGIT_YEAR_PIVOT ? 2000 : 1900) : read.value
                    break
                case "M":
                    fields.month = token.length > 2 ? read.value : read.value - 1
                    break
                case "d":
                    if (token.length <= 2) {
                        fields.day = read.value
                    }
                    break
                case "H":
                case "h":
                    fields.hour = read.value
                    break
                case "m":
                    fields.minute = read.value
                    break
                case "s":
                    fields.second = read.value
                    break
                case "t":
                    isPm = read.value
                    break
            }
        }
        if (position !== text.length) {
            return null
        }
        if (isPm !== null) {
            if (fields.hour < 1 || fields.hour > 12) {
                return null
            }
            fields.hour = fields.hour % 12 + (isPm ? 12 : 0)
        }
        if (fields.hour > 23 || fields.minute > 59 || fields.second > 59) {
            return null
        }
        var date = new Date(fields.year, fields.month, fields.day, fields.hour, fields.minute, fields.second)
        var exists = date.getFullYear() === fields.year && date.getMonth() === fields.month && date.getDate() === fields.day
        return exists ? date : null
    }

    /**
     * Turns a Java SimpleDateFormat pattern, as the locale settings store it (e.g. "EEE, d MMM yyyy", "hh:mm a"),
     * into the pattern Date#format reads. Only the weekday (E) and AM/PM (a) letters differ; the rest are the same.
     */
    function fromJavaPattern(pattern) {
        return pattern.replace(/E{4,}/g, "dddd").replace(/E{1,3}/g, "ddd").replace(/a+/g, "tt")
    }

    $.extend(Date.prototype, {
        gmt: function () {
            var gmtDate = new Date(this.getTime() + (this.getTimezoneOffset() * 60000))
            return gmtDate
        },
        toZone: function () {
            var gmtDate = new Date(this.getTime() - (this.getTimezoneOffset() * 60000))
            return gmtDate
        },
        format: function (pattern) {
            return pattern ? formatDate(this, pattern) : this.toString()
        }
    })
    Date.parseFormatted = parseDate
    Date.fromJavaPattern = fromJavaPattern
})()
//endregion

//region OBJECT
var _cachedObjectProtoToString = Object.prototype.toString
Object.defineProperty(Object.prototype, "isArray", {
    get: function () {
        return this.cached_is_array || _cachedObjectProtoToString.call(this) == "[object Array]"
    },
    set: function (v) {
        this.cached_is_array = v
    }
})
Object.defineProperty(Object.prototype, "isFunction", {
    get: function () {
        return this.cached_is_function || typeof this === "function"
    },
    set: function (v) {
        this.cached_is_function = v
    }
})
Object.defineProperty(Object.prototype, "isString", {
    get: function () {
        return _cachedObjectProtoToString.call(this) == "[object String]"
    }
})
Object.defineProperty(Object.prototype, "isNumber", {
    get: function () {
        return this.cached_is_number || _cachedObjectProtoToString.call(this) == "[object Number]"
    },
    set: function(v) {
        this.cached_is_number = v
    }
})
Object.defineProperty(Object.prototype, "isDate", {
    get: function () {
        return _cachedObjectProtoToString.call(this) == "[object Date]"
    }
})

;(function () {
    function defineGetter(name, getter) {
        var existing = Object.getOwnPropertyDescriptor(Object.prototype, name)
        if (existing && !existing.configurable) {
            return
        }
        try {
            Object.defineProperty(Object.prototype, name, {
                configurable: true,
                get: getter
            })
        } catch (e) { /* frozen prototype or hostile environment — ignore */ }
    }
    defineGetter("isUndefined", function () {
        return typeof this === "undefined"
    })
    defineGetter("jqObject", function () {
        var jq = (typeof window !== 'undefined' && window.jQuery)
        if (!jq) {
            try { jq = (window.parent && window.parent !== window && window.parent.jQuery) || (window.top && window.top !== window && window.top.jQuery) || null } catch (e) { jq = null }
        }
        if (!jq) { jq = (typeof $ !== 'undefined') ? $ : null }
        if (!jq) return null
        return this instanceof String ? jq(this.toString()) : jq(this)
    })
})()
//endregion

//region JQUERY EXPR
var sizzle_expando = Object.keys($.expr.pseudos.not)[0]
$.extend($.expr.pseudos, {
    hasparent: (function () {
        var fn = function (selector) {
            return function (elem) {
                return $(elem.parentNode).is(selector)
            }
        }
        fn[sizzle_expando] = true
        return fn
    })(),
    value: (function () {
        var fn = function (selector) {
            return function (elem) {
                return elem.value == selector
            }
        }
        fn[sizzle_expando] = true
        return fn
    })()
})
//endregion

; $.paginator_config = {
    el: undefined,
    onPageClick: undefined,
    alwaysShow: false,
    next: "",
    prev: "",
    first: "",
    last: ""
};

var Paginator = function (element, config) {
    this.showPages = 4;
    var tag = $(element);
    $.extend(this, $.paginator_config, config);
    // Markup opt-in for alwaysShow: <paginator always-show="true"> keeps Prev / 1 / Next on a
    // single-page list for that one pager, without changing the shared initPaginator helpers
    // that build it. Every pager without the attribute still hides itself below 2 pages.
    if (tag.attr("always-show") === "true") {
        this.alwaysShow = true;
    }
    var total = parseInt(tag.attr("total"), 10);
    total = total > 0 ? total : 0;
    var itemsPerPage = parseInt(tag.attr("max"), 10);
    var offset = parseInt(tag.attr("offset"), 10);
    offset = offset > 0 ? offset : 0;
    var currentPage = Math.floor(offset / itemsPerPage) + 1;
    var pages = tag.attr("pages");
    if (pages) {
        try {
            this.showPages = parseInt(pages, 10);
        } finally {
        }
    }
    this.el = $("<span></span>");
    this.el.attr("class", tag.attr("class"));
    tag.replaceWith(this.el);
    this.el.addClass(this.className || "pagination"); // for custom design or override css
    this.el.data(tag.data());
    this.el.data("wcui-pagination", this);
    this.update(total, itemsPerPage, currentPage);
};

var _p = Paginator.prototype;

(function () {
    function renderPageRange(strict) {
        this.el.empty();

        var fstElm;
        if (this.first !== false) {
            fstElm = $('<span page="1" class="first ' + (this.currentPage == 1 ? 'disabled' : '') + '"></span>');
            fstElm.text(this.first);
            this.el.append(fstElm);
        }
        var prevElm;
        if (this.prev !== false) {
            prevElm = $('<span page="' + (this.currentPage - 1) + '" class="prev ' + (this.currentPage == 1 ? 'disabled' : '') + '"></span>');
            prevElm.text(this.prev);
            this.el.append(prevElm);
        }

        if (!strict) {
            if (this.currentPage < this.startpage) {
                this.startpage = this.currentPage;
                this.endpage = this.startpage + this.showPages - 1;
            }

            if (this.currentPage > this.endpage) {
                this.endpage = this.currentPage;
                this.startpage = this.endpage - this.showPages + 1;
            }
        }

        if (this.startpage != 1) {
            this.el.append('<span class="prev-more" page="prev-pages">...</span>');
        }

        for (var i = this.startpage; i <= this.endpage; i++) {
            if (i == this.currentPage)
                this.el.append('<span page="' + i + '" class="page-number current">' + i + '</span>');
            else
                this.el.append('<span page="' + i + '" class="page-number">' + i + '</span>');
        }

        if (this.endpage != this.pageCount) {
            this.el.append('<span class="next-more" page="next-pages">...</span>')
        }

        var nxtElm
        if (this.next !== false) {
            nxtElm = $('<span page="' + (this.currentPage + 1) + '" class="next ' + (this.currentPage == this.pageCount ? 'disabled' : '') + '"></span>')
            nxtElm.text(this.next)
            this.el.append(nxtElm)
        }
        var lstElm
        if (this.last !== false) {
            lstElm = $('<span page="' + this.pageCount + '" class="last ' + (this.currentPage == this.pageCount ? 'disabled' : '') + '"></span>')
            lstElm.text(this.last)
            this.el.append(lstElm)
        }

        this.el.find('span').click(this, function (ev) {
            if ($(this).hasClass('current') || $(this).hasClass('disabled')) {
                return
            }
            var paginator = ev.data
            var pageNo = $(this).attr('page')
            if (pageNo == "prev-pages") {
                paginator.startpage = paginator.startpage > paginator.showPages ? paginator.startpage - paginator.showPages : 1
                paginator.endpage = paginator.pageCount < (paginator.showPages + 1) ? paginator.pageCount : (paginator.startpage + (paginator.showPages - 1))
                renderPageRange.call(paginator, true)
                return
            }
            if (pageNo == "next-pages") {
                paginator.startpage = paginator.startpage + (paginator.showPages - 1) < paginator.pageCount ? paginator.startpage + paginator.showPages : paginator.startpage
                paginator.startpage = (paginator.startpage + (paginator.showPages - 1) > paginator.pageCount) ? paginator.pageCount - (paginator.showPages - 1) : paginator.startpage
                paginator.endpage = paginator.pageCount < (paginator.showPages + 1) ? paginator.pageCount : (paginator.startpage + (paginator.showPages - 1))
                renderPageRange.call(paginator, true)
                return
            }
            pageNo = parseInt(pageNo, 10)
            paginator.currentPage = pageNo
            if ($(this).hasClass('page-number')) {
                $(this).siblings('.current').removeClass("current")
                $(this).addClass("current")
                if (nxtElm) {
                    nxtElm[(pageNo == paginator.pageCount ? "add" : "remove") + "Class"]("disabled")
                    nxtElm.attr("page", "" + (paginator.currentPage + 1))
                }
                if (lstElm) {
                    lstElm[(pageNo == paginator.pageCount ? "add" : "remove") + "Class"]("disabled")
                }
                if (prevElm) {
                    prevElm[(pageNo == 1 ? "add" : "remove") + "Class"]("disabled")
                    prevElm.attr("page", "" + (paginator.currentPage - 1))
                }
                if (fstElm) {
                    fstElm[(pageNo == 1 ? "add" : "remove") + "Class"]("disabled")
                }
            } else {
                renderPageRange.call(paginator)
            }
            if (paginator.onPageClick) {
                paginator.onPageClick.call(paginator.el, pageNo)
            }
        })
    }

    _p.update = function (total, itemsPerPage, currentPage) {
        var paginator = this.el
        if (typeof total == "number") {
            this.total = total > 0 ? total : 0
        }
        if (typeof itemsPerPage == "number") {
            this.all = itemsPerPage == -1
            this.itemsPerPage = itemsPerPage > 1 ? itemsPerPage : (itemsPerPage == -1 ? this.total : 1)
        }
        this.pageCount = this.all ? (this.total == 0 ? 0 : 1) : Math.ceil(this.total / this.itemsPerPage)
        // alwaysShow (opt-in, the integration "native" footer): render Prev/1/Next for a 0- or 1-page list
        // instead of nothing — clamped here so every later this.pageCount check sees the same number. Every
        // other pager (admin lists, storefront) keeps hiding itself for a single page.
        if (this.alwaysShow) {
            this.pageCount = Math.max(1, this.pageCount)
        }
        if (typeof currentPage == "number") {
            this.currentPage = currentPage > 1 ? (currentPage <= this.pageCount ? currentPage : this.pageCount) : 1
        } else {
            this.currentPage = this.currentPage > 1 ? (this.currentPage <= this.pageCount ? this.currentPage : this.pageCount) : 1
        }
        if (this.pageCount < 2 && !this.alwaysShow) {
            paginator.empty()
            return
        }
        var middlePage = Math.ceil(this.showPages / 2)
        this.startpage = (currentPage > middlePage && this.pageCount > this.showPages) ? currentPage - (middlePage - 1) : 1
        this.startpage = (this.startpage + (this.showPages - 1) > this.pageCount && this.startpage != 1) ? this.pageCount - (this.showPages - 1) : this.startpage
        this.endpage = this.pageCount < (this.showPages + 1) ? this.pageCount : (this.startpage + (this.showPages - 1))

        renderPageRange.call(this)
    }
})()

_p.getPageCount = function () {
    return this.pageCount
}

_p.getCurrentPage = function () {
    return this.currentPage
}

_p.setCurrentPage = function (currentPage, forceReload) {
    if (typeof currentPage != "undefined") {
        if (currentPage < 1) {
            currentPage = 1
        }
        if (this.currentPage != currentPage || forceReload) {
            this.update(undefined, undefined, currentPage)
            this.onPageClick.call(this.el, this.currentPage)
        }
    }
}

_p.getTotal = function () {
    return this.total
}

_p.setTotal = function (total) {
    if (typeof total != "undefined") {
        this.update(total, undefined, undefined)
    }
}

_p.getItemsPerPage = function () {
    return this.itemsPerPage
}

_p.setItemsPerPage = function (itemsPerPage) {
    if (typeof itemsPerPage != "undefined") {
        this.update(undefined, itemsPerPage, undefined)
    }
}

$.prototype.paginator = function (config) {
    if (!this.length) {
        return this
    }
    return this.each(function () {
        new Paginator(this, config)
    })
}
; (function(m){function u(b){b.async&&(b.filesLoaded+=1,b.filesLoaded===b.totalFiles&&b.callback&&b.callback())}function q(b,a){m.ajax({url:b,async:a.async,dataType:"text",success:function(b,c){v(b,a.mode);u(a)},error:function(d,c,e){console.log("Failed to download or parse "+b);u(a)}})}function v(b,a){for(var d="",c=b.split(/\n/),e=/(\{\d+})/g,f=/\{(\d+)}/g,k=/(\\u.{4})/ig,g=0;g<c.length;g++)if(c[g]=c[g].replace(/^\s\s*/,"").replace(/\s\s*$/,""),0<c[g].length&&"#"!=c[g].match("^#")){var l=c[g].split("=");
if(0<l.length){for(var r=decodeURI(l[0]).replace(/^\s\s*/,"").replace(/\s\s*$/,""),h=1==l.length?"":l[1];"\\"==h.match(/\\$/);)h=h.substring(0,h.length-1),h+=c[++g].replace(/\s\s*$/,"");for(var p=2;p<l.length;p++)h+="="+l[p];h=h.replace(/^\s\s*/,"").replace(/\s\s*$/,"");if("map"==a||"both"==a){if(l=h.match(k))for(p=0;p<l.length;p++)h=h.replace(l[p],w(l[p]));m.i18n.map[r]=h}if("vars"==a||"both"==a)if(h=h.replace(/"/g,'\\"'),x(r),e.test(h)){for(var l=h.split(e),p=!0,n="",q=[],t=0;t<l.length;t++)!e.test(l[t])||
0!=q.length&&-1!=q.indexOf(l[t])||(p||(n+=","),n+=l[t].replace(f,"v$1"),q.push(l[t]),p=!1);d+=r+"=function("+n+"){";r='"'+h.replace(f,'"+v$1+"')+'"';d+="return "+r+";};"}else d+=r+'="'+h+'";'}}eval(d)}function x(b){if(/\./.test(b)){var a="";b=b.split(/\./);for(var d=0;d<b.length;d++)0<d&&(a+="."),a+=b[d],eval("typeof "+a+' == "undefined"')&&eval(a+"={};")}}function w(b){var a=[];b=parseInt(b.substr(2),16);0<=b&&b<Math.pow(2,16)&&a.push(b);b="";for(var d=0;d<a.length;++d)b+=String.fromCharCode(a[d]);
return b}m.i18n={};m.i18n.map={};m.i18n.properties=function(b){b=m.extend({name:"Messages",language:"",path:"",mode:"vars",cache:!1,encoding:"UTF-8",async:!1,checkAvailableLanguages:!1,callback:null},b);b.language=this.normaliseLanguageCode(b.language);var a=function(a){b.totalFiles=0;b.filesLoaded=0;var c;c=(c=b.name)&&c.constructor==Array?c:[c];if(b.async)for(var e=0,f=c.length;e<f;e++){b.totalFiles+=1;var k=b.language.substring(0,2);if(0==a.length||-1!=m.inArray(k,a))b.totalFiles+=1;5<=b.language.length&&
(k=b.language.substring(0,5),0==a.length||-1!=m.inArray(k,a))&&(b.totalFiles+=1)}e=0;for(f=c.length;e<f;e++)q(b.path+c[e]+".properties",b),k=b.language.substring(0,2),0!=a.length&&-1==m.inArray(k,a)||q(b.path+c[e]+"_"+k+".properties",b),5<=b.language.length&&(k=b.language.substring(0,5),0!=a.length&&-1==m.inArray(k,a)||q(b.path+c[e]+"_"+k+".properties",b));b.callback&&!b.async&&b.callback()};b.checkAvailableLanguages?m.ajax({url:b.path+"languages.json",async:b.async,cache:!1,success:function(b,c,
e){a(b.languages||[])}}):a([])};m.i18n.prop=function(b){var a=m.i18n.map[b];if(null==a)return b;var d;2==arguments.length&&m.isArray(arguments[1])&&(d=arguments[1]);var c;if("string"==typeof a){for(c=0;-1!=(c=a.indexOf("\\",c));)a="t"==a.charAt(c+1)?a.substring(0,c)+"\t"+a.substring(c++ +2):"r"==a.charAt(c+1)?a.substring(0,c)+"\r"+a.substring(c++ +2):"n"==a.charAt(c+1)?a.substring(0,c)+"\n"+a.substring(c++ +2):"f"==a.charAt(c+1)?a.substring(0,c)+"\f"+a.substring(c++ +2):"\\"==a.charAt(c+1)?a.substring(0,
c)+"\\"+a.substring(c++ +2):a.substring(0,c)+a.substring(c+1);var e=[],f,k;for(c=0;c<a.length;)if("'"==a.charAt(c))if(c==a.length-1)a=a.substring(0,c);else if("'"==a.charAt(c+1))a=a.substring(0,c)+a.substring(++c);else{for(f=c+2;-1!=(f=a.indexOf("'",f));)if(f==a.length-1||"'"!=a.charAt(f+1)){a=a.substring(0,c)+a.substring(c+1,f)+a.substring(f+1);c=f-1;break}else a=a.substring(0,f)+a.substring(++f);-1==f&&(a=a.substring(0,c)+a.substring(c+1))}else"{"==a.charAt(c)?(f=a.indexOf("}",c+1),-1==f?c++:(k=
parseInt(a.substring(c+1,f)),!isNaN(k)&&0<=k?(c=a.substring(0,c),""!=c&&e.push(c),e.push(k),c=0,a=a.substring(f+1)):c=f+1)):c++;""!=a&&e.push(a);a=e;m.i18n.map[b]=e}if(0==a.length)return"";if(1==a.length&&"string"==typeof a[0])return a[0];e="";for(c=0;c<a.length;c++)e="string"==typeof a[c]?e+a[c]:d&&a[c]<d.length?e+d[a[c]]:!d&&a[c]+1<arguments.length?e+arguments[a[c]+1]:e+("{"+a[c]+"}");return e};m.i18n.normaliseLanguageCode=function(b){if(!b||2>b.length)b=navigator.languages?navigator.languages[0]:
navigator.language||navigator.userLanguage||"en";b=b.toLowerCase();b=b.replace(/-/,"_");3<b.length&&(b=b.substring(0,3)+b.substring(3).toUpperCase());return b};var n;n||(n=function(b,a,d){if("[object RegExp]"!==Object.prototype.toString.call(a))return"undefined"==typeof n._nativeSplit?b.split(a,d):n._nativeSplit.call(b,a,d);var c=[],e=0,f=(a.ignoreCase?"i":"")+(a.multiline?"m":"")+(a.sticky?"y":"");a=new RegExp(a.source,f+"g");var k,g,l;b+="";n._compliantExecNpcg||(k=new RegExp("^"+a.source+"$(?!\\s)",
f));if(void 0===d||0>+d)d=Infinity;else if(d=Math.floor(+d),!d)return[];for(;g=a.exec(b);){f=g.index+g[0].length;if(f>e&&(c.push(b.slice(e,g.index)),!n._compliantExecNpcg&&1<g.length&&g[0].replace(k,function(){for(var a=1;a<arguments.length-2;a++)void 0===arguments[a]&&(g[a]=void 0)}),1<g.length&&g.index<b.length&&Array.prototype.push.apply(c,g.slice(1)),l=g[0].length,e=f,c.length>=d))break;a.lastIndex===g.index&&a.lastIndex++}e===b.length?!l&&a.test("")||c.push(""):c.push(b.slice(e));return c.length>
d?c.slice(0,d):c},n._compliantExecNpcg=void 0===/()??/.exec("")[1],n._nativeSplit=String.prototype.split);String.prototype.split=function(b,a){return n(this,b,a)}})(jQuery);

; (function() {
    /**
     * "dependent field" — a control that only makes sense for certain values of another control,
     * so it stays hidden until that one has a qualifying value. Opt in from markup only:
     *
     *     <div class="config-group border-width"
     *          data-fee-show-when="border-style"     <- `name` of the controlling field
     *          data-fee-show-unless="none">          <- comma-separated values that HIDE this row
     *
     * The panel should also render the row `style="display:none"` when the seeded value is already
     * a hiding value, so it never flashes in and out on mount.
     *
     * HIDE, never disable or clear: the row keeps its stored `.config` value while hidden, so
     * switching back restores what the user had and the save path is untouched.
     *
     * Lives here rather than in a front-end-editor module because the same markup appears in plain
     * admin popups, FEE context menus and shared GSP partials — everything that calls updateUi().
     * A no-op unless a row actually carries the attributes.
     */
    $.prototype.dependentFields = function () {
        var $scope = this;
        // Rows grouped by their controlling field: ONE handler per source that refreshes every row
        // it drives. Binding per row (off() + on() with one namespace) left only the LAST row of a
        // shared source wired - the earlier rows never updated again.
        var bySource = {};
        $scope.find("[data-fee-show-when]").each(function () {
            var $row = $(this),
                name = $row.attr("data-fee-show-when"),
                hideOn = String($row.attr("data-fee-show-unless") || "").split(","),
                $src = $scope.find("[name='" + name + "']").first();
            if (!$src.length) {
                return;
            }
            var run = function () {
                var value = $src.is(":radio") ? $scope.find("[name='" + name + "']:checked").val() : $src.val();
                $row.toggle($.inArray(String(value), hideOn) === -1);
            };
            $row.data("feeDependentApply", run);
            run();
            (bySource[name] = bySource[name] || { $src: $src, runs: [] }).runs.push(run);
        });
        $.each(bySource, function (name, entry) {
            var $all = $scope.find("[name='" + name + "']");
            // off() first - updateUi() re-runs on the same panel and a stacked handler would fire
            // once per previous mount.
            $all.off("change.feeDependentField").on("change.feeDependentField", function () {
                $.each(entry.runs, function (i, run) { run(); });
            });
        });
        return this;
    };

    /**
     * "broken image fallback" - an <img> whose file may be missing, opted in from markup only:
     *
     *     <img src="..." alt="" data-broken-image-fallback>
     *     <span class="broken-image-fallback" aria-hidden="true" hidden>...icon...</span>
     *
     * When the file behind `src` cannot be loaded the browser paints its own broken-image glyph,
     * which reads as a defect inside a picker grid. On the image's `error` we hide the <img> and
     * reveal the placeholder that follows it, so the tile shows the designed icon instead.
     *
     * HIDE, never remove or re-point the <img>: the pickers read the original `img[src]` back when
     * a tile is clicked, so the selected URL must stay exactly what the server rendered.
     *
     * Lives here rather than in a front-end-editor module because the same markup appears in the
     * FEE image pickers and in plain admin asset panels - everything that calls updateUi().
     * A no-op unless an image actually carries the attribute.
     */
    $.prototype.brokenImageFallback = function () {
        this.find("img[data-broken-image-fallback]").each(function () {
            var $image = $(this),
                $placeholder = $image.next(".broken-image-fallback"),
                isSvgSource = /\.svg([?#]|$)/i.test(String($image.attr("src") || ""));
            if (!$placeholder.length) {
                return;
            }
            var showPlaceholder = function () {
                $image.hide();
                $placeholder.prop("hidden", false);
            };
            // off() first - updateUi() re-runs on the same panel and a stacked handler would fire
            // once per previous mount.
            $image.off("error.wcBrokenImage").on("error.wcBrokenImage", showPlaceholder);
            // `error` can have fired before this ran: these grids are server-rendered, so their
            // images start loading with the panel HTML and updateUi() only follows the insert.
            // A finished image with no intrinsic width has failed - except an .svg, which
            // legitimately reports no natural size when it carries only a viewBox, so an svg
            // thumbnail is left to the `error` handler above rather than measured here.
            if ($image.prop("complete") && !$image.prop("naturalWidth") && !isSvgSource) {
                showPlaceholder();
            }
        });
        return this;
    };

    /**
     * "per-page-count dropdown" — progressively replaces the core per-page <select>
     * (UITagLib#perPageCountSelector, class="per-page-count") with a hand-built trigger+listbox — opt-in:
     * only a select that also has "pp-custom" (and "raw", so Chosen leaves it alone) is replaced. Applied to
     * every per-page select it sat next to the Chosen control updateUi() had already added (two dropdowns on
     * ~250 list screens) and showed unstyled in the classic admin, where editor-v2.css is not loaded.
     * Callers: the integration "native" footer (_dataPagination.gsp).
     * (rounded card, pale-blue selected row + checkmark — the Claude/Xero export design), because a
     * native select's open popup is 100% OS-drawn chrome with zero CSS access: no styling can ever
     * reach its rows, corners or shadow on any platform.
     *
     * Admin-only, guarded on #workspace (the legacy classic-admin shell's own root id) OR
     * body.new-editor-body (the modern FEE-based admin shell's own marker, set by layouts/newEditor.gsp
     * — confirmed via live DOM check against the actual Xero popup: #workspace is NOT present there,
     * only this class is, so the original #workspace-only guard silently no-opped the whole enhancement
     * on this exact screen). Neither is ever present on a storefront page: this same taglib is also used
     * by the public customer-profile order history (site/autopage/customerProfile/.../orderListView.gsp),
     * which must keep its plain native select untouched rather than suddenly growing admin-only
     * markup/JS on the storefront.
     *
     * Idempotent via .pp-dropdown-done on the original select, so updateUi() re-running on the same
     * panel (every AJAX reload) doesn't stack a second trigger/listbox next to the first — it just
     * leaves an already-enhanced select alone. The hidden original <select> stays the one source of
     * truth every existing change handler already reads (e.g. fee.integration-data-section.js's
     * ".mc-per-page" .val()/.change()) — selecting an option here only sets it and fires a real
     * `change`, so nothing that reads this select needs to know this widget exists.
     */
    $.prototype.perPageDropdown = function () {
        if (!$("#workspace, body.new-editor-body").length) { return this; }
        this.find("select.per-page-count.pp-custom:not(.pp-dropdown-done)").each(function () {
            var $select = $(this).addClass("pp-dropdown-done");
            var $wrap = $("<span class=\"pp-dropdown\"></span>");
            $select.before($wrap);
            $wrap.append($select.hide());
            var $trigger = $(
                "<button type=\"button\" class=\"pp-dropdown-trigger\" aria-haspopup=\"listbox\">" +
                "<span class=\"pp-dropdown-trigger-label\"></span>" +
                "<svg width=\"14\" height=\"14\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.75\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m6 9 6 6 6-6\"/></svg>" +
                "</button>"
            );
            var $menu = $("<div class=\"pp-dropdown-menu\" role=\"listbox\" style=\"display:none;\"></div>");
            $select.find("option").each(function () {
                var $o = $(this);
                $menu.append(
                    $("<button type=\"button\" role=\"option\" class=\"pp-dropdown-option" + ($o.is(":selected") ? " is-selected" : "") + "\" data-value=\"" + $o.val() + "\">" +
                        "<span>" + $o.text() + "</span>" +
                        "<svg class=\"pp-dropdown-check\" width=\"14\" height=\"14\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.75\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M20 6 9 17l-5-5\"/></svg>" +
                        "</button>")
                );
            });
            $trigger.find(".pp-dropdown-trigger-label").text($select.find("option:selected").text());
            $wrap.append($trigger).append($menu);
        });
        return this;
    };

    if (!window.__wcPpDropdownWired) {
        window.__wcPpDropdownWired = true;
        $(document).on("click", ".pp-dropdown-trigger", function (e) {
            e.stopPropagation();
            var $wrap = $(this).closest(".pp-dropdown");
            var $menu = $wrap.find(".pp-dropdown-menu").first();
            var wasOpen = $menu.is(":visible");
            $(".pp-dropdown-menu").hide();
            $(".pp-dropdown").removeClass("is-open");
            if (!wasOpen) { $menu.show(); $wrap.addClass("is-open"); }
        });
        $(document).on("click", ".pp-dropdown-option", function (e) {
            e.stopPropagation();
            var $opt = $(this);
            var $wrap = $opt.closest(".pp-dropdown");
            $wrap.find(".pp-dropdown-option").removeClass("is-selected");
            $opt.addClass("is-selected");
            $wrap.find(".pp-dropdown-trigger-label").text($opt.find("span").first().text());
            $wrap.find("select").val($opt.attr("data-value")).trigger("change");
            $wrap.find(".pp-dropdown-menu").hide();
            $wrap.removeClass("is-open");
        });
        $(document).on("click", function () {
            $(".pp-dropdown-menu").hide();
            $(".pp-dropdown").removeClass("is-open");
        });
    }

    $.prototype.updateUi = function() {
        //if(app.is_front_end) { return this }
        this.find("select:not([multiple], .raw), div.wcui-select.chosen").chosen();
        this.perPageDropdown();
        this.dependentFields();
        this.brokenImageFallback();
        var multipleSelect = this.find("select[multiple]:not(.raw)");
        multipleSelect.not(".special-select-chosen").chosen();
        var specialSelect = multipleSelect.filter(".special-select-chosen");
        specialSelect.each(function() {
            var chosen = $(this);
            chosen.multispecialchosen(chosen.config("chosen"))
        });
        this.find("div.multitxtchosen").multitxtchosen({type: "multi"});
        this.find("input.multitxtchosen").multitxtchosen({type: "csv"});
        this.find("input.spinner").each(function() {
            var _this = $(this);
            var config = {
                min : _this.attr("min"),
                max : _this.attr("max")
            };
            _this.trigger("onStepperBind", [config]);
            _this.stepper(config);
        });
        this.find("paginator").paginator({
            next: $.i18n.prop("next"),
            prev: $.i18n.prop("prev"),
            first: "<<",
            last: ">>"
        });
        this.find(".bmui-tab:not(.alone)").tabify({
            loader_template: "<span class='wc-loader wc-loader--center'></span>"
        });

        // Custom Fields (Unified) petab drag-reorder — guarded, feature-owned init (fee.product-cf-tab.js).
        if (window.WcCustomFieldPetab) {
            window.WcCustomFieldPetab.initSortable(this);
        }

        // new article redactor - only initialize visible editors to prevent broken state on hidden elements
        // ($.fn guard: articleRedactor lives in custom-ui-editor.js, absent on the storefront)
        if ($.fn.articleRedactor) {
            this.find("textarea.wceditor:visible").each(function() {
                var editor = $(this);
                app.articleEditor = editor.articleRedactor()
                // editor.trigger("change")
            });
        }
        this.find(".accordion-panel:not(.raw)").accordion();
        this.find(".datefield-between").each(function() {
            var group = $(this);
            group.find('.datefield-from').date({
                direction: undefined,
                show_select_today: false,
                lang_clear_date: $.i18n.prop("clear"),
                pair: group.find(".datefield-to").date({
                    direction: true,
                    show_select_today: false,
                    lang_clear_date: $.i18n.prop("clear")
                })
            });
        });
        this.find(".timefield-between").each(function() {
            var group = $(this);
            group.find('.timefield-from').date({
                direction: undefined,
                show_select_today: false,
                lang_clear_date: $.i18n.prop("clear"),
                pair: group.find(".timefield-to").date({
                    direction: true,
                    show_select_today: false,
                    lang_clear_date: $.i18n.prop("clear"),
                    time: "HH:mm:ss"
                }),
                time: "HH:mm:ss"
            });
        });
        this.find(".datefield").each(function() {
            var field = $(this);
            field.date({
                direction: field.attr("no-previous") ? true : (field.attr("no-next") ? false : undefined),
                show_select_today: false,
                lang_clear_date: $.i18n.prop("clear")
            })
        });
        this.find(".timefield").each(function() {
            var field = $(this);
            field.date({
                direction: field.attr("no-previous") ? true : (field.attr("no-next") ? false : undefined),
                show_select_today: false,
                lang_clear_date: $.i18n.prop("clear"),
                time: "HH:mm:ss",
                time_style: field.data("time-style") || 'modern'
            })
        });
        this.find("input[type='file']").file();
        this.find("input:checkbox:not(.raw)").checkbox();
        // `.fee-type-selector` radios render as segmented Show/Hide pills (hidden input +
        // label + CSS `:has(input:checked)`). The legacy wcui-radio dot widget must NOT
        // enhance them: it injects a separate <span class="wcui-radio"> dot whose checked
        // state mis-tracks, leaving BOTH pills marked `checked` (both fill at once). Skip
        // pill radios so the pill styling is the sole UI; all other radios are unaffected.
        this.find("input:radio:not(.raw)").filter(function () {
            return !$(this).closest(".fee-type-selector").length;
        }).radio();
        if(!app.is_front_end) {
            this.find('[title][title!=""]').not('[data-tooltip-position]').tooltipster({
                contentAsHTML: true
            });
        }
        this.find('.fee-info-tooltip[title], [data-tooltip-position][title]').each(function () {
            var $tip = $(this);
            $tip.tooltipster({
                theme: 'tooltipster-light',
                // Per-element override via data-tooltip-position (top|bottom|left|right); defaults to right.
                side: $tip.attr('data-tooltip-position') || 'right',
                contentAsHTML: true,
                maxWidth: 280
            });
        });
        // $.fn guards: these three live in custom-ui-editor.js (editor/admin surfaces only) -
        // an undefined $.fn method throws even on an empty find() result. .file() above keeps
        // its unguarded call: it has a js-chunk-loader queueing stub owned by the forms chunk.
        if ($.fn.wcTimepicker) { this.find('.wc-timepicker').wcTimepicker(); }
        if ($.fn.wcDateRangePicker) { this.find('.wc-daterangepicker').wcDateRangePicker(); }
        bm.cBaseDoc(this.find(".context-documentation"));
        if ($.fn.chart) { this.find(".chart-block").chart(); }
        this.find("textarea, .redactor-layer").on("mousewheel", function(event, delta) {
            var $this = $(this);
            var scrollTop = $this.scrollTop();
            var scrollHeight = this.scrollHeight;
            var innerHeight = $this.innerHeight();
            $this.scrollTop(scrollTop - delta * 40);
            scrollTop = $this.scrollTop();
            if(scrollTop != 0 && (scrollTop + innerHeight) < scrollHeight) {
                event.originalEvent.ignoreSroll = true
            }
        });
        return this;
    };

    ////////////// checkbox //////////////////////
    // Storefront-needed (moved back from custom-ui-editor.js): every site checkbox/radio
    // without .raw renders through these widgets via the unguarded updateUi calls above.

    var _checkbox_classes = "checked partial unchecked";

    var _checkbox_pubs = {
        state: function(state) {
            if(state) {
                switch(state) {
                    case "checked":
                        if(this.state != 1) {
                            _checkbox_privs.state.call(this, 1);
                        }
                        break;
                    case "unchecked":
                        if(this.state != 4) {
                            _checkbox_privs.state.call(this, 4);
                        }
                        break;
                    case "partial":
                        if(this.state == 1 || this.state == 4) {
                            this.state == 1 ? _checkbox_privs.state.call(this, 2) : (this.state == 4 ? _checkbox_privs.state.call(this, 3) : "")
                        }
                        break;
                }
                return;
            }
            return this.state == 1 ? "checked" : (this.state == 4 ? "unchecked" : "partial")
        },
        enable: function(isEnabled) {
            if(isEnabled) {
                this.el.removeAttr("disabled", "disabled");
                this.removeClass("disabled")
            } else {
                this.addClass("disabled");
                this.el.attr("disabled", "disabled")
            }
        }
    };

    var _checkbox_privs = {
        state: function(state) {
            this.removeClass(_checkbox_classes);
            switch(state) {
                case 1:
                    this.el[0].checked = true;
                    this.addClass("checked");
                    break;
                case 2:
                case 3:
                    this.addClass("partial");
                    break;
                case 4:
                    this.el[0].checked = false;
                    this.addClass("unchecked");
                    break;
            }
            this.state = state;
        }
    };

    var _checkbox_prop = $.prototype.prop;

    $.prototype.prop = function(propName, value) {
        if(propName == "checked" && value != undefined) {
            return this.each(function() {
                var check = $(this);
                var instance = check.data("wcui-checkbox");
                if(instance) {
                    _checkbox_pubs.state.call(instance, value ? "checked" : (value === false ? "unchecked" : undefined))
                } else {
                    _checkbox_prop.apply(check, [propName, value]);
                }
            })
        } else {
            return _checkbox_prop.apply(this, arguments);
        }
    };

    $.prototype.checkbox = function(func) {
        if(!this.length || $(this).hasClass('skip-wcui')) {
            return this;
        }
        if(func) {
            var toReturn;
            var params = Array.prototype.splice.call(arguments, 1);
            this.each(function() {
                var instance = $(this).data("wcui-checkbox");
                if(!instance) {
                    throw $.error(func + " is being called before initialization");
                }
                toReturn = _checkbox_pubs[func].apply(instance, params);
                return toReturn == undefined;
            });
            return toReturn == undefined ? this : toReturn;
        }
        return this.each(function() {
            var original = $(this);
            if(original.css("display") == "none") {
                return;
            }
            var instance = original.data("wcui-checkbox");
            if(instance) {
                return;
            }
            var type = "";
            if(original.is(".single")) {
                type = "single";
            } else if(original.is(".multiple")) {
                type = "multiple";
            }
            var fancy = $("<span class='wcui-checkbox " + type + "'></span>");
            instance = $.extend({}, {el: original}, fancy);
            original.data("wcui-checkbox", instance);
            original.after(fancy).hide();
            if(original.is("[disabled]")) {
                fancy.addClass("disabled");
            }
            if(original.is("[title]")) {
                fancy.attr("title", original.attr("title"));
            }
            if(this.checked) {
                _checkbox_privs.state.call(instance, 1)
            } else {
                _checkbox_privs.state.call(instance, 4)
            }
            // A <label for>, a keyboard activation or plain code can flip the real input without going
            // through the proxy; mirror it so the drawn box never contradicts what will be submitted.
            original.on("change.wcui-checkbox-sync", function() {
                var wanted = this.checked ? 1 : 4;
                if(instance.state != wanted) {
                    _checkbox_privs.state.call(instance, wanted);
                }
            });
            fancy.bind("click", function(e) {
                if(original.is("[disabled]")) {
                    return;
                }
                // The proxy usually sits INSIDE the <label> that wraps the real input, so this click also
                // bubbles to the label, whose default action toggles that very input again — two toggles,
                // net zero. The box then LOOKED ticked (our class) while input.checked stayed false, so
                // nothing was submitted. Suppressing the default leaves this handler as the only toggle.
                if(e && e.preventDefault) {
                    e.preventDefault();
                }
                switch(instance.state) {
                    case 1:
                        _checkbox_privs.state.call(instance, 4);
                        break;
                    case 2:
                        _checkbox_privs.state.call(instance, 4);
                        break;
                    case 3:
                        _checkbox_privs.state.call(instance, 1);
                        break;
                    case 4:
                        _checkbox_privs.state.call(instance, 1);
                        break;
                }
                original.triggerWithPropagation("change");
                if(this.closest(".scrollable-table-wrapper table")){
                    var listTable = this.closest(".scrollable-table-wrapper table").jqObject;
                    if(listTable.find(".check-all").closest("th").length){
                        var checkAllBox = listTable.find(".check-all").closest("th")[0].jqObject;
                        listTable.tscrollbar("content", checkAllBox)
                    }
                }
            });
        })
    };

    ////////////// radio //////////////////////

    var _radio_classes = "checked unchecked";

    var _radio_privs = {
        state: function(state) {
            this.removeClass(_radio_classes);
            switch(state) {
                case 1:
                    this.el[0].checked = true;
                    this.addClass("checked");
                    break;
                case 2:
                    this.addClass("unchecked");
                    break;
            }
            this.state = state;
        },
        clear_others: function() {
            var group = this.group;
            if(group) {
                $.each(group, function() {
                    if(this.el[0].checked) {
                        _radio_privs.state.call(this.el.data("wcui-radio"), 2);
                        return false;
                    }
                })
            }
        }
    };

    var _radio_pubs = {
        check: function() {
            if(this.state != 1) {
                _radio_privs.clear_others.call(this);
                _radio_privs.state.call(this, 1);
            }
        },
        val: function(value) {
            var group = this.group;
            if(typeof value != "undefined") {
                var to_check;
                $.each(group || [this], function() {
                    if(this.el.val() == value) {
                        to_check = this;
                        return false;
                    }
                });
                if(!to_check) {
                    return false;
                }
                _radio_pubs.check.call(to_check);
                return true;
            } else {
                var val;
                $.each(group || [this], function() {
                    if(this.el[0].checked) {
                        val = this.el.val();
                        return false;
                    }
                });
                return val;
            }
        },
        state: _radio_privs.state
    };

    $.prototype.radio = function(func) {
        if(!this.length) {
            return this;
        }
        if(func) {
            var toReturn;
            var params = Array.prototype.splice.call(arguments, 1);
            this.each(function() {
                var instance = $(this).data("wcui-radio");
                if(!instance) {
                    throw $.error(func + " is being called before initialization");
                }
                toReturn = _radio_pubs[func].apply(instance, params);
                return toReturn == undefined;
            });
            return toReturn == undefined ? this : toReturn;
        }
        var groups = {};
        return this.each(function() {
            var original = $(this);
            var instance = original.data("wcui-radio");
            if(instance) {
                return;
            }
            var fancy = $("<span class='wcui-radio'></span>");
            if(original.css("display") == "none") {
                fancy.hide();
            }
            var name = original.attr("name");
            instance = $.extend({}, {el: original}, fancy);
            if(name) {
                var group = groups[name];
                if(!group) {
                    group = [];
                    groups[name] = group;
                }
                instance.group = group;
                group.push(instance);
            }
            original.data("wcui-radio", instance);
            original.after(fancy).hide();
            if(original.is("[disabled]")) {
                fancy.addClass("disabled");
            }
            if(this.checked) {
                _radio_privs.state.call(instance, 1)
            } else {
                _radio_privs.state.call(instance, 2)
            }
            fancy.bind("click", function(e) {
                if(instance.state == 1 || original.is("[disabled]")) {
                    return;
                }
                // Same reason as the checkbox proxy: inside a wrapping <label> the default action would
                // re-activate the real input this handler has just set.
                if(e && e.preventDefault) {
                    e.preventDefault();
                }
                _radio_pubs.check.call(instance);
                original.triggerWithPropagation("change");
            });
        })
    };

    /********Scroll to**********/
    $.prototype.scrollTo = function( target, options, callback ) {
        if(!target) {
            return;
        }
        if(typeof options == 'function' && arguments.length == 2){ callback = options; options = target; }
        var settings = $.extend({
            scrollTarget  : target,
            offsetTop     : 50,
            duration      : 500,
            easing        : 'swing'
        }, options);
        var scrollTarget = (typeof settings.scrollTarget == "number") ? settings.scrollTarget : settings.scrollTarget;
        return this.each(function(){
            var scrollPane = $(this);
            var scrollY = (typeof scrollTarget == "number") ? scrollTarget : scrollTarget.offset().top + scrollPane.scrollTop() - parseInt(settings.offsetTop);
            scrollPane.animate({scrollTop : scrollY }, parseInt(settings.duration), settings.easing, function(){
                if (typeof callback == 'function') { callback.call(this); }
            });
        });
    }


})();

; (function() {
    var _def_config = {
        shopping_cart_page_message_display_time: 5000,
        server_message_display_time: 8000,
        newsletter_subscription_message_display_time: 6000,
        checkout_step_message_display_time: 6000,
        validation_newsletter_subscription_error_position: "inline",
        customer_profile_message_display_time: 6000,
        driver_profile_message_display_time: 6000,
        product_details_page_status_time: 5000,
        product_zoom_box_dimension: "1x", //1x,1.25x,1.5x,1.75x,2x
        number_block_in_paginator_count: 7,
        number_block_in_paginator_count_800: 3,
        site_popup_animation_clazz: "anim-fade-zoom"
    };
    app.config = $.extend(_def_config, app.config);
})();
; /**
 * HWC-4151 — on-demand loader for the split site JS feature chunks.
 * The layout emits window.__wcJsChunkUrls with URLs ONLY for chunks it did NOT include,
 * so a chunk can never execute twice. Guarded call sites (site.js) and plugin code call
 * wcLoadJsChunk('name', cb) when a needed jQuery plugin is missing.
 */
(function () {
    "use strict";

    var loading = {};
    // callbacks parked by a failed load, replayed when a later call retries successfully
    var pending = {};

    window.wcLoadJsChunk = function (name, callback) {
        var urls = (window.__wcJsChunkUrls || {})[name];
        if (!urls || !urls.length) {
            // chunk was emitted with the page (or unknown) — nothing to load
            if (callback) callback();
            return;
        }
        if (loading[name]) {
            loading[name].push(callback);
            return;
        }
        loading[name] = (pending[name] || []).concat(callback ? [callback] : []);
        delete pending[name];

        function next() {
            if (!urls.length) {
                delete window.__wcJsChunkUrls[name];
                var callbacks = loading[name];
                delete loading[name];
                callbacks.forEach(function (cb) { if (cb) cb(); });
                return;
            }
            var script = document.createElement("script");
            script.src = urls[0];
            script.onload = function () {
                // consume the URL only once it actually executed, so a retry never re-runs it
                urls.shift();
                next();
            };
            script.onerror = function () {
                // Do NOT treat a failed file as loaded: the callbacks would run against a
                // half-loaded chunk and throw at the call site. Leave the remaining URLs
                // registered and park the callbacks - the next wcLoadJsChunk call retries from
                // the failed file and replays them once the chunk really lands.
                pending[name] = loading[name];
                delete loading[name];
            };
            document.head.appendChild(script);
        }
        next();
    };

    /* HWC-4153 — queueing stubs for the jQuery plugin families that moved into lazy chunks
     * (see ResourceList.siteFeatureJsChunks). Call sites all over view.js / custom-ui.js /
     * site.js invoke these unconditionally (updateUi calls .chosen()/.tabify()/… on find()
     * results, and an undefined $.fn method throws even on an empty set), so instead of
     * touching every caller: a stub on a non-empty set lazy-loads the owning chunk and
     * replays the call once the real plugin — which overwrites the stub — has executed.
     * Empty sets return without loading anything. When a chunk was emitted with the page,
     * its files execute before DOM-ready code runs and the real plugins have already
     * replaced the stubs, so eager pages never take this path.
     * Limitation: a pre-load call with getter semantics (e.g. chosen("val")) returns the
     * set instead of the value — same contract as calling a getter before init today. */
    var stubbedPlugins = {
        select: ["chosen", "multitxtchosen", "multispecialchosen"],
        widgets: ["tabify", "accordion", "childAccordion"],
        scrollbar: ["scrollbar", "tscrollbar"],
        // "file" (custom-ui-file.js, HWC-4153 round 5): updateUi calls .file() on every
        // input[type=file] - empty on most pages (no-op), a real file input lazy-loads forms.
        forms: ["ajaxForm", "ajaxSubmit", "file"],
        commerce: ["stepper"]
    };

    /* HWC-4750 — the chunk "landing" is not proof that the plugin is THERE.
     *
     * A chunk emitted EAGERLY with the page is deliberately absent from __wcJsChunkUrls, so
     * wcLoadJsChunk takes its "nothing to load" branch and fires the callback synchronously — even
     * though that eagerly-emitted file is `defer`red and may not have executed yet. jQuery makes
     * that window reachable on every page: loaded by a deferred script it sees readyState
     * "interactive" and dispatches ready on a setTimeout, and that timer can run BETWEEN two
     * deferred files. A replay landing in the window found the stub still installed and, under the
     * old guard, did nothing at all — silently. That is how a product page ended up showing a plain
     * quantity box instead of a +/- stepper (jquery.fs.stepper.js lives in `commerce`), and the same
     * hole applies to every family stubbed below: an unstyled chosen select, an un-tabified tab set.
     *
     * So wait for the real plugin instead of testing once. Bounded, so a chunk that genuinely never
     * defines the method still settles into the old no-op rather than polling forever.
     */
    var REPLAY_POLL_MS = 100;
    var REPLAY_MAX_ATTEMPTS = 100; // ~10s

    function replayWhenPluginReal($, method, set, args) {
        var attempts = 0;
        (function poll() {
            if ($.fn[method] && !$.fn[method].__wcChunkStub) {
                $.fn[method].apply(set, args);
                return;
            }
            if (++attempts > REPLAY_MAX_ATTEMPTS) {
                return;
            }
            setTimeout(poll, REPLAY_POLL_MS);
        })();
    }

    function stubPluginMethod($, chunkName, method) {
        if ($.fn[method]) {
            return;
        }
        var stub = function () {
            if (!this.length) {
                return this;
            }
            var set = this;
            var args = arguments;
            window.wcLoadJsChunk(chunkName, function () {
                replayWhenPluginReal($, method, set, args);
            });
            return this;
        };
        stub.__wcChunkStub = true;
        $.fn[method] = stub;
    }

    if (window.jQuery) {
        Object.keys(stubbedPlugins).forEach(function (chunkName) {
            stubbedPlugins[chunkName].forEach(function (method) {
                stubPluginMethod(window.jQuery, chunkName, method);
            });
        });
    }

    /* Interaction backstop for the precise plugin-asset split (PluginTagLib.siteCss/JsBundles,
     * flag precise_plugin_asset_matching): plugin CSS/JS the head emission skipped by gallery
     * precision is listed in window.__wcDeferredPluginAssets {css:[urls], js:[urls]}. Load it
     * ALL on the first user interaction — or after an idle fallback for no-interaction visits —
     * so anything the precision matching missed (a slider injected by later JS, quick-view
     * content) styles and behaves correctly the moment the visitor engages. A false skip
     * therefore costs one late load, never broken styling — the property that makes aggressive
     * head pruning safe (the same original-CSS-on-interaction pattern WP's Debloat uses). */
    var deferredAssetsLoaded = false;
    function loadDeferredPluginAssets() {
        if (deferredAssetsLoaded) {
            return;
        }
        deferredAssetsLoaded = true;
        var registry = window.__wcDeferredPluginAssets || {};
        (registry.css || []).forEach(function (url) {
            var link = document.createElement("link");
            link.rel = "stylesheet";
            link.href = url;
            document.head.appendChild(link);
        });
        (registry.js || []).forEach(function (url) {
            var script = document.createElement("script");
            // Dynamically inserted scripts ignore `defer` and execute in arbitrary async order;
            // async=false is what preserves the registry's (activePlugins) insertion order.
            script.async = false;
            script.src = url;
            document.head.appendChild(script);
        });
        window.__wcDeferredPluginAssets = {};
    }
    // Registered unconditionally: with an empty/absent registry the handler is a cheap no-op,
    // and the registry script tags may execute after this file (both are deferred).
    ["pointerdown", "keydown", "touchstart"].forEach(function (eventName) {
        window.addEventListener(eventName, loadDeferredPluginAssets, {once: true, passive: true, capture: true});
    });
    // Idle fallback: crawlers and no-interaction visits still get the full asset set eventually.
    setTimeout(loadDeferredPluginAssets, 8000);
})();

; /**
 * HWC-4152 — deep navigation subtrees (level 3+) ship inside inert <template>
 * elements (see WidgetService.getNavigationDom). Mount a parent's direct subtree
 * on its first hover / tap / focus, before the CSS :hover rule needs it.
 * Delegated on document so drawer/pushbar clones of the nav keep working.
 *
 * Plugin authors: on the live site, level 3+ nav subtrees are NOT in the DOM until the
 * parent item's first interaction — query them lazily (or after this mount), never at boot.
 */
(function () {
    "use strict";

    function mountDirectChildren(navItem) {
        var container = null;
        for (var i = 0; i < navItem.children.length; i++) {
            if (navItem.children[i].classList.contains("navigation-item-child-container")) {
                container = navItem.children[i];
                break;
            }
        }
        if (!container) {
            return;
        }
        var tpl = container.firstElementChild;
        if (!tpl || tpl.tagName !== "TEMPLATE" || !tpl.classList.contains("nav-children-template")) {
            return;
        }
        container.appendChild(tpl.content);
        tpl.remove();
    }

    function onInteraction(event) {
        var node = event.target;
        while (node && node.classList) {
            if (node.classList.contains("navigation-item") && node.classList.contains("has-child")) {
                mountDirectChildren(node);
            }
            node = node.parentNode;
        }
    }

    ["mouseover", "pointerdown", "focusin", "touchstart"].forEach(function (evt) {
        document.addEventListener(evt, onInteraction, {capture: true, passive: true});
    });
})();
